/* GENERATED SPLIT of snippets/vivid-cc.liquid (23-Aug-2026) by
 * tools/flagpole/extract_ccjs.py. The snippet stamps liquid values onto
 * window.__VVCC and renders vivid-cc-browse as window globals; everything
 * else lives here, free of the 256KB template cap. Edit THIS file for
 * logic; edit the snippet only for liquid-stamped data. */
(function(){
  if(window.__vvCCInit)return; window.__vvCCInit=true;
  var BACKEND='https://phpstack-321644-985620.cloudwaysapps.com/customercanvas';
  // Our own server. It owns the print-file step: it creates the Customer's Canvas project,
  // renders the hi-res PDF and copies it into our storage. It is NOT the Cloudways PHP —
  // cc-render.php is pinned to the retired storefront 51 and 409s for every product we sell
  // today ("EcommerceProduct with ID … does not exist"), which is why the print file is built
  // here instead. See docs/customers-canvas/PRINT-READINESS-AUDIT.md.
  var PORTAL='https://portal.vividads.com.au';
  /* PREVIEW CACHE EPOCH — BUMP ON EVERY RE-SEED. The preview URL carries no
     version, so an old `immutable` header pinned blank thumbnails in browsers
     for a year, and the ETag (built from the design's CC lastModified) does not
     move when a thumbnail is re-seeded. This constant is what retires stale
     copies. Full account: docs/customers-canvas/PREVIEWS-AND-PORTAL-UPTIME.md,
     11-Aug. */
  var PREV_EPOCH='20260828e'; /* 28-Aug (2): the cube re-seed landed AFTER the 'b' bump, so
     browsers that had already cached ...?w=400&e=20260828b kept serving the OLD FLAT strip
     cards from disk — the owner saw 13 flat, 2 3D, while the portal was serving 3D for all
     15. The rule this proves: bump the epoch AFTER the seed finishes, never before.
     BUMP ON EVERY RE-SEED */
  function prevUrl(id,w){ return id?(PORTAL+'/api/design-preview/'+id+'?w='+w+'&e='+PREV_EPOCH):''; }
  var HUB='https://au.customerscanvashub.com';
  var TENANT='27', STOREFRONT='54';
  /* 7-Oct-2026 — UI FRAMEWORK PIN (owner-approved). The hub hands the SDK a FLOATING UIF channel
     (https://staticjs-aurigma.azureedge.net/libs/au/uif) that Aurigma republishes in place: on 6 Oct a 4.47.0
     pre-release landed there and broke every launch for 32 minutes (docs/incident/INCIDENT-2026-10-06-uif-4.47.md).
     We pin the known-good, production-proven build (4.46.98: its design-selector chunk is byte-identical to the one
     the channel served 11 Aug - 6 Oct, md5 75cb0620...). Upgrades are deliberate: docs/incident/UIF-PINNING.md.
     ROLLBACK = set this to '' (the hub's floating value is used again). Nothing else changes. */
  var VV_UIF_PIN='https://staticjs-aurigma.azureedge.net/ui-framework/4.46.98';
  var PRODUCT_ID=window.__VVCC.PRODUCT_ID;
  var PRODUCT_TITLE=window.__VVCC.PRODUCT_TITLE;
  var CUSTOMER_ID=window.__VVCC.CUSTOMER_ID;
  var FALLBACK_VID=window.__VVCC.FALLBACK_VID;
  var modal=document.getElementById('vv-cc-modal');
  var box=document.getElementById('vv-cc-editor');
  var cover=document.getElementById('vvcc-cover');
  var hdrcover=document.getElementById('vvcc-hdrcover');
  var finishBtn=document.getElementById('vvcc-finish');
  var stage=modal.querySelector('.vvcc-stage');
  var STATES={loading:document.getElementById('vvcc-loading'),timeout:document.getElementById('vvcc-timeout'),
              empty:document.getElementById('vvcc-empty'),error:document.getElementById('vvcc-error'),
              signin:document.getElementById('vvcc-signin')};
  var booted=false, monTimer=null;
  /* 3-Sep-2026: true between sf.loadEditor() being called and its promise
     settling. mountRetry refuses to relaunch while it is set — see there. */
  var _loadInFlight=false;
  /* How long the wizard is allowed to take to paint before we call it dead.
     See the long note at the use site: this is a measured number. */
  var NO_WIZARD_MS=75000;

  // ---- BROWSE-DESIGNS MODE SWITCH (UPDATE 26) ------------------------------
  // Per-product, additive. A handle listed here gets the Vistaprint-style
  // "browse designs" gallery when the VividCanvas button is clicked; every
  // other product keeps today's direct-open flow untouched (BROWSE_MODE false
  // makes every vvbr* function below a no-op and the overlay is never shown).
  // REVERT for a product = remove its handle from this array (one line).
  // ENABLE for a product = add its handle (and stamp vvIndustries custom
  // fields on its designs — tools/cc-mediawall/tag_industries.py pattern).
  // Round 17: the owner chose the Vistaprint browse style for the WHOLE pull-up
  // family, so 526 (premium-pullup-banners) FLIPS FROM DIRECT to browse here and
  // 547 (fabric-banner-stand) joins it. 522 was already browse (§6.12 Step K).
  // 10-Aug, owner: corflute "is not the same flow as pull up banners ... its
  // showing images in the customer canvas left menu". Exactly this switch — the
  // handle was missing, so BROWSE_MODE was false and corflute took the
  // direct-open path, landing the customer in CC's own design rail instead of
  // our gallery. Adding the handle is the whole fix; the registry entries below
  // (names/industries/keywords) are a separate quality step — until corflute
  // keys are in vivid-cc-registry.js the designs still list, under "All
  // designs" with their own names, because every lookup falls back.
  //
  // 10-Aug, same report again for selfie frames: "the gallery flow is not
  // showing on that product and its showing the designs in customer canvas
  // left side where the editor is ... this flow should be same as pull up
  // banner". Identical cause, identical fix — 'custom-selfie-frames' added.
  // THIS IS THE STEP THAT GETS FORGOTTEN. Pushing designs, binding them to the
  // product and writing registry entries all succeed independently of this
  // array, so a new product can be fully built and still open into CC's own
  // rail. Any product that gets a design library needs its handle here.
  // 'a-frame-signs' is product 542, the TWO-BOARD frame — a different product
  // from 'corrugated-a-frame-signs' (560, the wrap sheet). Adding the handle
  // only switches browse mode ON; it does NOT put designs on the page. Three
  // more things have to be true first or the customer gets an empty gallery:
  // the designs must be BOUND to 542, spliced into vivid-cc-registry.js, and
  // seeded. Do not ship this line ahead of those.
  /* vivid-cc-browse globals are stamped by the data script in the snippet */
  // v4: card price line = the CURRENT selection's Shopify variant price (design is
  // free, so every card shows the same, EXACT price - recorded in BROWSE-MODE-SPEC).
  var BROWSE_PRICES=window.__VVCC.BROWSE_PRICES;
  // UPDATE 38: design-service fee tiers for THIS product type — read live from the
  // ACTIVE Shopify add-on products (Basic/Standard/Premium Design Services, one
  // variant per product type, e.g. "Pull Up Banners (any size / type)"). The fee
  // reaches the cart as a COMPANION LINE — the theme's standing native fee
  // mechanism (the Same Day Production hidden-product pattern in
  // vivid-native-options/vivid-buy-cards). Empty array (type not covered or
  // products unpublished) degrades the designer panel to brief-only.
  var DESIGN_TIERS=window.__VVCC.DESIGN_TIERS;

  // ---- UPDATE 32b: AUTO-RETRY + failure report (owner: "it should not fail") --
  // A mount that dies (no wizard in 18s, or loadEditor threw) RELAUNCHES ITSELF:
  // bounded attempts with backoff via the clean single-relaunch path (launchGen
  // guard, EDIT counters reset per launch). The customer keeps the branded
  // loading state; when attempts exhaust: the busy panel + a beacon to the
  // portal (/api/cc-mount-failure -> Postmark email to zulfe@) with the
  // per-attempt stage log. pagehide fires the beacon too (tab closed mid-retry).
  var mountTry={n:0,max:3,stages:[]};
  /* 6-Oct-2026 — VENDOR DEPENDENCY NOTE. Aurigma pushed UI Framework 4.47.0 to the UNVERSIONED CDN path this tenant
     points at (editor.json 11:18:49 GMT); its design-selector constructor read this.auWizard before assignment and every
     launch lost the design feed (wizard up, no rows, apply-slow at 45 s) until Aurigma republished at 11:51 GMT.
     No shim is shipped: a theme-side patch of a vendor chunk is tied to one build hash and goes stale on the next
     publish. The durable fix is pinning uiFrameworkUrl to a versioned path in BackOffice (owner decision, see
     docs/incident/INCIDENT-2026-10-06-uif-4.47.md). The incident recorder below now captures this class of failure
     (pageerror inside the UIF chunk + feed never landing) so it is diagnosed, not guessed, next time. */
  /* 6-Oct-2026 — INCIDENT RECORDER (owner: "make the failure email a mini incident report").
     One id per launch (correlates the browser's beacons with the portal's sink), a timeline of every
     milestone we can see from here (page → token → SDK → mount → feed → pick → apply → interactive,
     plus visibility / connection changes and the customer leaving), JS errors, failed or slow requests to
     our own hosts, long tasks and device facts. NOTHING sensitive: no cookies, tokens, headers, request
     bodies, artwork or customer text — URLs are kept without query strings except our own vv* params.
     The portal classifies REAL_CUSTOMER / SYNTHETIC_MONITOR / STAFF_QA from `kind` + entry + UA. */
  var vvInc=(function(){
    var t0=(function(){try{return performance.timeOrigin||Date.now();}catch(e){return Date.now();}})();
    var id='inc_'+Date.now().toString(36)+'_'+Math.random().toString(36).slice(2,8);
    var tl=[], errs=[], reqs=[], lt={n:0,ms:0,max:0}, left=null, lastStage='', connLog=[];
    function now(){ try{return Math.round(performance.now());}catch(e){return Date.now()-t0;} }
    function mark(stage,extra){ try{
      lastStage=stage; var e={t:now(),s:String(stage).slice(0,80)};
      if(extra!=null){ try{ e.x=(typeof extra==='object')?JSON.parse(JSON.stringify(extra)):String(extra).slice(0,160); }catch(_){ e.x=String(extra).slice(0,160);} }
      tl.push(e); if(tl.length>160) tl.splice(0,tl.length-160);
    }catch(e){} }
    function safeUrl(u){ try{ var x=new URL(String(u),location.href); var q=[]; x.searchParams.forEach(function(v,k){ if(/^(vv|variant$|product$|gallery$|designId$|userId$)/i.test(k)) q.push(k+'='+String(v).slice(0,60)); }); return x.origin+x.pathname+(q.length?'?'+q.join('&'):''); }catch(e){ return String(u).slice(0,120); } }
    var OURS=/vividads\.com\.au|aurigma|customerscanvas|azureedge\.net|cdn\.shopify\.com|fly\.dev/i;
    try{ addEventListener('error',function(ev){ try{ var m=(ev&&ev.message)||'', st=(ev&&ev.error&&ev.error.stack)||'';
      var tg=ev&&ev.target; if(tg&&tg!==window&&(tg.src||tg.href)){ var ru=String(tg.src||tg.href||''); if(!OURS.test(ru))return; errs.push({t:now(),type:'resource',name:String(tg.tagName||'').toLowerCase(),msg:'failed to load',src:safeUrl(ru)}); if(errs.length>12)errs.splice(0,errs.length-12); return; }
      if(!m&&!st)return;
      errs.push({t:now(),type:'error',name:(ev&&ev.error&&ev.error.name)||'Error',msg:String(m).slice(0,240),src:safeUrl(ev&&ev.filename||''),line:ev&&ev.lineno,stack:String(st).slice(0,400)}); if(errs.length>12)errs.splice(0,errs.length-12); }catch(_){} },true); }catch(e){}
    try{ addEventListener('unhandledrejection',function(ev){ try{ var r=ev&&ev.reason; errs.push({t:now(),type:'unhandledrejection',name:(r&&r.name)||'',msg:String((r&&r.message)||r||'').slice(0,240),stack:String((r&&r.stack)||'').slice(0,400)}); if(errs.length>12)errs.splice(0,errs.length-12); }catch(_){} }); }catch(e){}
    try{ if(window.PerformanceObserver){
      var po=new PerformanceObserver(function(list){ try{ list.getEntries().forEach(function(en){
        if(!OURS.test(en.name)) return;
        var st=en.responseStatus||0, slow=en.duration>3000, opaque=!(st>=400)&&en.duration>1500&&en.transferSize===0&&en.decodedBodySize===0, failed=(st>=400)||(opaque&&st===0&&!/azureedge|aurigma|customerscanvas|cdn\.shopify/i.test(en.name));
        if(!slow&&!failed&&!opaque) return;   // a cross-origin host without Timing-Allow-Origin hides size + status: say 'opaque', not 'failed'
        reqs.push({t:Math.round(en.startTime),url:safeUrl(en.name),ms:Math.round(en.duration),status:st||undefined,type:en.initiatorType,bytes:en.transferSize||0,why:failed?'failed/empty':(opaque?'opaque (size/status hidden by CORS; may be cached)':'slow')});
        if(reqs.length>40) reqs.splice(0,reqs.length-40);
      }); }catch(_){} });
      po.observe({type:'resource',buffered:true});
      try{ var lo=new PerformanceObserver(function(list){ try{ list.getEntries().forEach(function(en){ lt.n++; lt.ms+=Math.round(en.duration); if(en.duration>lt.max) lt.max=Math.round(en.duration); }); }catch(_){} }); lo.observe({type:'longtask',buffered:true}); }catch(_){}
    } }catch(e){}
    try{ document.addEventListener('visibilitychange',function(){ mark('page:'+document.visibilityState); }); }catch(e){}
    try{ if(document.visibilityState==='hidden') mark('page:hidden',{initial:1}); }catch(e){}   // 7-Oct P0: opened in the background
    try{ addEventListener('online',function(){ mark('net:online'); }); addEventListener('offline',function(){ mark('net:offline'); }); }catch(e){}
    try{ var c=navigator.connection; if(c&&c.addEventListener) c.addEventListener('change',function(){ var e={t:now(),et:c.effectiveType,dl:c.downlink,rtt:c.rtt}; connLog.push(e); if(connLog.length>10)connLog.shift(); mark('net:change',e); }); }catch(e){}
    try{ addEventListener('pagehide',function(){ left={t:now(),at:new Date().toISOString(),lastStage:lastStage}; mark('page:pagehide'); },{capture:true}); }catch(e){}
    try{ addEventListener('pageshow',function(ev){ if(!ev||!ev.persisted) return; var fz=left?Math.max(0,now()-left.t):null;   // dd3c-bfc: restored from the back/forward cache
      window.__vvRestore={at:Date.now(),frozenMs:fz,pending:null}; window.__vvIntentNav=null; mark('page:restored',{frozenMs:fz,lastLeft:left?left.lastStage:''}); left=null; },{capture:true}); }catch(e){}
    function device(){ var d={}; try{ d.ua=navigator.userAgent.slice(0,240); }catch(e){}
      try{ var u=navigator.userAgentData; if(u){ d.mobile=!!u.mobile; d.platform=u.platform; d.brands=(u.brands||[]).map(function(b){return b.brand+' '+b.version;}).join(', ').slice(0,120); } }catch(e){}
      try{ d.vp=innerWidth+'x'+innerHeight; d.screen=screen.width+'x'+screen.height; d.dpr=devicePixelRatio; d.touch=('ontouchstart' in window)||navigator.maxTouchPoints>0; d.cores=navigator.hardwareConcurrency; d.mem=navigator.deviceMemory; d.lang=navigator.language; d.tz=Intl.DateTimeFormat().resolvedOptions().timeZone; d.vis=document.visibilityState; d.online=navigator.onLine; }catch(e){}
      try{ var c=navigator.connection||{}; d.conn={et:c.effectiveType||'',dl:c.downlink||0,rtt:c.rtt||0,sd:!!c.saveData}; }catch(e){}
      try{ var mm=performance.memory; if(mm) d.jsHeapMB=Math.round(mm.usedJSHeapSize/1048576); }catch(e){}
      return d; }
    function nav(){ try{ var n=performance.getEntriesByType('navigation')[0]; if(!n) return null; return {type:n.type,ttfb:Math.round(n.responseStart),html:Math.round(n.responseEnd),dcl:Math.round(n.domContentLoadedEventEnd),load:Math.round(n.loadEventEnd),redirects:n.redirectCount}; }catch(e){ return null; } }
    function kind(){ try{ var q=new URLSearchParams(location.search); if(q.get('vvqa')==='1'||sessionStorage.getItem('vvqa')==='1'||/VividQA|HeadlessChrome/.test(navigator.userAgent)) return 'STAFF_QA'; if(/VividMon/.test(navigator.userAgent)) return 'SYNTHETIC_MONITOR'; }catch(e){} return 'REAL_CUSTOMER'; }
    function snapshot(){ return {inc:id,kind:kind(),t0:new Date(t0).toISOString(),timeline:tl.slice(-160),errors:errs.slice(),requests:reqs.slice(),longTasks:lt,device:device(),nav:nav(),connLog:connLog.slice(),left:left,
      page:safeUrl(location.href),referrer:(function(){try{return safeUrl(document.referrer);}catch(e){return '';}})(),
      deep:(function(){try{var q=new URLSearchParams(location.search),o={};['vvcc','vvstyle','vvsize','vvmaster','vvfrom','vvsides','vvstate','vvresume','variant'].forEach(function(k){if(q.get(k))o[k]=String(q.get(k)).slice(0,60);});return o;}catch(e){return {};}})(),
      way:(function(){try{ var m=(location.search||'').match(/[?&]vvcc=(blank|upload)/); if(m) return m[1]; if(/[?&]vvstyle=/.test(location.search||'')) return 'template'; return (typeof BROWSE_MODE!=='undefined'&&BROWSE_MODE)?'browse':'direct'; }catch(e){ return 'unknown'; }})(),
      build:(window.__vvGalBuild||''),customer:(function(){try{var g=guestId();return {loggedIn:/^shopify_customer_/.test(g),cc:g};}catch(e){return null;}})()}; }
    mark('page:script-loaded');
    return {id:id,mark:mark,snapshot:snapshot,kind:kind,errors:errs};
  })();
  try{ window.__vvInc=vvInc; }catch(e){}
  /* Which failure this beacon is about. 'mount' = the editor never opened.
     'finish' = the editor opened fine and the FINISH run (approval -> proof ->
     add to cart -> CC's hi-res generation) blew its 180s cap. Both show the
     customer the same panel, so without this the emails were indistinguishable
     — and until 22-Aug the finish one was never sent at all. The portal reads
     this to write an accurate subject line. */
  var beaconPhase='mount';
  /* 26-Aug — WHOSE NETWORK IS IT?
     A mount failure whose error is an unexpected HTML page tells us nothing on
     its own: the page could have come from our portal, from Customer's Canvas,
     from Azure, or from something sitting between the customer and all three.
     From here every one of those hosts answers correctly, so a report of
     "HTTP 200 OK. <!DOCTYPE html>" is unfalsifiable — which is the same problem
     as every other check in this system that could not fail.
     So on a FINAL failure, ask the three hosts from the CUSTOMER's connection
     and record what THEY said. A portal health endpoint that comes back as
     HTML for them and JSON for us is not ambiguous. Costs three requests, on a
     session that has already failed, and can never throw. */
  function chainProbe(){
    var hosts=[
    /* 28-Aug — THE PORTAL LINE WAS A GUARANTEED FALSE ALARM.
       This probed PORTAL+'/healthz', and every alert it ever produced said
       portal=ERR "Load failed" / "Failed to fetch" — including two (27-Aug
       06:26Z, 28-Aug 01:28Z) whose confirm probe had just proven the portal
       answering in under a second FROM THE SAME BROWSER. Measured with curl:
       the portal has NO /healthz route at all; app.get('*') catches it and
       serves the SPA's index.html — 200 text/html, and, decisively, no
       Access-Control-Allow-Origin header. A cross-origin fetch from
       www.vividads.com.au is therefore CORS-blocked by the browser EVERY
       time, healthy or not, and rejects with the browser's generic network
       TypeError — indistinguishable in this report from a dead connection.
       That is the exact defect the netAlive() comment below documents having
       caught before shipping ("NOT /healthz ... it sends no
       Access-Control-Allow-Origin") — chainProbe was written the same day and
       inherited the URL anyway. So the one line of the alert pointing at OUR
       host was the one line that could never be right, while cchub and sdkcdn
       (whose hosts do send CORS headers) reported honestly beside it.
       /api/cc-token/health is the fix for the same reason it was the fix for
       netAlive: CORS-allowlisted for the storefront origin, static JSON from
       memory (no DB, no CC call), and it is the endpoint the mount path
       actually depends on — if IT answers, token minting is reachable. */
      ['portal', PORTAL+'/api/cc-token/health'],
      ['cchub',  HUB+'/api/v1/tenants/'+TENANT+'/integrations/'+PRODUCT_ID+'?storefrontId='+STOREFRONT],
      ['sdkcdn', 'https://staticjs-aurigma.azureedge.net/back-office/storefront/1.2.16/storefront.main.js']
    ];
    return Promise.all(hosts.map(function(h){
      return fetch(h[1],{signal:_abortIn(4000),cache:'no-store'}).then(function(r){
        var ct=(r.headers.get('content-type')||'').split(';')[0];
        return r.text().then(function(t){
          var page=/^\s*(<!doctype|<html|<\?xml)/i.test(t);
          return h[0]+'='+r.status+' '+ct+(page?' PAGE:'+t.slice(0,60).replace(/\s+/g,' '):'');
        },function(){ return h[0]+'='+r.status+' '+ct+' (body unreadable)'; });
      }).catch(function(e){ return h[0]+'=ERR '+String((e&&e.message)||e).slice(0,60); });
    })).catch(function(){ return []; });
  }
  /* `offline` (26-Aug): set only by mountOffline, and it is the difference
     between "VividCanvas broke" and "this customer's connection dropped". The
     portal reads it to pick the counter and the subject line, so it must reach
     the payload verbatim rather than being inferred server-side from an
     ambiguous probe result. */
  /* dd3c-bfc: a warning measured across a frozen (back/forward-cached) interval waits until the page has been live for 20 s */
  function mountBeacon(final,probe,offline){
    try{ if(window.__vvIntentNav){ vvInc.mark('beacon-skipped-intent-nav',{phase:beaconPhase}); return; } }catch(e){}   // dd3f: our own navigation, not a failure
    try{ var rs=window.__vvRestore; if(rs&&!final&&Date.now()-rs.at<20000){
      if(!rs.pending){ rs.pending=[probe,offline,beaconPhase]; try{ vvInc.mark('beacon-deferred-after-restore'); }catch(e){}
        setTimeout(function(){ var p=rs.pending; if(!p)return; rs.pending=null; var bp=beaconPhase; beaconPhase=p[2]; mountBeacon0(false,p[0],p[1]); beaconPhase=bp; },20500-(Date.now()-rs.at)); }
      return; } }catch(e){}
    return mountBeacon0(final,probe,offline);
  }
  try{ addEventListener('pagehide',function(){ try{ var rs=window.__vvRestore,p=rs&&rs.pending; if(p){ rs.pending=null; var bp=beaconPhase; beaconPhase=p[2]; mountBeacon0(false,p[0],p[1]); beaconPhase=bp; } }catch(e){} },{capture:true}); }catch(e){}
  function mountBeacon0(final,probe,offline){
    try{
      var _cn={}; try{ var c=navigator.connection||{};
        _cn={et:c.effectiveType||'',dl:c.downlink||0,rtt:c.rtt||0,sd:!!c.saveData}; }catch(e){}
      var _tokHit=false; try{ _tokHit=(typeof tokScan==='function')&&tokScan(); }catch(e){}
      var _incSnap=null; try{ _incSnap=vvInc.snapshot(); }catch(e){}
      var payload=JSON.stringify({ts:new Date().toISOString(),url:location.href.slice(0,300),
        inc:_incSnap,kind:(_incSnap&&_incSnap.kind)||'REAL_CUSTOMER',
        retry:{mountMax:mountTry.max,mountRetries:mountTry.n,applyKicks:(function(){try{return (typeof ccKick!=='undefined'&&ccKick)?ccKick.tries:0;}catch(e){return 0;}})(),
               applyPolicy:'compile kick every 1.2s x6 then every 5s; warn at 45s; give up at 300s',
               applyAgeMs:(function(){try{return (ccKick&&ccKick.t0)?(Date.now()-ccKick.t0):0;}catch(e){return 0;}})(),
               applyConfirmed:(function(){try{return !!(ccKick&&ccKick.telConfirmed);}catch(e){return false;}})(),
               applyDead:(function(){try{return !!(ccKick&&ccKick.dead);}catch(e){return false;}})()},
        productId:PRODUCT_ID,handle:window.__VVCC.HANDLE,variant:String(vid()),
        entry:(EDIT.proj?'edit-from-cart':(BROWSE_MODE?'gallery':'direct')),vvproj:EDIT.proj||'',
        phase:beaconPhase,
        attempts:mountTry.n,designApplyAttempts:(function(){try{return (typeof ccKick!=='undefined'&&ccKick)?ccKick.tries:0;}catch(e){return 0;}})(),stages:mountTry.stages.slice(0,24),
        uid:(function(){try{return guestId();}catch(e){return '?';}})(),
        conn:_cn,tokTextSeen:_tokHit,probe:probe||null,
        ua:navigator.userAgent.slice(0,180),vp:innerWidth+'x'+innerHeight,final:!!final,
        offline:!!offline});
      var blob=new Blob([payload],{type:'text/plain'});   // safelisted: no preflight for sendBeacon
      if(!(navigator.sendBeacon&&navigator.sendBeacon(PORTAL+'/api/cc-mount-failure',blob)))
        fetch(PORTAL+'/api/cc-mount-failure',{method:'POST',body:payload,keepalive:true,
          headers:{'Content-Type':'text/plain'}}).catch(function(){});
    }catch(e){}
  }
  /* 23-Aug — THE FINISH FAILURES WERE SILENT, which is why three reports of
     "it shows processing but fails" produced no diagnostics at all. mountBeacon
     with phase 'finish' only ever fired at the 180s hard cap; every showState
     'error' path below it returned without telling anyone. The customer saw a
     sentence and we saw nothing.
     Same lesson as the design-apply bug earlier today: a failure that does not
     report is a failure you get told about three times and cannot fix. Every
     finish error now beacons, and the last one is printed on the diag panel so
     it can be read straight off the phone. */
  function finishFail(where, err){
    var msg = String((err && (err.message || err)) || where || 'unknown').slice(0, 200);
    try { window.__vvFinishErr = where + ': ' + msg; } catch(e){}
    try {
      beaconPhase = 'finish';
      mountStage('finish-error:' + where + ':' + msg.slice(0, 80));
      try { galBeat('cc-finish', { stage: 'finish-error', where: String(where || '').slice(0, 40) }); } catch (e2) {}   // rc4.2.6
      mountBeacon(true);
      beaconPhase = 'mount';
    } catch(e){}
  }
  /* ==========================================================================
     MOUNT PROGRESS — 26-Aug.

     Measured this day, one editor open pulls 74 files from four Customer's Canvas
     hosts. Wire time: ~2.8s aurigma apps + 1.9s CC hub + 0.7s their CDN, against
     0.8s of ours. It is their SPA booting, not a server of ours waking up - the
     portal has min_machines_running=2, auto_stop off, and a token mint measured
     at a flat 0.5s warm or idle. So the seconds are not ours to remove.

     What IS ours is what the customer sees while it happens. The panel said
     "This takes a few seconds" over a bare spinner, on a boot the bug board
     records at 25-30s cold. Promising a few seconds and taking thirty is worse
     than saying nothing: they decide it has hung and leave. Eight people finished
     designs on 25 Aug and none of them bought.

     So the bar is driven by the real stages, the copy escalates honestly as the
     wait grows, and it never quotes a number we cannot keep. It also creeps on a
     timer between stages, because a bar that sits still reads as a crash.
     ========================================================================== */
  /* 3-Sep-2026 — 'editor-loaded' IS NOT 'Ready'.
     Measured across 40 throttled mounts (Pixel 7/3G, iPhone 13/4G, 4-6x CPU):
     the SDK resolves loadEditor and fires editor-loaded, and the wizard then
     takes a FURTHER 10-60s to paint. So the bar reached 100% and the step
     froze on the word "Ready" while the customer sat in front of a studio
     that had not opened — that is the screenshot the owner was sent on 3 Sep:
     a full red bar, the word "Ready", and nothing behind it. Promising
     "Ready" and delivering nothing is the same broken promise the panel copy
     above exists to stop making.
     'Ready' and 100% now belong to 'wizard-up', emitted only once au-wizard
     is actually in the DOM. */
  var MOUNT_PCT={ 'pw-sdk':22, 'pw-token':38, 'pw-sf':48, 'pw-integration':64,
                  'prewarmed':70, 'editor-loaded':92, 'wizard-up':100 };
  var MOUNT_STEP={ 'pw-sdk':'Loading the design tools\u2026', 'pw-token':'Signing you in\u2026',
                   'pw-sf':'Connecting to the design studio\u2026', 'pw-integration':'Fetching your product setup\u2026',
                   'prewarmed':'Almost ready\u2026', 'editor-loaded':'Opening the editor\u2026',
                   'wizard-up':'Ready' };
  /* 3-Sep-2026 (owner: "show in loader your connection is slow loading will
     take 50-80 second ... so user is aware that its due to his slow
     connection"). A silent spinner reads as a crash; a number the customer
     can wait out does not. 50-80s is not a guess — it is the measured
     wizard-paint window on the throttled profiles: the fastest of those
     mounts painted at 29s, the slowest at 78s. navigator.connection is
     Chromium-only (absent on iOS Safari), so it SHARPENS the wording when
     present and is never required for the message to appear. The live
     seconds counter is deliberate: a number that moves is the customer's
     proof the page has not frozen. */
  function slowNetLine(el){
    var et='';
    try{ var c=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
         if(c&&c.effectiveType)et=String(c.effectiveType); }catch(e){}
    var named=(et==='slow-2g'||et==='2g'||et==='3g');
    return (named ? 'Your connection is on '+et.toUpperCase()+' right now, so this is slow. '
                  : 'Your connection is slow right now. ')
         + 'The design studio needs about 50-80 seconds on a link like this. '
         + 'Keep this open — it is still loading ('+el+'s).';
  }
  var _mp={pct:0, t0:0, iv:null};
  function mountProgress(st){
    try{
      /* Whichever waiting panel is actually up. The gallery flow uses #vvbr-wait,
         the direct-open flow uses #vvcc-loading, and instrumenting only one of
         them is how this change nearly shipped doing nothing. */
      var bar=document.getElementById('vvbr-wait-bar')||document.getElementById('vvcc-load-bar');
      if(!bar) return;                                   // no panel up: no-op, never throw
      if(!_mp.t0){
        _mp.t0=Date.now();
        /* Creep between stages so the bar is never still, but never past 95 -
           arriving at 100 before the editor exists would be a second broken
           promise, and this whole change exists because of the first one. */
        _mp.iv=setInterval(function(){
          try{
            var el=Math.round((Date.now()-_mp.t0)/1000);
            /* Re-find every tick. #vvbr-wait is created dynamically and can appear
               AFTER the first stage fires, so a bar captured once would be stale. */
            var b2=document.getElementById('vvbr-wait-bar')||document.getElementById('vvcc-load-bar');
            if(_mp.pct<95){ _mp.pct=Math.min(95,_mp.pct+0.6); if(b2)b2.style.width=_mp.pct.toFixed(1)+'%'; }
            var h=document.getElementById('vvcc-load-h'), p=document.getElementById('vvcc-load-p');
            var bt=document.getElementById('vvbr-wait-t');
            /* Past ~26s this is NOT a normal first load, and saying "nearly
               there" for another minute is the lie that loses the customer.
               Name the cause and give the honest window instead. */
            if(el>26){ var _sl=slowNetLine(el);
                       if(h)h.textContent='Slow connection \u2014 still loading';
                       if(p)p.textContent=_sl;
                       if(bt)bt.textContent='Slow connection \u2014 still loading ('+el+'s)'; }
            else if(el>22){ if(h)h.textContent='Still working \u2014 nearly there';
                       if(p)p.textContent='The first load is the slow one. It opens instantly next time.';
                       if(bt)bt.textContent='Still working \u2014 nearly there'; }
            else if(el>10){ if(h)h.textContent='Opening your design studio';
                            if(p)p.textContent='Loading the design tools \u2014 this is a big one.';
                            if(bt)bt.textContent='Loading the design tools\u2026'; }
          }catch(e){}
        }, 500);
      }
      var pct=MOUNT_PCT[st];
      if(pct!=null && pct>_mp.pct){ _mp.pct=pct; bar.style.width=pct+'%'; }
      var stepEl=document.getElementById('vvbr-wait-step')||document.getElementById('vvcc-load-step');
      if(stepEl && MOUNT_STEP[st]) stepEl.textContent=MOUNT_STEP[st];
      if(st==='wizard-up'){ if(_mp.iv){clearInterval(_mp.iv);_mp.iv=null;} _mp.t0=0; _mp.pct=0; }
    }catch(e){}
  }
  var _vvEverMounted=false;
  function vvRelaunchReload(auto){ try{
      if(auto){ if(vvModernEntry()) return false;   // gallery entries already used their 2 automatic reloads (vvModernRetry)
        var n=parseInt(sessionStorage.getItem('vvRelaunchN')||'0',10)||0; if(n>=2) return false; sessionStorage.setItem('vvRelaunchN',String(n+1)); }
      var q=new URLSearchParams(location.search); if(!vvModernEntry()&&q.get('vvcc')!=='1') q.set('vvcc','1');
      try{ window.__vvNoNav=1; window.__vvIntentNav='relaunch-reload'; }catch(e){}
      try{ vvInc.mark('mount:relaunch-reload',{auto:auto?1:0}); }catch(e){}
      location.replace(location.pathname+'?'+q.toString()+location.hash); return true; }catch(e){ return false; } }
  function mountStage(st){
    if(st==='wizard-up'||st==='editor-loaded') _vvEverMounted=true;
    try{ vvGeomLoad(); }catch(e){}
    try{ mountTry.stages.push(mountTry.n+':'+st+'@'+(performance.now()/1000).toFixed(1)+'s'); }catch(e){}
    try{ vvInc.mark('mount:'+st,{attempt:mountTry.n}); }catch(e){}
    mountProgress(st);
  }
  var _mountPagehideArmed=false;
  /* 26-Aug — WHEN A RETRY IS THE WRONG ANSWER.
     One real customer, 07:01Z, arriving on a Google Ads click. Desktop Chrome,
     and the browser itself reported 4g / 10Mbps / 50ms rtt when the page
     loaded. Their trail:
         editor-loaded@39.6s                  the studio DID open for them
         cover-stall-67s-netidle-15s@108.1s   then the cover sat for 67 seconds
         3 relaunches, each: prewarm-start -> pw-sdk -> loadEditor-error:
           "signal timed out", exactly 8.0s apart
         chain probe: portal=ERR  cchub=ERR  sdkcdn=ERR
     Our portal was healthy throughout — /healthz answered 200 in 20-75ms for
     everyone else in that minute. Three unrelated hosts on three different
     clouds do not fail together. What failed was THAT BROWSER's ability to
     reach anything: a dropped wifi, a slept laptop, a VPN flap.
     What we did about it was worse than nothing. We tore down an editor that
     had already loaded, spent 24 further seconds relaunching it into a dead
     network, and then sent the owner an alert whose subject said VividCanvas
     failed to load — indistinguishable from a real outage.
     So: before spending a retry, find out whether the customer can reach
     ANYTHING. One 2.5s call to our own /healthz answers it. If they cannot,
     stop, tell them the truth, and label the beacon so it lands in the
     connection-dropped bucket instead of counting against the editor. */
  var NET_PROBE_MS=2500;          // the customer is waiting: keep the DECISION fast
  var NET_CONFIRM_MS=8000;        // the customer is done waiting: take time to be RIGHT
  var _netAlive={at:0,p:null,why:''};
  function netAlive(){
    /* onLine===false is trustworthy; onLine===true is not (it only means an
       interface exists), so a true still has to be proven with a request. */
    try{ if(navigator.onLine===false) return Promise.resolve(false); }catch(e){}
    if(_netAlive.p&&(Date.now()-_netAlive.at)<10000) return _netAlive.p;
    _netAlive.at=Date.now();
    /* NOT /healthz. It answers 200 to a server, but it sends no
       Access-Control-Allow-Origin, so a fetch from www.vividads.com.au is
       blocked by the browser and the promise rejects — which this function
       would read as "the customer is offline". Caught before shipping by
       calling __vvCCNetAlive() on a page where everything was working: it
       returned false. Left unfixed it would have inverted the whole feature,
       classifying EVERY mount failure as a dropped connection and disabling
       the retries that currently rescue most of them.
       /api/cc-token/health is CORS-enabled and is the more useful probe anyway:
       if it answers, the mint path the editor depends on is alive too. */
    /* 27-Aug: .catch(()=>false) collapsed four different answers into one —
       timed out, DNS failed, connection refused, blocked by CORS. Only the last
       three are evidence of a dead network. A TIMEOUT at 2.5s is evidence of a
       SLOW one, and this probe runs at the worst possible moment for it: the
       browser has just pulled ~74 files for the Aurigma editor and its
       connection pool is saturated. One alert this morning had
       editor-loaded@418.6s — seven minutes — and a link that slow will blow a
       2.5s budget whether or not anything is broken. Record which it was. */
    var _t0=Date.now();
    /* 1-Sep-2026 — A FAILED PROBE IS NOT EVIDENCE OF A DEAD NETWORK.
       This .catch used to `return false`, i.e. "the customer is offline", and
       that verdict does two things: it shows "Your internet connection dropped"
       and it CANCELS the retries that rescue most mount failures.

       It was firing on every failure, for everyone, because the endpoint it
       probes does not exist in production. /api/cc-token/health is in
       origin/staging at portal/server.js:3674, but the deployed app is a
       3,249-line server.js (the repo's is 7,700+) built from a rollback
       snapshot whose own SNAPSHOT-README says "Do not deploy from it". The
       route therefore falls through to the storefront catch-all, which answers
       200 with index.html and NO Access-Control-Allow-Origin — so the browser
       blocks the response and this fetch rejects. Measured 1-Sep:
           /api/design-preview/...  200 image/jpeg  + ACAO   <- fine
           /api/cc-token/health     200 text/html   + no ACAO <- blocked
       Confirmed on the box: grep -c api/cc-token/health /app/server.js -> 0.

       This is the exact trap the comment above already warns about for
       /healthz ("would invert the whole feature"). Moving the probe to
       /api/cc-token/health did not escape it, because that route never shipped.

       So: only navigator.onLine===false (handled above) is trusted as proof of
       an offline customer. Anything else — timeout, DNS, refused, CORS-blocked
       — is INCONCLUSIVE and must return true, which restores the retries and
       stops us telling a customer on a working connection that their internet
       dropped. SA Police spent days on that message across two computers and
       two networks while the fault was ours.

       Cost, accepted deliberately: a genuinely dead connection now spends its
       retries before showing a panel, instead of being told immediately. That
       is how it behaved before the offline feature existed, and a wrong
       accusation is worse than a slow one. `why` is still measured and still
       beaconed, so the alerts keep showing exactly what was observed.

       REVERT THIS once production actually serves /api/cc-token/health with
       CORS — verify with:
         curl -sD- -o/dev/null -H 'Origin: https://www.vividads.com.au' \
           https://portal.vividads.com.au/api/cc-token/health | \
           grep -i 'content-type\|access-control-allow-origin'
       expected: application/json + access-control-allow-origin. */
    _netAlive.p=fetch(PORTAL+'/api/cc-token/health',{cache:'no-store',signal:_abortIn(NET_PROBE_MS)})
      .then(function(r){ _netAlive.why=r.ok?'ok':('http-'+r.status); return !!r.ok; })
      .catch(function(e){
        var ms=Date.now()-_t0;
        var ab=(e&&(e.name==='AbortError'||/abort/i.test(String(e&&e.message||''))));
        _netAlive.why='inconclusive:'+(ab?'timed-out-after-':'network-error-after-')+ms+'ms'+
                      (ab?'':' ('+String((e&&e.message)||e).slice(0,60)+')');
        return true;   /* NOT false — see the block comment above */
      });
    return _netAlive.p;
  }
  /* Exposed so the decision can be exercised from outside instead of argued
     about. The only way to reach mountOffline organically is a 67s cover stall
     on a dead connection, which is not a thing a test can wait for. */
  try{ window.__vvCCNetAlive=function(){ _netAlive.at=0; _netAlive.p=null; return netAlive(); }; }catch(e){}
  function mountOffline(stage){
    mountStage('offline-abort:'+stage);
    stopMonitor(); coverOff();
    showState('error',
      'Your internet connection dropped while the design studio was loading, so we stopped ' +
      'trying. Check your connection and open the designer again — nothing has been lost.',
      'Your connection dropped');
    /* Beacon anyway. It usually gets through, because a flapping connection is
       normally back by the time this runs — the 07:01Z probe failed on all
       three hosts and the beacon that carried that result posted successfully
       0.4s later. The offline flag is what keeps it out of the editor's
       failure count.

       27-Aug — WHAT THIS USED TO SEND, AND WHY IT WAS WRONG.
       The second line was the literal string
           'portal /api/cc-token/health unreachable from this browser'
       — hardcoded, never measured at this moment, and printed in the alert
       under a heading that says "Chain probe (run from the customer's own
       connection)". So the email asserted a specific technical fact it had not
       checked, and then told the owner to ignore it. That is the same defect
       this system has been caught for four times already, just pointed at a
       different reader: a message that reassures.
       It also skipped chainProbe() entirely — the one thing here that DOES ask
       all three hosts and report what each said.

       Now: the customer already has their panel, so there is nothing left to
       rush. Ask again with a budget that is honest about a slow link, and ask
       all three hosts. If the confirmation SUCCEEDS, the fast probe was a false
       alarm and the alert must say so at the top, because that is the only way
       we ever find out this threshold is too tight. */
    try{
      var lines=['navigator.onLine='+(function(){try{return String(navigator.onLine);}catch(e){return '?';}})(),
                 'fast probe ('+NET_PROBE_MS+'ms budget): '+(_netAlive.why||'no result recorded')];
      var t1=Date.now();
      fetch(PORTAL+'/api/cc-token/health',{cache:'no-store',signal:_abortIn(NET_CONFIRM_MS)})
        .then(function(r){ return r.ok; },function(){ return false; })
        .then(function(alive2){
          var ms=Date.now()-t1;
          lines.push('confirm probe ('+NET_CONFIRM_MS+'ms budget): '+(alive2?('ANSWERED in '+ms+'ms'):('no answer in '+ms+'ms')));
          if(alive2) lines.unshift('*** NOT PROVEN: the portal DID answer on the second ask, so this '+
                                   'customer was SLOW, not disconnected. Do not read the subject line as fact.');
          return chainProbe();
        },function(){ return chainProbe(); })
        .then(function(p){ mountBeacon(true,lines.concat(p||[]),true); },
              function(){ mountBeacon(true,lines,true); });
    }catch(e){ try{ mountBeacon(true,null,true); }catch(_){} }
  }
  /* 28-Aug — A PROVEN-ALIVE NETWORK MUST NOT BE ABORTED AS DEAD.
     Second occurrence of the same pattern in two days (27-Aug 06:26Z
     loose-table-cloths-throws, 28-Aug 01:28Z media-wall, iPhone Safari), and
     this time the whole trail was in the portal log:
         stages: pw-sdk@75.7s ... no-wizard-18s@94.6s
                 offline-abort:no-wizard-18s@97.1s,  attempts: 0
         fast probe (2500ms budget): timed-out-after-2505ms
         confirm probe (8000ms budget): ANSWERED in 959ms
     Read that again: the customer had THREE retries budgeted and got NONE,
     because the 2.5s fast probe timed out on a link so slow the page took 75
     seconds to fetch the SDK — and 2.5 seconds later our own diagnostics
     proved the portal reachable in under a second from that same phone. The
     netAlive() comment above already names the mechanism (the probe runs
     right after ~74 editor files have saturated the connection pool) and
     already concedes that a timeout is evidence of a SLOW network, not a dead
     one. But the 27-Aug change only made the ALERT honest; the DECISION still
     treated slow as dead, tore everything down, and told a customer with a
     working connection "Your connection dropped".
     So: when the fast probe says dead AND retries remain, spend the confirm
     probe (same 8s budget mountOffline already uses for diagnostics) BEFORE
     aborting, not after. If it answers, this is the slow-not-dead case: put
     the retry budget back to work exactly as if the fast probe had passed,
     and mark the stage 'slow-net-retry:<ms>' so the beacons measure how often
     this rescue fires and how long the confirm took. If it does not answer,
     mountOffline runs as before and its own second confirm probe still gives
     the alert an honest "asked twice, no answer both times".
     BOUNDED, twice over: (1) every rescue funnels into mountRetry(), which is
     gated by mountTry.n<mountTry.max — the rescue never grants attempts the
     fast-probe-passing path would not have had; (2) an explicit belt-and-
     braces cap of mountTry.max rescues per page, so no future refactor of the
     retry gate can turn this into a loop.
     Cost to the GENUINELY dead network: the offline panel arrives up to 8s
     later (usually far less — a dead interface rejects in milliseconds; only
     a silent-drop wifi burns the full budget). That is the right trade: the
     8s is paid once, by someone already 90+ seconds into a failed mount,
     while the thing it buys back is not ending a live customer's session.
     navigator.onLine===false still short-circuits straight to the abort —
     that signal is trustworthy (see netAlive) and needs no second opinion. */
  var _slowNetRescues=0;
  function slowNetRescue(stage){
    try{ if(navigator.onLine===false){ mountOffline(stage); return; } }catch(e){}
    if(_slowNetRescues>=mountTry.max){ mountOffline(stage); return; }
    var t0=Date.now(), done=false;
    var settle=function(alive){
      if(done)return; done=true;
      if(alive){
        _slowNetRescues++;
        mountStage('slow-net-retry:'+(Date.now()-t0)+'ms');
        mountRetry();
      } else {
        mountOffline(stage);
      }
    };
    try{
      fetch(PORTAL+'/api/cc-token/health',{cache:'no-store',signal:_abortIn(NET_CONFIRM_MS)})
        .then(function(r){ settle(!!r.ok); },function(){ settle(false); });
    }catch(e){ settle(false); }
  }
  function mountFail(stage){
    mountStage(stage);
    if(!_mountPagehideArmed){ _mountPagehideArmed=true;
      addEventListener('pagehide',function(){
        if(mountTry.n>0&&!booted&&!modal.hasAttribute('hidden')) mountBeacon(false);
      });
    }
    if(mountTry.n<mountTry.max){
      netAlive().then(function(alive){
        if(!alive){ slowNetRescue(stage); return; }   // 28-Aug: confirm before abandoning (see above)
        mountRetry();
      },function(){ mountRetry(); });   // the check itself must never block a retry
      return;
    }
    /* Exhausted -> tell the team, but ask the customer's own network first so the
       alert says whose fault it is. The panel goes up immediately either way;
       only the beacon waits, and only for as long as the probe's own 4s cap. */
    showState('timeout');       // the busy panel
    try{ chainProbe().then(function(p){ mountBeacon(true,p); },
                           function(){ mountBeacon(true,null); }); }
    catch(e){ mountBeacon(true,null); }
  }
  function mountRetry(){
    {
      /* 3-Sep-2026 — NEVER RELAUNCH ON TOP OF A LOAD THAT IS STILL RUNNING.
         runLaunch() empties `box` and re-enters sf.loadEditor(). Doing that
         while the previous loadEditor has not settled rips the container out
         from under Aurigma mid-build. The deadline change above is the primary
         fix for that; this is the belt-and-braces one for the case where the
         SDK really is still inside loadEditor when some other path calls
         mountFail. Bounded at 90s so a promise that never settles cannot
         wedge the retry ladder forever. */
      if(_loadInFlight){
        if(!mountRetry._dt)mountRetry._dt=Date.now();
        if(Date.now()-mountRetry._dt<90000){
          if(!mountRetry._said){ mountRetry._said=true;
            try{ mountStage('retry-deferred:load-in-flight'); }catch(e){} }
          if(!browseUsable())showState('loading');
          setTimeout(mountRetry,1000); return;
        }
      }
      mountRetry._dt=0; mountRetry._said=false;
      mountTry.n++;
      // 19-Aug: drop cached sf+token so each retry mints fresh (fixes Invalid-security-token loop)
      try{ if(window.__vvCCPreReset)window.__vvCCPreReset(); if(window.__vvCCTokReset)window.__vvCCTokReset(); }catch(e){}
      var h=STATES.loading.querySelector('.vvcc-h');
      if(h)h.textContent='Still loading \u2014 retrying ('+mountTry.n+'/'+mountTry.max+')\u2026';
      /* same rule on the retry: never cover a gallery the customer can use */
      if(!browseUsable())showState('loading');
      /* Release-hardening (2026-10-06) — Invariant 3: an automatic relaunch on a gallery-origin entry re-enters
         the same way (page reload re-arms the blank/upload/style entry); bounded to 2 per session so a
         hard-down editor still reaches the honest error panel instead of reloading forever. */
      if(!VV_REC.loadCalled||mountRetry._stall||(performance.now()<75000)){ var _st=mountRetry._stall||VV_REC.loadCalled; mountRetry._stall=false; VV_REC.loadCalled=false; vvRecTell(_st?'editor':'premount',_st?'relaunch-in-page':'retry-in-page',{n:mountTry.n}); setTimeout(function(){ booted=false; runLaunch(); },600*mountTry.n); return; }
      try{ if(vvModernEntry()){ var _rk='vvModernRetry', _rn=parseInt(sessionStorage.getItem(_rk)||'0',10)||0;
        if(_rn<2){ sessionStorage.setItem(_rk,String(_rn+1)); setTimeout(function(){ location.reload(); },1200*mountTry.n); return; } } }catch(e){}
      if(_vvEverMounted){   // dd3n: an in-page relaunch leaks the previous UI-framework instance — reload instead, or stop honestly
        if(vvRelaunchReload(true)) return;
        try{ showState('error','The design studio couldn\u2019t restart cleanly, so we\u2019ve stopped here \u2014 nothing has been added to your cart. Tap Try again to reload the page; your product is kept.','The design studio couldn\u2019t load'); }catch(e){}
        return; }
      setTimeout(function(){ booted=false; runLaunch(); },1200*mountTry.n);  // backoff
      return;
    }
  }

  // MEMOISED — must stay that way. Two callers race for this: the idle warmer at PDP load and
  // prewarm() on the click. Un-memoised, a click landing inside the ~0.9-1.5s cold fetch window
  // started a SECOND fetch+eval of the 147KB UMD bundle, re-defining window.Aurigma underneath
  // the instance the first caller was already building.
  var _lib=null;
  function lib(){
    if(window.Aurigma&&window.Aurigma.StorefrontJS)return Promise.resolve();
    if(_lib)return _lib;
    /* 26-Aug SPEED — WHY THE CDN AND NOT THE BLOB STORE.
       The same 1.2.16 bundle sits behind both of Aurigma's hosts, and only one
       of them compresses it:
         staticjs.blob.core.windows.net   150,720 B, NO content-encoding, and it
                                          ignores Accept-Encoding entirely
         staticjs-aurigma.azureedge.net    21,234 B, content-encoding: br
       Decompressed they are byte-identical (md5 b105872ba3cc4b96d1d04576aa6dcd0c
       from both, checked 26-Aug). So every visitor was pulling 150KB of
       uncompressed JavaScript on the warm path to get 21KB of bundle — the
       single largest thing we make a phone download before it can design.
       Both hosts send Cache-Control: no-cache, so this is not a first-visit
       cost, it is paid on EVERY page view that warms the SDK.
       The blob URL stays as the fallback, tried only if the CDN fails: an edge
       outage or a corporate proxy that blocks azureedge must not stop the
       editor booting, and 150KB slow beats not working. */
    /* 11-Sep — SDK PINNED VERSION, UNDER TEST.
       Saved projects stopped loading. Aurigma's storage client now hands the
       project payload back as an ArrayBuffer and their own code does
           const n = await t.data.text();  return JSON.parse(n)
       so every restore dies on
           Unexpected token 'o', "[object ArrayBuffer]" is not valid JSON
       Reproduced on a cart line created minutes earlier, correct identity, the
       project listed by getAllProjects() in 36ms. It breaks BOTH "Change
       artwork" from the cart and My Designs, because both go through
       savedProjectsManager.loadProject.

       Nothing on our side changed: this file pins the version, and the code
       comments record a working 36-second restore on 31-Aug.

       TESTED 11-Sep AND RULED OUT. The CDN offers 1.2.17, 1.2.18 and 1.2.19
       (1.2.20 does not exist). 1.2.19 was pushed to the dev theme and loaded -
       confirmed by the resource URL - and threw the IDENTICAL error on the
       identical project. So the newest build Aurigma publish does not fix it
       and the pinned version is not the cause. Reverted to 1.2.16 rather than
       leave a dependency changed for no benefit.

       This needs Aurigma. The fix on their side is one line: decode the
       ArrayBuffer (TextDecoder) instead of stringifying it. Intercepting it
       ourselves is not possible either - the throw happens inside
       client.getFile, below the service, before any bytes we can reach. */
    var SDK_PATH='/back-office/storefront/1.2.16/storefront.main.js';
    var SDK_URL='https://staticjs-aurigma.azureedge.net'+SDK_PATH;
    var SDK_FALLBACK='https://staticjs.blob.core.windows.net'+SDK_PATH;
    /* 26-Aug: this used to be .then(r=>r.text()).then(c=>eval(c)) with NO check on
       r.ok and no look at what came back. Anything that answers that URL with a
       page instead of the bundle — a captive portal, a corporate proxy, a CDN
       error page, an Azure outage — got eval'd as JavaScript, and the error a
       customer's beacon then carried was whatever the parser happened to say
       about someone else's HTML. Check it, and name the URL when it is wrong,
       because the whole cost of these failures is not knowing where they came
       from. */
    /* 30-Sep PERF: the CDN serves this 150 KB bundle with cache-control: no-cache, so
       every launch re-fetched it — measured 1.3–1.6 s on the critical path, warm or
       cold. The path pins the version (1.2.16), so the text is immutable: keep it in
       localStorage under that path and eval it at once on the next launch. A bad or
       missing entry falls through to the network exactly as before. */
    var SDK_LS='vv_cc_sdk:'+SDK_PATH;
    function bundleCached(){
      try{ var c=localStorage.getItem(SDK_LS); if(c&&c.length>100000&&!/^\s*</.test(c)) return c; }catch(e){}
      return null;
    }
    function bundleRemember(c){ try{ if(c&&c.length>100000) localStorage.setItem(SDK_LS,c); }catch(e){} }
    function bundle(url){
      return fetch(url).then(function(r){
        if(!r.ok) throw new Error('cc-sdk-bundle HTTP '+r.status+' from '+url);
        var ct=(r.headers.get('content-type')||'');
        return r.text().then(function(c){
          if(/^\s*(<!doctype|<html|<\?xml)/i.test(c))
            throw new Error('cc-sdk-bundle returned a PAGE not JavaScript ('+r.status+' '+ct+') from '+url+' :: '+c.slice(0,80).replace(/\s+/g,' '));
          return c;
        });
      });
    }
    var _cachedSdk=bundleCached();
    _lib=(_cachedSdk?Promise.resolve(_cachedSdk):bundle(SDK_URL).then(function(c){ bundleRemember(c); return c; }))
      .catch(function(err){
        /* Name BOTH hosts in the eventual beacon if the fallback fails too,
           otherwise a report says "blob store failed" and hides that the CDN
           was the thing that actually broke. */
        try{ mountStage('pw-sdk-cdn-fail'); }catch(e){}
        return bundle(SDK_FALLBACK).catch(function(err2){
          throw new Error('cc-sdk-bundle BOTH hosts failed :: cdn: '+
            (err&&err.message||err)+' :: blob: '+(err2&&err2.message||err2));
        });
      })
      .then(function(c){(0,eval)(c);});
    _lib.catch(function(){_lib=null;}); // a failed load must not poison later attempts
    return _lib;
  }
  // ---- lazyJs script guard (UPDATE 13) — THE intermittent-hang fix ---------------------------
  // The theme's speed optimiser monkey-patches Node.prototype.appendChild / insertBefore and
  // stamps type="lazyJs" on injected <script> elements (89 scripts on a PDP carry it). A script
  // inserted with an unknown type is inert FOREVER — it never fetches, never runs, and fires
  // neither onload nor onerror; resetting .type afterwards cannot revive it.
  //
  // sf.loadEditor() injects Aurigma's UI Framework <script>. When the optimiser neuters it the
  // UIF never boots, so loadEditor NEVER resolves and never rejects: no au-wizard, empty
  // container, and our 18s no-mount timeout shows "This is taking longer than usual".
  // MEASURED: appendChild/insertBefore report as non-native, and a probe script pointed at
  // staticjs-aurigma.azureedge.net came back type="lazyJs" immediately after append with no
  // load/error event ever firing. It is intermittent because once the UIF is loaded in a
  // pageview nothing is injected again — which is exactly why "Try again" usually worked, and
  // why a second launch in the same tab looked fine. This is the same lazyJs swallow logged
  // against the coder's theme in UPDATE 3; it turns out to affect ours too, via loadEditor.
  //
  // Fix: for Aurigma/CC scripts ONLY, insert with a pristine native appendChild/insertBefore
  // borrowed from a blank same-origin iframe, bypassing the optimiser's wrapper so the type is
  // never rewritten. Every other node on the page still goes through the optimiser untouched.
  var _nat=(function(){
    try{
      var f=document.createElement('iframe');
      f.setAttribute('aria-hidden','true');
      f.style.cssText='position:absolute;width:0;height:0;border:0;visibility:hidden';
      (document.body||document.documentElement).appendChild(f);
      var N=f.contentWindow.Node.prototype;
      var r={append:N.appendChild, insert:N.insertBefore};
      f.parentNode.removeChild(f);          // functions stay callable after the frame goes
      return r;
    }catch(e){ return null; }
  })();
  // Matches BOTH shapes loadEditor uses. Measured on a live launch: it appends exactly two
  // scripts, and neither has a src — they are tiny INLINE `type="module"` scripts (149 and 168
  // chars) that `import` the UI Framework from staticjs-aurigma. Those are what the optimiser
  // was rewriting to lazyJs, so a src-only guard did nothing. Match inline text as well.
  var CC_SCRIPT=/aurigma|customerscanvashub|staticjs\.blob\.core\.windows\.net|\/uif\//i;
  // While the editor is mounting we bypass the optimiser for EVERY injected script, not just the
  // ones we can pattern-match. Reason, measured: matching on src alone fixed nothing (loadEditor's
  // two scripts are inline `type="module"` imports); matching those as well got the UIF bundle
  // downloading (9 files, all 200) but it still never booted, because Polymer's HTML-import path
  // (`themes/au-default-theme.html` + `webcomponents-loader.js`) injects a further generation of
  // scripts that carry no Aurigma marker at all. Enumerating Aurigma's injection shapes is
  // whack-a-mole; scoping by TIME is not. The window only ever opens when the customer clicks
  // Design, closes as soon as the wizard mounts (or after CC_GUARD_MAX_MS), and the only effect
  // on anything else caught in it is that the script runs immediately instead of being deferred.
  var CC_GUARD_MAX_MS=60000;

  /* ---- describeMountErr (3-Sep-2026) — NAME THE THING THAT FAILED --------------------------
     `loadEditor-error: [object Event]` was the LARGEST failure bucket in the beacons — 28 of 63
     real customer failures, 13 Aug - 2 Sep — and it told us nothing at all. Cause: the old line
     was String(err&&err.message||err). An Event has no .message, so String(err) yields the
     literal "[object Event]" and the one useful field, the thing that failed, was thrown away.

     ⚠ WHY THIS DOES NOT JUST READ err.target.src. Per the measurement in the lazyJs comment
     above, loadEditor appends TWO INLINE `type="module"` scripts and NEITHER HAS A src — they
     `import` the UI Framework. A failed module import therefore has no src to report, and an
     src-only capture would have printed "loadEditor-error: script" and looked instrumented
     while telling us nothing. So take four independent shots at naming it:

       1. .src            classic <script src> failures
       2. .outerHTML      INLINE module scripts — the import statement carries the URL
       3. .tagName/.type  shape of the failure when neither of the above resolves
       4. resTail()       the last resource entries the browser completed, so we can see what
                          was in flight even when the Event names nothing

     Pure instrumentation: it runs only inside a catch that already fired, and returns a string.
     It cannot affect a mount that is working. */
  function resTail(n){
    try{
      var e=performance.getEntriesByType('resource')||[];
      return e.slice(-(n||4)).map(function(r){
        return (r.name||'').split('/').slice(-1)[0].slice(0,42)+'@'+Math.round(r.duration)+'ms';
      }).join(' ');
    }catch(e){ return ''; }
  }
  function describeMountErr(err){
    try{
      if(err&&err.message) return String(err.message).slice(0,120);
      var t=err&&err.target, bits=[];
      if(t){
        if(t.src) bits.push('src='+String(t.src).slice(-70));
        else if(t.outerHTML) bits.push('inline='+String(t.outerHTML).replace(/\s+/g,' ').slice(0,110));
        if(t.tagName) bits.push('<'+String(t.tagName).toLowerCase()+'>');
      }
      if(err&&err.type) bits.push('type='+err.type);
      if(!bits.length) bits.push(String(err).slice(0,60));
      var tail=resTail(4); if(tail) bits.push('last:'+tail);
      return bits.join(' ').slice(0,300);
    }catch(e){ return 'describe-failed:'+String(err).slice(0,60); }
  }
  var _guardAllUntil=0;
  function guardAllOn(){ _guardAllUntil=Date.now()+CC_GUARD_MAX_MS; }
  function guardAllOff(){ _guardAllUntil=0; }
  function isCCScript(n){
    try{
      if(!n||n.nodeType!==1||n.tagName!=='SCRIPT')return false;
      if(Date.now()<_guardAllUntil)return true;        // mounting: let every script run natively
      var src=n.src||n.getAttribute('src')||'';
      if(src)return CC_SCRIPT.test(src);
      var txt=n.textContent||'';
      return txt.length<4000 && CC_SCRIPT.test(txt);   // small loader shims only, never a big bundle
    }catch(e){ return false; }
  }
  // If something upstream already stamped lazyJs, restore a real type: an `import` statement only
  // works as a module, everything else runs as classic script.
  function unlazy(n){
    try{
      if(n.getAttribute('type')!=='lazyJs')return;
      if(/(^|[\s;{(])import[\s(]/.test(n.textContent||'')) n.setAttribute('type','module');
      else n.removeAttribute('type');
    }catch(e){}
  }
  function armScriptGuard(){
    if(!_nat)return;                                   // no pristine natives -> leave the page alone
    if(Node.prototype.appendChild.__vvGuard)return;     // ours is already outermost
    var ac=Node.prototype.appendChild, ib=Node.prototype.insertBefore;
    var A=function(n){
      if(isCCScript(n)){ unlazy(n); return _nat.append.call(this,n); }
      return ac.apply(this,arguments);
    };
    var I=function(n,ref){
      if(isCCScript(n)){ unlazy(n); return _nat.insert.call(this,n,ref||null); }
      return ib.apply(this,arguments);
    };
    A.__vvGuard=1; I.__vvGuard=1;
    Node.prototype.appendChild=A; Node.prototype.insertBefore=I;
  }
  armScriptGuard();

  /* 9-Sep-2026 SAVED DESIGNS: a save lives under the CC user it was made with.
     When a signed-in customer reopens a design they saved as a guest, the
     resume link carries that guest id (?vvuser=) and this session runs as it. */
  var VV_USER_OVERRIDE='';
  try{ if(CUSTOMER_ID&&window.__vvUserFallbackOn){ var _fb=sessionStorage.getItem('vvUserFallback'); if(_fb&&/^guest_[a-z0-9]{6,20}$/.test(_fb)&&!/[?&](vvstate|vvsaved|vvproj|vvline)=/.test(location.search)) VV_USER_OVERRIDE=_fb; } }catch(e){}   // dd3h: this session fell back to the device guest user
  (function(){ try{   // dd3h: watch the editor's init call
    function seen(u,status,body){ try{ if(status>=400&&/EditorInit\/RequestInitData/.test(u)) vvInitRejected(status,body); }catch(e){} }
    var of=window.fetch; if(of) window.fetch=function(i,o){ var u=(typeof i==='string')?i:((i&&i.url)||''); var p=of.apply(this,arguments);
      if(/EditorInit\/RequestInitData/.test(u)) p.then(function(r){ if(r&&r.status>=400){ try{ r.clone().text().then(function(t){ seen(u,r.status,t); },function(){ seen(u,r.status,''); }); }catch(e){ seen(u,r.status,''); } } },function(){}); return p; };
    var oo=XMLHttpRequest.prototype.open, os=XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open=function(m,u){ try{ this.__vvU=String(u||''); }catch(e){} return oo.apply(this,arguments); };
    XMLHttpRequest.prototype.send=function(){ var x=this; try{ if(/EditorInit\/RequestInitData/.test(x.__vvU||'')) x.addEventListener('loadend',function(){ var t=''; try{ t=String(x.responseText||''); }catch(e){} seen(x.__vvU,x.status,t); }); }catch(e){} return os.apply(this,arguments); };
  }catch(e){} })();
  function vvInitRejFast(){ try{
    if(vvDesignReady()||VV_RD.failed||anyStateOn()) return;   // the editor recovered, or a panel is already up
    VV_RD.failed=true; var r=window.__vvInitRej||{};
    vvRdTell('ready-fail',{ms:r.at?Date.now()-r.at:null,sid:'',surf:VV_RD.surf,why:'init-rejected',status:r.status||0});
    try{ sessionStorage.setItem('vvModernRetry','2'); }catch(e){}
    showState('error','We couldn’t start your design session just now, so your design can’t be opened. Nothing has been added to your cart. Please try again in a few minutes.','The design studio couldn’t start');
  }catch(e){} }
  function vvInitRejected(status,body){
    if(window.__vvInitRej) return; var why=String(body||'').replace(/\s+/g,' ').slice(0,80); window.__vvInitRej={status:status,why:why,at:Date.now()};
    var uid=''; try{ uid=guestId(); }catch(e){} var who=/^shopify_customer_/.test(uid)?'customer':'guest';
    try{ vvInc.mark('editor:init-rejected',{status:status,why:why,user:who}); }catch(e){}
    try{ galBeat('cc-editor-init',{ok:0,status:status,why:why.slice(0,40),user:who}); }catch(e){}
    if(!window.__vvUserFallbackOn){ setTimeout(vvInitRejFast,8000); return; }   // dd3m: fail fast and honestly. Fallback OFF by default: telemetry only until it is proven in the lab (a forced guest session hung the page in the harness)
    var fb=null; try{ fb=sessionStorage.getItem('vvUserFallback'); }catch(e){ return; }
    if(who!=='customer'||fb||/[?&](vvstate|vvsaved|vvproj|vvline)=/.test(location.search)) return;
    var g=null; try{ g=localStorage.getItem('cc_guest_id'); }catch(e){} if(!g||!/^guest_[a-z0-9]{6,20}$/.test(g)){ g='guest_'+Math.random().toString(36).slice(2,12); try{ localStorage.setItem('cc_guest_id',g); }catch(e){} }
    try{ sessionStorage.setItem('vvUserFallback',g); }catch(e){ return; }
    try{ vvInc.mark('editor:user-fallback'); }catch(e){} try{ galBeat('cc-editor-init',{ok:0,action:'user-fallback'}); }catch(e){}
    try{ window.__vvIntentNav='user-fallback'; }catch(e){}
    try{ browseWait(true,'Reopening the designer\u2026'); }catch(e){}
    setTimeout(function(){ try{ window.__vvNoNav=1; }catch(e){} location.reload(); },900);
  }
  try{ var _su=new URLSearchParams(location.search);
       if((_su.get('vvsaved')==='1'||_su.get('vvstate')) && /^[A-Za-z0-9_\-]{3,80}$/.test(_su.get('vvuser')||'')) VV_USER_OVERRIDE=_su.get('vvuser'); }catch(e){}   // class 10: a state resume runs as the user that owns the state
  function guestId(){
    if(VV_USER_OVERRIDE)return VV_USER_OVERRIDE;
    if(CUSTOMER_ID)return 'shopify_customer_'+CUSTOMER_ID;
    // localStorage (was sessionStorage): the guest's CC user survives tab close on this device,
    // and one device provisions ONE CC user instead of one per tab-session (cost). Durable
    // cross-device saving still requires sign-in — see the save gate below.
    var g=null;
    try{g=localStorage.getItem('cc_guest_id')||sessionStorage.getItem('cc_guest_id');}catch(e){}
    if(!g)g='guest_'+Math.random().toString(36).slice(2,12);
    try{localStorage.setItem('cc_guest_id',g);}catch(e){try{sessionStorage.setItem('cc_guest_id',g);}catch(e2){}}
    return g;
  }
  /* 21-Aug "INVALID TOKEN" FIX (owner, real phone, mobile-only). This cache had
     NO expiry. CC tokens live 60 minutes; prewarm() rebuilds its Storefront
     object after 45 — but the rebuild calls token(), which returned the SAME
     cached, by-then-expired JWT forever. A desktop session is usually fresh; a
     phone tab lives in the background for hours and comes back with all JS
     state intact, so the next editor open sent a dead token and CC showed
     "invalid token". Even [Try again] looped on it: the mount-death relaunch
     resets these caches, but an expired token doesn't kill the mount — it
     mounts an editor that displays an error, so no reset path ever ran.
     TTL 10 min here (a mint is one portal call), and prewarm's window is 40:
     worst case the editor holds a token aged 10+40=50 min < 60. */
  var _tok={};
  /* 26-Aug: this reset is the mount-death recovery path. It used to clear only
     the in-memory map; now that a copy is persisted it MUST clear that too,
     otherwise "Try again" re-reads the same bad token off disk and loops. */
  try{window.__vvCCTokReset=function(){_tok={};try{window.__vvCCTokLsClear&&window.__vvCCTokLsClear();}catch(e){}};}catch(e){}
  /* 22-Aug: BOUND THE TOKEN FETCH. This call had no timeout at all, and a fetch
     that never settles is the worst possible failure here: the mount watchdog
     declares death at 18s, but the dead promise is still holding the launch, so
     the customer sits on a spinner. Measured server-side the same day: the
     portal hung on 9 of 120 token calls (its own upstream call was equally
     un-timeboxed — now fixed there too), and the client had no way to give up.
     8s is deliberately well inside the 18s watchdog, so a slow or dead call
     fails FAST into mountFail's bounded auto-retry — which mints a fresh token
     — instead of stalling past it. AbortSignal.timeout is Safari 16+/Chrome 103+;
     older browsers fall back to a manual AbortController, and anything without
     AbortController at all just behaves as it always did. */
  var TOKEN_MS=8000;
  var VV_WINLOAD_MAX_MS=15000; try{ window.__vvT0=window.__vvT0||Date.now(); }catch(e){}
  /* ---- BOUNDED RECOVERY (candidate) ---- */
  var VV_REC={loadCalled:false, launchAt:0, capture:null};
  function vvPoorNet(){ try{ var c=navigator.connection; return !!(c&&(/2g|3g/.test(c.effectiveType||'')||(c.downlink&&c.downlink<2)||(c.rtt&&c.rtt>400))); }catch(e){ return false; } }
  function vvRecTell(stage,action,x){ try{ vvInc.mark('rec:'+stage+':'+action,x||{}); }catch(e){} try{ galBeat('recovery',Object.assign({stage:stage,action:action},x||{})); }catch(e){} }
  function vvCaptureLateLoad(){
    var fns=[], orig=window.addEventListener, done=false, t0=Date.now();
    var wrap=function(type,fn){ try{ if(!done&&type==='load'&&typeof fn==='function') fns.push(fn); }catch(e){} return orig.apply(this,arguments); };
    try{ window.addEventListener=wrap; }catch(e){ return null; }
    var restore=function(){ done=true; try{ if(window.addEventListener===wrap) window.addEventListener=orig; }catch(e){} };
    (function poll(){
      if(document.readyState==='complete'){
        restore();
        var wc=window.WebComponents;
        if(fns.length&&wc&&wc.ready!==true){
          vvRecTell('boot','late-load-replay',{n:fns.length,ms:Date.now()-t0});
          var ev; try{ ev=new Event('load'); }catch(e){ ev=null; }
          fns.forEach(function(f){ try{ f.call(window,ev); }catch(e){} });
        }
        return;
      }
      var wc2=window.WebComponents, lim=vvPoorNet()?45000:20000;
      if(fns.length&&wc2&&wc2.ready!==true&&Date.now()-t0>lim){      // the real load never came (a hung third-party resource)
        restore(); vvRecTell('boot','late-load-replay-noload',{n:fns.length,ms:Date.now()-t0,rs:document.readyState});
        var ev2; try{ ev2=new Event('load'); }catch(e){ ev2=null; } fns.forEach(function(f){ try{ f.call(window,ev2); }catch(e){} }); return; }
      if(Date.now()-t0>240000){ restore(); return; }
      setTimeout(poll,200);
    })();
    return {count:function(){ return fns.length; }, stop:restore};
  }   // 7-Oct-2026: longest the launch waits for window load before handing the page to the UI framework
  function _abortIn(ms){
    try{ if(AbortSignal&&AbortSignal.timeout)return AbortSignal.timeout(ms); }catch(e){}
    try{ var ac=new AbortController(); setTimeout(function(){try{ac.abort();}catch(e){}},ms); return ac.signal; }catch(e){}
    return undefined;
  }
  /* 26-Aug SPEED: the same cache, but it now survives a page navigation.
     _tok is per-page state, so a visitor who looked at three corflute pages
     before clicking Design paid three portal round trips for a JWT that is
     valid for sixty minutes — and on the first of them the portal itself pays
     three sequential calls to Customer's Canvas (404, create, re-fetch),
     which is where the ~0.5-0.8s cold token came from. localStorage keeps the
     TEN-MINUTE policy exactly as it was — the 21-Aug mobile "invalid token"
     bug was an UNBOUNDED cache, and nothing here loosens that bound — it just
     stops us re-minting a token we already hold. Keyed by userId, so the
     strike-2 guest-id rotation naturally misses this cache instead of
     resurrecting the broken identity. */
  var TOK_LS_MS=10*60*1000;
  function tokLsKey(userId){ return 'vv_cc_tok_'+userId; }
  function tokLsRead(userId){
    try{
      var raw=localStorage.getItem(tokLsKey(userId)); if(!raw)return null;
      var o=JSON.parse(raw);
      if(!o||!o.userToken||typeof o.at!=='number')return null;
      if((Date.now()-o.at)>=TOK_LS_MS){ try{localStorage.removeItem(tokLsKey(userId));}catch(e){} return null; }
      /* A clock that jumped BACKWARDS would make an old token look fresh
         forever. at>now means the stamp cannot be trusted; throw it away. */
      if(o.at>Date.now()+60000){ try{localStorage.removeItem(tokLsKey(userId));}catch(e){} return null; }
      return {id:userId,userToken:o.userToken,at:o.at};
    }catch(e){ return null; }
  }
  function tokLsWrite(userId,u){
    try{ localStorage.setItem(tokLsKey(userId),JSON.stringify({userToken:u.userToken,at:Date.now()})); }catch(e){}
  }
  try{window.__vvCCTokLsClear=function(){ try{
    for(var i=localStorage.length-1;i>=0;i--){ var k=localStorage.key(i);
      if(k&&k.indexOf('vv_cc_tok_')===0)localStorage.removeItem(k); }
  }catch(e){} };}catch(e){}
  function token(userId){
    var e=_tok[userId];
    if(e&&(Date.now()-e.at)<10*60*1000)return e.p;
    var ls=tokLsRead(userId);
    if(ls){ var pc=Promise.resolve({id:ls.id,userToken:ls.userToken});
            _tok[userId]={p:pc,at:ls.at}; return pc; }
    try{ vvInc.mark('token:mint-start'); }catch(e){}
    var _tokT0=Date.now();
    var p=fetch(PORTAL+'/api/cc-token?userId='+encodeURIComponent(userId),{signal:_abortIn(TOKEN_MS)})   // portal: mints the CC storefront-user token (natively since 22-Aug, see docs/customers-canvas/CC-TOKEN-MINTING.md). Also works on shopifypreview.com share links, which the old www-only PHP did not.
      .then(function(r){ try{ vvInc.mark('token:response',{status:r.status,ms:Date.now()-_tokT0}); }catch(e){} if(!r.ok)throw new Error('token '+r.status);return r.json();},function(err){ try{ vvInc.mark('token:error',{msg:String((err&&err.message)||err).slice(0,80),ms:Date.now()-_tokT0}); }catch(e){} throw err; })
      .then(function(u){if(!u||!u.userToken)throw new Error('no userToken');tokLsWrite(userId,u);return u;})
      .catch(function(err){delete _tok[userId];throw err;});
    _tok[userId]={p:p,at:Date.now()};
    return p;
  }
  /* 27-Aug — THE 24-HOUR WEDGE, found because the owner's browser failed while
     incognito worked on the same machine, same minute, same product.

     This cached WHATEVER the hub answered for 24 hours — including "no". One
     non-2xx from the integrations endpoint (a 429 while the page hammered it, a
     5xx blip, a proxy in between) and this browser stored ok:false, boot()'s
     hideNow() then hid the Design button with display:none !important on every
     visit, and armWarmers() never ran — for a DAY, in that browser only. Every
     other browser was fine, which made it look like "sometimes down". A hard
     refresh clears the HTTP cache but never localStorage, which is why the
     owner's hard refresh changed nothing. Incognito has no localStorage, which
     is why incognito worked.

     The asymmetry that matters: a cached YES is safe (worst case we warm a
     product that lost its integration, and the launch itself still checks), but
     a cached NO disables the studio outright. So the answers are no longer
     treated alike:
       - ok:true            -> cache 24h, as before
       - 404/409            -> the hub's actual "this product is not linked".
                               Cache "no", but for 10 MINUTES, not a day —
                               products get linked while pages sit open.
       - anything else non-2xx (429, 5xx, auth hiccups) -> NOT an answer about
                               the product. Never cached; next visit re-asks. */
  function resolves(pid){
    var ck='vv_cc_ok_'+pid;
    try{
      var c=JSON.parse(localStorage.getItem(ck)||'null');
      if(c && typeof c.ok==='boolean'){
        var age=Date.now()-c.t;
        if(c.ok ? age<864e5 : age<6e5) return Promise.resolve(c.ok);
      }
    }catch(e){}
    var _rsT0=Date.now();
    return token('vv_cc_probe').then(function(u){
      return fetch(HUB+'/api/v1/tenants/'+TENANT+'/integrations/'+pid+'?storefrontId='+STOREFRONT,
        {headers:{Authorization:'Bearer '+u.userToken}});
    }).then(function(r){
      try{ vvInc.mark('resolve:response',{status:r.status,ms:Date.now()-_rsT0}); }catch(e){}
      if(r.ok){ try{localStorage.setItem(ck,JSON.stringify({ok:true,t:Date.now()}));}catch(e){} return true; }
      if(r.status===404||r.status===409){
        try{localStorage.setItem(ck,JSON.stringify({ok:false,t:Date.now()}));}catch(e){} return false;
      }
      try{localStorage.removeItem(ck);}catch(e){}   // a throttle or outage is not an answer
      return null;
    }).catch(function(err){ try{ vvInc.mark('resolve:error',{msg:String((err&&err.message)||err).slice(0,80),ms:Date.now()-_rsT0}); }catch(e){} return null; });
  }
  function vid(){
    var i=document.querySelector('form[action*="/cart/add"] [name="id"]');
    return (i&&i.value)?i.value:FALLBACK_VID;
  }
  function qty(){
    // 21-Aug e2e (bollard covers): the buy-cards quantity tiles are the ONLY quantity UI the
    // customer sees, and on the CRO-ladder path they drive ITORIS's tier <li>s — never the legacy
    // input[name="quantity"], which sits hidden holding the PRODUCT's default (3 here). Reading the
    // legacy input first meant "2 units · $38.00" on screen and 3 units in the cart, every time.
    // window.__vvbcQty is what the customer actually picked; the legacy inputs stay as fallbacks
    // for products that never build the tile UI.
    var own=parseInt(window.__vvbcQty,10);
    if(own>0)return own;
    var sels=['#PDPQty','[name="quantity"]','.quantity__input','input.qty'];
    for(var i=0;i<sels.length;i++){var el=document.querySelector(sels[i]);
      if(el){var n=parseInt(el.value,10);if(n>0)return n;}}
    return 1;
  }

  // ---- SIZE BINDING: the design decides the cart line (UPDATE 13) -----------
  // The hole this closes: the CC editor resolves its OWN product variant (with its own Size /
  // Printed Sides / Flag Base option values), while the cart was being added on whatever variant
  // the PDP happened to have selected. Observed live: designed the CC 850x2050 pull-up template,
  // cart line came back "600mm W x 1400mm H". Design one, buy another.
  //
  // How CC actually binds (read from BackOffice, tenant 27, 2 Aug):
  //   GET /api/backoffice/v1/products/{id}/variant-designs?tenantId=27
  //   Each row carries storefrontProductVariantId + sku + productVariantOptions.
  //   · TEARDROP (394) is CORRECT: sku "VDK23SHG-GS" is a real Shopify variant sku
  //     (variant 942041661461) and the CC option triple matches Shopify's exactly.
  //   · PULL-UP (522) is BROKEN DATA: one CC variant, sku "VDK-522-PULLUP-850", option
  //     Size "850mm W x 2050mm H" — a sku that exists nowhere in Shopify and a size Vivid does
  //     not sell on that product (Shopify has 600x1400 / 800x2000 / 1000x2000).
  // So the binding MECHANISM is sound; pull-up's CC product data is wrong. This code therefore
  // trusts the mapping where it exists and refuses to guess where it doesn't.
  //
  // Direction chosen (HelloPrint's): what the customer designed is what goes in the cart.
  var SHOPIFY_VARIANTS=window.__VVCC.SHOPIFY_VARIANTS;
  var PRODUCT_OPTION_NAMES=window.__VVCC.PRODUCT_OPTION_NAMES;
  function vnorm(s){ var t=String(s==null?'':s); var m=/(\d+)\s*mm\s*w\s*[x\u00d7]\s*(\d+)\s*mm\s*h/i.exec(t); if(m) return m[1]+'mmwx'+m[2]+'mmh'; return t.toLowerCase().replace(/[^a-z0-9]/g,''); }
  function ccVariant(){ try{ if(window.__vvDD&&window.__vvDD.dv) return window.__vvDD.dv; var sel=deepFind('au-widget-pim-design-selector'); return (sel&&sel._)||null; }catch(e){ return null; } }
  function ccOptionMap(cv){
    var m={}; ((cv&&cv.options)||[]).forEach(function(o){
      if(o&&o.productOptionTitle) m[vnorm(o.productOptionTitle)]=vnorm(o.productOptionValueTitle);
    });
    return m;
  }
  // Resolve the Shopify variant that corresponds to the CC design variant.
  //  mode 'cc-options' → every CC option value matched a Shopify variant's option values (best)
  //  mode 'cc-sku'     → matched on sku alone
  //  mode 'pdp'        → the CC variant carries nothing to match on; keep the PDP's variant
  //  mode 'mismatch'   → the CC variant DOES say a size and it contradicts the PDP's → refuse
  function resolveCartVariantCC(){
    var cv=ccVariant();
    var pdpId=parseInt(vid(),10);
    if(!cv) return {id:pdpId,mode:'pdp'};
    var sku=cv.sku||cv.storefrontProductVariantId||'';
    var m=ccOptionMap(cv);
    var names=PRODUCT_OPTION_NAMES.map(vnorm);
    var keys=Object.keys(m).filter(function(k){return names.indexOf(k)>=0;});
    if(keys.length){
      var hit=SHOPIFY_VARIANTS.filter(function(v){
        return keys.every(function(k){ return vnorm(v.options[names.indexOf(k)])===m[k]; });
      });
      // prefer one that also matches the sku, then any available one, then the first
      /* 7-Oct-2026 cart identity: the customer's own PDP variant wins whenever the design is valid for it (it is one of the
         option-matching variants). Before this, a size-only CC catalogue (Rectangle, Bow) resolved by SKU to Single + Ground Spike. */
      var mine=hit.filter(function(v){return String(v.id)===String(pdpId);})[0];
      if(mine) return {id:mine.id,mode:(hit.length>1?'cc-options-pdp':'cc-options'),sku:mine.sku||sku,title:mine.title};
      var best=hit.filter(function(v){return sku&&v.sku===sku;})[0]
            || hit.filter(function(v){return v.available;})[0] || hit[0];
      if(best) return {id:best.id,mode:'cc-options',sku:sku,title:best.title};
    }
    var bySku=SHOPIFY_VARIANTS.filter(function(v){return sku&&v.sku===sku;})[0];
    if(bySku) return {id:bySku.id,mode:'cc-sku',sku:sku,title:bySku.title};
    // Nothing matched. Only refuse if the CC variant actually asserts a size that the PDP
    // variant contradicts — that is the design-one-buy-another case and must not ship.
    var si=names.indexOf('size');
    var cur=SHOPIFY_VARIANTS.filter(function(v){return String(v.id)===String(pdpId);})[0];
    var ccSize=m['size'], pdpSize=(si>=0&&cur)?vnorm(cur.options[si]):null;
    if(ccSize&&pdpSize&&ccSize!==pdpSize){
      var ccRaw='',pdpRaw='';
      ((cv.options)||[]).forEach(function(o){ if(vnorm(o.productOptionTitle)==='size') ccRaw=o.productOptionValueTitle; });
      if(si>=0&&cur) pdpRaw=cur.options[si];
      return {id:null,mode:'mismatch',sku:sku,ccSize:ccRaw,pdpSize:pdpRaw};
    }
    return {id:pdpId,mode:'pdp',sku:sku};
  }

  /* 13-Oct-2026 P0 — GEOMETRY FIRST. A real customer reopened a saved 6 Foot loose table cloth (3325.7 x 2429.2 mm on
     the canvas, correct for the page's 6 Foot variant) and Finish refused it: the CC design variant read above
     (window.__vvDD.dv, else the pim design selector's current row) was still the CC product's DEFAULT row
     (LooseTableClothsThrows-DYO-2720.7x2294.1, Size=4 Foot). A saved-design / change-artwork / draft restore puts the
     customer's STATE on the canvas but never moves that row (measured live 13-Oct: 8 Foot saved design reopened,
     selector still on the 4 Foot DYO row), so its option values named the 4 Foot variant and the geometry guard
     (correctly) refused a 6 ft design on a 4 ft line.
     The surface measured from the live editor at Finish (window.__vvGeomFinal.sf, read twice, stable) is the truth
     about what was designed; a stale option value is not. So, only when the option pick DISAGREES with the page:
       · the page's own variant fits the measured surface and the option pick does not  -> the page's variant ('geom-pdp')
       · the page's variant has no fit either, and exactly ONE variant of this product with the page's other options
         fits the surface (only reachable when the page's variant has no ENFORCED geometry: an enforced mismatch is
         refused before this runs)                                                       -> that variant ('geom-variant')
       · anything else                                                                    -> unchanged (today's behaviour)
     The geometry guard still runs after this against whatever is chosen, and still refuses a real mismatch. */
  function vvSizeIdx(){ var n=PRODUCT_OPTION_NAMES.map(vnorm); for(var i=0;i<n.length;i++){ if(n[i].indexOf('size')>=0) return i; } return -1; }
  function vvVarById(id){ return SHOPIFY_VARIANTS.filter(function(v){ return String(v.id)===String(id); })[0]||null; }
  function vvSizeLabel(v){ var si=vvSizeIdx(); var t=(v&&si>=0&&v.options)?String(v.options[si]||''):String((v&&v.title)||''); return t.replace(/\s*-\s*SALE!?\s*$/i,'').trim(); }
  /* true = registry geometry for this variant fits the surface, false = it does not, null = no registry geometry */
  function vvGeomFits(id,sf){ var e=vvGeomRaw(id); return e?(vvGeomVerdict(sf,{s:e.s})==='match'):null; }
  /* variants with the page variant's OTHER options (every option but size) whose registry geometry fits sf */
  function vvGeomFitVariants(sf,pageId){
    var page=vvVarById(pageId), si=vvSizeIdx(); if(!page||!sf||!sf.length) return [];
    return SHOPIFY_VARIANTS.filter(function(v){
      for(var i=0;i<(page.options||[]).length;i++){ if(i!==si&&vnorm(v.options[i])!==vnorm(page.options[i])) return false; }
      return vvGeomFits(v.id,sf)===true; });
  }
  /* the page variant's own "<W>mm W x <H>mm H" (variants with no registry geometry), within max(25 mm, 5 %), rotation allowed */
  function vvTitleWH(v){ var m=/(\d+(?:\.\d+)?)\s*mm\s*w\s*[x×]\s*(\d+(?:\.\d+)?)\s*mm\s*h/i.exec(String((v&&v.title)||'')); return m?[+m[1],+m[2]]:null; }
  function vvTitleFits(v,sf){ var wh=vvTitleWH(v); if(!wh||!sf||!sf.length) return null; var PT=72/25.4, near=function(a,b){ return Math.abs(a-b)<=Math.max(25,0.05*b); };
    return sf.every(function(x){ var w=x.width/PT, h=x.height/PT; return (near(w,wh[0])&&near(h,wh[1]))||(near(w,wh[1])&&near(h,wh[0])); }); }
  function vvGeomFirst(base,pdpId){
    try{
      var g=window.__vvGeomFinal; if(!g||!g.sf||!g.sf.length||g.v==='unstable'||g.v==='unread') return base;
      if(base&&base.id&&String(base.id)===String(pdpId)) return base;            // the options already agree with the page
      if(base&&base.id&&vvGeomFits(base.id,g.sf)===true) return base;            // the option pick IS what is on the canvas
      var why={from:(base&&base.mode)||'',fromId:(base&&base.id)?String(base.id):'',ccSize:(base&&base.ccSize)||'',mm:g.mm||''}, pick=null, mode='';
      var pdp=vvVarById(pdpId);
      if(pdp&&vvGeomFits(pdpId,g.sf)===true){ pick=pdp; mode='geom-pdp'; }
      else if(pdp&&vvGeomFits(pdpId,g.sf)!==true){
        var c=vvGeomFitVariants(g.sf,pdpId);
        if(c.length===1&&(!base||!base.id||String(c[0].id)!==String(base.id))){ pick=c[0]; mode='geom-variant'; }
      }
      if(!pick&&pdp&&vvGeomFits(pdpId,g.sf)===null&&(!base||!base.id||vvGeomFits(base.id,g.sf)===false)&&vvTitleFits(pdp,g.sf)===true){ pick=pdp; mode='geom-pdp-title'; }   // no registry row for the page: its own W x H
      if(!pick) return base;
      var r={id:pick.id,mode:mode,sku:pick.sku||(base&&base.sku)||'',title:pick.title,was:why};
      try{ console.log('[vivid-cc] size-sync: cart variant from the measured design surface, not the stale CC option values',r); }catch(e){}
      try{ vvRdTell('cart-variant-geom',{mode:mode,to:String(pick.id),from:why.fromId,fromMode:why.from,mm:why.mm,pdp:String(pdpId)}); }catch(e){}
      return r;
    }catch(e){ return base; }
  }
  function resolveCartVariant(){ var pdpId=parseInt(vid(),10); return vvGeomFirst(resolveCartVariantCC(),pdpId); }

  // ---- state machine -------------------------------------------------------
  function anyStateOn(){ for(var k in STATES){ if(STATES[k]&&STATES[k].hasAttribute('data-on'))return true;} return false; }
  function showState(name,msg,heading){
    try{ var _ga=document.getElementById('vvgeom-acts'); if(_ga) _ga.remove(); }catch(e){}   // 13-Oct P0: geometry-offer buttons
    for(var k in STATES){ if(STATES[k]) STATES[k].removeAttribute('data-on'); }
    if(name && STATES[name]){ STATES[name].setAttribute('data-on','1'); }
    // The error panel's heading is settable (UPDATE 14). It used to be a hardcoded "The design
    // studio couldn't load", which is a lie for the two failures that happen AFTER a successful
    // design — the size-mismatch block and a failed cart add. Telling a customer the studio
    // didn't load when they have just spent five minutes designing in it is worse than useless.
    if(name==='error'){
      var h=document.getElementById('vvcc-error-h');
      if(h) h.textContent=(heading||'The design studio couldn’t load');
      if(msg){ var m=document.getElementById('vvcc-error-msg'); if(m) m.textContent=msg; }
      /* 10-Sep: "Try again" cannot revive an expired Customer's Canvas session —
         only a reload can. Set for the expired panel, restored for every other. */
      try{
        var vvB=document.querySelector('#vvcc-error .vvcc-actions [data-vvcc="retry"],#vvcc-error .vvcc-actions [data-vvcc="vvreload"]');
        if(vvB){
          vvB.setAttribute('data-vvcc', vvExpiredNow ? 'vvreload' : 'retry');
          vvB.textContent = vvExpiredNow ? 'Reload and start again' : 'Try again';
        }
      }catch(e){}
    }
  }
  /* ---- SESSION EXPIRY (10-Sep-2026) --------------------------------------
     A Customer's Canvas editor session does not live forever, and a tab can.
     vvEditorAt is stamped when the editor loads; vvHiddenAt when the tab goes
     away. Nothing here guesses: vvSessionAlive() actually asks CC. */
  var vvEditorAt=0, vvHiddenAt=0, vvExpiredShown=false, vvExpiredNow=false;
  var VV_STALE_MS=45*60*1000;        // an editor this old is worth checking before a finish run
  var VV_AWAY_MS=20*60*1000;         // ...as is coming back to a tab left this long
  function vvWithTimeout(pr,ms){
    return Promise.race([pr,new Promise(function(_,rej){setTimeout(function(){rej(new Error('probe timeout'));},ms);})]);
  }
  /* TRUE = the session answered. FALSE = it did not, twice, with a pause in
     between. The retry is the whole point: one dropped request must never be
     enough for us to tell a customer their work is gone. */
  async function vvSessionAlive(){
    try{ if(sessionStorage.getItem('vvccForceExpire')==='1'){ sessionStorage.removeItem('vvccForceExpire'); return false; } }catch(e){}   // QA: forced expiry (scripts/qa/session-recovery-probe.mjs)
    for(var i=0;i<2;i++){
      if(i) await new Promise(function(r){setTimeout(r,2000);});
      try{
        var wiz=deepFind('au-wizard'), svc=wiz&&wiz.savedProjectsManager&&wiz.savedProjectsManager._service;
        if(!svc||!svc.getAllProjects) return true;   // nothing to ask — do not invent a verdict
        await vvWithTimeout(svc.getAllProjects(),12000);
        return true;
      }catch(e){
        try{console.warn('[vivid-cc] session probe '+(i+1)+'/2 failed',e);}catch(_){ }
      }
    }
    return false;
  }
  /* The panel. Reuses the error state and retargets its primary button, because
     "Try again" cannot revive a session that no longer exists — only a reload
     can, and the URL already carries the variant and the design deep link. */
  /* QA only: run the real session check now (scripts/qa/session-recovery-probe.mjs forces the verdict via sessionStorage). */
  try{ window.__vvCCSessionCheck=function(){ return vvSessionAlive().then(function(a){ if(!a) vvShowExpired(); return a; }); }; }catch(e){}
  function vvShowExpired(){
    if(vvExpiredShown)return; vvExpiredShown=true;
    try{ prepStop(); }catch(e){}
    /* Release-hardening (2026-10-06), class 10: the editor session is gone, the customer's work is not.
       A draft autosaved in THIS editor session → reopen it in a fresh session (vvsaved/vvproj path, fresh
       token). No draft (nothing was ever changed) → reload the same entry: nothing to lose, nothing to ask.
       Bounded: two automatic recoveries per tab, then the honest panel. */
    try{
      var _rs=[]; try{ _rs=(JSON.parse(sessionStorage.getItem('vvccRecover')||'[]')||[]).filter(function(t){ return Date.now()-t<600000; }); }catch(e){ _rs=[]; }
      if(_rs.length<2){
        var _d=vvDraftGet();
        var _mine=_d&&_d.stateId&&_d.at&&vvEditorAt&&_d.at>=vvEditorAt-300000;
        _rs.push(Date.now()); sessionStorage.setItem('vvccRecover',JSON.stringify(_rs));
        try{ galBeat('cc-session-recover',{ok:1,draft:_mine?1:0,age:_d?Math.round((Date.now()-_d.at)/1000):-1}); }catch(e){}
        showState('loading'); try{ browseWait(true,'Welcome back — your design has been saved. Reopening it where you left off…'); }catch(e){}
        try{ mountStage('session-recover'); }catch(e){}
        setTimeout(function(){ if(_mine) location.href=vvDraftResumeUrl(_d,'expired'); else if(vvModernEntry()) location.reload(); else location.href=location.href; },900);
        return;
      }
    }catch(e){}
    /* showState owns the button swap (see there) so that ANY later use of the
       error panel gets its normal "Try again" back. Doing it here instead left a
       reload button sitting on unrelated errors for the rest of the page's life. */
    vvExpiredNow=true;
    try{
      showState('error',
        'This tab was open for a while and our design studio closed the session at its end. Nothing has been added to your cart. Reload the page and your product, size and design will still be selected \u2014 you will just need to make your changes again.',
        'Your design session has expired');
    } finally { vvExpiredNow=false; }
    try{ mountStage('session-expired'); }catch(e){}
  }
  function stopMonitor(){ if(monTimer){clearTimeout(monTimer);clearInterval(monTimer);monTimer=null;} }
  function coverOff(){ cover.removeAttribute('data-on'); }
  /* SCROLL LOCK (21-Aug). Was: document.documentElement.style.overflow='hidden'.
     Measured on iPhone 13 WebKit with the editor open, the page still scrolled
     underneath (y 2907 -> 600). iOS Safari only honours a scroll lock if the
     body is taken out of flow, so on touch engines we pin the body and put the
     scroll position back on close. Desktop keeps the cheap overflow-only path —
     position:fixed there would collapse the scrollbar and shift the layout. */
  var _vvLockY = 0, _vvLocked = false;
  var _vvTouch = (function(){
    try {
      return (navigator.maxTouchPoints || 0) > 0 ||
             /iP(hone|ad|od)|Android/i.test(navigator.userAgent || '');
    } catch (e) { return false; }
  })();
  function vvLockScroll(){
    if (_vvLocked) return;
    _vvLocked = true;
    _vvLockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('vv-cc-locked');
    if (_vvTouch) {
      document.body.classList.add('vv-cc-locked');
      document.body.style.top = (-_vvLockY) + 'px';
    }
  }
  function vvUnlockScroll(){
    if (!_vvLocked) return;
    _vvLocked = false;
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('vv-cc-locked');
    if (_vvTouch) {
      document.body.classList.remove('vv-cc-locked');
      document.body.style.top = '';
      /* 'instant' so closing the editor does not animate the customer back
         down the page; some engines still want the legacy boolean form. */
      try { window.scrollTo({ top: _vvLockY, behavior: 'instant' }); }
      catch (e) { window.scrollTo(0, _vvLockY); }
    }
  }
  function closeModal(){ try{ ccAbandon('close'); }catch(e){}
    stopMonitor(); stopAutosave(); coverOff();
    try{ prep.cancelled=true; prepStop(); pfCloseOnly(); }catch(e){}
    try{ kickNotice(false); }catch(e){}   // position:fixed strip would outlive the editor
    modal.setAttribute('hidden',''); vvUnlockScroll(); }
  function openOwnDesign(){ // damage-control fallback -> the upload / own-artwork path
    /* Invariant 3 / context: from the VividCanvas gallery, "Upload my own artwork" is the studio's upload
       entry for THIS product + variant/config — not the product page's own CTA with the gallery return lost. */
    try{ var _g=vvFromTarget(); if(_g&&_g.gallery){
      var _q=(location.search||'').replace(/^\?/,'').split('&').filter(function(kv){ return kv && !/^(vvcc|vvstyle|vvfresh|vvfrom)=/.test(kv); });
      _q.push('vvcc=upload','vvfrom=gallery'); location.href=location.pathname+'?'+_q.join('&'); return; } }catch(e){}
    closeModal();
    var own=document.querySelector('.vvbc-cta--own');
    if(own){ own.click(); return; }
    var up=document.querySelector('.requiredesignstep, form[action*="/cart/add"]');
    if(up&&up.scrollIntoView) up.scrollIntoView({behavior:'smooth',block:'center'});
  }
  function openDesignService(){
    closeModal();
    var ds=document.querySelector('[data-opt="expert"]');
    if(ds){ ds.click(); }
  }
  // deep shadow-DOM helpers (the UIF renders into open shadow roots)
  var _dfCache={};
  function deepFind(tag){
    try{ var c=_dfCache[tag]; if(c&&c.isConnected){ var r=c.getRootNode&&c.getRootNode({composed:true}); if(r===document&&box&&box.isConnected) return c; } }catch(e){}
    var f=deepFind0(tag); if(f) _dfCache[tag]=f; else delete _dfCache[tag]; return f;
  }
  function deepFind0(tag){
    var hit=null, seen=new Set();
    (function scan(root,d){ if(!root||d>13||hit)return; var els=root.querySelectorAll?root.querySelectorAll('*'):[];
      for(var i=0;i<els.length;i++){var e=els[i]; if(seen.has(e))continue; seen.add(e);
        if(e.tagName&&e.tagName.toLowerCase()===tag){hit=e;return;}
        if(e.shadowRoot)scan(e.shadowRoot,d+1); if(hit)return;}
    })(box,0);
    return hit;
  }
  function preloaderText(){ // Aurigma's post-Next compile preloader ("Preparing Your Design")
    // NOTE: only match the compile step. The editor pane also shows "Loading, please wait…" as its
    // normal IDLE state before a design is selected — that is not a stall, so it must NOT match here.
    var t=null, seen=new Set();
    (function scan(root,d){ if(!root||d>13||t)return; var els=root.querySelectorAll?root.querySelectorAll('*'):[];
      for(var i=0;i<els.length;i++){var e=els[i]; if(seen.has(e))continue; seen.add(e);
        if(e.children&&e.children.length===0){var x=(e.textContent||'');
          if(/preparing your design/i.test(x)){t=x.trim();return;}}
        if(e.shadowRoot)scan(e.shadowRoot,d+1); if(t)return;}
    })(box,0);
    return t;
  }
  function galleryCount(){
    try{ var sel=deepFind('au-widget-pim-design-selector'); return sel&&sel.variants?sel.variants.length:null; }catch(e){ return null; }
  }
  // ---- Aurigma-preloader occlusion (branding) ------------------------------
  // The UIF shows Aurigma-branded preloaders (au-preloader / au-preloader-primary: a white pane
  // with the '[ ]' CC bracket logo + spinner) during "Preparing Your Design" and other
  // interstitials. We never restyle Aurigma internals (fragile class names) — instead, whenever
  // one is VISIBLE we lay our own Vivid-branded panel exactly over its box. The covered DOM/text
  // underneath stays fully readable, so preloaderText() and the stall monitor keep working.
  function preloaderScan(){ // one walk: biggest visible Aurigma preloader + what it says it's doing
    var best=null, label=null, seen=new Set();
    (function scan(root,d){ if(!root||d>13)return; var els=root.querySelectorAll?root.querySelectorAll('*'):[];
      for(var i=0;i<els.length;i++){var e=els[i]; if(seen.has(e))continue; seen.add(e);
        var tn=e.tagName?e.tagName.toLowerCase():'';
        if(tn==='au-preloader'||tn==='au-preloader-primary'){
          var r=e.getBoundingClientRect();
          if(r.width>60&&r.height>60&&(!best||r.width*r.height>best.width*best.height))best=r;
        }
        if(!label&&e.children&&e.children.length===0){var x=(e.textContent||'');
          if(/saving project/i.test(x))label='Saving your project';
          else if(/preparing your design/i.test(x))label='Preparing your design';}
        if(e.shadowRoot)scan(e.shadowRoot,d+1);}
    })(box,0);
    return {rect:best,label:label};
  }
  function coverSync(){ // occlude, don't restyle: position our panel over the visible preloader
    var p=preloaderScan();
    if(!p.rect){ coverOff(); return false; }
    var s=stage.getBoundingClientRect(), r=p.rect;
    cover.style.left=Math.max(0,r.left-s.left)+'px';
    cover.style.top=Math.max(0,r.top-s.top)+'px';
    cover.style.width=Math.min(r.width,s.width)+'px';
    cover.style.height=Math.min(r.height,s.height)+'px';
    var h=document.getElementById('vvcc-cover-h');
    if(h)h.textContent=p.label||'Just a moment…';
    cover.setAttribute('data-on','1');
    return true;
  }
  // ---- HelloPrint-parity header (UPDATE 10) --------------------------------
  // The Aurigma wizard header row (Design/Approval tabs + My Projects / Save Project / Next) is
  // OCCLUDED with an opaque strip, and our top bar carries the single HelloPrint-style exit CTA
  // ("Finished designing? Click here") which drives the hidden native Next programmatically.
  // Occlusion, not restyling: the header DOM is untouched, so Shabbir's hub relayout replaces
  // this cleanly. The UPDATE 9 guest save gate stays in code (dormant — the buttons are covered).
  function wizHeader(){
    var wiz=deepFind('au-wizard');
    try{ return wiz&&wiz.shadowRoot?wiz.shadowRoot.querySelector('header'):null; }catch(e){ return null; }
  }
  function nativeNext(){
    var h=wizHeader(); if(!h)return null;
    var btns=h.querySelectorAll('paper-button');
    for(var i=0;i<btns.length;i++){var t=(btns[i].textContent||'').trim().toLowerCase();
      if(t==='next'||t==='finish')return btns[i];}
    return null;
  }
  /* rc4.2.8 FINISH READINESS GATE — see scripts/qa/apply-finishgate.mjs for the evidence. */
  var VV_RD={key:'',since:0,ok:false,sid:'',surfOk:false,surf:'',checking:false,checkedSid:'',lastCheck:0,retried:false,failed:false,label:''};
  var VV_RD_MS=45000, VV_RD_POOR_MS=90000, VV_RD_MIN_PT=28.35;   // 10 mm in points
  function vvRdPoor(){ try{ var c=navigator.connection||{}; return /2g|3g/.test(String(c.effectiveType||''))||(c.downlink>0&&c.downlink<2)||(c.rtt>400); }catch(e){ return false; } }
  function vvHealth(){ try{ var sn=vvInc.snapshot(), d=sn.device||{}, lt=sn.longTasks||{};
      var cls=function(u){ u=String(u||''); var h=((u.match(/^https?:\/\/([^\/?#]+)/)||[])[1]||'').split('.').slice(-3).join('.');
        var p=/RequestInitData/.test(u)?'init':/from-design/.test(u)?'from-design':/getcctoken/.test(u)?'getcctoken':/cc-token/.test(u)?'cc-token':/\/resources\//.test(u)?'resource':/page\/iframe/.test(u)?'editor-iframe':/gal-telemetry|cc-apply|mount-failure/.test(u)?'beacon':'other';
        return h+':'+p; };
      var slow=(sn.requests||[]).slice().sort(function(a,b){ return (b.ms||0)-(a.ms||0); }).slice(0,5).map(function(r){ return cls(r.url)+':'+(r.ms||0)+':'+(r.status||r.why||''); });
      return {lt:[lt.n||0,lt.ms||0,lt.max||0],c:d.cores||0,m:d.mem||0,net:d.conn?[d.conn.et,d.conn.dl,d.conn.rtt]:null,slow:slow,rej:window.__vvInitRej?(window.__vvInitRej.status||1):0,vis:document.visibilityState}; }catch(e){ return null; } }
  function vvRdTell(stage,x){ try{ vvInc.mark('finish:'+stage,x||{}); }catch(e){} try{ var _x=Object.assign({stage:stage},x||{}); if(/retry|fail|geom/.test(stage)) _x.h=vvHealth(); galBeat('cc-ready',_x); }catch(e){} }
  function vvRdCheck(ed,sid){
    if(VV_RD.checking||(VV_RD.checkedSid===sid&&VV_RD.surfOk&&(Date.now()-VV_RD.lastCheck<5000||document.hidden))||Date.now()-VV_RD.lastCheck<1000) return;
    try{ vvGeomLoad(); }catch(e){}
    VV_RD.checking=true; VV_RD.lastCheck=Date.now(); var _c0=Date.now(); VV_RD.nCheck=(VV_RD.nCheck||0)+1;
    var to=new Promise(function(r){ setTimeout(function(){ r('__slow'); },4000); });
    Promise.race([Promise.resolve(ed.customersCanvasPromise).then(function(cc){ return (cc&&typeof cc.getProduct==='function')?cc.getProduct():null; }),to])
      .then(function(pr){ VV_RD.prodMs=Date.now()-_c0; if(pr==='__slow') VV_RD.nSlow=(VV_RD.nSlow||0)+1;
        if((pr==='__slow'||!pr||!pr.surfaces)&&VV_RD.checkedSid===sid&&VV_RD.surfOk) return;   // dd3n: keep the verified verdict
        var sf=(pr&&pr!=='__slow'&&pr.surfaces)||[];
        if(sf.length&&!VV_RD.surfAt) VV_RD.surfAt=Date.now();
        VV_RD.surf=sf.map(function(x){ return Math.round(x.width)+'x'+Math.round(x.height); }).join(',');
        var _sz=sf.length>0&&sf.every(function(x){ return x&&x.width>=VV_RD_MIN_PT&&x.height>=VV_RD_MIN_PT; });
        VV_RD.geom=_sz?vvGeomVerdict(sf,vvGeomExpect()):'';
        if(VV_RD.geom==='mismatch'&&VV_RD.geomTold!==VV_RD.surf){ VV_RD.geomTold=VV_RD.surf; var _ge=vvGeomExpect(); try{ vvRdTell('geom-mismatch',{mm:vvGeomMm(sf),exp:_ge?_ge.s.map(function(x){ return x[0]+'x'+x[1]; }).join(','):'',vid:String(vid()||'')}); }catch(e){} }
        if(VV_RD.geom==='unknown'){ var _gr=vvGeomRaw(); if(_gr&&_gr.e===0&&vvGeomVerdict(sf,{s:_gr.s})==='mismatch'&&VV_RD.geomObs!==VV_RD.surf){ VV_RD.geomObs=VV_RD.surf; try{ vvRdTell('geom-observe',{mm:vvGeomMm(sf),rec:_gr.s.map(function(x){ return x[0]+'x'+x[1]; }).join(','),vid:String(vid()||'')}); }catch(e){} } }
        VV_RD.surfOk=_sz&&VV_RD.geom!=='mismatch';
        VV_RD.checkedSid=sid; })
      .catch(function(){ VV_RD.surfOk=false; })
      .then(function(){ VV_RD.checking=false; });
  }
  function vvRdDiag(ed){ try{ var s0=VV_RD.since||Date.now(), rel=function(t){ return t?Math.round((t-s0)/100)/10:null; };
      var ifr=null; try{ var f=ed&&(ed.shadowRoot||ed).querySelector&&(ed.shadowRoot||ed).querySelector('iframe'); ifr=f?(String(f.src||'').indexOf('about:blank')===0||!f.src?'blank':'loaded'):'none'; }catch(e){ ifr='?'; }
      return { idAt:rel(VV_RD.idAt), sidAt:rel(VV_RD.sidAt), surfAt:rel(VV_RD.surfAt), checks:VV_RD.nCheck||0, slow:VV_RD.nSlow||0, prodMs:VV_RD.prodMs||null, iframe:ifr,
        inited:!!(ed&&ed._isInited), lock:ed?ed._preloaderLockingSum:null, li:(typeof CUSTOMER_ID!=='undefined'&&CUSTOMER_ID)?1:0 }; }catch(e){ return { err:String(e).slice(0,40) }; } }
  var VV_GEOM=null, VV_GEOM_P=null;
  function vvGeomLoad(){ if(VV_GEOM_P) return VV_GEOM_P; var u='';
    try{ u=window.__VVGEOM_URL||String(window.__VVREG_URL||'').replace(/vivid-cc-registry\.js.*$/,'vivid-cc-geom.json'); }catch(e){}
    if(!u||u.indexOf('vivid-cc-geom.json')<0){ VV_GEOM_P=Promise.resolve(null); return VV_GEOM_P; }
    /* 21-Oct: the URL derived from the registry's loses its ?v=, and Shopify's CDN serves an unversioned asset with
       max-age=1 year — live was still handing out the 9-Oct geometry after the 20-Oct update. The snippet now sets
       __VVGEOM_URL from asset_url (versioned); until then, an hourly key keeps a stale copy from living forever. */
    if(u.indexOf('?')<0) u+='?vvg='+Math.floor(Date.now()/3600e3);
    /* a freshly versioned asset can answer 502 on its first CDN miss (seen 21-Oct): one retry after 1.5 s */
    var _get=function(){ return fetch(u,{credentials:'omit'}).then(function(r){ return r.ok?r.json():null; }).catch(function(){ return null; }); };
    VV_GEOM_P=_get().then(function(j){ return (j&&j.variants)?j:new Promise(function(res){ setTimeout(res,1500); }).then(_get); })
      .then(function(j){ VV_GEOM=(j&&j.variants)||null; return VV_GEOM; }).catch(function(){ return null; });
    return VV_GEOM_P; }
  /* only ENFORCED entries (e:1 — one unambiguous, corroborated geometry) can block; recorded entries are observed in telemetry only */
  function vvGeomRaw(v){ try{ var e=VV_GEOM&&VV_GEOM[String(v||vid()||'')]; return (e&&e.s&&e.s.length)?e:null; }catch(e){ return null; } }
  function vvGeomExpect(v){ var e=vvGeomRaw(v); return (e&&e.e!==0)?e:null; }
  function vvGeomMm(sf){ var PT=72/25.4; return (sf||[]).map(function(x){ return Math.round(x.width/PT)+'x'+Math.round(x.height/PT); }).join(','); }
  /* match = same number of surfaces, each within max(2 mm, 0.3 %) of the measured CC geometry for this variant, rotation allowed */
  function vvGeomVerdict(sf,exp){ if(!exp) return 'unknown'; if(!sf||!sf.length||sf.length!==exp.s.length) return 'mismatch';
    var PT=72/25.4, near=function(a,b){ return Math.abs(a-b)<=Math.max(2,0.003*b); };
    for(var i=0;i<sf.length;i++){ var w=sf[i].width/PT, h=sf[i].height/PT, W=exp.s[i][0], H=exp.s[i][1];
      if(!((near(w,W)&&near(h,H))||(near(w,H)&&near(h,W)))) return 'mismatch'; }
    return 'match'; }
  function vvReadProduct(ms){ var ed=deepFind('au-widget-design-editor'); if(!ed) return Promise.resolve(null);
    return Promise.race([Promise.resolve(ed.customersCanvasPromise).then(function(cc){ return (cc&&typeof cc.getProduct==='function')?cc.getProduct():null; }),
      new Promise(function(r){ setTimeout(function(){ r(null); },ms||4000); })]).then(function(p){ return (p&&p.surfaces)?p.surfaces.map(function(x){ return {width:x.width,height:x.height}; }):null; },function(){ return null; }); }
  /* Finish-time: registry loaded, product read twice 1.2 s apart and identical (up to 3 tries), then compared with variant v */
  async function vvGeomFinal(v){
    try{ await Promise.race([vvGeomLoad(),new Promise(function(r){ setTimeout(r,3000); })]); }catch(e){}
    var a=null,b=null;
    for(var i=0;i<3;i++){ a=await vvReadProduct(4000); await new Promise(function(r){ setTimeout(r,1200); }); b=await vvReadProduct(4000);
      if(a&&b&&vvGeomMm(a)===vvGeomMm(b)) break; }
    var exp=vvGeomExpect(v), stable=!!(a&&b&&vvGeomMm(a)===vvGeomMm(b));
    var r={v:!b?'unread':(!stable?'unstable':vvGeomVerdict(b,exp)), sf:b, mm:vvGeomMm(b), exp:exp?exp.s.map(function(x){ return x[0]+'x'+x[1]; }).join(','):'', vid:String(v||vid()||'')};
    window.__vvGeomFinal=r; return r; }

  /* 13-Oct P0: which other size of this product the design on the canvas is (unique fit with the page's other options) */
  function vvGeomOffer(){
    var pageId=vid(), pV=vvVarById(pageId); if(!pV) return null;
    var g=window.__vvGeomFinal, sf=null, mm='';
    if(g&&g.sf&&g.sf.length&&String(g.vid)===String(pageId)){ sf=g.sf; mm=g.mm||''; }
    else if(VV_RD&&VV_RD.surf){ sf=String(VV_RD.surf).split(',').map(function(x){ var q=x.split('x'); return {width:+q[0],height:+q[1]}; }).filter(function(x){ return x.width>0&&x.height>0; }); mm=vvGeomMm(sf); }
    if(!sf||!sf.length) return null;
    if(vvGeomFits(pageId,sf)===true) return null;
    var c=vvGeomFitVariants(sf,pageId); if(c.length!==1) return null;
    var dV=c[0], dL=vvSizeLabel(dV), pL=vvSizeLabel(pV); if(!dL||!pL||vnorm(dL)===vnorm(pL)) return null;
    return {dV:dV,pV:pV,dLabel:dL,pLabel:pL,mm:mm};
  }
  function vvGeomOfferButtons(o){
    try{ var old=document.getElementById('vvgeom-acts'); if(old) old.remove(); }catch(e){}
    var host=document.getElementById('vvcc-error'); if(!host) return;
    var w=document.createElement('div'); w.id='vvgeom-acts'; w.className='vvcc-actions';
    var b1=document.createElement('button'); b1.type='button'; b1.id='vvgeom-switch'; b1.className='vvcc-btn vvcc-btn--primary'; b1.textContent='Switch to '+o.dLabel;
    var b2=document.createElement('button'); b2.type='button'; b2.id='vvgeom-fresh'; b2.className='vvcc-btn vvcc-btn--ghost'; b2.textContent='Start a '+o.pLabel+' design';
    b1.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); vvSwitchPageVariant(o.dV); });
    b2.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); try{ vvRdTell('geom-offer-fresh',{p:String(o.pV.id)}); }catch(_){ }
      /* 13-Oct P0 review: leave this design ONLY after it has been saved, so the customer's edits are never lost */
      vvGeomSaveThen(b2,'Start a '+o.pLabel+' design',function(){ try{ location.href=location.pathname+'?variant='+encodeURIComponent(String(o.pV.id))+'&vvcc=1&vvfresh=1'; }catch(_){ } }); });
    w.appendChild(b1); w.appendChild(b2);
    var acts=host.querySelector('.vvcc-actions'); if(acts) host.insertBefore(w,acts); else host.appendChild(w);
  }
  /* put the page on the design's size WITHOUT touching the design: push the canvas to a CC state, then reopen this page at
     the design's variant with that state (?vvstate= restore, which re-checks the size against the new variant). A variant
     change event is never fired here: on staging it re-filters the feed and applies that size's starter over the canvas. */
  /* 13-Oct P0 review: save the canvas FIRST. Navigate only when CC confirms the save with a state id. If the save fails,
     times out (15 s) or throws, nothing changes: no navigation, no variant change, the design stays open with its edits,
     the button is re-enabled and the customer is told to try again. */
  function vvGeomSaveThen(btn,label,go){
    var ed=null, p;
    try{ if(btn){ btn.disabled=true; btn.textContent='Saving your design…'; } }catch(e){}
    try{ ed=deepFind('au-widget-design-editor'); p=(ed&&typeof ed.saveProduct==='function')?Promise.resolve(ed.saveProduct()):Promise.reject(new Error('no editor')); }catch(e){ p=Promise.reject(e); }
    vvWithTimeout(p,15000).then(function(r){
      var sid=String((r&&r.stateId)||''), uid=String((r&&r.userId)||'');
      if(!/^[0-9a-f\-]{20,60}$/i.test(sid)) throw new Error('save returned no state id');
      go(sid,uid);
    }).catch(function(err){
      try{ vvRdTell('geom-offer-save-failed',{why:String((err&&err.message)||err||'').slice(0,80)}); }catch(_){ }
      try{ vvInc.mark('geom-offer:save-failed',{why:String((err&&err.message)||err||'').slice(0,80)}); }catch(_){ }
      try{ if(btn){ btn.disabled=false; btn.textContent=label; } }catch(_){ }
      try{ editNotice('We couldn’t save your design just now, so nothing has changed — your design is still open with all your edits. Please try again in a moment.'); }catch(_){ }
    });
  }
  function vvSwitchPageVariant(v){
    try{ vvRdTell('geom-offer-switch',{to:String(v.id),from:String(vid())}); }catch(e){}
    var b=null; try{ b=document.getElementById('vvgeom-switch'); }catch(e){}
    vvGeomSaveThen(b,'Switch to '+vvSizeLabel(v),function(sid,uid){
      var q=new URLSearchParams(location.search);
      ['vvstate','vvuser','vvresume','vvfresh','vvproj','vvsaved','vvforce','vvstyle'].forEach(function(k){ q.delete(k); });
      q.set('variant',String(v.id)); if(!q.get('vvcc')) q.set('vvcc','1');
      q.set('vvstate',sid); q.set('vvuser',uid||guestId()); q.set('vvresume','size-switch');
      try{ window.__vvIntentNav='size-switch'; vvInc.mark('nav:size-switch',{to:String(v.id),sid:sid.slice(0,8)}); }catch(e){}
      location.href=location.pathname+'?'+q.toString();
    });
  }

  function vvGeomBlock(r,where){
    try{ vvRdTell('geom-fail',{v:r.v,mm:r.mm,exp:r.exp,vid:r.vid,where:where}); }catch(e){}
    try{ prep.cancelled=true; prepStop(); }catch(e){}
    /* 13-Oct P0: when the design fits exactly one other size of this product, name both sizes and offer both ways out
       (switch the page to the design's size / start a design at the page's size). Never a silent resize, never a silent switch. */
    try{ var _o=(r.v==='mismatch')?vvGeomOffer():null;
      if(_o){ showState('error','Your design is '+_o.dLabel+' ('+String(_o.mm).replace(/x/g,' \u00d7 ')+' mm); this page is set to '+_o.pLabel+'. We haven\u2019t let it be finished \u2014 nothing has been added to your cart. Switch this page to '+_o.dLabel+' to order the design as it is, or start a new '+_o.pLabel+' design.','Your design is '+_o.dLabel+'; this page is set to '+_o.pLabel);
        vvGeomOfferButtons(_o); try{ vvRdTell('geom-offer',{d:String(_o.dV.id),p:String(_o.pV.id),mm:_o.mm,where:where}); }catch(e){} return; } }catch(e){}
    /* 20-Oct (friction): a SIDE-COUNT mismatch (e.g. A-frame "Two Printed Signs" opened on the one-sided blank
       starter) printed as "606 × 906 mm … selected is 606 × 906,606 × 906 mm" and offered Try again, which reloads
       the same one-sided canvas and fails again. Say what is actually wrong and point at the ways out that work. */
    try{ var _ms=String(r.mm||'').split(',').filter(Boolean), _es=String(r.exp||'').split(',').filter(Boolean);
      if(r.v==='mismatch' && _ms.length && _es.length && _ms.length!==_es.length){
        var _same=_es.every(function(x){ return x===_es[0]; }), _sz=function(x){ return String(x).replace(/x/g,' \u00d7 ')+' mm'; };
        var _sides=function(n){ return n+' printed side'+(n===1?'':'s'); };
        showState('error','This design has '+_sides(_ms.length)+', but the option you chose needs '+_sides(_es.length)+' ('+(_same?(_es.length+' \u00d7 '+_sz(_es[0])):_es.map(_sz).join(' + '))+'), so we haven\u2019t let it be finished \u2014 nothing has been added to your cart. Go back to design ideas and pick a design made for '+_sides(_es.length)+', or upload your own artwork.','This design has '+_ms.length+' side'+(_ms.length===1?'':'s')+'; this option needs '+_es.length);
        return; } }catch(e){}
    showState('error', r.v==='mismatch'
      ? 'The design on screen is '+String(r.mm).replace(/x/g,' \u00d7 ')+' mm, but the size selected is '+String(r.exp).replace(/x/g,' \u00d7 ')+' mm, so we haven\u2019t let it be finished \u2014 nothing has been added to your cart. Tap Try again to reload the design at the selected size.'
      : 'Your design was still changing when you pressed Finish, so we haven\u2019t let it be finished \u2014 nothing has been added to your cart. Tap Try again.',
      'Your design isn\u2019t the size you selected'); }
  function vvDesignReady(){
    var ed=deepFind('au-widget-design-editor'); if(!ed||!edDesignId(ed)) return false;
    if(!VV_RD.idAt) VV_RD.idAt=Date.now();
    if(window.__vvUpPending) return false;   // dd3i: the customer's uploaded file is still being placed
    var sid=''; try{ sid=String(ed.stateId||''); }catch(e){}
    if(!sid) return false; if(!VV_RD.sidAt) VV_RD.sidAt=Date.now();
    vvRdCheck(ed,sid);
    return VV_RD.checkedSid===sid&&VV_RD.surfOk;
  }
  function vvRdLabel(loading){
    try{ if(!VV_RD.label) VV_RD.label=finishBtn.textContent;
      var want=loading?'Loading your design\u2026':VV_RD.label; if(finishBtn.textContent!==want) finishBtn.textContent=want; }catch(e){}
  }
  function vvFinishGate(){
    var ed=deepFind('au-widget-design-editor'); var key=(ed&&edDesignId(ed))||'';
    if(key!==VV_RD.key){ VV_RD.key=key; VV_RD.since=Date.now(); VV_RD.retried=false; VV_RD.failed=false; VV_RD.ok=false; }
    if(vvDesignReady()){
      if(!VV_RD.ok){ VV_RD.ok=true; vvRdTell('ready',{ms:Date.now()-VV_RD.since,surf:VV_RD.surf,retried:VV_RD.retried?1:0,diag:vvRdDiag(deepFind('au-widget-design-editor'))}); }
      vvRdLabel(false); return true;
    }
    if(VV_RD.ok){ VV_RD.ok=false; VV_RD.since=Date.now(); vvRdTell('ready-lost',{}); }   // the editor is rebuilding: a new clock
    vvRdLabel(true);
    if(!key||prep.on||VV_RD.failed||anyStateOn()) return false;   // no design requested yet / finishing / a panel is up: no clock
    var dl=vvRdPoor()?VV_RD_POOR_MS:VV_RD_MS, waited=Date.now()-VV_RD.since;
    if(waited<dl) return false;
    if(!VV_RD.retried){
      VV_RD.retried=true; VV_RD.since=Date.now();
      vvRdTell('ready-retry',{ms:waited,sid:String((ed&&ed.stateId)||'').slice(0,8),surf:VV_RD.surf,diag:vvRdDiag(ed)});
      try{ var sel=deepFind('au-widget-pim-design-selector');
        Promise.resolve().then(function(){ return (sel&&typeof sel.compile==='function')?sel.compile():null; })
          .then(function(){ return (ed&&typeof ed.compile==='function')?ed.compile():null; })
          .catch(function(e){ try{console.warn('[vivid-cc] readiness retry compile failed',e);}catch(_){ } }); }catch(e){}
      return false;
    }
    VV_RD.failed=true;
    vvRdTell('ready-fail',{ms:waited,sid:String((ed&&ed.stateId)||'').slice(0,8),surf:VV_RD.surf});
    if(VV_RD.geom==='mismatch'){ var _gx=vvGeomExpect(); vvGeomBlock({v:'mismatch',mm:VV_RD.surf?vvGeomMm(VV_RD.surf.split(',').map(function(x){ var p=x.split('x'); return {width:+p[0],height:+p[1]}; })):'',exp:_gx?_gx.s.map(function(x){ return x[0]+'x'+x[1]; }).join(','):'',vid:String(vid()||'')},'gate'); return false; }
    try{ showState('error','Your design hasn\u2019t finished loading, so we haven\u2019t let it be finished \u2014 nothing has been added to your cart. Tap Try again; your product and design are kept.','Your design is still loading'); }catch(e){}
    return false;
  }
  function headerSync(){
    var h=wizHeader();
    if(!h){ hdrcover.removeAttribute('data-on'); finishBtn.setAttribute('disabled',''); return; }
    var r=h.getBoundingClientRect(), s=stage.getBoundingClientRect();
    if(r.width>0&&r.height>0){
      // CLAMP TO THE CANVAS TOP (3 Aug). The wizard header ELEMENT is taller than the header
      // BAND it draws: measured 60px (y 96-156) while the editor's own area starts at ~104.
      // Sized to the raw rect, the cover therefore sat over the top ~36px of the design canvas
      // and ate every click there — at the default 10.4% zoom on an 800x2000 banner that is
      // roughly the top 340mm, i.e. the headline, unselectable. Stop the cover where the editor
      // widget begins: the header band is still fully occluded and Aurigma's native Next is
      // still unreachable, but the canvas is the customer's again.
      var edEl=deepFind('au-widget-design-editor');
      var bottom=r.bottom;
      if(edEl){
        var er=edEl.getBoundingClientRect();
        if(er.height>0 && er.top>r.top) bottom=Math.min(bottom,er.top);
      }
      hdrcover.style.left=Math.max(0,r.left-s.left)+'px';
      hdrcover.style.top=Math.max(0,r.top-s.top)+'px';
      hdrcover.style.width=Math.min(r.width,s.width)+'px';
      hdrcover.style.height=Math.max(0,bottom-r.top)+'px';
      hdrcover.setAttribute('data-on','1');
    } else { hdrcover.removeAttribute('data-on'); }
    var nx=nativeNext();
    var nxOn=!!(nx && !nx.disabled && !nx.hasAttribute('disabled'));
    if(nxOn && !finishBtn.__vvGuarded) nxOn=vvFinishGate();   // rc4.2.8: never finish on the placeholder product
    if(nxOn) finishBtn.removeAttribute('disabled');
    else finishBtn.setAttribute('disabled','');
  }
  finishBtn.addEventListener('click',function(){
    // UPDATE 12: the CTA no longer jumps straight to Aurigma's Approval step. It opens our
    // pre-flight checklist (HelloPrint's sequence); the checklist's last Continue drives the
    // native Next, the approval tick and the add, behind the progress modal.
    var nx=nativeNext();
    if(nx && !nx.disabled && !nx.hasAttribute('disabled')) pfOpen();
  });

  // ---- H7 FIX: fire the Design step's onActivate chain that UIF never fires (2 Aug) ---------
  // Workflow 74's step 1 ("Design") declares onActivate:
  //   design-selector.compile() -> editor.compile()
  // but UIF does NOT fire onActivate for the step that is already active at load, so on the
  // storefront the chain never runs: the design-editor's iframe stays on about:blank, stateId
  // stays empty, and the wizard's next step ("Approval") then hangs forever on
  // "Preparing Your Design" because its own onActivate calls editor.saveProduct(stateId) with
  // no state. Running the SAME two public widget calls from here paints the canvas (verified
  // live on pull-up: state created, template rendered, Approval preview rendered, Add to cart
  // produced a real _CC_Design_ID line). ORDER MATTERS — editor.compile() alone resolves with
  // an empty product (iframe stays about:blank); design-selector.compile() must run first.
  // This is a page-side stand-in for a hub-side fix (Shabbir item 1): if the workflow ever
  // gains a native initial-step trigger this block becomes a harmless no-op (the second
  // compile of an already-loaded selection is idempotent).
  // UPDATE 22 — WHY THIS NEEDED READ-BACK. It used to compile ONCE per design id. But UIF pushes
  // the selection into the editor's params.changeDesignVariant ASYNCHRONOUSLY, so that one
  // attempt usually ran before the binding landed, baked the PREVIOUS designVariant, and never
  // tried again — owner's "when i click the designed ones they dont load". Measured then: tile
  // = TD-seasonal-small-Double while the editor's param was still TD-blank-small-Double.
  // So: target = the selected designId, success = the editor's PARAM matching it, retry on a
  // cadence until it does. Never trust a write you have not read back.
  /* 22-Aug — THE GIVE-UP IS THE BUG (owner, on his phone: tapped a design, the studio
     opened with its name in the header and the canvas showed the blank starter).
     MEASURED, instrumenting a real pick on a fast desktop: selection changes at
     34.8s, UIF's binding lands it in the editor's params at 41.8s — 7.0s to settle,
     on office wifi. The old cap was 6x1.2s + 14x5s then STOP FOREVER (~77s); a phone
     on 4G need not be much over 10x slower to blow it, and then kickCompile returns
     forever — no retry, no message, no report, blank canvas under the right name.
     A tries cap was the wrong shape: each retry is read-back gated and nearly free.
     Bound the TIME on the wrong canvas instead, and stop failing silently:
     45s -> warn + Retry + beacon; 5m -> stop and say so. */
  /* 23-Aug — THE BLANK CANVAS WAS SILENT FOR 45 SECONDS, and that silence is what
     the owner kept reporting as "the design does not load". Measured on a fast
     desktop: the selection changes at 34.8s and UIF's binding lands it in the
     editor's params at 41.8s — SEVEN SECONDS of a blank starter canvas with the
     design's name in the header and nothing saying anything is still happening.
     On a phone it is longer. Every customer in that window reasonably concludes
     it is broken and leaves, which is exactly what happened.

     So the NOTICE and the BEACON are now separate thresholds. The strip appears
     at 4s, because by then a blank canvas needs explaining; the beacon still
     waits 45s, because firing on every ordinary 7s load would drown the signal
     it exists to carry. The strip clears the moment the read-back matches. */
  var KICK_NOTICE_MS=4000, KICK_WARN_MS=45000, KICK_GIVEUP_MS=300000;
  /* How long the full-screen 'Opening your design…' cover may stay up before it
     gives way to the non-blocking strip. Long enough for a phone on 4G, short
     enough that nobody is ever stuck behind white over a usable editor. */
  /* 25s covers the design binding on a phone. It briefly went to 45s while the
     editor bootstrap was being moved inside this cover; that experiment is
     reverted (see __vvCCLaunch), so the shorter budget is correct again. */
  var VVBR_PICK_MAX_MS=25000;
  /* ---- Observability-only, behaviour-neutral (added 2026-10-05) --------------
     design-apply lifecycle beacons to the portal, LOG-ONLY (no email), privacy-safe
     (no artwork, design content or customer text). Mirrors galBeat. Changes NOTHING
     about the apply algorithm, the kick cadence or the 300s budget — it only reports
     them, so success / recovery / giveup RATES become measurable. */
  function applyTel(ev,extra){
    try{
      var _cn={}; try{ var _c=navigator.connection||{}; _cn={et:_c.effectiveType||'',dl:_c.downlink||0,rtt:_c.rtt||0,sd:!!_c.saveData}; }catch(e){}
      var _att=(function(){try{return ccKick?ccKick.tries:0;}catch(e){return 0;}})();
      var p={ev:ev, ts:new Date().toISOString(), phase:'design-apply',
        eid:ev+'|'+(function(){try{return (ccKick&&ccKick.t0)||0;}catch(e){return 0;}})()+'|'+(function(){try{return String(vid());}catch(e){return '';}})(),
        productId:(typeof PRODUCT_ID!=='undefined'?PRODUCT_ID:''),
        handle:(window.__VVCC&&window.__VVCC.HANDLE)||'',
        variant:(function(){try{return String(vid());}catch(e){return '';}})(),
        entry:(function(){try{return (typeof EDIT!=='undefined'&&EDIT&&EDIT.proj)?'edit-from-cart':((typeof BROWSE_MODE!=='undefined'&&BROWSE_MODE)?'gallery':'direct');}catch(e){return 'direct';}})(),
        /* 6-Oct: the entry WAY (blank / upload / template / direct) so the funnel can be read by way — the incident
           could only be attributed to ?vvcc=blank by hand */
        way:(function(){try{ var m=(location.search||'').match(/[?&]vvcc=(blank|upload)/); if(m) return m[1]; if(/[?&]vvstyle=/.test(location.search||'')) return 'template'; return (typeof BROWSE_MODE!=='undefined'&&BROWSE_MODE)?'browse':'direct'; }catch(e){ return 'unknown'; }})(),
        designApplyAttempts:_att,
        warned:!!(function(){try{return ccKick&&ccKick.warned;}catch(e){return false;}})(),
        kageMs:(function(){try{return (ccKick&&ccKick.t0)?(Date.now()-ccKick.t0):0;}catch(e){return 0;}})(),
        uid:(function(){try{return guestId();}catch(e){return '?';}})(),
        conn:_cn, vp:innerWidth+'x'+innerHeight, ua:navigator.userAgent.slice(0,160),
        build:(window.__vvGalBuild||''),inc:vvInc.id,kind:vvInc.kind(),lastStage:(function(){try{var t=vvInc.snapshot().timeline;return t.length?t[t.length-1].s:'';}catch(e){return '';}})()};
      if(extra)for(var k in extra)p[k]=extra[k];
      var s=JSON.stringify(p), blob=new Blob([s],{type:'text/plain'});
      if(!(navigator.sendBeacon&&navigator.sendBeacon(PORTAL+'/api/cc-apply-telemetry',blob)))
        fetch(PORTAL+'/api/cc-apply-telemetry',{method:'POST',body:s,keepalive:true,headers:{'Content-Type':'text/plain'}}).catch(function(){});
    }catch(e){}
  }
  try{ addEventListener('pagehide',function(){ try{ if(ccKick&&ccKick.want&&!ccKick.loaded&&!ccKick.dead) applyTel('apply-abandon'); }catch(e){} },{capture:true}); }catch(e){}
  var ccKick={loaded:false,busy:false,last:null,want:null,tries:0,at:0,t0:0,warned:false,noticed:false,dead:false,telConfirmed:false};
  function edDesignId(ed){
    try{ return ed.params.changeDesignVariant.designVariant.designId; }catch(e){ return null; }
  }
  /* Non-blocking strip at the bottom of the editor — deliberately NOT the full-screen
     error panel: the editor is up and usable, and covering a working canvas would be
     worse than the thing being reported. spinner=true while still retrying. */
  function kickNotice(on,msg,spinner){
    var el=document.getElementById('vvk-n');
    if(!on){ if(el)el.remove(); return; }
    if(!el){
      el=document.createElement('div'); el.id='vvk-n';
      el.setAttribute('style','position:fixed;left:50%;transform:translateX(-50%);bottom:18px;'
        +'z-index:99997;max-width:min(92vw,520px);display:flex;align-items:center;gap:10px;'
        +'padding:11px 14px;border-radius:10px;background:#191919;color:#fff;'
        +'font-size:14px;line-height:1.35;box-shadow:0 6px 24px #0003');
      el.innerHTML='<style>@keyframes vvk{to{transform:rotate(360deg)}}</style>'
        +'<i id="vvk-s" style="width:15px;height:15px;flex:0 0 15px;border:2px solid #fff6;'
        +'border-top-color:#fff;border-radius:50%;animation:vvk .8s linear infinite"></i>'
        +'<span id="vvk-m" style="flex:1 1 auto"></span>'
        +'<button type="button" id="vvk-r" style="flex:0 0 auto;background:#d6202b;color:#fff;'
        +'border:0;border-radius:7px;padding:7px 12px;font:inherit;font-weight:600">Retry</button>';
      document.body.appendChild(el);
      el.querySelector('#vvk-r').addEventListener('click',function(){
        ccKick.tries=0; ccKick.at=0; ccKick.t0=Date.now(); ccKick.warned=false; ccKick.noticed=false; ccKick.dead=false;
        kickNotice(true,'Still loading the design you picked…',true);
        try{ kickCompile(); }catch(e){}     // same chain the loop uses, clean budget
      });
    }
    var m=el.querySelector('#vvk-m'); if(m)m.textContent=msg||'';
    var s=el.querySelector('#vvk-s'); if(s)s.style.display=spinner?'':'none';
  }
  /* The gallery is a view onto the editor's rail, so the cards you can already see
     are real but the rest of the wall — and every tap — only works once the mount
     finishes. Says so, without covering what has loaded.
     Cleared by whichever comes first: the mount finishing, or the backstop. The
     backstop matters because a strip that outlives its reason is worse than none:
     it would sit there over a working gallery telling the customer to wait. */
  var BOOT_NOTICE_MAX_MS=90000;
  var _bootT=null;
  function bootNotice(on){
    var el=document.getElementById('vvbr-boot');
    if(!on){ if(el)el.remove(); if(_bootT){clearInterval(_bootT);_bootT=null;} return; }
    if(!el){
      el=document.createElement('div'); el.id='vvbr-boot';
      el.setAttribute('style','position:fixed;left:50%;transform:translateX(-50%);bottom:18px;'
        +'z-index:99997;max-width:min(92vw,520px);display:flex;align-items:center;gap:10px;'
        +'padding:11px 14px;border-radius:10px;background:#191919;color:#fff;'
        +'font-size:14px;line-height:1.35;box-shadow:0 6px 24px #0003;pointer-events:none');
      el.innerHTML='<style>@keyframes vvbb{to{transform:rotate(360deg)}}</style>'
        +'<i style="width:15px;height:15px;flex:0 0 15px;border:2px solid #fff6;'
        +'border-top-color:#fff;border-radius:50%;animation:vvbb .8s linear infinite"></i>'
        +'<span style="flex:1 1 auto">Loading the rest of the designs&hellip;</span>';
      document.body.appendChild(el);
    }
    if(_bootT)clearInterval(_bootT);
    var t0=Date.now();
    /* Polling rather than a callback on purpose: while the bootstrap holds the
       main thread nothing fires anyway, and the first tick after it lets go is
       exactly when this should disappear. */
    _bootT=setInterval(function(){
      if(booted || Date.now()-t0>BOOT_NOTICE_MAX_MS || modal.hasAttribute('hidden')) bootNotice(false);
    },400);
  }

  function kickCompile(){
    /* 24-Aug BUSY WATCHDOG. Reproduced on desktop (FBS, size-switch relaunch):
       after a pick the selector held the picked design, the editor sat on the
       blank starter for 60s+, and ONE manual sel.compile()+ed.compile() from
       the console applied it in ~4s — so the chain works and this loop simply
       was not firing. A compile() started just as UIF tears down / re-renders
       the widget can be a promise that never settles, and busy had no timeout,
       so one such hang latched this function shut for the rest of the session.
       15s is far beyond any observed successful compile round-trip. */
    if(ccKick.busy){
      if(ccKick.busyAt && Date.now()-ccKick.busyAt>15000){ ccKick.busy=false; ccKick.busyAt=0;
        try{console.warn('[vivid-cc] compile kick hung >15s - busy latch cleared');}catch(e){} }
      else return;
    }
    var sel=deepFind('au-widget-pim-design-selector'), ed=deepFind('au-widget-design-editor');
    if(!sel||!ed||typeof ed.compile!=='function')return;
    var cur=null; try{ cur=sel._&&sel._.designId; }catch(e){}
    /* 23-Aug — THIS LOOP WAS CHECKING THE WRONG THING, and that is why it reported
       success while the customer looked at the blank starter. Its target was
       whatever the SELECTOR happened to hold, so when the tile tap failed to move
       the selector, selector and editor agreed with each other on the initial
       design and the read-back passed. Measured on the owner's iPhone: picked
       d86193f9, selector and editor both c9b55afb, loop satisfied after one try.
       The target is the design the CUSTOMER picked. Nothing else is success. */
    var want=(browse.entered&&browse.pickedId)||null;
    var cur0=cur; cur=want||cur;
    if(!cur)return;                              // nothing selected yet
    /* 30-Sep — DUPLICATE NAMES. Customer's Canvas holds two designIds under one name
       ("PullUp-aut-battry-800x2000": 45d5a06e… and a6bb51ce…); the rail's first page
       shows one, the full page the other. Judging by id alone made every warm pull-up
       pick fail its read-back for 30 s — and re-tap the tile on every tick meanwhile.
       Same name = same design: that is the read-back too. */
    var _edn=null; try{ _edn=ed.params.changeDesignVariant.designVariant.designName; }catch(e){}
    var _sameName=!!(want&&browse.pickedName&&_edn&&_edn===browse.pickedName);
    if(want&&cur0!==want&&!_sameName){
      /* The selector is still on another design — re-firing compile() would only
         re-apply that one. Re-tap the tile first, with the full event sequence. */
      var rt=browse.pickedName?browseTileFor(browse.pickedName):null;
      if(rt) browseTap(rt);
    }
    /* 7-Oct-2026 P0: the picked row may have been another SIZE of the same style on the unfiltered feed (above). Once the feed is
       filtered the rail holds only this variant's row and CC has loaded it: picked id gone from the rail + editor holds a
       same-style row that IS on the rail → that row is the pick. Marked, so the record says the size was corrected. */
    try{ var _edNow=edDesignId(ed); if(want&&browse.pickedName&&vvFeedSettled()&&((_edNow!==want&&!_sameName)||((vvRailSizeKeys().length&&vvHasSize(browse.pickedName)&&!vvRailSizeMatch(browse.pickedName))||!vvSideOk(browse.pickedName)))){   // rc4.2.5: also when the editor holds the wrong pick
      var _rows2=sel.displayedVariants||[], _onRail=false, _styleRow=null, _ps=null; try{ _ps=browseStyleOf(browse.pickedName); }catch(e){}
      for(var _q=0;_q<_rows2.length;_q++){ var _r2=_rows2[_q]; if(String(_r2.designId||'')===String(want)){ _onRail=true; break; }
        if(_ps&&!_styleRow){ var _es=null; try{ _es=browseStyleOf(_r2.designName||''); }catch(e){} if(_es&&vvStyleSame(_ps,_es)) _styleRow=_r2; } }
      if(!_onRail&&_styleRow&&_rows2.length){ try{ vvInc.mark('apply:size-corrected',{from:browse.pickedName,to:_styleRow.designName,editorHas:String(_edNow||'').slice(0,12)}); }catch(e){}
        try{ console.log('[vivid-cc] picked another size of this style on the unfiltered feed; this variant\'s row is',_styleRow.designName); }catch(e){}
        browse.pickedName=_styleRow.designName; browse.pickedId=_styleRow.designId; want=_styleRow.designId; cur=want;
        _sameName=false;                                                          // rc4.2.5: the old same-name pass was for the wrong pick
        if(String(_edNow||'')===String(want)) _sameName=true;                    // CC already loaded it (the front-loaded row) → confirmed below
        else { var _rt2=browseTileFor(_styleRow.designName); if(_rt2) browseTap(_rt2); }   // otherwise tap this variant's row
      } } }catch(e){}
    /* rc4.2.5: never confirm a pick named for another size or sides while the feed is still unfiltered (bounded 20 s). */
    try{ if(browse.pickedName&&((vvRailSizeKeys().length&&vvHasSize(browse.pickedName)&&!vvRailSizeMatch(browse.pickedName))||!vvSideOk(browse.pickedName))&&!vvFeedSettled()&&Date.now()-(ccKick.holdT0||(ccKick.holdT0=Date.now()))<20000){
      if(!ccKick.heldSize){ ccKick.heldSize=1; try{ vvInc.mark('apply:hold-size',{picked:browse.pickedName,key:vvRailSizeKey(),side:vvRailSideKey()}); }catch(e){} }
      return; } }catch(e){}
    if(edDesignId(ed)===cur||_sameName){         // READ-BACK: the editor really has this design
      if(ccKick.last!==cur){ ccKick.last=cur; ccKick.loaded=true; }
      try{ if(!ccKick.telConfirmed){ ccKick.telConfirmed=true; try{ vvInc.mark('apply:confirmed',{kicks:ccKick.tries,ageMs:Date.now()-(ccKick.t0||Date.now())}); }catch(_){} applyTel(ccKick.warned?'apply-recovered':'apply-confirmed'); } }catch(e){}
      kickNotice(false);                         // it landed — clear any "still loading" notice
      // ...and lift the cover from browsePick(). This is the ONLY success signal
      // either of them has: the editor's own params naming the picked design.
      try{ if(browse.pickWaitAt){ browse.pickWaitAt=0; browseWait(false); } }catch(e){}
      return;
    }
    if(ccKick.want!==cur){                       // new target: fresh budget, fresh notice state
      ccKick.want=cur; ccKick.tries=0; ccKick.at=0;
      ccKick.t0=Date.now(); ccKick.warned=false; ccKick.noticed=false; ccKick.dead=false; kickNotice(false);
      ccKick.telConfirmed=false; try{ vvInc.mark('apply:start',{want:String(ccKick.want||'').slice(0,60)}); }catch(e){} try{ applyTel('apply-start'); }catch(e){}
    }
    // Cadence history: 5-Aug (UPDATE 34, ROUND 15c, media-wall) proved the binding can settle
    // slower than the then-budget of 6x1.2s, and that a manual sel.compile()+ed.compile()
    // minutes later applied the pick cleanly — the chain is right, only the budget was wrong.
    // The 1.2s fast lane / 5s patient lane below is from that. The 20-try cap it also added is
    // now a TIME budget (block above), because phones were hitting it and hitting it meant silence.
    if(ccKick.dead)return;                       // already gave up and said so
    var kage=Date.now()-(ccKick.t0||Date.now());
    if(kage>KICK_GIVEUP_MS){                     // 5 minutes: stop, and be honest about it
      ccKick.dead=true;
      try{ if(browse.pickWaitAt){ browse.pickWaitAt=0; browseWait(false); } }catch(e){}
      kickNotice(true,'We couldn’t load that design. Please go back and pick it again, or start from a blank canvas.',false);
      try{ beaconPhase='design-apply'; mountStage('design-apply-giveup@'+Math.round(kage/1000)+'s');
           mountBeacon(true); beaconPhase='mount'; }catch(e){}
      try{ applyTel('apply-giveup'); }catch(e){}
      return;
    }
    if(kage>KICK_NOTICE_MS && !ccKick.noticed){  // 4s: say something rather than show a blank canvas
      ccKick.noticed=true;
      // If the pick cover is up it is already saying this, and better; only put the
      // strip up once we are showing the customer the canvas again.
      if(!browse.pickWaitAt) kickNotice(true,'Still loading the design you picked…',true);
    }
    if(kage>KICK_WARN_MS && !ccKick.warned){     // 45s: this one is slow enough that we want to know
      ccKick.warned=true;
      try{ beaconPhase='design-apply'; mountStage('design-apply-slow@'+Math.round(kage/1000)+'s');
           mountBeacon(false); beaconPhase='mount'; }catch(e){}
      try{ applyTel('apply-slow'); }catch(e){}
    }
    var kgap=ccKick.tries<6?1200:5000;           // fast lane -> patient lane
    if(Date.now()-ccKick.at<kgap)return;         // let the binding settle between attempts
    ccKick.at=Date.now(); ccKick.tries++; ccKick.busy=true; ccKick.busyAt=Date.now(); ccKick.last=cur;
    try{ if(ccKick.tries<=6||ccKick.tries%5===0) vvInc.mark('apply:kick',{n:ccKick.tries,ageMs:kage,want:String(cur).slice(0,60),editorHas:String(edDesignId(ed)||'').slice(0,60)}); }catch(e){}

    // A gallery click alone changes nothing (the workflow sets autoCompile:false), so the same
    // two calls re-run on every selection change. Do NOT push the variant with
    // updateParamsAsync({changeDesignVariant}) here: tried on teardrop, it re-applies the
    // workflow's DUMMY initial.productDefinition ({surfaces:[{width:1,height:1}]}) and the
    // editor comes back with a 1x1 surface (zoom 63697%, only the Background layer). Letting
    // UIF's own binding feed $['design-selector']._ into the widget and just re-compiling keeps
    // the design's real surface.
    Promise.resolve()
      .then(function(){ return (typeof sel.compile==='function') ? sel.compile() : null; })
      .then(function(){ return ed.compile(); })
      .then(function(){ ccKick.loaded=true; })
      .catch(function(e){ try{console.warn('[vivid-cc] design compile kick failed',e);}catch(_){ } })
      .then(function(){ ccKick.busy=false; });
  }

  // ---- Design-gallery tile size, matched to HelloPrint/Canva (UPDATE 11) ----
  // Measured live in the owner's Chrome (window 3440 CSS px):
  //   HelloPrint's Canva embed — templates panel ~360px, thumbnails in a THREE-column grid at
  //   ~102 x ~209 CSS px (cards follow the design's own aspect ratio).
  //   Ours, before this — rail 278px, TWO columns at 135 x 135 (the widget forces aspect-ratio
  //   1/1, so a tall banner is letterboxed inside a square card).
  // The widget exposes its own CSS custom properties on :host (--min-items-width / --gap /
  // --max-items-width) and the grid is auto-fill, so tile size is a supported one-property
  // change — no injection into Aurigma's shadow DOM and nothing that depends on its class names.
  // 86px is the largest min-width that still fits THREE columns in the 278px rail
  // (3*86 + 2*8 gap = 274), which reproduces HelloPrint's three-up density at ~87px per tile.
  // Residual, deliberate differences: our rail is 278px vs their 360px, and the widget's
  // aspect-ratio:1/1 card is hub/UIF-side, not ours — both noted for Shabbir.
  // NOTE: --min-items-width alone is not enough. The widget computes its own
  // --columns-number (inline, at mount) and the grid is repeat(var(--columns-number), …), so the
  // column count must be set too — verified live: with both set the rail renders 3 x 87px.
  var GALLERY_MIN_ITEM='86px', GALLERY_COLS='3';
  // Product options belong on the PDP, not in the editor rail (UPDATE 20). Flip to false to
  // restore Aurigma's native Size / Printed Sides / Flag Base groups inside the editor.
  var HIDE_EDITOR_PRODUCT_OPTIONS=true;
  function sizeGallery(){
    var sel=deepFind('au-widget-pim-design-selector');
    if(!sel)return;
    if(sel.style.getPropertyValue('--min-items-width')!==GALLERY_MIN_ITEM)
      sel.style.setProperty('--min-items-width',GALLERY_MIN_ITEM);
    if(sel.style.getPropertyValue('--columns-number')!==GALLERY_COLS)
      sel.style.setProperty('--columns-number',GALLERY_COLS); // widget re-computes on resize
  }

  // ---- The product-option groups do not belong in the editor (UPDATE 20) ---
  // Owner, 3 Aug, with a screenshot of the rail: Size / Printed Sides / Flag Base radio groups
  // sitting under the template gallery. "this is not how its setup on easy signs or hello print" —
  // and he is right: their editor rail is Text / Image / Shape / Barcode + Layers, nothing else.
  // The customer configures the product on the PDP; the editor is for artwork.
  //
  // These appeared the moment teardrop 394 moved from workflow 72 to 74 (see
  // CUSTOMERS-CANVAS-INTEGRATION §19) — 74's `sidebar` group declares a second tab holding a
  // pim-options widget. Pull-up 522 has been on 74 all along and has shown a "Size" group all along.
  //
  // WHY HIDE RATHER THAN REMOVE THE WIDGET FROM THE WORKFLOW:
  //  · workflow 74 is shared by ~40 live products — editing it is a catalogue-wide blast radius,
  //    and the finish chain reads `$['pim-options']._`, so deleting the widget risks the very
  //    stall §19 just closed.
  //  · display:none keeps the element MOUNTED. Its value, and every binding that reads it, keep
  //    working exactly as before — this is occlusion, the same principle as the header cover and
  //    the Aurigma preloader panel. Nothing is taken away from the widget.
  // The PDP selection already drives which designs are offered and which canvas opens (galSync
  // above), and resolveCartVariant keys the cart line off the PDP variant, so nothing downstream
  // needs the customer to touch these controls.
  //
  // MID-DESIGN SIZE CHANGE: with the groups hidden the path is close the editor → change the
  // option on the PDP → reopen, which is exactly Easy Signs' model (their "Edit configuration"
  // leaves the editor too). Work in progress is preserved by the existing autosave.
  function hideProductOptions(){
    if(!HIDE_EDITOR_PRODUCT_OPTIONS) return;
    var n=0;
    (function scan(root,d){ if(!root||d>13)return;
      var els=root.querySelectorAll?root.querySelectorAll('au-widget-pim-options'):[];
      for(var i=0;i<els.length;i++){
        var e=els[i];
        // hide the whole tab panel (au-widget wrapper) so its heading goes with it
        var host=(e.parentElement&&e.parentElement.tagName&&
                  e.parentElement.tagName.toLowerCase()==='au-widget')?e.parentElement:e;
        if(!host.hasAttribute('data-vv-cc-optshidden')){
          host.style.setProperty('display','none','important');
          host.setAttribute('data-vv-cc-optshidden','1'); n++;
        }
      }
      var kids=root.querySelectorAll?root.querySelectorAll('*'):[];
      for(var j=0;j<kids.length;j++){ if(kids[j].shadowRoot) scan(kids[j].shadowRoot,d+1); }
    })(box,0);
    return n;
  }

  // ---- PDP SELECTION DRIVES THE EDITOR (UPDATE 16) -------------------------
  // Owner, 3 Aug: "when i use double sided option in the products page it should show me the
  // double sided flag to design ... you are showing all size and other options in the left menu
  // this is not how its setup on easy signs or hello print".
  //
  // What was happening, measured on teardrop 394 (tenant 27, storefront 54): the design-selector's
  // feed is one row per (product variant x design) — 156 rows, 7 pages — so the rail listed EVERY
  // size and side at once. A customer who chose Double-sided on the PDP was shown small, medium and
  // large singles and doubles mixed together, and the editor opened on whatever came first
  // ("01 - DYO- 818x1605", a SMALL SINGLE). Design one, buy another — resolveCartVariant then
  // refuses the add, so the reward for designing was an error message.
  //
  // TWO ROUTES WERE TRIED AND REJECTED before this one. Recording both so nobody repeats them:
  //  1. pim-ajax `choices`. Workflow 74 wires the design feed's choices param to a pim-options
  //     widget that the workflow DOES NOT DECLARE, so it resolves to undefined and is dropped
  //     (read back live: pim-ajax.params has no choices key). Pushing choices in by hand —
  //     four different shapes — left the feed at 156 rows every time.
  //  2. Replacing the design-selector's `variants` array. It renders (rail correctly showed the 6
  //     matching designs) but it BREAKS SELECTION: the iron-selector still holds a selected id from
  //     the original model, cannot reconcile it against the replacement, and silently swallows every
  //     click — _selectedOnCurrentPage never moves. A filtered gallery you cannot pick from is worse
  //     than an unfiltered one, so this was reverted before shipping.
  //
  // WHAT THIS DOES INSTEAD — nothing is taken away from the widget, so its own machinery keeps
  // working. Two supported moves plus a purely visual one:
  //   a) updateParamsAsync({itemsPerPage}) — a documented param of this widget — puts every row on
  //      one page, so the matches can never be split across pagination.
  //   b) the non-matching tiles are hidden with an inline display:none on the rendered tile. The
  //      model is untouched, so clicks resolve exactly as they always did.
  //   c) one auto-selection per launch, by clicking the first visible tile, verified by read-back.
  // Verified live: teardrop Medium + Double-sided -> rail shows the 6 medium doubles, clicking one
  // selects sku VDK27MHG-GS with options Medium / Double-sided / Ground Spike, and the canvas opens
  // as the SIDE-BY-SIDE double. (If Shabbir ever adds a real pim-options widget to 74 this becomes
  // redundant; it no-ops as soon as the feed already matches the selection.)
  //
  // Rules:
  //  · Match on option TITLE + VALUE TITLE, normalised — never on hardcoded tag ids. Teardrop's ids
  //    have already moved once (docs record Size 3477 / Printed Sides 3478; live is 3879/3880/3881),
  //    so any hardcoded id would have rotted. Titles are what CC and Shopify genuinely share.
  //  · FAIL OPEN. A CC option is constrained only when its title matches a Shopify option name AND
  //    the customer's chosen value exists among CC's values for it. Nothing lines up (pull-up 522's
  //    CC data is known-wrong — one variant, a sku that exists nowhere in Shopify) -> rail untouched.
  //    A filter that would empty the rail is discarded for the same reason.
  //  · CALCULATOR PRODUCTS: their size is a custom W x H, not an option value, so Size never matches
  //    and their gallery stays unfiltered — they open on the full library. Documented, not papered
  //    over: this workflow has no arbitrary-canvas entry point, so there is nothing to preselect.
  //  · Duplicate rows collapse: a design bound to 4 Flag Base values is 4 feed rows but one design.
  //    Only the first is shown, so the rail lists designs, not permutations.
  var gal={hold:0,auto:false,tries:0,at:0,paged:false,el:null};
  function galReset(){ gal={hold:0,auto:false,tries:0,at:0,paged:false,el:null}; }
  // UPDATE 22: once the customer has touched the gallery, the auto-selection machinery stands
  // down for the rest of the session. It lives OUTSIDE gal{} on purpose — galReset() runs whenever
  // the feed changes, and a customer's explicit choice must survive that. Their click always wins.
  var galUser=false;

  // ---- UPDATE 21: the design FEED must follow the PDP -----------------------
  // Owner, 3 Aug: "when i click the design button it loads a single sided template and same when
  // i press edit from cart". Root cause, read live off the widgets:
  //
  //   pim-ajax.params.choices is bound to $['pim-options']._ , so the design feed is filtered
  //   SERVER-SIDE by whatever the pim-options widget holds. Nothing ever synced that widget from
  //   the PDP, so it sat on its DEFAULTS (each option's isDefault value = Small / Single-sided /
  //   Ground Spike). The feed therefore came back as 7 rows, every one of them Single-sided,
  //   for a customer who had chosen Double-sided. UPDATE 20 then hid the widget, which removed
  //   the only way a customer could have corrected it by hand — so the wrong side became certain
  //   instead of merely likely. Measured: pim-options._ = {3894:[21595],3895:[21598],3896:[21600]}
  //   with the PDP on Double-sided + Premium Cross Base, whose real ids are 21599 / 21601.
  //
  // This is also why galSync alone could not save it: galKeys only constrains an option when the
  // customer's value EXISTS among the feed's values for it. With a Single-sided-only feed,
  // "Printed Sides" was silently dropped from the constraint set, leaving Size as the only filter
  // — so all 7 single-sided rows matched and the auto-click opened a single-sided design.
  //
  // Fix: push the PDP's selection into pim-ajax's own documented updateParamsAsync as `choices`,
  // built from the pim-options widget's OWN model so no id is ever hardcoded (ids have now moved
  // twice: docs say Size 3477, then 3879, live is 3894). Matching is on normalised option and
  // value TITLE, the only thing Shopify and CC genuinely share.
  // TIMING, and it is the whole game: updateParamsAsync is LAZY. Measured live — immediately after
  // `await aj.updateParamsAsync({choices})`, aj.params.choices is STILL the old value; it only flips
  // ~8 s later, and pim-options._ flips with it. So a fire-once call that assumes success is wrong
  // twice over: the first attempt lands while the widget graph is still initialising and gets
  // overwritten by the graph's own push of the option DEFAULTS, and the code has already marked
  // itself done. That is exactly what shipped and still opened Single-sided.
  // Therefore: the only proof is READ-BACK of aj.params.choices, and we retry on a cadence until it
  // matches. Same discipline as everything else here — never trust a write you have not read back.
  var feed={want:'',ok:false,last:0,tries:0};
  function feedReset(){ feed={want:'',ok:false,last:0,tries:0}; }
  // {choices:{optionId:[valueId]}, missing:[option names], all:bool} or null
  function feedChoices(){
    var po=deepFind('au-widget-pim-options'); if(!po||!po.options||!po.options.length) return null;
    var chosen=pdpChosen(); if(!chosen) return null;
    var choices={}, missing=[], n=0;
    for(var i=0;i<po.options.length;i++){
      var w=po.options[i], op=w&&w.params&&w.params.option;
      if(!op||!op.id) continue;
      var want=chosen[vnorm(op.name)], vals=op.values||[], hit=null;
      if(want!==undefined){
        for(var j=0;j<vals.length;j++){ if(vnorm(vals[j].name)===want){ hit=vals[j]; break; } }
      }
      if(hit){ choices[op.id]=[hit.id]; n++; } else { missing.push(op.name); }
    }
    if(!n) return null;                       // nothing lined up — leave the feed alone
    return {choices:choices, missing:missing, all:missing.length===0};
  }
  function feedSync(){
    var aj=deepFind('au-widget-pim-ajax'); if(!aj||!aj.params) return;
    var c=feedChoices(); if(!c) return;
    var target=JSON.stringify(c.choices);
    var key=target+'@'+String(vid());         // re-syncs when the customer changes the PDP variant
    if(feed.want!==key){ feed.want=key; feed.ok=false; feed.tries=0; feed.last=0; }
    if(feed.ok) return;
    // READ-BACK: it actually took. UPDATE 33b: the hub-served UIF build (hash
    // q4lhgv43a0, rolled out 4 Aug 2026 platform-side) STOPPED echoing applied
    // choices on the public aj.params.choices (stays []) while still applying
    // them internally (aj._params.choices + client-side filterOutput — proven
    // by the design set switching per variant). Read the public echo first
    // (older/fixed builds), then the applied private state. Without this the
    // feed read-back never confirms and the browse gallery skeletons forever.
    var applied=aj.params.choices;
    if(!applied||(Array.isArray(applied)&&!applied.length))
      applied=(aj._params&&aj._params.choices)||applied;
    if(JSON.stringify(applied||null)===target){
      feed.ok=true; galReset();               // new feed ⇒ let the gallery re-evaluate and select
      try{ vvInc.mark('feed:filtered-ok'); }catch(e){}
      return;
    }
    if(feed.tries>=40) return; // 16-Aug SSW: 6 tries lost the init race and the feed NEVER landed -> 0-design gallery on a range bound to one size; galSync only filters client-side, it cannot fetch
    if(Date.now()-feed.last<2500) return;     // give the previous attempt time to land
    feed.last=Date.now(); feed.tries++;
    try{ aj.updateParamsAsync(Object.assign({},aj.params,{choices:c.choices})); }
    catch(e){ console.warn('[vivid-cc] feedSync failed',e); }
  }


  function pdpChosen(){   // normalised {shopify option name -> chosen value} for the live variant
    var id=String(vid()), v=null;
    for(var i=0;i<SHOPIFY_VARIANTS.length;i++){ if(String(SHOPIFY_VARIANTS[i].id)===id){ v=SHOPIFY_VARIANTS[i]; break; } }
    if(!v||!v.options) return null;
    var m={};
    for(var j=0;j<PRODUCT_OPTION_NAMES.length;j++){
      var n=vnorm(PRODUCT_OPTION_NAMES[j]); if(n) m[n]=vnorm(v.options[j]);
    }
    return m;
  }
  function galKeys(rows){ // which CC options we are entitled to constrain, and to what
    var chosen=pdpChosen(); if(!chosen) return null;
    var byOpt={};
    rows.forEach(function(r){ (r.options||[]).forEach(function(o){
      var t=vnorm(o.productOptionTitle); if(!t) return;
      (byOpt[t]=byOpt[t]||{})[vnorm(o.productOptionValueTitle)]=1; }); });
    var want={}, keys=[];
    for(var t in byOpt){ if(chosen[t]!==undefined && byOpt[t][chosen[t]]){ want[t]=chosen[t]; keys.push(t); } }
    return keys.length?{want:want,keys:keys}:null;
  }
  /* 21-Aug BURST FIX — the gallery hang, root-caused. galSync's (a) flattens
     CC's rail to ONE page of the whole catalogue so browseTileFor can resolve a
     tile by index. Necessary — browseCollect and click-to-select both depend on
     tiles.length===rows.length — but CC renders an <img> per tile, and eager
     images load even when occluded. Measured at gallery-open: bollards fired
     501 requests to api.au.customerscanvashub.com/.../resources/{id}/file
     (pull-ups 245), ~6 connections per host, half the responses >2s — minutes
     of queued network for a rail the customer NEVER SEES in browse mode. That
     queue is the "hang", and it is why bollards (500 designs) feels worse than
     pull-ups (254): same mechanism, double the volume.
     Fix: stamp every img inside the rail's shadow root loading="lazy". Combined
     with the display:none host (extended below to cover the browse phase — the
     same hidden state UPDATE 30/36 proved safe for reads AND tile clicks), a
     lazy img has no box, never intersects, never fetches. The flatten, the
     tile-by-index resolution, the click and the swap-verify are UNTOUCHED —
     which design goes to print is decided by exactly the same code as before. */
  var railImgMo=null;
  function railImgCalm(sel){
    if(!BROWSE_MODE||!sel||!sel.shadowRoot)return;
    function stamp(root){
      try{
        var imgs=root.querySelectorAll?root.querySelectorAll('img:not([loading])'):[];
        for(var i=0;i<imgs.length;i++){ imgs[i].setAttribute('loading','lazy'); imgs[i].setAttribute('decoding','async'); }
      }catch(e){}
    }
    stamp(sel.shadowRoot);
    try{
      if(railImgMo)railImgMo.disconnect();
      railImgMo=new MutationObserver(function(ms){
        for(var i=0;i<ms.length;i++){ var ns=ms[i].addedNodes;
          for(var j=0;j<ns.length;j++){ var n=ns[j];
            if(n.nodeType!==1)continue;
            if(n.tagName==='IMG'){ if(!n.getAttribute('loading')){ n.setAttribute('loading','lazy'); n.setAttribute('decoding','async'); } }
            else stamp(n);
          }
        }
      });
      railImgMo.observe(sel.shadowRoot,{childList:true,subtree:true});
    }catch(e){}
  }
  function galSync(){
    var sel=deepFind('au-widget-pim-design-selector'); if(!sel||!sel.shadowRoot) return;
    if(gal.el!==sel){ gal.el=sel; gal.paged=false; gal.auto=false; gal.tries=0; gal.at=0;
      try{ sel.addEventListener('click',function(){ gal.hold=Date.now()+1200; galUser=true; },true); }catch(e){}
      try{ railImgCalm(sel); }catch(e){}
    }
    var rows=sel.displayedVariants||[]; if(!rows.length) return;
    var all=sel.variants||[];
    // (a) one page, so a match can never be hidden behind pagination
    if(!gal.paged && all.length>rows.length){
      gal.paged=true;
      try{ sel.updateParamsAsync(Object.assign({},sel.params||{},{itemsPerPage:Math.max(all.length,50)})); }catch(e){ gal.paged=false; }
      return;
    }
    var k=galKeys(all.length?all:rows); if(!k) return;    // nothing to constrain -> leave it alone
    var tiles=sel.shadowRoot.querySelectorAll('.gallery__item');
    if(tiles.length!==rows.length) return;                // mid-render; try again next tick
    var seen={}, first=null, shown=0;
    for(var i=0;i<rows.length;i++){
      var have={}; (rows[i].options||[]).forEach(function(o){ have[vnorm(o.productOptionTitle)]=vnorm(o.productOptionValueTitle); });
      var ok=true;
      for(var q=0;q<k.keys.length;q++){ if(have[k.keys[q]]!==k.want[k.keys[q]]){ ok=false; break; } }
      if(ok && seen[rows[i].designName]) ok=false;        // one tile per design, not per permutation
      if(ok && browseRailHide(rows[i])) ok=false;         // UPDATE 28: collapse unpicked colourway tiles (BROWSE_MODE products only; returns false elsewhere)
      if(ok){ seen[rows[i].designName]=1; shown++; if(!first) first={row:rows[i],tile:tiles[i]}; }
      rows[i].__vvOk=ok;
    }
    if(!shown) return;                                    // never strand the customer on an empty rail
    for(var j=0;j<rows.length;j++){
      var want=rows[j].__vvOk?'':'none';
      if(tiles[j].style.display!==want) tiles[j].style.setProperty('display',want);
    }
    // (c) open on the matching canvas — once, and only if the current pick is not already valid
    if(gal.auto || Date.now()<gal.hold) return;
    if(galUser){ gal.auto=true; return; }   // UPDATE 22: the customer has chosen; never override
    // UPDATE 21 — NEVER AUTO-SELECT ON A GUESS. Auto-selection is only safe when every option the
    // CC product declares was confidently matched to the customer's PDP choice by title. If even
    // one could not be mapped (a renamed value, a calculator product with no Size option value, a
    // product whose CC data is wrong) we leave the rail filtered and select NOTHING, so the
    // customer picks deliberately. Opening the wrong side is the one outcome worth failing to
    // avoid — it is what produced "it loads a single sided template".
    var fc=feedChoices();
    if(fc && !fc.all){ gal.auto=true; console.warn('[vivid-cc] no auto-select: unmapped options',fc.missing); return; }
    // ...and never while the feed itself is still the wrong one. feed.ok is set only by read-back of
    // aj.params.choices, so until it flips we are still looking at the DEFAULT (single-sided) feed
    // and auto-selecting would pick exactly the wrong design. Wait, or select nothing at all.
    if(fc && !feed.ok) return;
    var cur=(sel._&&sel._.id)||null;
    for(var c=0;c<rows.length;c++){ if(rows[c].__vvOk && rows[c].id===cur){ gal.auto=true; return; } }
    if(gal.tries>=3){ gal.auto=true; return; }            // give up quietly; the rail is still correct
    gal.tries++; gal.hold=Date.now()+4000;
    try{ first.tile.click(); }catch(e){}
  }

  // ---- UPDATE 26/27/28: BROWSE-DESIGNS MODE (Vistaprint-grade gallery) -----
  // Structure surveyed on Vistaprint (UPDATE 26/27 docs); branding/copy OURS.
  // ADDITIVE: everything no-ops unless BROWSE_MODE (the switch above). Data
  // source = the design-selector rail (feedSync-filtered rows + tiles +
  // 240px previews); a pick clicks THAT rail tile (kickCompile machinery).
  // CANONICAL industry list (BROWSE-MODE-SPEC §4): 60k-order weights, slugs
  // anchored to the Shopify industry collections; menu shows only industries
  // with >=1 design, so it scales as libraries grow. 'trade' never tagged.
  var BROWSE_INDUSTRY_LABELS={corporate:'Corporate & Business',charity:'Charity & Non-Profit',
    education:'School & Education',health:'Health & Medical','cafe-food':'Café, Restaurant & Food',
    tech:'Tech & Startup','real-estate':'Real Estate',fitness:'Gym, Fitness & Sport',
    construction:'Construction & Trades',government:'Government & Council',
    events:'Events & Exhibitions',manufacturing:'Manufacturing & Industrial',
    finance:'Finance & Legal',automotive:'Automotive & Car Yard',retail:'Retail & Shopfront',
    church:'Church & Religious',beauty:'Beauty & Salon','sale-promo':'Sale & Promotion',
    // 10-Aug: 'personal' is in the finalised order-book taxonomy
    // (CORFLUTE-INDUSTRY-WEIGHTS.json, 73 orders) but was never in this map —
    // corflute's dog/pet, novelty-home, pool and garage-sale ranges all sit
    // here, and an industry with no label renders as an unnamed facet.
    personal:'Personal & Home'};
  var BROWSE_INDUSTRY_ORDER=['corporate','charity','education','health','cafe-food','tech',
    'real-estate','fitness','construction','government','events','manufacturing','finance',
    'automotive','retail','church','beauty','personal','sale-promo'];
  // Mirrors vvIndustries (tag_industries.py canonical map); feed exposes no
  // custom fields, so derived from designName. []='general' (All designs only).
  var BROWSE_STYLE_INDUSTRIES=(window.__VVREG||{}).industries||{};
  var BROWSE_STYLE_NAMES=(window.__VVREG||{}).names||{};
  /* Filled by vvRegLoad() when the registry actually arrives. Everything that
     reads these maps runs at gallery-open time, never at page-parse time — the
     one thing to preserve if this file is refactored. */
  function vvRegBind(){
    var R=window.__VVREG||{};
    __bsSorted=null; __bsMemo={};   // 21-Aug freeze fix: registry changed
    BROWSE_STYLE_INDUSTRIES=R.industries||BROWSE_STYLE_INDUSTRIES;
    BROWSE_STYLE_NAMES=R.names||BROWSE_STYLE_NAMES;
    BROWSE_STYLE_KEYWORDS=R.keywords||BROWSE_STYLE_KEYWORDS;
    BROWSE_TYPES_BY_IND=R.typesByIndustry||BROWSE_TYPES_BY_IND;
    BROWSE_TYPE_LABELS=R.typeLabels||BROWSE_TYPE_LABELS;
  }
  var _vvRegP=null,_vvRegTried=false;
  /* 26-Aug — PER-PRODUCT REGISTRY SLICE.
     The full registry reached 11,926 style keys: 2.97MB parsed, 393KB brotli,
     and __vvCCLaunch BLOCKS on it, so on a cold visit all of that sits between
     the tap and the gallery. A corflute page uses 1,465 of those keys. A slice
     built from the same registry plus the product's own cold-start snapshot is
     37KB brotli for corflute and under 10KB for most products.
     It is not only bytes: browseStyleOf() resolves a design name to a registry
     key by longest-prefix scan over EVERY key in the catalogue, and that scan is
     what froze the 500-design bollard gallery for 45s in August. The slice cuts
     that loop by the same factor.
     THE SLICE IS A DERIVATION AND CAN GO STALE. It is built from a snapshot, so
     a design bound after the snapshot has no key in it. That degrades gracefully
     — the card falls back to its own name, per BROWSE_STYLE_NAMES[st]||g.names —
     but it also loses its industry facet, so vvRegEnsureFull() below measures
     how much of what is actually on screen the slice failed to cover and pulls
     the full registry when too much is missing. Stale means slow, never wrong.
     Deleting every vvreg-*.js restores the old behaviour exactly. */
  var _vvRegFullP=null;
  function vvRegFetch(u){
    return new Promise(function(res,rej){
      /* THE CLASS IS LOAD-BEARING on the <script> fallback below — see the note
         in the original loader. Keep the fetch-first order too: on slow mobile a
         script tag racing a fetch downloaded the registry twice in parallel. */
      fetch(u,{credentials:'omit'})
        .then(function(r){ if(!r.ok) throw new Error('registry '+r.status); return r.text(); })
        .then(function(txt){
          var before=window.__VVREG;
          try{ (0,eval)(txt); }catch(e){ throw new Error('registry did not parse'); }
          if(!(window.__VVREG&&window.__VVREG.names)){ window.__VVREG=before; throw new Error('registry defined nothing'); }
          res();
        })
        .catch(rej);
    });
  }
  /* Pull the FULL registry over the top of a slice. Deliberately bypasses the
     "already have names" guard in vvRegLoad, which exists to stop redundant
     loads and would otherwise make a slice permanent. */
  function vvRegEnsureFull(reason){
    if(_vvRegFullP)return _vvRegFullP;
    var u=window.__VVREG_URL; if(!u)return Promise.resolve();
    if(window.__VVREG&&!window.__VVREG.__slice)return Promise.resolve();  // already full
    try{ mountStage('reg-full:'+(reason||'?')); }catch(e){}
    _vvRegFullP=vvRegFetch(u).then(function(){ vvRegBind(); },function(){ _vvRegFullP=null; });
    return _vvRegFullP;
  }
  try{ window.__vvCCRegFull=vvRegEnsureFull; window.__vvCCRegInfo=function(){
    var R=window.__VVREG||{}; return {slice:R.__slice||null,keys:Object.keys(R.industries||{}).length}; };
    /* Test hooks. The self-healing path only fires on a render that follows a
       real staleness, which is not a state a test can create by waiting — the
       same reason __vvCCNetAlive exists. __vvCCRegCheck runs the decision
       against the live item list; __vvCCRegCoverage reports what it sees. */
    window.__vvCCRegCheck=function(){ vvRegBind(); vvRegCheckCoverage((typeof browse!=='undefined'&&browse.items)||[]); };
    window.__vvCCRegCoverage=function(){ vvRegBind(); return vvRegCoverage((typeof browse!=='undefined'&&browse.items)||[]); };
  }catch(e){}
  /* How much of what the customer is looking at does the loaded registry
     actually explain? Called once the gallery items are known. A handful of
     unresolved designs is normal (a blank canvas has no style); a large share
     means the slice predates a binding round. */
  function vvRegCoverage(items){
    var n=0,miss=0;
    for(var i=0;i<(items||[]).length;i++){
      var g=items[i]; if(!g||g.blank||!g.style)continue;
      n++; if(!BROWSE_STYLE_INDUSTRIES[g.style])miss++;
    }
    return {n:n,miss:miss};
  }
  function vvRegCheckCoverage(items){
    try{
      var R=window.__VVREG||{}; if(!R.__slice)return;         // already on the full file
      var c=vvRegCoverage(items);
      if(c.n<20)return;                                       // too few to judge
      if(c.miss/c.n<=0.05)return;                             // 5% is normal noise
      vvRegEnsureFull('coverage-'+c.miss+'/'+c.n).then(function(){
        try{ browse._fp=null; browseRender(); }catch(e){}     // re-label with the real data
      });
    }catch(e){}
  }
  function vvRegLoad(){
    if(window.__VVREG&&window.__VVREG.names){ vvRegBind(); return Promise.resolve(); }
    if(_vvRegP)return _vvRegP;
    _vvRegP=new Promise(function(res){
      var u=window.__VVREG_URL; if(!u){res();return;}
      var slice=window.__VVREG_SLICE_URL;
      if(slice){
        /* Slice first. Any failure at all — 404 because the generator has not
           run for this handle, a truncated body, a parse error — falls straight
           through to the full file rather than leaving the gallery unlabelled. */
        vvRegFetch(slice).then(function(){ vvRegBind(); res(); },
          function(){ vvRegFetch(u).then(function(){ vvRegBind(); res(); },function(){ res(); }); });
        return;
      }
      /* THE CLASS IS LOad-BEARING. The original tag carried
         class="shopify-vivid-cc-registry" to be exempt from the speed
         optimizer's lazyJs deferral (theme.liquid isShopifyScript looks for
         "shopify" in the class). My injected tag had no class, so on the selfie
         product the optimizer held it: the <script> was in the DOM, the browser
         never fetched it — no resource entry at all — and the studio sat on
         "Opening your design studio". Corflute happened not to hit it, which is
         exactly how a bug like this ships. */
      /* 17-Aug MOBILE: fetch+eval is PRIMARY now. The old script tag raced a
         4s fetch fallback; slow mobile takes >4s, so the registry downloaded
         TWICE in parallel (measured 2x132KB). fetch dodges the optimizer; the
         idle warmer in vivid-buy-cards makes it a cache hit. */
      var settled=false;
      function ok(){ if(settled)return; settled=true; vvRegBind(); res(); }
      fetch(u,{credentials:'omit'}).then(function(r){return r.text();})
        .then(function(txt){ try{ (0,eval)(txt); }catch(e){} ok(); })
        .catch(function(){ /* network/CSP failure: fall back to a script tag */
          if(settled)return;
          var t=document.createElement('script'); t.src=u;
          t.className='shopify-vivid-cc-registry';
          t.onload=ok;
          t.onerror=function(){ if(!settled){settled=true; res();} };
          document.head.appendChild(t);
          setTimeout(function(){ if(!settled){settled=true; vvRegBind(); res();} }, 10000);
        });
    });
    return _vvRegP;
  }
  // Search keywords — MIRRORS the vvKeywords CC custom field (the storefront
  // feed exposes no custom fields, same mirror rule as BROWSE_STYLE_INDUSTRIES).
  var BROWSE_STYLE_KEYWORDS=(window.__VVREG||{}).keywords||{};
  /* SUB-CATEGORY RAIL (11-Aug, owner). typesByIndustry comes from the category
     briefs, so it includes types with nothing bound — an empty row is the
     commissioning list, not a rendering bug. */
  var BROWSE_TYPES_BY_IND=(window.__VVREG||{}).typesByIndustry||{};
  var BROWSE_TYPE_LABELS=(window.__VVREG||{}).typeLabels||{};
  function vvTypeName(t){ return String(t).replace(/^(sf|af)-/,'').split('-')
    .map(function(w){return w.charAt(0).toUpperCase()+w.slice(1);}).join(' '); }
  function browseTypeOf(g){
    var st=g&&g.style; if(!st)return null;
    var p=String(st).split('-');
    if(p[0]==='as')return 'as-1319-safety';
    if(p[0]==='sec')return 'security-cctv';
    /* af-* keys: 3 tokens so the type IS the category slug (af-cafe-coffee) */
    if(p[0]==='af')return p.slice(0,3).join('-');
    return p.slice(0,2).join('-');
  }
  // Colourway registry (UPDATE 28: every recolourable style) — mirrors the
  // vvColourway custom field stamped by cwgen.py; fam feeds the Colour facet.
  var BROWSE_COLOURWAYS={
    slate:{label:'Slate & Amber',css:'#5a6b7a',fam:'grey'},
    burgundy:{label:'Burgundy & Champagne',css:'#7a2437',fam:'red'},
    olive:{label:'Olive & Cream',css:'#6b7042',fam:'green'},
    charcoal:{label:'Charcoal & Blush',css:'#4a4a4f',fam:'grey'},
    sunset:{label:'Sunset Orange',css:'#c96a1e',fam:'orange'},
    royal:{label:'Royal Blue',css:'#1d3fa8',fam:'blue'},
    red:{label:'Red Alert',css:'#a8232c',fam:'red'},
    green:{label:'Fresh Green',css:'#2e6b34',fam:'green'},
    plum:{label:'Plum',css:'#6b2d5e',fam:'purple'},
    teal:{label:'Deep Teal',css:'#1c5f63',fam:'teal'},
    navy:{label:'Navy Tint',css:'#38507a',fam:'blue'},
    sand:{label:'Sand & Bronze',css:'#a9946a',fam:'brown'},
    /* 27-Aug: the teardrop set ships crimson/ember/emerald and none of the three
       existed here, so 48 of its 166 designs fell to the grey default. */
    crimson:{label:'Crimson',css:'#a8232c',fam:'red'},
    ember:{label:'Ember',css:'#c96a1e',fam:'orange'},
    emerald:{label:'Emerald',css:'#1f7a4d',fam:'green'}};
  var BROWSE_CW_BASE={corporate:{label:'Classic Navy',css:'#23456e',fam:'blue'},
    cafe:{label:'Terracotta',css:'#b0603a',fam:'orange'},
    event:{label:'Teal & Magenta',css:'#128f96',fam:'teal'},
    sale:{label:'Navy & Gold',css:'#1d3c6b',fam:'blue'},
    dots:{label:'Navy Night',css:'#3a4f80',fam:'blue'},
    repeat:{label:'Soft Grey',css:'#8a8a8a',fam:'grey'},
    'logo-repeat':{label:'Light Grid',css:'#c9ccd2',fam:'grey'}};
  // Per-product colourway meta overrides — slug meaning is PER PRODUCT (560's
  // A-frame palettes reuse some 552 slugs with different colours); the global
  // registry stays 552's, a handle listed here shadows it. Round 15.
  var BROWSE_CW_OVERRIDES={'corrugated-a-frame-signs':{
    cws:{forest:{label:'Forest & Brass',css:'#1f5136',fam:'green'},
      charcoal:{label:'Charcoal & Amber',css:'#333438',fam:'grey'},
      teal:{label:'Coastal Teal',css:'#2a6b6e',fam:'teal'},
      blush:{label:'Blush & Rose',css:'#b5626e',fam:'red'},
      orange:{label:'Blaze Orange',css:'#e07020',fam:'orange'},
      cyan:{label:'Electric Blue',css:'#2ba7e0',fam:'blue'},
      navy:{label:'Deep Navy',css:'#20406e',fam:'blue'},
      purple:{label:'Royal Purple',css:'#5b2d82',fam:'purple'},
      green:{label:'Estate Green',css:'#2c5e3f',fam:'green'},
      blue:{label:'Clinical Blue',css:'#2b5fae',fam:'blue'},
      plum:{label:'Plum Care',css:'#7d3b6a',fam:'purple'}},
    base:{corporate:{label:'Navy & Gold',css:'#1c3a5e',fam:'blue'},
      cafe:{label:'Latte & Espresso',css:'#5d4037',fam:'brown'},
      open:{label:'Charcoal & Lime',css:'#2b2b2b',fam:'grey'},
      sale:{label:'Scarlet Red',css:'#c1272d',fam:'red'},
      realestate:{label:'Charcoal & Red',css:'#4a4a4f',fam:'grey'},
      medical:{label:'Fresh Teal',css:'#0e8390',fam:'teal'}}},
    'pullup-banners':{
    cws:{teal:{label:'Teal & Magenta',css:'#0b5a5e',fam:'teal'},
      navy:{label:'Navy & Lime',css:'#15223f',fam:'blue'}},
    base:{edupop:{label:'Royal Pop',css:'#1a3a8c',fam:'blue'}}},
    /* 23-Aug BOW: none of Bow's nine colourway slugs existed in any map, so
       every swatch dot fell to the grey default and the Colour facet filed
       104 of 112 designs under "Grey" — measured on the live quick view,
       where even the selected "berry" rendered as a grey circle. Colours are
       the ramp signature CMYKs from tools/bow/bowlib.py converted to sRGB
       (extraction shown in the commit), not guesses. */
    'bow-head-flags':{
    cws:{original:{label:'Original',css:'#5a6b7a',fam:'grey'},
      heritage:{label:'Heritage Navy',css:'#002770',fam:'blue'},
      sunset:{label:'Sunset Orange',css:'#ff6600',fam:'orange'},
      forest:{label:'Forest Green',css:'#29a70a',fam:'green'},
      berry:{label:'Berry',css:'#7e0bcf',fam:'purple'},
      mono:{label:'Mono',css:'#3a3a3a',fam:'grey'},
      ocean:{label:'Ocean Blue',css:'#1565a8',fam:'blue'},
      clay:{label:'Clay & Earth',css:'#6b3a2a',fam:'brown'},
      inkgold:{label:'Ink & Gold',css:'#b08a2e',fam:'brown'}}}};
  var _bcwo=BROWSE_CW_OVERRIDES[window.__VVCC.HANDLE]||{};
  function browseCwLookup(slug){ return (_bcwo.cws&&_bcwo.cws[slug])||BROWSE_COLOURWAYS[slug]; }
  function browseCwBaseLookup(style){ return (_bcwo.base&&_bcwo.base[style])||BROWSE_CW_BASE[style]; }
  var BROWSE_FAMS={blue:['Blue','#2b4f9e'],teal:['Teal','#1c6f74'],green:['Green','#3c6b40'],
    orange:['Orange','#c96a1e'],red:['Red','#a8232c'],purple:['Purple','#6b2d5e'],
    brown:['Brown','#8a6f4d'],grey:['Grey','#5a6b7a']};
  var BROWSE_FAM_ORDER=['blue','teal','green','orange','red','purple','brown','grey'];
  // Styles & Themes facet (our own labels; Vistaprint has Bold & Colourful etc.)
  var BROWSE_STYLE_THEMES={corporate:'conservative',cafe:'warm',event:'bold',sale:'bold',dots:'playful',repeat:'minimal','logo-repeat':'minimal',open:'bold',realestate:'conservative',medical:'conservative',edupop:'playful',
    corpwelcome:'modern',corptrade:'bold',corpstage:'modern',corphire:'bold',corpservices:'modern',corpsponsor:'conservative',corplaunch:'modern',corpmilestone:'elegant',corpwayfind:'bold',corpseminar:'conservative'};
  // tranche 1b: 'modern' and 'elegant' are plan §7 adjectives that had no label
  // yet — without them those designs fall out of the Themes facet entirely.
  var BROWSE_THEME_LABELS={bold:'Bold & Colourful',modern:'Modern',conservative:'Conservative',elegant:'Elegant',warm:'Warm & Friendly',playful:'Playful',minimal:'Minimal & Pattern'};
  var BROWSE_THEME_ORDER=['bold','modern','conservative','elegant','warm','playful','minimal'];
  // favourites: device-local only (localStorage; not synced to the account)
  // TESTING-PHASE gallery curation (owner, 6 Aug 2026): ?vvdel=<sig> reveals a ✕ on
  // every card that hard-deletes the design via the portal (unbind + CC storage delete
  // + preview-cache purge). The sig is a delete-scoped HMAC minted server-side — the
  // master key never reaches the browser. Without the param nothing renders.
  // The key arrives in the URL once and is then REMEMBERED for the browser
  // session: the owner opens the special link, then clicks through variants and
  // pages that drop the query string, and the buttons must not vanish with it
  // ("I still cannot see the delete"). sessionStorage, not localStorage — it
  // expires when the browser closes, so a shared machine cannot inherit it.
  var VV_DEL_KEY=(function(){
    var k='';
    try{ k=(location.search.match(/[?&]vvdel=([a-f0-9]{20,64})/)||[])[1]||''; }catch(e){}
    try{
      if(k) sessionStorage.setItem('vv_del_key',k);
      else k=sessionStorage.getItem('vv_del_key')||'';
    }catch(e){}
    return k;
  })();
  /* 46d: sweep poisoned "null"/"undefined" favs at READ time (pre-46c devices lit every heart) */
  function browseFavs(){ try{ var f=JSON.parse(localStorage.getItem('vv_browse_favs_'+PRODUCT_ID)||'{}');
    if(f['null']!==undefined||f['undefined']!==undefined){ delete f['null']; delete f['undefined'];
      try{ localStorage.setItem('vv_browse_favs_'+PRODUCT_ID,JSON.stringify(f)); }catch(e){} }
    return f; }catch(e){ return {}; } }
  /* 46c: anonymous favourites live in localStorage keyed by registry style; keyless cards once
     hearted to the string "null" (one shared bucket). Registry backfilled; guard below. */
  function browseFavToggle(k){ try{ if(!k||k==='null'||k==='undefined')return; var f=browseFavs();
    delete f['null']; delete f['undefined'];
    if(f[k])delete f[k]; else f[k]=1; localStorage.setItem('vv_browse_favs_'+PRODUCT_ID,JSON.stringify(f)); }catch(e){} }
  if(VV_DEL_KEY){ var _bde=document.getElementById('vvcc-browse'); if(_bde)_bde.setAttribute('data-vvdel','1'); }
  var browseEl=document.getElementById('vvcc-browse'),
      browseFacets=document.getElementById('vvbr-facets'),
      browseGrid=document.getElementById('vvbr-grid'),
      browseSearch=document.getElementById('vvbr-search'),
      browseSort=document.getElementById('vvbr-sort'),
      browseChips=document.getElementById('vvbr-chips'),
      browseCount=document.getElementById('vvbr-count'),
      browseQv=document.getElementById('vvbr-qv'),
      browseUp=document.getElementById('vvbr-up'),      // UPDATE 37: upload panel
      browseDs=document.getElementById('vvbr-ds');      // UPDATE 37: designer-brief panel
  var browse={done:false,cat:'all',typ:'',col:'',thm:'',q:'',sort:'rec',sig:'',items:null,cwSel:{},qv:null,pickedId:null,fs:{ind:true,col:true,thm:false},more:{}};
  function browseReset(){
    try{ vvccBrowseHdr(false); }catch(e){}       // UPDATE 35: never leak into a fresh launch
    browse={done:false,cat:'all',typ:'',col:'',thm:'',q:'',sort:'rec',sig:'',items:null,cwSel:{},qv:null,pickedId:null,fs:{ind:true,col:true,thm:false},more:{}};
    if(browseSearch)browseSearch.value='';
    if(browseSort)browseSort.value='rec';
    if(browseQv)browseQv.setAttribute('hidden','');
    if(browseUp)browseUp.setAttribute('hidden','');   // UPDATE 37
    if(browseDs)browseDs.setAttribute('hidden','');   // UPDATE 37
    // Edit sessions (?vvcc=1&vvproj=…) restore a line's artwork (UPDATE 24);
    // a gallery would fight the restore — straight to the editor as before.
    if(BROWSE_MODE && !EDIT.proj && (!EDIT.line || EDIT.fresh)){ browseSkeleton(); browseEl.setAttribute('data-on','1'); modal.setAttribute('data-browse','1');
      /* 23-Aug THE SPLASH WAS BAKED INTO THE MARKUP. #vvcc-loading ships with
         data-on IN THE HTML, and nothing cleared it until the CC wizard
         mounted 20-30s later — so the "paint the gallery first" fix of 21-Aug
         painted the gallery BEHIND an opaque curtain. Measured as a customer:
         25-60s of "Opening your design studio" on every first open, on every
         product, while finished cards sat underneath. The gallery IS the
         first screen in browse mode: the moment it is on-screen, the splash
         comes down. The empty/timeout watchdogs in the mount monitor still
         cover the gallery-never-fills case. */
      try{ if(STATES.loading.hasAttribute('data-on'))showState(null); }catch(e){}
      /* ...and if this launch came from a deep link, cover it immediately.
         See vvDeepCover: the gallery must run, but must not be seen. */
      try{ vvDeepCover(); }catch(e){} }
    else { browseEl.removeAttribute('data-on'); modal.removeAttribute('data-browse');
      // UPDATE 39: gallery still skipped for an edit session, but on a browse
      // product it now takes the browse CHROME — set synchronously, before the
      // wizard mounts, so the CSS collapses the rail column pre-paint (the
      // UPDATE-36 rationale) instead of flashing it.
      try{ vvccCartHdr.named=false; vvccCartHdr(); }catch(e){} }
  }
  /* 21-Aug FREEZE FIX: this used to Object.keys().sort() the FULL registry
     (15,600+ keys once bollards landed) on EVERY call, and it is called per
     design per gallery pass — scrolling the 500-design bollard gallery
     hard-froze the renderer for 45s+ (owner-reported, reproduced via CDP).
     The sorted list is now built once per registry load (vvRegBind resets
     it) and results are memoised per design name. */
  var __bsSorted=null,__bsMemo={};
  function browseStyleOf(name){
    var i=(name||'').indexOf('-'); if(i<0)return null;
    if(__bsMemo[name]!==undefined)return __bsMemo[name];
    var rest=name.slice(i+1);
    if(!__bsSorted)__bsSorted=Object.keys(BROWSE_STYLE_INDUSTRIES).sort(function(a,b){return b.length-a.length;});
    var keys=__bsSorted,out=null;
    for(var k=0;k<keys.length;k++){ if(rest.indexOf(keys[k]+'-')===0){ out=keys[k]; break; } }
    __bsMemo[name]=out;
    return out;
  }
  function browseIsBlank(name){ return /dyo|blank/i.test(name||''); }
  /* 27-Aug COLOUR FACET. The gallery reads a design's colourway from a `-cw<slug>-`
     token in its name. Measured on the live cache, NOT ONE design carries that token:
     teardrop 167/167 null, pull-up 323/323, corflute 1468/1468. Every one of them
     therefore fell through browseCwMeta's default and was filed under Grey, which is
     why a customer filtering "Blue" on a 166-design gallery got 2 results and cleared
     the filter 1.3 seconds later (gal-telemetry, 27-Aug 00:41).

     The teardrop set does carry its colour — fused into the style token, as
     `TD2-arrowsChar-small-Single` — so it can be recovered by reading a colour word
     off the end of that segment. Pull-up (`PullUp-aut-battry-...`) and corflute
     (`CorrugatedPlasticSigns-DYO-601x901`) carry no colour anywhere in the name and
     cannot be recovered here; for those the facet is now hidden rather than shown as
     a single meaningless Grey bucket (see browseRender).

     Only ever ADDS a slug where there was none, so any product already using the
     `-cw` convention is untouched. */
  var BROWSE_CW_WORDS={char:'charcoal',charcoal:'charcoal',crimson:'crimson',ember:'ember',
    emerald:'emerald',navy:'navy',olive:'olive',plum:'plum',royal:'royal',slate:'slate',
    teal:'teal',burgundy:'burgundy',sunset:'sunset',sand:'sand',red:'red',green:'green'};
  function browseCwOf(name){
    var m=/-cw([a-z0-9]+)-/.exec(name||''); if(m)return m[1];
    var seg=String(name||'').split('-')[1]||'';
    var mm=/[a-z0-9]([A-Z][a-z]+)$/.exec(seg);
    if(mm){ var w=BROWSE_CW_WORDS[mm[1].toLowerCase()]; if(w)return w; }
    return null;
  }
  function browseCwMeta(g,ix){
    var e=g.cws[ix]||g.cws[0];
    if(!e.slug) return browseCwBaseLookup(g.style)||{label:'Original',css:'#9aa2ad',fam:'grey'};
    return browseCwLookup(e.slug)||{label:e.slug,css:'#9aa2ad',fam:'grey'};
  }
  // RAIL FLOODING (UPDATE 28): with 12 colourways bound, the editor rail would
  // hit 20 tiles/variant. In BROWSE MODE ONLY, galSync additionally hides any
  // -cw tile that is not the picked design (guarded one-line hook in galSync),
  // so the rail shows one tile per style + the picked colourway. Colourway
  // switching lives in the gallery. Non-browse products: hook returns false.
  function browseRailHide(row){
    if(!BROWSE_MODE)return false;
    var n=(row&&row.designName)||'';
    if(n.indexOf('-cw')<0)return false;
    return row.designId!==browse.pickedId;
  }
  /* 21-Aug CACHE KEY WAS GLOBAL. 'vvbr_cache_v1' carried no product, so after
     browsing bollards the pull-up gallery painted 501 BOLLARD cards from cache
     until live data replaced them. Key it per product. */
  var VVBR_CACHE_KEY='vvbr_cache_v1_'+window.__VVCC.HANDLE;
  /* 21-Aug COLD START — the last of the "gallery is stuck" reports. Measured on
     a fresh phone (WebKit, 440x758): first designs land 5-15s after the tap,
     because with an empty cache the gallery shows six shimmer tiles until
     Customer's Canvas's hidden rail has bootstrapped and rendered the whole
     catalogue. The SAME device on its second visit paints in 225ms straight
     from localStorage. So every returning customer was fast and every
     FIRST-TIME customer — i.e. every new customer — waited. The card model is
     small (501 bollard designs = 212KB, 255 pull-ups = 103KB), so ship it as a
     theme asset and read it when the cache is empty.
     Fails safe in every direction: no asset (products without a generated file
     404), bad JSON, or live data already painted => this does nothing and the
     old shimmer-then-wait behaviour stands. The model is a PLACEHOLDER exactly
     like the localStorage one — live rows replace it the moment they land, and
     selection stays name-resolved and swap-verified, so a stale entry can
     never send a wrong design to print. */
  var VVBR_COLD_URL=window.__VVCC.COLD_URL;
  function browseColdStart(){
    if(browse.coldTried)return; browse.coldTried=1;
    try{
      fetch(VVBR_COLD_URL,{cache:'force-cache'})
        .then(function(r){ if(!r.ok)throw new Error('no cold model'); return r.json(); })
        .then(function(j){
          var items=(j&&j.items)||j;
          if(!items||!items.length)return;
          if(browse.sig!=='skel')return;          // cache or live data won the race
          try{ vvInc.mark('feed:cold-model',{items:items.length}); }catch(e){}
          browse.sig='skel-cache'; browse.items=items; browseRender();
          var c=document.getElementById('vvbr-count');
          if(c)c.textContent=(c.textContent||'')+'  \u00b7 refreshing\u2026';
        }).catch(function(){});
    }catch(e){}
  }
  function browseSkeleton(){
    if(browse.sig==='skel'||browse.sig==='skel-cache')return;
    /* UPDATE 45: paint the cached card model INSTANTLY while the live feed
       loads (the 297-row feed takes 15-25s; it also sometimes never lands -
       the stuck-at-0 bug the owner hit twice). Live data replaces this the
       moment browseSync gets real rows (sig differs). */
    var cached=null;
    try{ var raw=localStorage.getItem(VVBR_CACHE_KEY);
      if(raw){ var cj=JSON.parse(raw); if(cj&&cj.items&&cj.items.length&&(Date.now()-cj.t)<7*86400000)cached=cj.items; } }catch(e){}
    if(cached){
      try{ vvInc.mark('feed:cache-painted',{items:cached.length}); }catch(e){}
      browse.sig='skel-cache'; browse.items=cached; browseRender();
      var c=document.getElementById('vvbr-count');
      if(c)c.textContent=(c.textContent||'')+'  · refreshing…';
    }else{
      browse.sig='skel';
      try{ vvInc.mark('feed:skeleton'); }catch(e){}
      if(browseFacets)browseFacets.innerHTML='';
      var h=''; for(var i=0;i<6;i++)h+='<div class="vvbr-skel"></div>';
      browseGrid.innerHTML=h;
      browseColdStart();   // 21-Aug: first-time customers get the cache too
    }
    /* 6-Oct-2026 — DEAD FEED WATCHDOG (controlled-failure series, FAIL=feed): with the design list never landing the
       customer sits on "Loading this design… Starting…" and NOTHING reports — the 45-s apply warning only runs once a
       pick has started applying, which needs the feed. Beacon only: 30 s after the first skeleton with still no rows,
       a non-final record (phase 'feed'), and a final one if the customer leaves while it is still dead. */
    if(!window.__vvFeedWd){ var _fwd=window.__vvFeedWd={at:Date.now(),dead:false,hiddenMs:0,hiddenSince:(document.visibilityState==='hidden'?Date.now():0)};
      /* 7-Oct P0: how long the tab has been in the background since the skeleton — a launch paused by the browser is not a dead feed */
      try{ document.addEventListener('visibilitychange',function(){ try{ if(document.visibilityState==='hidden'){ if(!_fwd.hiddenSince)_fwd.hiddenSince=Date.now(); } else if(_fwd.hiddenSince){ _fwd.hiddenMs+=Date.now()-_fwd.hiddenSince; _fwd.hiddenSince=0; } }catch(e){} }); }catch(e){}
      var _fwHidden=function(){ var h=_fwd.hiddenMs+(_fwd.hiddenSince?Date.now()-_fwd.hiddenSince:0), el=Date.now()-_fwd.at; return {h:Math.round(h/1000),el:Math.round(el/1000),mostly:(h>el*0.5)||document.visibilityState==='hidden'}; };   // once per page: browse is rebuilt on relaunch, the watchdog is not
      /* "dead" is judged on the selector's own rows + the apply read-back, NOT browse.sig: on the gallery / blank entry the
         grid path that sets sig never runs, so sig stays 'skel-cache' on a perfectly healthy launch (measured 6-Oct:
         167 rows, design confirmed at 8.9 s, sig still 'skel-cache' at 11 s). */
      var _fwDead=function(){ try{ if(typeof ccKick!=='undefined'&&ccKick&&ccKick.telConfirmed)return false; var sel=deepFind('au-widget-pim-design-selector'); return !sel||!(sel.displayedVariants&&sel.displayedVariants.length); }catch(e){ return false; } };
      try{ setTimeout(function(){ try{ if(!_fwDead())return; _fwd.dead=true;
        var _hv=_fwHidden(); beaconPhase='feed'; mountStage((_hv.mostly?'feed-stall-hidden@':'feed-stall@')+_hv.el+'s'+(_hv.h?'(hidden '+_hv.h+'s)':'')); mountBeacon(false); beaconPhase='mount'; }catch(e){} },30000); }catch(e){}
      try{ addEventListener('pagehide',function(){ try{ if((_fwd.dead||Date.now()-_fwd.at>8000)&&_fwDead()){   // left with the feed still dead (8 s = the re-kick ladder's own 'stuck' threshold)
        var _hv2=_fwHidden(); beaconPhase='feed'; mountStage((_hv2.mostly?'feed-stall-hidden-left@':'feed-stall-left@')+_hv2.el+'s'+(_hv2.h?'(hidden '+_hv2.h+'s)':'')); mountBeacon(true); beaconPhase='mount'; } }catch(e){} },{capture:true}); }catch(e){}
    }
    /* stuck-feed retry ladder: re-kick the design-selector if nothing lands */
    if(!browse.kick)browse.kick=0;
    if(browse.kick<3&&!browse.kickTimer){
      browse.kickTimer=setTimeout(function(){
        browse.kickTimer=null;
        if(browse.sig!=='skel'&&browse.sig!=='skel-cache')return;   // live data arrived
        browse.kick++;
        try{
          var sel=deepFind('au-widget-pim-design-selector');
          if(sel&&sel.updateParamsAsync)sel.updateParamsAsync({itemsPerPage:999});
          try{console.warn('[vivid-cc] feed stuck - re-kick '+browse.kick);}catch(_){}
          try{ vvInc.mark('feed:re-kick',{n:browse.kick,rows:(function(){try{return (sel&&sel.displayedVariants||[]).length;}catch(e){return -1;}})()}); }catch(_){}
        }catch(e){}
        browseSkeleton();
      },8000);
    }
  }
  // One CARD per style; -cw designs collapse into the base card as colourway
  // entries. cw rows are included even when the rail-hide hook stamped them
  // __vvOk=false — they are still real, feed-filtered designs for this size.
  function browseCollect(){
    var sel=deepFind('au-widget-pim-design-selector'); if(!sel||!sel.shadowRoot)return null;
    var rows=sel.displayedVariants||[]; if(!rows.length)return null;
    var tiles=sel.shadowRoot.querySelectorAll('.gallery__item');
    if(tiles.length!==rows.length)return null;
    var out=[],seen={},byStyle={};
    for(var i=0;i<rows.length;i++){
      var n=rows[i].designName||''; if(!n||seen[n])continue;
      var cw=browseCwOf(n);
      if(rows[i].__vvOk===false && !cw)continue;   // hidden by the PDP filter
      seen[n]=1;
      /* UPDATE 46 — GALLERY LOAD SPEED (owner, 8 Aug: "loads too slow ... like
         canva fast loading"). Measured: each card thumb was a 500 KB PNG, so a
         60-tile screen pulled ~29 MB. The card paints the design at ~178 CSS px
         wide, so a 400px rung was already more than the eye can use, and PNG is
         the wrong codec for photographic banner art. The portal now renders
         thumbnail rungs as JPEG (513.9 KB -> 95.6 KB measured, identical
         pixels) and has a 240px rung; asking for 240 instead of 400 takes it
         to ~35 KB. Retina gets the 600 rung via srcset, which is still JPEG. */
      /* UPDATE 46b — MEASURED AGAINST CANVA (owner: "still slow ... blank then
         blurry then clears up"). Two faults, both mine:
         (1) the card paints at 274 CSS px but was served the 240 rung, so every
             thumbnail was UPSCALED — that is the softness, not the network.
             Canva serves 600px into a 187px slot: ~3x oversampled, never soft.
         (2) progressive JPEG paints a coarse pass then refines = the blur phase.
             Fixed at the encoder (baseline now).
         Measured Canva vs us: Canva 96 KB @ 80ms median, ours 24 KB @ 20ms. We
         are 4x FASTER per request and were simply serving too few pixels. So
         serve 600 on desktop (~60-90 KB, still lighter and quicker than Canva)
         and keep 240 for narrow viewports via sizes/srcset. */
      var ent={name:n,thumb:(rows[i].designId?prevUrl(rows[i].designId,600):(rows[i].previewUrl||'')),thumbSm:prevUrl(rows[i].designId,240),cc:rows[i].previewUrl||'',tile:tiles[i],slug:cw,id:rows[i].designId};
      if(browseIsBlank(n)){ out.push({names:n,blank:true,style:null,cws:[ent]}); continue; }
      var st=browseStyleOf(n), g=st&&byStyle[st];
      if(g){ g.cws.push(ent); g.names+='|'+n; }
      else{ g={names:n,blank:false,style:st,cws:[ent]}; if(st)byStyle[st]=g; out.push(g); }
    }
    out.forEach(function(g){ if(!g.blank&&g.cws.length>1)
      g.cws.sort(function(a,b){return (a.slug?1:0)-(b.slug?1:0);}); });
    /* 21-Oct (blank starters): ONE "Blank canvas" card. A product can carry an old and a new starter for the same
       size (A-frame: one-face "AFrameSigns-DYO-606x906" + two-face "AFrameSigns-DYO-2face-606x906"); the card's tap
       re-resolves the starter through vvBlankRowFor anyway, so keep the card for the starter it will open. */
    try{ var _bl=out.filter(function(g){ return g.blank; });
      if(_bl.length>1){ var _keep=vvBlankFaceFilter(_bl,function(g){ return g.names||''; })[0]||_bl[0];
        out=out.filter(function(g){ return !g.blank||g===_keep; }); } }catch(e){}
    return out.length?out:null;
  }
  // UPDATE 35: gallery-entered header content — design · colourway + product ·
  // variant · exact price (mirrors Vistaprint's studio price surfacing). The
  // [data-vvbrhdr] attribute drives the CSS swap; removed on return/close so the
  // direct-flow header is untouched. Read-only additive — no widget interaction.
  function vvccBrowseHdr(on,g,ix){
    var m=document.getElementById('vv-cc-modal'); if(!m)return;
    if(!on){ m.removeAttribute('data-vvbrhdr'); m.removeAttribute('data-vvedit'); return; }
    try{
      vvccBackLabel('gallery'); m.removeAttribute('data-vvedit');
      var name=g.blank?'Blank canvas':(BROWSE_STYLE_NAMES[g.style]||g.names);
      if(!g.blank){ var meta=browseCwMeta(g,typeof ix==='number'?ix:0);
        if(meta&&meta.label)name+=' · '+meta.label; }
      var vv=null; for(var i=0;i<SHOPIFY_VARIANTS.length;i++){ if(String(SHOPIFY_VARIANTS[i].id)===String(vid())){vv=SHOPIFY_VARIANTS[i];break;} }
      var price=BROWSE_PRICES[String(vid())];
      document.getElementById('vvcc-ctx1').textContent=name;
      document.getElementById('vvcc-ctx2').textContent=PRODUCT_TITLE
        +(vv?(' · '+vv.title):'')
        +((typeof price==='number')?(' · $'+(price/100).toFixed(2)):'');
      m.setAttribute('data-vvbrhdr','1');
    }catch(e){}
  }
  // ---- UPDATE 39: EDIT-FROM-CART gets the SAME editor chrome ---------------
  // Owner (522 "Change artwork" from the cart): "it should have been same with
  // the back to browse design button which we changed already for the browse
  // mode." UPDATE 30/35/36 were all gated on browse.entered — true only for
  // gallery-entered sessions — so an edit-from-cart session (which deliberately
  // SKIPS the gallery so the restore owns the editor, UPDATE 24/30) still got
  // the old chrome: visible design rail, bare chevron, no context.
  // Now: BROWSE_HANDLES products in an edit session take the same rail hiding +
  // header, with a back labelled for where they actually came from — the CART
  // (Option B). Option A (open the gallery, keep the vvline binding through a
  // re-pick) is NOT shipped: a re-pick swaps the design under a restored
  // project mid-session, and the line binding is the cart-safety invariant of
  // helloprint-finish-flow/INCIDENT-wrong-cart-line-deleted.md — not a thing to
  // ship unproven. Direct-flow products are untouched (BROWSE_MODE false).
  function browseCartEdit(){ return !!(BROWSE_MODE && (EDIT.proj||EDIT.line)); }
  /* 12-Sep - THE BACK BUTTON HAS TO GO BACK.
     A session that arrived from a design gallery carries vvfrom (the path) and
     vvfromname (what to call it). With those, the top-left control stops being
     "View all designs" - which closes the editor onto the full catalogue - and
     becomes "Back to <that gallery>", which returns there. Without them nothing
     changes: someone who came straight to the product page still wants the
     browser, and the cart and saved-design labels are untouched. */
  /* 30-Sep — NO vvfrom AT ALL means "the VividCanvas gallery for this product".
     Old links, ads, search results and the studio opened from a product page carry
     no vvfrom, and their back control used to drop the customer into the studio's
     own browse grid — the old gallery (owner: "it's loading in many places … send
     those places to the new gallery instead"). The snippet on every product page
     defines __vvGalleryUrl (product, handle, chosen variant); the gallery itself
     copes with a product that has no library yet (upload / AI / blank still offered).
     Cart edits and saved designs never reach this: every caller checks
     browseCartEdit() first, and the finish paths ignore gallery targets. */
  function vvGalleryDefault(){
    var gu=null; try{ gu=(typeof window.__vvGalleryUrl==='function')?window.__vvGalleryUrl():null; }catch(e){}
    if(!gu||!/^https:\/\/(create\.vividads\.com\.au|vivid-design-tool(-staging)?\.fly\.dev)\/gallery\.html/.test(gu)) return null;
    return { path: gu, name: 'design ideas', gallery: true, implicit: true };
  }
  /* a modern-gallery entry: came from gallery.html AND asked for a specific way in */
  function vvModernEntry(){
    try{ var g=vvFromTarget(); return !!(g&&g.gallery&&/[?&](vvcc=(blank|upload)|vvstyle=)/.test(location.search||'')); }catch(e){ return false; }
  }
  function vvFromTarget(){
    try{
      var m = location.search.match(/[?&]vvfrom=([^&#]+)/);
      if(!m) return vvGalleryDefault();
      var p = decodeURIComponent(m[1]);
      /* 30-Sep — FROM THE VIVIDCANVAS GALLERY. Every way out of the gallery page
         (ready-made, blank, upload) lands here with vvfrom=gallery; "back" must
         return THERE, not to the studio's own grid (owner: "when you click the
         back button it loads the old style gallery"). The gallery lives on the
         design tool's host, so its URL is rebuilt by vivid-buy-cards.liquid's
         __vvGalleryUrl (product, handle, chosen variant) rather than carried in
         the query. Never a post-finish destination — see vvAfterCartHref. */
      if(p==='gallery'){
        var gu=null; try{ gu=(typeof window.__vvGalleryUrl==='function')?window.__vvGalleryUrl():null; }catch(e){}
        if(!gu||!/^https:\/\/(create\.vividads\.com\.au|vivid-design-tool(-staging)?\.fly\.dev)\/gallery\.html/.test(gu)) return null;
        return { path: gu, name: 'design ideas', gallery: true };
      }
      /* same-origin, absolute path, nothing clever - never bounce a customer
         off-site on the strength of a query parameter.
         5-Oct (Q3 legacy-reachability): a tampered / malformed vvfrom used to return
         null, which dropped the close control into the studio's own grid; it now
         falls back to this product's VividCanvas gallery (still on-site). */
      if(!/^\/[A-Za-z0-9\-\/_]{0,120}$/.test(p)) return vvGalleryDefault();
      var n = location.search.match(/[?&]vvfromname=([^&#]+)/);
      var name = n ? decodeURIComponent(n[1]).replace(/[<>]/g,'').slice(0,40) : '';
      return { path: p, name: name };
    }catch(e){ return null; }
  }
  /* 15-Sep - FINISHING INSIDE A PACK.
     A session opened from the event-pack block carries vvfrom (where to go back to)
     and vvpack / vvslot (which pack, which slot). Two consequences, both gated on
     those parameters being present, so a normal product page session is byte for
     byte unchanged:
       1. the finished line is STAMPED with _vv_pack / _vv_slot, so the pack page can
          recognise its own lines in the cart and never add a second one;
       2. after the cart write we go BACK to the pack instead of to /cart, so the
          customer can design the next item. Zulfe: "it should have come back to the
          same page with the design added and shown in in your box".
     Why the cart write still happens at all: Finish is what renders the print file and
     attaches vivid.artwork_uploads. Saving instead would leave the order with no
     artwork - a silent failure, and far worse than an early cart line. */
  function vvPackCtx(){
    try{
      var m=location.search.match(/[?&]vvpack=([^&#]*)/); if(!m)return null;
      var pack=decodeURIComponent(m[1]).replace(/[<>]/g,'').slice(0,60);
      if(!pack)return null;
      var sm=location.search.match(/[?&]vvslot=([^&#]*)/);
      var slot=sm?decodeURIComponent(sm[1]).replace(/[<>]/g,'').slice(0,40):'';
      return {pack:pack,slot:slot};
    }catch(e){ return null; }
  }
  /* Where to land after a successful cart write. '/cart' unless this session came from
     somewhere that asked for the customer back. Used ONLY on the finish paths - the
     explicit "Back to cart" control is untouched. */
  function vvAfterCartHref(){
    try{ var f=vvFromTarget(); return (f&&f.path&&!f.gallery)?f.path:'/cart'; }catch(e){ return '/cart'; }
  }
  function vvccBackLabel(mode){
    try{
      var b=document.getElementById('vvcc-backall'), cart=(mode==='cart'), sv=(mode==='saved');
      var from = (!cart && !sv) ? vvFromTarget() : null;
      var backTo = from ? ('Back to ' + (from.name || 'designs')) : null;
      b.querySelector('.lbl').textContent=sv?'Close':(cart?'Back to cart':(backTo||'View all designs'));
      b.querySelector('.lbls').textContent=sv?'Close':(cart?'Cart':(from?'Back':'Designs'));
      b.setAttribute('aria-label',sv?'Close the design studio':(cart?'Back to cart':(backTo||'Back to all designs')));
    }catch(e){}
  }
  // Design NAME for a restored project: NOT resolvable, and we do not guess.
  // Measured (5 Aug): the finish stamps `_CC_Design_ID` as the mutated per-order
  // design (62c0eda2… on a School-Colour-Pop line), which matches NO catalogue
  // row in the rail's displayedVariants; this UIF build exposes no
  // selectedDesignId either, and a class-based "which tile looks selected" read
  // returned the DYO tile — i.e. it labelled a School Colour Pop line "Blank
  // canvas". A wrong design name on a cart-bound editor is worse than none, so
  // line 1 says "Your saved design" and line 2 carries the identifying facts
  // (product · variant · price) read from the bound line itself.
  function vvccCartHdr(){
    var m=document.getElementById('vv-cc-modal'); if(!m||!browseCartEdit())return;
    try{
      vvccBackLabel(EDIT.saved?'saved':'cart');
      document.getElementById('vvcc-ctx1').textContent=EDIT.fresh?'New design for your cart item':'Your saved design';
      var vv=null; for(var i=0;i<SHOPIFY_VARIANTS.length;i++){ if(String(SHOPIFY_VARIANTS[i].id)===String(vid())){vv=SHOPIFY_VARIANTS[i];break;} }
      var price=BROWSE_PRICES[String(vid())];
      document.getElementById('vvcc-ctx2').textContent=PRODUCT_TITLE
        +(vv?(' · '+vv.title):'')
        +((typeof price==='number')?(' · $'+(price/100).toFixed(2)):'');
      m.setAttribute('data-vvbrhdr','1');   // same attribute -> same CSS: rail column collapsed pre-paint, labelled back, no bare chevron
      m.setAttribute('data-vvedit','1');    // audit hook only (§20.6 token); no CSS depends on it
    }catch(e){}
    // Enrich line 2 from the BOUND cart line — that line is the truth for this
    // session. READ-ONLY: /cart.js only, never change.js, never a delete.
    if(!EDIT.line)return;
    try{
      fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(cj){
        var ln=(cj.items||[]).filter(function(i){return i.key===EDIT.line;})[0];
        if(!ln)return;
        document.getElementById('vvcc-ctx2').textContent=
          (ln.product_title||PRODUCT_TITLE)
          +(ln.variant_title?(' · '+ln.variant_title):'')
          +((typeof ln.price==='number')?(' · $'+(ln.price/100).toFixed(2)):'');
      }).catch(function(){});
    }catch(e){}
  }
  // Back for an edit session: to the CART, where the customer came from. Same
  // teardown as closeModal (monitor/autosave/preflight) so nothing keeps
  // ticking through the navigation; Esc runs this identical path.
  function vvccBackToCart(){
    try{ stopMonitor(); stopAutosave(); }catch(e){}
    try{ prep.cancelled=true; prepStop(); pfCloseOnly(); }catch(e){}
    try{ window.__vvNoNav=1; }catch(e){}
    window.location.href='/cart';
  }
  // ⚠ NEVER HOLD A TILE NODE — 9-Aug, owner: "i was editing a design and now if
  // you open any other design the same design will load which i was editing".
  // browseCollect captures sel.shadowRoot's .gallery__item nodes BY INDEX at
  // collect time. The widget re-renders that gallery whenever its design list
  // changes, which today happens constantly because we publish into the same
  // product while the gallery is open. A captured node is then either detached
  // — the click goes nowhere and the editor simply keeps the design it already
  // had, which is exactly the bug — or recycled onto a DIFFERENT design, which
  // is the other half of it: reproduced live, clicked "4X4 Ready" and the rail
  // selected PullUp-fit-newgym while _privateDesignId never changed at all.
  // Names are stable; DOM nodes are not. Resolve at click time.
  /* 23-Aug — WHY A BARE .click() WAS NOT ENOUGH, proven on the owner's iPhone.
     The diag panel reported tile found=Y inDoc=Y click=Y, and the selector's
     designId never changed from the initial one. So the node was right, it was
     live, the call did not throw — and UIF simply did not react. That is the
     signature of a handler bound to POINTER events: HTMLElement.click() synthesises
     a bare MouseEvent and nothing else, which desktop handlers usually catch and
     pointer-based ones do not. Desktop worked because a real mouse produces the
     whole sequence; a synthetic click on iOS produces one event nobody is
     listening for.
     So fire the sequence a finger would: pointerdown/up, mousedown/up, click, and
     the native .click() last as a belt-and-braces for anything still on it. */
  function browseTap(el){
    if(!el)return false;
    try{ vvInc.mark('pick:tile-tap',{name:(el.getAttribute&&(el.getAttribute('aria-label')||el.getAttribute('title')))||browse.pickedName||''}); }catch(e){}
    var r={left:0,top:0,width:0,height:0};
    try{ r=el.getBoundingClientRect(); }catch(e){}
    var base={bubbles:true,cancelable:true,composed:true,view:window,
              clientX:r.left+r.width/2,clientY:r.top+r.height/2};
    var fired=false;
    function go(ev){ try{ el.dispatchEvent(ev); fired=true; }catch(e){} }
    try{ if(window.PointerEvent){
      var pk={pointerId:1,pointerType:'touch',isPrimary:true,width:1,height:1,pressure:.5};
      go(new PointerEvent('pointerdown',Object.assign({},base,pk)));
      go(new PointerEvent('pointerup',Object.assign({},base,pk)));
    } }catch(e){}
    try{
      go(new MouseEvent('mousedown',base));
      go(new MouseEvent('mouseup',base));
      go(new MouseEvent('click',base));
    }catch(e){}
    try{ el.click(); fired=true; }catch(e){}
    return fired;
  }
  function browseTileFor(name){
    var sel=deepFind('au-widget-pim-design-selector'); if(!sel||!sel.shadowRoot)return null;
    var rows=sel.displayedVariants||[], tiles=sel.shadowRoot.querySelectorAll('.gallery__item');
    /* Release-hardening (2026-10-06): every rail tile carries title="<designName>" (measured live,
       UIF 7.1.74). Match on that first — the index mapping below silently picks a DIFFERENT design
       whenever the rail has re-rendered between capture and tap (the "Start from blank opened a
       template" defect: blank tapped, "PullUp-med-womenh-800x2000" opened). */
    for(var t=0;t<tiles.length;t++){ if((tiles[t].getAttribute('title')||'')===name)return tiles[t]; }
    if(!rows.length||tiles.length!==rows.length)return null;
    for(var i=0;i<rows.length;i++){ if((rows[i].designName||'')===name)return tiles[i]; }
    return null;
  }
  // Verify the editor swapped its private working copy (9-Aug: it silently keeps the old design
  // otherwise); if not, resolve the tile again + retry once. PIM-selector-driven.
  function browseSelectWhenReady(name,tries){
    tries=tries||0;
    var t=browseTileFor(name);
    if(t){ try{ t.click(); }catch(e){} return; }
    if(tries<60)setTimeout(function(){ browseSelectWhenReady(name,tries+1); },500);
  }
  /* 24-Aug BUG-107 — "clicking Start Editing does not allow us to proceed".
     This overlay is the ONLY feedback a customer gets between tapping a design and
     the editor opening, and it was invisible: it was appended to <body> at
     z-index 99998 while #vv-cc-modal (vivid-cc.css) sits at z-index 2147483000,
     so it always painted BEHIND the full-screen gallery. Verified live:
     document.elementFromPoint(centre) returned a .vvbr-thumbwrap card, not the
     overlay. Every "Loading this design…" and every "taking longer than usual"
     message has therefore been unseen since the shell was introduced — the tap
     read as a dead button. Mount it INSIDE the modal (its own stacking context)
     so it is on top of #vvcc-browse (z-index 4) and #vvbr-qv (z-index 5). */
  function browseWait(on,msg){ var w=document.getElementById('vvbr-wait');
    if(!on){ if(w)w.remove(); return; }
    if(!w){ w=document.createElement('div'); w.id='vvbr-wait';
      /* 11-Sep: .9 alpha lets the gallery show through, which is right when the
         customer is LOOKING at the gallery and waiting for one design to open.
         On a deep link there is no gallery they chose to look at — the widget's
         own "Loading, please wait..." spinner bled through and read as two
         loaders stacked. Opaque for that case only. */
      var _deepCover=false; try{ _deepCover=!!vvDeepStyleParam() && !browse.entered; }catch(e){}
      w.setAttribute('style','position:absolute;inset:0;z-index:99998;background:'+
        (_deepCover?'#fff':'rgba(255,255,255,.9)')+
        ';display:flex;align-items:center;justify-content:center;padding:30px;');
      /* 26-Aug: THIS is the panel a customer actually stares at during the cold
         boot - the gallery flow never shows #vvcc-loading, so a progress bar added
         only there would have been a no-op on the main path. Found by testing,
         not by reading. Same bar, same honest copy, driven by the same stages. */
      w.innerHTML='<style>@keyframes vvbrsp{to{transform:rotate(360deg)}}</style><div style="display:flex;flex-direction:column;align-items:center;gap:12px;max-width:320px;text-align:center;font-weight:600;font-size:14.5px;color:#191919;"><span style="width:36px;height:36px;border:4px solid #e2e2e2;border-top-color:#d6202b;border-radius:50%;animation:vvbrsp .8s linear infinite;font-size:0;">&nbsp;</span><span id="vvbr-wait-t"></span><span id="vvbr-wait-track" style="display:block;width:260px;max-width:70vw;height:6px;border-radius:999px;background:#ececf1;overflow:hidden;"><span id="vvbr-wait-bar" style="display:block;height:100%;width:4%;border-radius:999px;background:linear-gradient(90deg,#d6202b,#ff6a3d);transition:width .5s cubic-bezier(.4,0,.2,1);font-size:0;">&nbsp;</span></span><span id="vvbr-wait-step" style="font-weight:400;font-size:12.5px;color:#6b6b76;">Starting\u2026</span></div>';
      (document.querySelector('#vv-cc-modal .vvcc-stage')||document.getElementById('vv-cc-modal')||document.body).appendChild(w); }
    var t=document.getElementById('vvbr-wait-t'); if(t)t.textContent=msg; }
  /* 11-Sep — A DEEP LINK MUST NEVER SHOW "PICK A DESIGN TO START WITH".

     Measured right after the picker was fixed. A customer who clicked "No Dogs"
     on a gallery page still got, in order: the product page; then a screen
     headed "Pick a design to start with" over three empty placeholder cards
     reading "22 designs - refreshing..."; then that same screen filled with
     1,467 cards; and only then their dog sign. Three screens, two of which ask
     a question the customer has already answered. Owner, 11-Sep: "when i
     customize from here it goes through several screens".

     The gallery still MOUNTS - browseSync, the rail watcher and the whole pick
     path hang off it, and tearing it out for this one case would fork the flow
     and is how the blank-editor bugs of 23/24-Aug happened. What changes is
     that it is never SEEN. browseWait's overlay already exists for the
     slow-feed case, already sits inside the modal's stacking context (the
     24-Aug BUG-107 fix), and mountProgress already re-finds #vvbr-wait-bar
     every tick - so raising it at open costs nothing and inherits the progress
     bar, the stage text and the honest slow-connection copy for free.

     One screen, named for the design that was asked for. */
  /* 30-Sep: "800x2000" from the PDP's chosen variant ("800mm W x 2000mm H - SALE"), the
     size key design names carry (…-800x2000). '' when the title has no WxH. */
  function vvPdpSizeKey(){
    try{ var v=vvVariant(); var t=(v&&v.title)||''; var m=t.match(/(\d{2,5})\s*mm\s*W?\s*[x×]\s*(\d{2,5})\s*mm/i); return m?(m[1]+'x'+m[2]):''; }catch(e){ return ''; }
  }
  /* Design names carry their size two ways: "…-800x2000" (pull-ups, corflute, flags)
     or width only, "SSW-…-lakemist-1500" (media walls). Match either for a wanted "WxH". */
  function vvSizeMatch(name,want){
    try{ var n=String(name||'').toLowerCase(), w=String(want||'').toLowerCase(); if(!n||!w)return false;
      if(n.indexOf('-'+w)>=0)return true;
      /* RC4 iPhone matrix (A-frame): the width-only rule used to accept ANY height — "-450(x…)?$" matched
         "CorrugatedAFrameSigns-DYO-450x450" for a wanted 450x900. Width-only names have no 'x' at all. */
      var w0=w.split('x')[0]; if(w.indexOf('x')>=0&&new RegExp('-'+w0+'$').test(n))return true;
      /* Flags are sized by WORD, not millimetres ("TD-blank-medium-Single", "Bow-cafe-large-single-…"):
         a word key matches a name that carries that word as its own hyphenated token. */
      if(/^(x-?small|small|medium|large|x-?large)$/.test(w)) return new RegExp('(^|-)'+w.replace('-','-?')+'(-|$)').test(n);
      /* Release-hardening (2026-10-06): the rail names carry the MASTER PAGE size, often with decimals
         ("FeatherFlags-DYO-600x2213.8", "MediaWall-DYO-1555.7x2404.5") or ±1 mm of the nominal size
         ("CorrugatedPlasticSigns-DYO-601x901" for a 600×900 sign). The wanted size now arrives from the
         create app as the master page size (?vvmaster=), so compare NUMERICALLY within 2 mm. */
      var wm=w.match(/^(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)$/), nm=n.match(/-(\d+(?:\.\d+)?)(?:x(\d+(?:\.\d+)?))?$/);
      if(!wm||!nm)return false;
      var dw=Math.abs(parseFloat(wm[1])-parseFloat(nm[1]));
      if(nm[2]==null) return dw<=2;
      return dw<=2 && Math.abs(parseFloat(wm[2])-parseFloat(nm[2]))<=2; }catch(e){ return false; }
  }
  /* the size key the rail is matched against: the master page size the create app resolved for this
     variant / configuration (?vvmaster=), else the deep link's ?vvsize, else the PDP variant title */
  function vvRailSizeKeys(){
    var keys=[];
    try{ var m=(location.search||'').match(/[?&]vvmaster=(\d+(?:\.\d+)?x\d+(?:\.\d+)?)/i); if(m) keys.push(m[1].toLowerCase()); }catch(e){}
    try{ var d=(typeof DEEP!=='undefined')&&DEEP&&DEEP.size; if(d&&/^\d+(\.\d+)?x\d+(\.\d+)?$/i.test(d)) keys.push(String(d).toLowerCase()); }catch(e){}
    try{ var pk=(vvPdpSizeKey()||'').toLowerCase(); if(pk) keys.push(pk); }catch(e){}
    /* the size WORD of the variant title ("Medium (3000mm H) Poles + Carry Bag" → medium) — flag rails are named by it */
    try{ var v=vvVariant(), t=((v&&v.title)||'').toLowerCase(), wm=t.match(/\b(x-?small|x-?large|small|medium|large)\b/); if(wm) keys.push(wm[1].replace(/\s+/g,'-')); }catch(e){}
    return keys;
  }
  /* Rail names carry EITHER the nominal size (PullUp-DYO-800x2000 on an 806×2170 master) OR the master page
     size (FeatherFlags-DYO-600x2213.8). A row is "this size" when it matches ANY of the keys we hold. */
  function vvRailSizeKey(){ var k=vvRailSizeKeys(); return k.length?k[0]:''; }
  function vvRailSizeMatch(name){ var k=vvRailSizeKeys(); for(var i=0;i<k.length;i++){ if(vvSizeMatch(name,k[i])) return true; } return false; }
  function vvHasSize(name){ var n=String(name||'').toLowerCase(); return /-\d+(\.\d+)?(x[\d.]+)?$/.test(n)||/(^|-)(x-?small|small|medium|large|x-?large)(-|$)/.test(n); }
  function vvDeepStyleParam(){
    /* read the URL directly rather than the DEEP object below: this runs from
       browseReset() at launch and must not depend on that assignment order. */
    try{ var m=location.search.match(/[?&]vvstyle=([^&#]+)/); return m?decodeURIComponent(m[1]):''; }catch(e){ return ''; }
  }
  /* 30-Sep — LINKS WITHOUT THE "gpt15-" PREFIX. The media-wall library's 500 designs are
     named gpt15-<theme>-<name> in Customer's Canvas and in the theme registry, and that
     prefix used to show in every link (owner: "the link says gpt … better to remove").
     Links now carry the key without it; the registry, the CC names and every old link
     keep the prefix. Both forms resolve to the same design: keys are compared with any
     leading gptNN- dropped. Nothing is renamed anywhere. */
  function vvStyleNorm(s){ return String(s||'').toLowerCase().replace(/^gpt\d+-/,''); }
  function vvStyleSame(a,b){ a=vvStyleNorm(a); b=vvStyleNorm(b); return !!a&&a===b; }
  function vvStyleTail(t,s){ t=vvStyleNorm(t); s=vvStyleNorm(s); return !!s&&(t===s||t.indexOf(s+'-')===0); }
  function vvStyleKeyOf(st){
    try{ if(BROWSE_STYLE_NAMES[st])return st; var n=vvStyleNorm(st);
      for(var k in BROWSE_STYLE_NAMES){ if(vvStyleNorm(k)===n)return k; } }catch(e){}
    return st;
  }
  function vvDeepCover(){
    var st=vvDeepStyleParam(); if(!st)return;
    function label(){ try{ return BROWSE_STYLE_NAMES[vvStyleKeyOf(st)]||''; }catch(e){ return ''; } }
    var nm=label();
    browseWait(true, nm?('Opening '+nm+'\u2026'):'Opening your design\u2026');
    try{ var s=document.getElementById('vvbr-wait-step');
         if(s)s.textContent='Finding your design\u2026'; }catch(e){}
    /* the registry that holds the human name loads async, so the first paint is
       often the generic line. Upgrade it once the name exists - but stop at 10s,
       because past that mountProgress owns this text and says something more
       useful about a slow connection. */
    if(!nm){
      var tries=0, iv=setInterval(function(){
        if(++tries>20){ clearInterval(iv); return; }
        var n2=label(); if(!n2) return;
        clearInterval(iv);
        var t=document.getElementById('vvbr-wait-t');
        if(t && /^Opening your design/.test(t.textContent||'')) t.textContent='Opening '+n2+'\u2026';
      },500);
    }
    /* AN ESCAPE, BECAUSE THIS OVERLAY IS OPAQUE AND COVERS A WORKING GALLERY.
       The rule this whole panel was built under (24-Aug, BUG-107) is that it
       must never trap anyone behind a white screen. A normal pick lands at
       6-9s; if 25s have passed something is wrong, and the customer must be
       able to get to the designs rather than watch a bar. */
    setTimeout(function(){
      try{
        if(browse.entered||browse.done)return;
        var w=document.getElementById('vvbr-wait'); if(!w)return;
        if(document.getElementById('vvdeep-esc'))return;
        var a=document.createElement('button');
        var _esc=null; try{ _esc=vvFromTarget(); }catch(e){}
        var _toGal=!!(_esc&&_esc.gallery&&_esc.path);
        a.id='vvdeep-esc'; a.type='button'; a.textContent=_toGal?'Back to design ideas':'Browse all designs instead';
        a.setAttribute('style','margin-top:6px;background:none;border:0;padding:6px 4px;'+
          'font:600 13px inherit;color:#d6202b;text-decoration:underline;cursor:pointer;');
        // Invariant 3: a gallery-origin customer goes back to the gallery, never into the legacy grid
        a.addEventListener('click',function(){ if(_toGal){ try{ location.href=_esc.path; }catch(e){} return; } try{ browseWait(false); }catch(e){} });
        (w.querySelector('div')||w).appendChild(a);
      }catch(e){}
    },25000);
    /* Hard backstop past the picker's own 90s budget: reveal the gallery rather
       than leave a dead screen. At worst the customer lands where they landed
       before this change, which is survivable; a frozen overlay is not. */
    setTimeout(function(){
      try{ if(!browse.entered && !browse.done && !browse.pickWaitAt){ vvOutagePanel('backstop-95s'); } }catch(e){}   // dd3e: never navigate the customer away unasked
    },95000);
    (function early(){ var n=0, iv=setInterval(function(){ try{ n++; if(browse.entered||browse.done||n>40){ clearInterval(iv); return; }
      if(window.__vvDDErr&&Date.now()-window.__vvDDErr.at>5000&&(Date.now()-(window.__vvT0||0))>35000){ clearInterval(iv); vvOutagePanel('direct-failed'); } }catch(e){} },2500); })();
  }
  /* dd3e: the design service is not answering — say so, keep everything the customer chose, let THEM decide */
  function vvOutagePanel(why){
    try{
      if(document.getElementById('vvout-retry'))return;
      var w=document.getElementById('vvbr-wait'); if(!w){ browseWait(true,''); w=document.getElementById('vvbr-wait'); } if(!w)return;
      try{ vvInc.mark('rec:outage:panel',{why:why}); }catch(e){} try{ galBeat('recovery',{stage:'design-service',action:'panel',why:why}); }catch(e){}
      var box=w.querySelector('div')||w, sp=box.querySelector('span'); if(sp) sp.style.display='none';
      var t=document.getElementById('vvbr-wait-t'), st=document.getElementById('vvbr-wait-step');
      if(t) t.textContent='We can’t load this design right now'; else { t=document.createElement('div'); t.id='vvbr-wait-t'; t.textContent='We can’t load this design right now'; box.appendChild(t); }
      if(st) st.textContent='The design service isn’t responding. Your product, size and design choice are kept — nothing has been lost.';
      var esc=document.getElementById('vvdeep-esc'); if(esc) esc.remove();
      var row=document.createElement('div'); row.setAttribute('style','display:flex;gap:10px;flex-wrap:wrap;justify-content:center;margin-top:6px;');
      var r=document.createElement('button'); r.id='vvout-retry'; r.type='button'; r.textContent='Try again';
      r.setAttribute('style','background:#d6202b;color:#fff;border:0;border-radius:6px;padding:10px 18px;font:600 14px inherit;cursor:pointer;');
      var g=null; try{ g=vvFromTarget(); }catch(e){}
      var b=document.createElement('button'); b.id='vvout-back'; b.type='button'; b.textContent=(g&&g.gallery)?'Back to design ideas':'Browse all designs';
      b.setAttribute('style','background:none;border:1px solid #ccc;border-radius:6px;padding:10px 16px;font:600 14px inherit;cursor:pointer;color:#191919;');
      row.appendChild(r); row.appendChild(b); box.appendChild(row);
      var tries=0;
      r.addEventListener('click',async function(){
        if(r.disabled)return; r.disabled=true; tries++; r.textContent='Checking…'; try{ vvInc.mark('rec:outage:retry',{n:tries}); }catch(e){}
        var ok=false, L=window.__vvDDLast;
        try{ if(L&&L.u){ var c=new AbortController(), tm=setTimeout(function(){ try{c.abort();}catch(e){} },6000);
               var rr=await fetch(L.u,{headers:{Authorization:'Bearer '+L.t},signal:c.signal}); clearTimeout(tm); ok=rr.ok||rr.status===401||rr.status===403; }   // 401/403 = answering (token aged): the reload mints a new one
             else ok=true; }catch(e){ ok=false; }
        if(ok){ try{ vvInc.mark('rec:outage:service-back'); }catch(e){} if(st) st.textContent='The design service is back — reopening your design…';
          try{ window.__vvNoNav=1; }catch(e){} location.reload(); return; }   // same URL: product, variant and design choice unchanged
        try{ vvInc.mark('rec:outage:still-down',{n:tries}); }catch(e){}
        if(st) st.textContent='Still not responding (try '+tries+'). Your choices are kept — please try again in a minute, or call 1300 721 614.';
        r.textContent='Try again'; r.disabled=false; });
      b.addEventListener('click',function(){ try{ vvInc.mark('rec:outage:back'); }catch(e){} if(g&&g.path){ location.href=g.path; return; } try{ browseWait(false); }catch(e){} });
    }catch(e){}
  }
  function browsePickVerify(name,was,wasDesign,wantId){
    setTimeout(function(){
      var ed=deepFind('au-widget-design-editor'); if(!ed)return;
      if(ed._privateDesignId&&ed._privateDesignId!==was)return;      // took (older UIF)
      var now=edDesignId(ed);
      /* Release-hardening (2026-10-06): when the pick knows WHICH design it wants (blank starter or a
         deep-linked style), "the editor names some other design than before" is not success — that is
         exactly how a blank pick ended on a template. Only the wanted id counts; otherwise re-tap. */
      if(wantId){ if(now&&String(now)===String(wantId))return; }
      else if(now&&now!==wasDesign)return;   // took: the editor names a design it did not before
      try{ if(ed._preloaderLockingSum>0||ed._isInited&&!wasDesign&&now)return; }catch(e){}   // mid-load: do not double it
      var again=browseTileFor(name);
      if(again){ try{ again.click(); }catch(e){} }
    },1800);
    /* 24-Aug PICK-SIDE APPLY LADDER — independent of the monitor loop and of
       ccKick's latches, because both have now been caught out at once: on a
       size-switch relaunch the selector held the picked design, the editor
       held the blank starter, kickCompile never fired a compile, and a single
       manual sel.compile()+ed.compile() applied the design in ~4s. This ladder
       IS that manual fix, automated: at 4s/9s/15s/22s after the pick, if the
       editor's own params still don't name the picked design, run the same
       two-call chain kickCompile uses (idempotent — 5-Aug media-wall note).
       Stops the moment the read-back matches or the session leaves browse. */
    [4000,9000,15000,22000].forEach(function(dly){
      setTimeout(function(){
        try{
          if(!browse.entered||!browse.pickedId)return;
          var sel=deepFind('au-widget-pim-design-selector'), ed=deepFind('au-widget-design-editor');
          if(!sel||!ed||typeof ed.compile!=='function')return;
          if(edDesignId(ed)===browse.pickedId)return;              // it landed
          Promise.resolve()
            .then(function(){ return (typeof sel.compile==='function')?sel.compile():null; })
            .then(function(){ return ed.compile(); })
            .catch(function(e){ try{console.warn('[vivid-cc] pick apply ladder failed',e);}catch(_){}});
        }catch(e){}
      },dly);
    });
  }
  /* 24-Aug BUG-107 — a pick taken before the live rail has rows used to depend
     ENTIRELY on browseSync()'s pendingPick handler to complete it. That handler
     sits behind three early returns (feed.ok, browseCollect()!==null and the
     stale-feed option guard) AND behind `if(browse.sig===sig)return;`, so any one
     of them strands the customer on a gallery that will never respond again —
     reproduced on /products/straight-stretch-fabric-walls: tapping "Start from
     blank" 2s after the gallery painted never opened the editor, 110s later, even
     though the rail had settled at 501/501 tiles and the design name matched
     exactly. Tapping the same card after the rail had settled opened it instantly.
     Wait on the thing we actually need — the tile — instead of on a sync tick.
     browseSync's handler stays as-is; whichever completes first wins (both clear
     pendingPick, and browsePick is idempotent from the gallery). */
  /* 24-Aug ALERT A — "finish-error:cart-add:cart/add 422" told us a number and nothing else.
     Shopify's /cart/add.js puts the ACTUAL reason in the response body's `description`
     (the live one was "Minimum quantity allowed is 10 (Plastic Flute Board Signs)"), and
     every throw site below was discarding that body and reporting only the status. A whole
     investigation was needed to recover one sentence Shopify had already handed us. Read it,
     put it in the customer's error panel, and beacon it. */
  /* 25-Aug — WHY EVERY CART WRITE NOW RETRIES.
     Shopify throttles the /cart/*.js endpoints and answers 429. That is a
     TRANSIENT condition, and it lands at the single worst moment in the whole
     flow: AFTER the customer has designed the product and AFTER we have already
     built the print file. Every call site below treated any non-2xx as fatal, so
     one throttled request destroyed a finished sale and showed the customer
     "your design was created but we couldn't add it to the cart".
     Measured on 25 Aug, from the monitor's own marks:
        onfinish-fired@2.8s  artwork-post@2.8s  artwork-completed@16.0s
        cart-write@16.4s     finish-error:cart-add:cart/add 429@51.5s
     — i.e. everything worked and the last inch threw the work away.
     Retry ONLY what is actually retryable: 429 and 5xx. A 422 is Shopify telling
     us the line itself is wrong (e.g. "Minimum quantity allowed is 10"); retrying
     that would just make the customer wait longer for the same answer, so it
     still fails on the first response. Retry-After is honoured when sent. */
  function cartRetryable(st){ return st===429 || st>=500; }
  async function cartWrite(url,body,what){
    var tries=0, res=null, backoff=800;
    while(true){
      res=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
      if(res.ok) return res;
      if(!cartRetryable(res.status) || tries>=3) return res;
      var ra=Number((res.headers&&res.headers.get&&res.headers.get('Retry-After'))||0);
      var wait=(ra>0)?Math.min(ra*1000,8000):backoff;
      try{ prepMark('cart-retry-'+res.status+'-wait'+wait); }catch(e){}
      try{ console.log('[vivid-cc] cart '+res.status+', retrying in '+wait+'ms ('+(tries+1)+'/3)'); }catch(e){}
      await new Promise(function(r){ setTimeout(r,wait); });
      backoff=Math.min(backoff*2,6000); tries++;
    }
  }
  async function cartErrMsg(res,what){
    var d='';
    try{ var b=await res.clone().json(); d=(b&&(b.description||b.message))||''; }catch(e){}
    return (what||'cart/add')+' '+res.status+(d?(': '+String(d).slice(0,160)):'');
  }
  /* What a pending pick waits for. A template: its own tile. The BLANK starter: a blank row of THIS size
     in the rail (the cached card may be named for another size — its tile is never the answer). */
  function browsePendingReady(name){
    if(browseIsBlank(name)){ try{   // a pending BLANK is recognised by its name — no flag to lose in a browseReset()
      var sel=deepFind('au-widget-pim-design-selector'), row=vvBlankRowFor((sel&&sel.displayedVariants)||[]);
      return !!(row&&browseTileFor(row.designName)); }catch(e){ return false; } }
    return !!browseTileFor(name);
  }
  /* THE blank starter for the PDP's selection, from the rail. A size key (the create app's master size, the deep
     link's size, the variant title's WxH or size word) picks among the rows of an unfiltered first page; once the
     feed carries the PDP's choices (vvFeedSettled) the blank it shows IS this size's starter even when its name
     cannot be matched (master mm vs nominal mm, "6 Foot"). An unfiltered page with no key match is never guessed. */
  /* 6-Oct-2026 INCIDENT (teardrop Small DOUBLE-sided, variant 39524664082501, design-apply-slow@45s, same browser
     twice in 24 h): the flag rails carry a SIDES word too ("TD-blank-small-Single" / "TD-blank-small-Double"). The
     size word alone matched the SINGLE-sided blank first whenever the unfiltered feed landed before the PDP filter
     (fast link, or a warm cache) — the wrong starter was tapped and the read-back could never pass. The variant
     title says which side it is; a blank whose name says the other side is never this variant's starter. */
  function vvRailSideKey(){
    try{ var v=vvVariant(), t=((v&&v.title)||'').toLowerCase();
      try{ var q=new URLSearchParams(location.search).get('vvsides'); if(q) t+=' '+String(q).toLowerCase(); }catch(e){}
      if(/double/.test(t)) return 'double'; if(/single/.test(t)) return 'single'; }catch(e){}
    return '';
  }
  function vvSideOk(name){
    var k=vvRailSideKey(); if(!k) return true;
    var n=String(name||'').toLowerCase(), has=/(^|[-_ ])(single|double)([-_ ]|$)/.exec(n);
    return !has||has[2]===k;
  }
  /* 21-Oct (blank starters): a blank may DECLARE how many printed faces it has ("AFrameSigns-DYO-2face-606x906").
     A-frame "Two Printed Signs" is two 606x906 faces; the old one-face "AFrameSigns-DYO-606x906" can never pass the
     Finish geometry guard there, and 36/36 blank starts in 30 days died on it. The variant's face count comes from
     vivid-cc-geom.json (measured surfaces), else from the variant title. A blank that declares a different count is
     never this variant's starter; one that declares the same count wins over an undeclared one. Blanks that declare
     nothing (every other product) are unaffected. */
  function vvBlankFaces(name){ var m=/(^|[-_ ])(\d)(face|faces)([-_ ]|$)/.exec(String(name||'').toLowerCase()); return m?+m[2]:0; }
  function vvWantFaces(){
    try{ var e=vvGeomRaw(vid()); if(e&&e.s&&e.s.length) return e.s.length; }catch(e){}
    try{ var v=vvVariant(), t=((v&&v.title)||'').toLowerCase(); if(/\btwo printed signs\b|\b2 printed signs\b/.test(t)) return 2; }catch(e){}
    return 0;
  }
  function vvBlankFaceFilter(blanks,nameOf){
    var wf=vvWantFaces(); if(!wf||blanks.length<1) return blanks;
    var dec=[], ok=[];
    for(var i=0;i<blanks.length;i++){ var f=vvBlankFaces(nameOf(blanks[i])); if(f===wf) dec.push(blanks[i]); if(!f||f===wf) ok.push(blanks[i]); }
    return dec.length?dec:ok;
  }
  var _vvBlankAmbigT0=0;
  function vvBlankRowFor(rows){
    var blanks=[]; for(var i=0;i<rows.length;i++){ if(browseIsBlank(rows[i].designName||'')&&vvSideOk(rows[i].designName||'')) blanks.push(rows[i]); }
    blanks=vvBlankFaceFilter(blanks,function(r){ return r.designName||''; });
    if(!blanks.length) return null;
    if(vvRailSizeKeys().length){
      var hit=[]; for(var b=0;b<blanks.length;b++){ var n=blanks[b].designName||''; if(vvRailSizeMatch(n)||!vvHasSize(n)) hit.push(blanks[b]); }
      /* 21-Oct: products with one blank PER VARIANT (Round Table Throws: size x drop) can show several blanks that all
         match the key ("small" fits both drops) while the feed is still unfiltered. Taking the first was a coin toss on
         size; wait for the PDP-filtered feed instead (bounded: 20 s, then the first match as before). */
      if(hit.length===1) return hit[0];
      if(hit.length>1){
        if(vvFeedSettled()){ _vvBlankAmbigT0=0; return hit[0]; }
        if(!_vvBlankAmbigT0) _vvBlankAmbigT0=Date.now();
        if(Date.now()-_vvBlankAmbigT0>20000) return hit[0];
        return null;
      }
    }
    return vvFeedSettled()?blanks[0]:null;
  }
  /* Has the design feed been filtered to the PDP's own choices? feed.ok flips only on read-back of the pushed
     choices (see feedChoices / feedSync). Before the options widget is even mounted nothing can be filtered —
     allow a bounded wait for it (single-option products never mount it and have one starter anyway). */
  var _vvFeedWaitT0=0;
  function vvFeedSettled(){
    try{
      var fc=feedChoices(); if(fc) return !!feed.ok;
      if(!pdpChosen()||SHOPIFY_VARIANTS.length<=1) return true;      // one variant (calculator products): nothing to filter                                     // no PDP options at all: nothing to filter
      var po=deepFind('au-widget-pim-options'); if(po&&po.options&&po.options.length) return !!feed.ok;
      if(!_vvFeedWaitT0) _vvFeedWaitT0=Date.now();                       // options exist but the widget is not up yet
      return Date.now()-_vvFeedWaitT0>15000;
    }catch(e){ return true; }
  }
  function browsePickPending(g,pix,name){
    try{ vvInc.mark('pick:pending',{name:name}); }catch(e){}
    browse.pendingPick=name;
    browseWait(true,'Loading this design…');
    var done=false, iv=null, mo=null, moSel=null, deadline=null;
    function stop(){ done=true;
      if(iv){clearInterval(iv);iv=null;}
      if(mo){try{mo.disconnect();}catch(e){} mo=null;}
      if(deadline){clearTimeout(deadline);deadline=null;} }
    function attempt(){
      if(done)return true;
      /* RC4 iPhone matrix (teardrop): the theme's late tab re-init calls browseReset() ~5 s in, which replaces the
         browse object — pendingPick becomes undefined, the pending pick died and the customer sat on the grid.
         undefined means "reset", not "completed" (completion sets null): re-register and keep waiting. */
      if(browse.pendingPick===undefined){ browse.pendingPick=name; }
      if(browse.pendingPick!==name){ stop(); return true; }        // browseSync completed it, or the customer moved on
      if(!browseEl.hasAttribute('data-on')){ stop(); return true; } // gallery closed
      if(!browsePendingReady(name)){ watch(); return false; }
      stop(); browse.pendingPick=null; browseWait(false);
      var live=(browse.items||[]);            // prefer the refreshed card model if it has landed
      for(var i=0;i<live.length;i++){ for(var j=0;j<live[i].cws.length;j++){
        if(live[i].cws[j].name===name){ browsePick(live[i],j); return true; } } }
      browsePick(g,pix); return true;
    }
    /* Watch the rail's OWN shadow root. MutationObserver callbacks are microtasks and are
       not subject to the background-tab timer throttling that makes a 500ms poll crawl, so
       the pick lands the instant the tiles are inserted instead of up to a poll late. */
    function watch(){
      try{
        var sel=deepFind('au-widget-pim-design-selector');
        if(sel&&sel.shadowRoot&&sel.shadowRoot!==moSel){
          if(mo){try{mo.disconnect();}catch(e){}}
          moSel=sel.shadowRoot;
          mo=new MutationObserver(function(){ attempt(); });
          mo.observe(moSel,{childList:true,subtree:true});
        }
      }catch(e){}
    }
    watch();
    iv=setInterval(attempt,500);                                   // belt and braces (rail swapped, no mutations)
    deadline=setTimeout(function(){                                // single timer, not a chain
      if(done)return; stop();
      if(browse.pendingPick!==name)return;
      browse.pendingPick=null;
      browseWait(true,'The design editor is taking longer than usual on this connection — please tap the design again in a moment.');
      setTimeout(function(){ browseWait(false); },4500);
    },30000);
    attempt();
  }
  function browsePick(g,ix){
    var pix=(typeof ix==='number'?ix:(browse.cwSel[g.style]||0)); if(pix>=g.cws.length)pix=0;
    var pick=g.cws[pix]||g.cws[0];
    try{ vvInc.mark('pick:request',{name:pick&&pick.name,blank:!!g.blank,tile:!!(pick&&pick.tile)}); }catch(e){}
    /* 9-Sep FRESH SESSION ON RE-PICK (owner: "when we click back it should close that console
       and load another one"). The editor instance has been used; do not re-pick into it —
       reload the page on the deep link so the second design boots exactly like the first. */
    if(browse.usedSession && !g.blank && pick && pick.id){
      try{ prepMark('fresh-repick'); ccClarity('fresh-repick'); }catch(e){}
      try{ browseWait(true,'Opening your design\u2026'); }catch(e){}
      var _fq='variant='+encodeURIComponent(vid()||'')+'&vvstyle='+encodeURIComponent(pick.id)+'&vvfresh=1';
      try{ if(EDIT.fresh&&EDIT.line) _fq+='&vvline='+encodeURIComponent(EDIT.line); }catch(e){}   // 20-Oct: a "create it again" session stays bound to its cart line (no duplicate)
      try{ window.__vvNoNav=1; }catch(e){}
      location.href=location.pathname+'?'+_fq;
      return;
    }
    /* 30-Sep — THE PULL-UP STACK OVERFLOW (measured on /products/pullup-banners
       ?vvstyle=aut-battry, live: "Maximum call stack size exceeded" at
       browsePickPending → attempt → browseTileFor → … → browsePick → browsePickPending).
       When browseSync is stranded (stale-feed guard, feed not ok) browse.items keeps the
       CACHED card model, whose entries carry no .tile. The pending attempt then finds the
       live rail tile (browseTileFor) and calls browsePick with that tile-less entry, which
       goes straight back to browsePickPending — forever, synchronously. Every gallery
       ready-made pick on that product sat on "Opening…" for the 30 s deadline. If the rail
       already has the tile, adopt it and carry on; only wait when it truly is not there. */
    /* Release-hardening (2026-10-06) — "START FROM BLANK OPENED A TEMPLATE" (measured live, pull-up 800×2000:
       the grid's blank card was the cached "PullUp-DYO-600x1400"; the size-filtered rail only holds
       "PullUp-DYO-800x2000", so the name matched no row, the stale captured node was tapped, and the editor
       opened whatever design that node now was — "PullUp-med-womenh-800x2000" under a "Blank canvas" header).
       The blank starter is ONE design per size: resolve it from the live rail by the PDP's own size before
       touching any tile. No tile for that size → honest wait (browsePickPending), never a different design. */
    var _bwait=false;
    if(g.blank){ try{
      var _bsel=deepFind('au-widget-pim-design-selector'), _brow=vvBlankRowFor((_bsel&&_bsel.displayedVariants)||[]);
      if(_brow&&(_brow.designName!==pick.name||String(_brow.designId||'')!==String(pick.id||''))){
        pick={name:_brow.designName,id:_brow.designId,tile:browseTileFor(_brow.designName)||null,thumb:pick.thumb,thumbSm:pick.thumbSm,cc:pick.cc,slug:pick.slug};
        g.cws[pix]=pick;
        try{ console.log('[vivid-cc] blank starter resolved for this size:',pick.name); }catch(e){}
        try{ vvInc.mark('pick:blank-resolved',{name:pick.name}); }catch(e){}
      } else if(!_brow){
        /* the rail has no blank at this size yet — wait for it rather than open a wrong-size starter.
           RC4 matrix, iPhone (pull-up / teardrop / bow / A-frame): at pick time the rail still held the
           UNFILTERED feed, whose only blank was the cached wrong-size starter; nulling the tile was not
           enough because the fresh-tile lookup below found that wrong-size tile and tapped it. Wait, full stop. */
        pick.tile=null; _bwait=true;
      }
    }catch(e){} }
    if(_bwait){ browsePickPending(g,pix,pick.name); return; }
    if(!pick.tile){ try{ var _fresh=browseTileFor(pick.name); if(_fresh) pick.tile=_fresh; }catch(e){} }
    if(!pick.tile){                     /* cached instant-paint card: live feed not in yet */
      /* 20-Aug: slow phones = feed 20s+ behind; tiny counter text read as a freeze. Real overlay. */
      browsePickPending(g,pix,pick.name);
      return;
    }
    /* 24-Aug STALE-TILE GUARD (the blank-editor half of the size-switch bug).
       pick.tile was captured when the cards rendered; a size change between
       launches remounts/refilters the rail, so that node can be DETACHED by
       pick time. Clicking a detached node throws nothing and selects nothing —
       the editor keeps the blank starter with the picked name in the header
       (owner's iPhone report, reproduced on desktop). If a fresh lookup misses
       AND the captured node is no longer in the document, this pick cannot
       succeed — take the same honest wait-for-feed path as a cached card, and
       browseSync's pendingPick handler completes it when live rows land. */
    if(!browseTileFor(pick.name) && !(pick.tile&&pick.tile.isConnected)){
      browsePickPending(g,pix,pick.name);
      return;
    }
    /* rung 4: past both bail-outs, so this pick really does open the canvas.
       Placed here and not at the top of browsePick because the two returns above
       hand off to browsePickPending, which re-enters here when the feed lands. */
    try{ ccClarity('canvas-open'); }catch(e){}
    /* 23-Aug — "it looks like the page froze and which is very bad for the client".
       Owner, on his iPhone: tapped a design, ~6 seconds of nothing, then the editor
       appeared showing the BLANK starter template with the design's name in the
       header. Two complaints, one cause — the gap between hiding the gallery and
       the picked design actually landing in the canvas was completely unlit.

       The overlay already existed for the slow-feed path below; it just never ran
       on the ordinary one. Now it does, and it stays up until the editor's own
       params READ BACK the design that was picked (kickCompile clears it), so the
       customer never sees the blank starter and mistakes it for their design.
       VVBR_PICK_MAX_MS is the backstop: it must never trap someone behind a white
       screen over a working editor, so it lifts regardless and the non-blocking
       "still loading" strip takes over from there. */
    /* NOT for "Start from blank" — there is no picked design to read back, so the
       cover would sit there for its full backstop over a perfectly good empty
       canvas. Blank is also the one case where the starter template IS the
       correct result. */
    if(!g.blank){
    try{ bootNotice(false); }catch(e){}   // the pick cover takes over from here
    /* 11-Sep: name it. The deep-link cover already says "Opening NO DOGS..." and
       reverting to the generic line at pick time reads as a step backwards. */
    browseWait(true, (function(){ try{ var n=BROWSE_STYLE_NAMES[g.style];
      return n?('Opening '+n+'\u2026'):'Opening your design\u2026'; }catch(e){ return 'Opening your design\u2026'; } })());
    browse.pickWaitAt=Date.now();
    setTimeout(function(){
      if(browse.pickWaitAt && Date.now()-browse.pickWaitAt >= VVBR_PICK_MAX_MS-50){
        browse.pickWaitAt=0; browseWait(false);
        // Handing over, not going quiet: if the design still is not in, say so.
        try{ if(!ccKick.loaded) kickNotice(true,'Still loading the design you picked…',true); }catch(e){}
      }
    },VVBR_PICK_MAX_MS);
    }
    vvccBrowseHdr(true,g,pix);
    /* 30-Sep — THE 30-SECOND PULL-UP (measured, warm, /products/pullup-banners
       ?vvstyle=aut-battry). Customer's Canvas holds two designIds under the same
       name ("PullUp-aut-battry-800x2000": 45d5a06e… and a6bb51ce…). The cached
       card model carried one id, the tile we click belongs to the other, so the
       read-back below (editor params === pickedId) could never match and the
       "Opening…" cover sat for its whole 30 s deadline over a finished editor.
       The id the read-back waits for must be the ROW OF THE TILE WE CLICK. */
    try{
      var _selR=deepFind('au-widget-pim-design-selector'), _tR=browseTileFor(pick.name)||pick.tile;
      if(_selR&&_selR.shadowRoot&&_tR){
        var _tilesR=_selR.shadowRoot.querySelectorAll('.gallery__item'), _ixR=Array.prototype.indexOf.call(_tilesR,_tR);
        var _rowR=_ixR>=0?(_selR.displayedVariants||[])[_ixR]:null;
        if(_rowR&&_rowR.designId&&String(_rowR.designId)!==String(pick.id||'')){ pick.id=_rowR.designId; }
      }
    }catch(e){}
    browse.pickedId=pick.id;                   // rail-hide keeps THIS tile visible
    browse.entered=true;                       // UPDATE 30: editor entered FROM the gallery
    try{ var gw=browseEl.querySelector('.vvbr-gridwrap'); browse.scroll=gw?gw.scrollTop:0; }catch(e){}
    browse.done=true; browseEl.removeAttribute('data-on'); modal.removeAttribute('data-browse');
    if(browseQv)browseQv.setAttribute('hidden','');
    // ⚠ REVERTED 9-Aug: runLaunch re-mount re-opened the gallery over the loading editor
    //   ("editor has stopped loading"). Keep tile-click path until entered-state is re-applied post-launch.
    var _ed=deepFind('au-widget-design-editor');
    /* 30-Sep PERF: _privateDesignId is never set by UIF 7.1.74 (measured: "" before,
       during and after a successful pick), so the 1.8 s verify below re-clicked EVERY
       deep link and every gallery pick — a second from-design + a second editor init,
       +1.0–1.5 s and an orphan private design each time. The editor's own params
       (changeDesignVariant.designVariant.designId, what edDesignId reads) are the
       honest signal; remember both. */
    var _was=_ed&&_ed._privateDesignId;
    var _wasDesign=_ed?edDesignId(_ed):null;
    var _tile=browseTileFor(pick.name)||pick.tile;   // fresh node, captured one only as a fallback
    /* 23-Aug — RECORD WHAT ACTUALLY HAPPENS HERE. Three rounds of emulation have
       now disagreed with the owner's iPhone, so stop inferring: this whole path
       rests on _tile.click() reaching a node that is still in the document and
       still wired to UIF's selector. If the rail is not rendered on a phone, or
       browseTileFor() misses and the captured fallback is stale, the click lands
       on a detached node, nothing throws, and the editor keeps the blank design
       with the picked name in the header — exactly what was reported. ?vvcc=diag
       puts these four facts on screen. */
    var _dg={name:pick.name,id:pick.id||'',fresh:!!browseTileFor(pick.name),
             tile:!!_tile,inDoc:false,clicked:false,err:'',at:Date.now()};
    /* isConnected, NOT document.contains(): the rail's tiles live inside Aurigma's
       shadow DOM, where contains() answers false for a perfectly live node. Caught
       it on the first run — Chromium reported inDoc=N while the click worked and
       the design applied, which would have sent us hunting a phantom on the phone. */
    try{ _dg.inDoc=!!(_tile&&_tile.isConnected); }catch(e){}
    try{ _dg.clicked=browseTap(_tile); }catch(e){ _dg.err=String(e&&e.message||e).slice(0,60); }
    browse.pickedName=pick.name;   // the retry needs to find this tile again
    browse.diag=_dg;

    browsePickVerify(pick.name,_was,_wasDesign,pick.id);
  }
  function browseDispIx(g){ // shown colourway: user pick, else first matching colour facet
    var ix=browse.cwSel[g.style]; if(typeof ix!=='number')ix=0; if(ix>=g.cws.length)ix=0;
    if(browse.col && browseCwMeta(g,ix).fam!==browse.col){
      for(var i=0;i<g.cws.length;i++){ if(browseCwMeta(g,i).fam===browse.col)return i; }
    }
    return ix;
  }
  function browseText(g){
    var inds=(g.style&&BROWSE_STYLE_INDUSTRIES[g.style])||[];
    var t=(BROWSE_STYLE_NAMES[g.style]||g.names)+' '
      +inds.join(' ')+' '
      +inds.map(function(d){return BROWSE_INDUSTRY_LABELS[d]||'';}).join(' ')+' '
      +(BROWSE_STYLE_KEYWORDS[g.style]||'');
    for(var i=0;i<g.cws.length;i++){ var m=browseCwMeta(g,i); t+=' '+m.label+' '+(BROWSE_FAMS[m.fam]||[''])[0]; }
    return t.toLowerCase();
  }
  function browseVisible(){
    var items=browse.items||[], q=browse.q.trim().toLowerCase();
    var vis=items.filter(function(g){
      if(g.blank)return true;
      var inds=(g.style&&BROWSE_STYLE_INDUSTRIES[g.style])||[];
      if(browse.cat!=='all'&&inds.indexOf(browse.cat)<0)return false;
      if(browse.thm&&BROWSE_STYLE_THEMES[g.style]!==browse.thm)return false;
      if(browse.typ&&browseTypeOf(g)!==browse.typ)return false;
      if(browse.col){ var hit=false;
        for(var i=0;i<g.cws.length;i++){ if(browseCwMeta(g,i).fam===browse.col){hit=true;break;} }
        if(!hit)return false; }
      if(q&&browseText(g).indexOf(q)<0)return false;
      return true;
    });
    var bl=vis.filter(function(g){return g.blank;});
    var rest=vis.filter(function(g){return !g.blank;});
    if(browse.sort==='az'){
      rest=rest.sort(function(a,b){
        var an=BROWSE_STYLE_NAMES[a.style]||a.names, bn=BROWSE_STYLE_NAMES[b.style]||b.names;
        return an<bn?-1:(an>bn?1:0);});
    }else{
      rest=browseSpread(rest);
    }
    return bl.concat(rest);
  }
  /* RECOMMENDED = SPREAD, not grouped (11-Aug, owner: "all danger ones a
     coming together"). CC returns creation order = generation order, whole
     families at a time; 612 AS 1319 signs made the opening screen five DANGER
     plates in a row. Deal one design per family in turn (family = first two
     key segments, the grain the clumping happens at), bigger families first.
     DETERMINISTIC on purpose — no shuffle: the grid pages on scroll and slices
     this list, so a changing order would make cards jump or repeat. Name A-Z
     is untouched. */
  function browseFamilyOf(g){
    var n=(g.cws&&g.cws[0]&&g.cws[0].name)||g.names||'';
    var i=n.indexOf('-'); if(i>=0)n=n.slice(i+1);        // drop CorrugatedSign- / SelfieFrame-
    var p=n.split('-');
    /* The family has to match what the EYE groups, not what the key does.
       First attempt used the first two segments, which split AS 1319 into ~120
       families of one or two (as-workmen, as-confined, as-hazardous) — every
       one a red DANGER plate, every one dealt its own slot, so six of them
       still landed side by side. Anything under `as-` is one visual family. */
    if(p[0]==='as')return 'as';
    /* 31-Aug, owner on the media wall / straight stretch wall gallery: "shuffle
       the designs so different designs show up in each section as currently
       its showing all brown color on top".
       The SSW library is ONE set of pictures published at five sizes, and the
       size lives in the FIRST segment (gpt, gpt15, gpt2m, gpt4m, gpt6m) while
       the subject repeats with a numeric suffix per size (bday, bday2 ... bday5
       are the same birthday pictures). First-two-segments therefore made 224
       families out of ~45 subjects, and the deal handed a slot to each — so
       round one was five birthdays, five events, then ten different trades all
       shot on timber. Same failure as the AS 1319 case above, same remedy:
       collapse to what the EYE groups. Measured on 2,644 live names, the first
       twelve go from bday/bday4/bday2/bday3/bday5/ev3/ev4/ev5/ev/ev2 to twelve
       different subjects. */
    if(/^gpt(\d+m?)?$/.test(p[0])&&p[1])return p[1].replace(/\d+$/,'');
    return p.slice(0,2).join('-')||n;
  }
  function browseCycle(list, keyOf){
    /* Deal one from each group in turn, round after round. Stable order, no
       shuffle — the grid pages on scroll and slices this list, so a reshuffle
       between renders would make cards jump or repeat as you scroll. */
    var g={}, ks=[];
    for(var i=0;i<list.length;i++){
      var k=keyOf(list[i]);
      if(!g[k]){g[k]=[]; ks.push(k);}
      g[k].push(list[i]);
    }
    if(ks.length<2)return list;
    ks.sort(function(x,y){ return (g[y].length-g[x].length)||(x<y?-1:(x>y?1:0)); });
    var out=[], r=0, more=true;
    while(more){
      more=false;
      for(var j=0;j<ks.length;j++){
        var q=g[ks[j]];
        if(r<q.length){ out.push(q[r]); if(r+1<q.length)more=true; }
      }
      r++;
    }
    return out;
  }
  function browseSpread(list){
    /* ONE OF EACH TYPE, THEN REPEAT (owner, 11-Aug). Type = browseFamilyOf:
       the sign category, with all of AS 1319 as one bucket because its ~120
       key-families are one red DANGER plate to the eye. Rejected first: an even
       mathematical spread (puts a four-design type 90 cards deep) and a
       three-in-a-row cap (still read as clumpy). See git log 19f9200. */
    var as=[], rest=[];
    for(var i=0;i<list.length;i++)
      (browseFamilyOf(list[i])==='as'?as:rest).push(list[i]);
    if(as.length>1){
      /* Re-order INSIDE the as bucket first, then deal. Cycling the whole list
         twice does not work: the second pass would split `as` into ~120 groups
         and hand it 120 slots a round, flooding the very thing being spread. */
      as=browseCycle(as, function(g){
        var n=(g.cws&&g.cws[0]&&g.cws[0].name)||g.names||'';
        var j=n.indexOf('-'); if(j>=0)n=n.slice(j+1);
        return n.split('-').slice(0,3).join('-');
      });
    }
    return browseDeal(rest.concat(as));
  }
  function browseDeal(list){
    /* Two passes (owner, 11-Aug: "keep seeing different industries as they
       scroll"). Pass 1: one of every type, so the opening screen is the whole
       breadth. Pass 2: each type's remainder spaced evenly down the rest, in
       proportion, so an industry keeps reappearing at depth instead of being
       spent in the first few rounds. Deterministic — the grid pages on scroll
       and slices this list. See git log 6c93357. */
    var g={}, ks=[];
    for(var i=0;i<list.length;i++){
      var k=browseFamilyOf(list[i]);
      if(!g[k]){g[k]=[]; ks.push(k);}
      g[k].push(list[i]);
    }
    if(ks.length<2)return list;
    ks.sort(function(x,y){ return (g[y].length-g[x].length)||(x<y?-1:(x>y?1:0)); });
    var head=[], tail=[];
    for(var j=0;j<ks.length;j++){
      var q=g[ks[j]];
      /* 10-Sep: START EACH FAMILY AT A DIFFERENT STYLE. Taking q[0] from every
         family gave the whole opening screen one style — on the walls that is
         clayrelief, so twelve different subjects arrived all terracotta and the
         owner read the gallery as "all brown". Offsetting by the family's own
         position deals a different style to each. Deterministic, like the rest
         of this: the grid slices this list as it pages. */
      if(q.length>1){ var off=j%q.length; q=q.slice(off).concat(q.slice(0,off)); }
      head.push(q[0]);
      for(var m=1;m<q.length;m++)
        tail.push({g:q[m], pos:(m-0.5)/(q.length-1||1), fam:ks[j]});
    }
    tail.sort(function(a,b){ return (a.pos-b.pos)||(a.fam<b.fam?-1:(a.fam>b.fam?1:0)); });
    return head.concat(tail.map(function(x){return x.g;}));
  }
  // ---- UPDATE 30: back returns to the GALLERY (state intact) --------------
  // Vistaprint's studio pattern: no template rail in the editor; changing your
  // mind = back to the gallery. Only for gallery-entered sessions on
  // BROWSE_HANDLES products — direct flow keeps today's close behaviour.
  // Deep-link/refresh: a reload loses the editor and reopens the GALLERY
  // (browseReset on launch); edit-from-cart (?vvproj) still skips the gallery
  // and its chevron closes the modal (browse.entered is false).
  /* 10-Sep: give the editor the whole connection while it loads. Removing src
     cancels an in-flight image; parking it on the element means the return trip
     costs nothing for the ones that had already arrived. */
  function vvPauseGalleryImgs(){
    var n=0;
    try{
      [].forEach.call(document.querySelectorAll('#vv-cc-modal img.vvbr-thumb'),function(im){
        try{
          if(im.complete && im.naturalWidth) return;        // already here — leave it alone
          var u=im.getAttribute('src'); if(!u) return;
          im.setAttribute('data-vvpaused',u); im.removeAttribute('src'); n++;
        }catch(e){}
      });
      if(n) console.log('[vivid-cc] paused '+n+' gallery image(s) so the editor gets the connection');
    }catch(e){}
    return n;
  }
  function vvResumeGalleryImgs(){
    try{
      [].forEach.call(document.querySelectorAll('#vv-cc-modal img[data-vvpaused]'),function(im){
        try{ im.setAttribute('src',im.getAttribute('data-vvpaused')); im.removeAttribute('data-vvpaused'); }catch(e){}
      });
    }catch(e){}
  }
  function browseReturnToGallery(){
    vvResumeGalleryImgs();                      // 10-Sep: whatever we cancelled on the way in
    browse.usedSession=true;                    // 9-Sep: the next pick gets a fresh studio (see browsePick)
    vvccBrowseHdr(false);                       // UPDATE 35: default header in the gallery
    // UPDATE 36b: the "Let's get your print right" preflight panel (vvpf) must
    // never survive into the GALLERY view — owner saw it open beside the cards
    // after finish -> back. closeModal already clears it; this path did not.
    try{ pfCloseOnly(); }catch(e){}
    browse.done=false; browse.qv=null;
    if(browseQv)browseQv.setAttribute('hidden','');
    if(browseUp)browseUp.setAttribute('hidden','');   // UPDATE 37: panels never survive a return
    if(browseDs)browseDs.setAttribute('hidden','');   // UPDATE 37
    browseEl.setAttribute('data-on','1'); modal.setAttribute('data-browse','1');
    browseRender();                             // refresh selected states
    try{ var gw=browseEl.querySelector('.vvbr-gridwrap'); if(gw)gw.scrollTop=browse.scroll||0; }catch(e){}
  }
  // ---- UPDATE 37: gallery utility panels (owner directive, Vistaprint study) --
  // Upload-your-design: a REAL dropzone. Files upload to the portal
  // (/api/cc-own-artwork -> artwork bucket -> durable signed artUrl) BEFORE the
  // cart add, and the line carries vivid.artwork_uploads — the SAME property the
  // designed-artwork finish flow stamps (~line 2770 below), so production reads
  // uploaded and designed artwork from one place. The old skip-editor behaviour
  // ("send artwork after checkout") is kept as an honest, labelled secondary —
  // it adds the line with no artwork property, exactly like the legacy PDP flow.
  // Designer brief: /api/design-brief -> Postmark email to the team (ReplyTo the
  // customer). No price is claimed on the panel: the ITORIS expert price reads
  // $0 on browse products and the real design-service pricing isn't wired here.
  var vvup={files:[],busy:false};
  function vvVariant(){ var v=null; for(var i=0;i<SHOPIFY_VARIANTS.length;i++){ if(String(SHOPIFY_VARIANTS[i].id)===String(vid())){v=SHOPIFY_VARIANTS[i];break;} } return v; }
  function vvCtxLine(){
    var vv=vvVariant(), price=BROWSE_PRICES[String(vid())];
    return PRODUCT_TITLE+(vv?(' · '+vv.title):'')+((typeof price==='number')?(' · $'+(price/100).toFixed(2)+' · 1 unit'):'');
  }
  function vvupOpen(){
    if(!browseUp)return;
    /* dd3c: a repeat open (the gallery opener's verify-and-reclick) must not throw away a file the customer already picked */
    if(!browseUp.hasAttribute('hidden') && vvup.files.length){ try{ document.getElementById('vvup-ctx').textContent=vvCtxLine(); }catch(e){} vvupRender(); return; }
    vvup.files=[]; vvup.busy=false;
    document.getElementById('vvup-ctx').textContent=vvCtxLine();
    var vv=vvVariant();
    document.getElementById('vvup-note').textContent=vv?('Your file prints at the size selected on this page: '
      +vv.title.replace(/\s*-\s*SALE!?/i,'')+'. Include 10mm bleed if you can — if not, prepress will sort it with you.'):'';
    var er=document.getElementById('vvup-err'); er.setAttribute('hidden',''); er.textContent='';
    vvupRender();
    browseUp.removeAttribute('hidden');
  }
  function vvupClose(){
    /* 30-Sep: the gallery's "Upload your own design" opened this panel directly
       (?vvcc=upload); closing it goes back to the gallery, not to the grid behind. */
    try{ var _gf=vvFromTarget(); if(_gf&&_gf.gallery&&/[?&]vvcc=upload\b/.test(location.search)){ location.href=_gf.path; return; } }catch(e){}
    if(browseUp)browseUp.setAttribute('hidden',''); vvup.files=[]; vvup.busy=false; }
  function vvupRender(){
    var ul=document.getElementById('vvup-list'), h='';
    vvup.files.forEach(function(f,i){
      h+='<li><span class="vvup-nm">'+f.name.replace(/[<>&"]/g,'')+'</span><span class="vvup-sz">'
        +(f.size>1048576?((f.size/1048576).toFixed(1)+'MB'):(Math.max(1,Math.round(f.size/1024))+'KB'))
        +'</span><button type="button" class="vvup-rm" data-rm="'+i+'" aria-label="Remove file">&#10005;</button></li>';
    });
    if(ul)ul.innerHTML=h;
    try{ var dz=document.getElementById('vvup-design'); if(dz){ if(vvup.files.length&&vvupPlaceable(vvup.files[0])) dz.removeAttribute('hidden'); else dz.setAttribute('hidden','');
      dz.textContent=vvup.toEd?'Opening the designer…':'Continue designing with this file'; if(vvup.busy) dz.setAttribute('disabled',''); else dz.removeAttribute('disabled'); } }catch(e){}
    var add=document.getElementById('vvup-add'), price=BROWSE_PRICES[String(vid())];
    if(add){
      add.textContent=vvup.busy?'Uploading…':('Add to basket'+((typeof price==='number')?(' — $'+(price/100).toFixed(2)):''));
      if(vvup.files.length&&!vvup.busy)add.removeAttribute('disabled'); else add.setAttribute('disabled','');
    }
  }
  function vvupErr(msg){ var er=document.getElementById('vvup-err'); if(er){ er.textContent=msg; er.removeAttribute('hidden'); } }
  function vvupTake(list){
    var er=document.getElementById('vvup-err'); if(er){er.setAttribute('hidden','');er.textContent='';}
    var ok=/\.(pdf|ai|eps|jpe?g|png|tiff?|svg)$/i;
    for(var i=0;i<list.length;i++){
      if(vvup.files.length>=4){ vvupErr('Up to 4 files per order here — more? Send them after checkout and we’ll match them to your order.'); break; }
      var f=list[i];
      if(!ok.test(f.name)){ vvupErr(f.name+': we accept PDF, AI, EPS, JPG, PNG, TIFF or SVG.'); continue; }
      if(f.size>60*1048576){ vvupErr(f.name+' is over 60MB — use “send artwork after checkout” below and we’ll take it by email or transfer link.'); continue; }
      vvup.files.push(f);
    }
    vvupRender();
  }
  function vvupPlaceable(f){ return !!f && /\.(pdf|jpe?g|png|svg|tiff?)$/i.test(String(f.name||'')); }
  function vvupCancel(){ vvup._xAsked=false; try{ vvInc.mark('upload:cancel'); }catch(e){} vvupClose(); }   // gallery if they came from it, else the product page
  function vvupX(){
    if(vvup.files.length&&!vvup.busy&&!vvup._xAsked&&vvupPlaceable(vvup.files[0])){ vvup._xAsked=true;
      vvupErr('Keep designing with your file? Choose “Continue designing with this file” — or “Cancel” to go back without it.');
      try{ document.getElementById('vvup-design').focus(); }catch(e){} return; }
    vvupCancel(); }
  async function vvupToEditor(){
    if(vvup.busy||!vvup.files.length)return; var f=vvup.files[0];
    if(!vvupPlaceable(f)){ vvupErr('This file type can’t be opened in the designer — use “Add to basket” and our team will check it.'); return; }
    var vvid=vid(), vv=vvVariant();
    try{
      vvup.busy=true; vvup.toEd=true; vvupRender(); try{ vvInc.mark('upload:to-editor'); }catch(e){}
      var fd=new FormData(); fd.append('file',f,f.name); var ctok='';
      try{ var cj=await (await fetch('/cart.js',{headers:{Accept:'application/json'}})).json(); ctok=String((cj&&cj.token)||'').split('?')[0]; }catch(e){}
      fd.append('cartToken',ctok); fd.append('productId',String(PRODUCT_ID)); fd.append('variantId',String(vvid)); fd.append('sku',(vv&&vv.sku)||''); fd.append('item',PRODUCT_TITLE+' (opened in designer)');
      var r=await fetch(PORTAL+'/api/cc-own-artwork',{method:'POST',body:fd}); var j=null; try{ j=await r.json(); }catch(e){}
      if(!r.ok||!j||!j.ok||!(j.files&&j.files.length)) throw new Error((j&&(j.error||j.detail))||('upload '+r.status));
      var rec={url:j.files[0].url,name:j.files[0].name||f.name,variant:String(vvid),pid:String(PRODUCT_ID),at:Date.now()};
      var q=new URLSearchParams(location.search); ['vvstate','vvuser','vvresume','vvproj','vvline','vvsaved','vvstyle'].forEach(function(k){ q.delete(k); });
      q.set('vvcc','blank'); q.set('variant',String(vvid)); q.set('vvupl','1');
      try{ sessionStorage.setItem('vvUpToEditor',JSON.stringify(rec)); }catch(e){ q.set('vvuplu',rec.url); q.set('vvupln',String(rec.name).slice(0,80)); }   // no storage: carry it in the link
      try{ window.__vvNoNav=1; }catch(e){}
      location.href=location.pathname+'?'+q.toString();
    }catch(err){
      vvup.busy=false; vvup.toEd=false; vvupRender();
      vvupErr('We couldn’t open your file in the designer ('+String(err&&err.message||err).slice(0,100)+'). Your file is still selected — try again, or use “Add to basket”.');
    }
  }
  function vvupRec(){ try{ if(!/[?&]vvupl=1\b/.test(location.search))return null; var q=new URLSearchParams(location.search);
      var r=null; try{ r=JSON.parse(sessionStorage.getItem('vvUpToEditor')||'null'); }catch(e){}
      if(!r&&q.get('vvuplu')) r={url:q.get('vvuplu'),name:q.get('vvupln')||'',pid:String(PRODUCT_ID),at:Date.now()};
      if(!r||!r.url||String(r.pid)!==String(PRODUCT_ID)||Date.now()-Number(r.at||0)>12*3600e3) return null; return r; }catch(e){ return null; } }
  (function vvupPlace(){ try{
    var rec=vvupRec(); if(!rec)return; var t0=Date.now(), tries=0, busy=false; window.__vvUpPending=true;
    function done(ok,why){ window.__vvUpPending=false; window.__vvUpPlaced=!!ok; try{ vvInc.mark(ok?'upload:placed':'upload:place-failed',{why:why||'',tries:tries}); }catch(e){}
      try{ galBeat('cc-upload-place',{ok:ok?1:0,why:String(why||'').slice(0,40),tries:tries,ms:Date.now()-t0}); }catch(e){}
      if(!ok){ try{ editNotice('We couldn\u2019t add your file to the canvas automatically. Use Image \u2192 Upload in the editor to add it, or go back and choose \u201cAdd to basket\u201d with your file.'); }catch(e){} } }
    function withTimeout(p,ms){ return Promise.race([p,new Promise(function(_,rj){ setTimeout(function(){ rj(new Error('timeout '+ms)); },ms); })]); }
    (function poll(){
      if(!window.__vvUpPending) return;
      if(Date.now()-t0>300000){ done(false,'never-ready'); return; }
      var ok=false; try{ ok=(vvInc.snapshot().timeline||[]).some(function(x){ return x.s==='apply:confirmed'; }); }catch(e){}
      var ed=null; try{ ed=deepFind('au-widget-design-editor'); }catch(e){}
      if(busy||!ok||!ed||!ed.stateId||typeof ed.getEditor!=='function'){ setTimeout(poll,700); return; }
      busy=true; tries++; try{ vvInc.mark('upload:place-attempt',{n:tries}); }catch(e){}
      withTimeout((async function(){
        var E=await ed.getEditor(), P=await E.getProduct(), S=P.currentSurface, M=window.CustomersCanvas.DesignAtoms.ObjectModel;
        var pm=await P.getProductModel(), all=pm.getAllItems(); all=all.toArray?all.toArray():Array.prototype.slice.call(all);
        if(all.some(function(i){ return i&&i.name==='Your uploaded file'; })) return 'already';
        var it=new M.ImageItem(null,new M.PointF(0,0),S.width,S.height);
        it.source=new M.ImageItem.ImageSource(null,rec.url,0,false,true); it.name='Your uploaded file';
        await S.insertItem(it); return 'placed';
      })(),20000).then(function(r){ busy=false; done(true,r); },
        function(e){ busy=false; try{ vvInc.mark('upload:place-retry',{n:tries,e:String((e&&e.message)||e).slice(0,60)}); }catch(_){}
          if(tries>=4){ done(false,String((e&&e.message)||e).slice(0,60)); return; } setTimeout(poll,1500); });
    })();
  }catch(e){ window.__vvUpPending=false; } })();
  async function vvupAdd(withFiles){
    if(vvup.busy)return;
    var vvid=vid(), vv=vvVariant();
    var props={'Design services':withFiles?'Own artwork (uploaded)':'Own artwork (sending after checkout)'};
    if(vv&&vv.sku)props['_CC_Variant_SKU']=vv.sku;
    try{
      vvup.busy=true; vvupRender();
      if(withFiles){
        if(!vvup.files.length){ vvup.busy=false; vvupRender(); return; }
        var fd=new FormData();
        vvup.files.forEach(function(f){ fd.append('file',f,f.name); });
        var ctok='';
        try{ var cj=await (await fetch('/cart.js',{headers:{Accept:'application/json'}})).json(); ctok=String((cj&&cj.token)||'').split('?')[0]; }catch(e){}
        fd.append('cartToken',ctok); fd.append('productId',String(PRODUCT_ID));
        fd.append('variantId',String(vvid)); fd.append('sku',(vv&&vv.sku)||''); fd.append('item',PRODUCT_TITLE);
        var r=await fetch(PORTAL+'/api/cc-own-artwork',{method:'POST',body:fd});
        var j=null; try{ j=await r.json(); }catch(e){}
        // FAIL LOUD: no stored file, no cart line claiming there is one.
        if(!r.ok||!j||!j.ok||!(j.files&&j.files.length)) throw new Error((j&&(j.error||j.detail))||('upload '+r.status));
        props['vivid.artwork_uploads']=j.files.map(function(f){return f.url;}).join(', ');
        props['_Artwork_Files']=j.files.map(function(f){return f.name;}).join(', ');
      }
      var res=await cartWrite('/cart/add.js',{id:vvid,quantity:qty(),properties:props},'cart/add');
      if(!res.ok)throw new Error(await cartErrMsg(res,'cart/add'));
      try{window.__vvNoNav=1;}catch(e){}
      window.location.href=vvAfterCartHref();
    }catch(err){
      vvup.busy=false; vvupRender();
      vvupErr('That didn’t work ('+String(err&&err.message||err).slice(0,120)+'). Nothing was added to your basket — try again, or call 1300 721 614.');
    }
  }
  // UPDATE 38 (owner): "design brief just attaches with the item and adds the
  // item to cart with its design cost already present". The design charges live
  // in the ACTIVE Shopify add-on products (Basic $15 / Standard $45 / Premium
  // $85 per product type — DESIGN_TIERS above); the fee reaches the cart as a
  // COMPANION LINE (the theme's Same Day Production pattern) and the stored
  // brief's signed URL is attached to BOTH lines. If no tier covers this
  // product type, the panel degrades to brief-only (email + stored brief).
  var vvdsTier=null;
  function vvdsSyncBtn(){
    var send=document.getElementById('vvds-send'), price=BROWSE_PRICES[String(vid())];
    if(vvdsTier){
      send.textContent='Add to basket with design service — '
        +((typeof price==='number')?('$'+(price/100).toFixed(2)+' + '):'')
        +'$'+(vvdsTier.price/100).toFixed(2);
    } else send.textContent='Send brief to our designers';
  }
  function vvdsRenderTiers(){
    var wrap=document.getElementById('vvds-tiers-wrap'), box=document.getElementById('vvds-tiers');
    if(!DESIGN_TIERS.length){ wrap.setAttribute('hidden',''); vvdsTier=null; vvdsSyncBtn(); return; }
    if(!vvdsTier) vvdsTier=DESIGN_TIERS[DESIGN_TIERS.length>1?1:0];   // default: the middle/Standard tier
    var h='';
    DESIGN_TIERS.forEach(function(t,i){
      h+='<button type="button" class="vvds-tier" data-ti="'+i+'"'+(vvdsTier&&vvdsTier.variant===t.variant?' data-on':'')
        +' role="radio" aria-checked="'+(vvdsTier&&vvdsTier.variant===t.variant)+'">'
        +'<b>'+t.tier.replace(/[<>&"]/g,'')+'</b><span class="vvds-tp">$'+(t.price/100).toFixed(2)+'</span></button>';
    });
    box.innerHTML=h; wrap.removeAttribute('hidden'); vvdsSyncBtn();
  }
  function vvdsOpen(){
    if(!browseDs)return;
    document.getElementById('vvds-ctx').textContent=vvCtxLine();
    var er=document.getElementById('vvds-err'); er.setAttribute('hidden',''); er.textContent='';
    document.getElementById('vvds-form').removeAttribute('hidden');
    document.getElementById('vvds-done').setAttribute('hidden','');
    vvdsTier=null; vvdsRenderTiers();
    browseDs.removeAttribute('hidden');
  }
  function vvdsClose(){ if(browseDs)browseDs.setAttribute('hidden',''); }
  async function vvdsSend(){
    if(vvdsSend._busy)return; vvdsSend._busy=true;
    var er=document.getElementById('vvds-err'), send=document.getElementById('vvds-send');
    er.setAttribute('hidden',''); er.textContent='';
    var email=(document.getElementById('vvds-email').value||'').trim();
    var brief=(document.getElementById('vvds-brief').value||'').trim();
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ er.textContent='Enter a valid email so our designers can reply.'; er.removeAttribute('hidden'); vvdsSend._busy=false; return; }
    if(!brief){ er.textContent='Tell us a little about the design you need.'; er.removeAttribute('hidden'); vvdsSend._busy=false; return; }
    var vv=vvVariant(), vvid=vid(), price=BROWSE_PRICES[String(vvid)];
    send.setAttribute('disabled',''); send.textContent='Sending…';
    try{
      // 1) optional logo/reference files -> the artwork bucket (same endpoint as the upload card)
      var refs=[], fi=document.getElementById('vvds-files');
      if(fi&&fi.files&&fi.files.length){
        var okExt=/\.(pdf|ai|eps|jpe?g|png|tiff?|svg)$/i, fd=new FormData(), any=false;
        for(var i=0;i<fi.files.length&&i<4;i++){ var f=fi.files[i];
          if(!okExt.test(f.name)||f.size>60*1048576) throw new Error(f.name+': PDF, AI, EPS, JPG, PNG, TIFF or SVG up to 60MB.');
          fd.append('file',f,f.name); any=true; }
        if(any){
          fd.append('productId',String(PRODUCT_ID)); fd.append('variantId',String(vvid));
          fd.append('sku',(vv&&vv.sku)||''); fd.append('item',PRODUCT_TITLE+' (design brief refs)');
          var ru=await fetch(PORTAL+'/api/cc-own-artwork',{method:'POST',body:fd});
          var rj=null; try{ rj=await ru.json(); }catch(e){}
          if(!ru.ok||!rj||!rj.ok) throw new Error((rj&&rj.error)||('file upload '+ru.status));
          refs=rj.files||[];
        }
      }
      // 2) store + email the brief; the response carries the durable signed brief URL
      var r=await fetch(PORTAL+'/api/design-brief',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({hp:document.getElementById('vvds-hp').value||'',
          name:document.getElementById('vvds-name').value||'',email:email,
          phone:document.getElementById('vvds-phone').value||'',brief:brief,
          service:vvdsTier?(vvdsTier.tier+' Design Service — $'+(vvdsTier.price/100).toFixed(2)):'brief only (no tier for this product type)',
          files:refs,
          product:PRODUCT_TITLE,variant:(vv&&vv.title)||'',variantId:String(vvid),
          price:(typeof price==='number')?('$'+(price/100).toFixed(2)):'',url:location.href.slice(0,300)})});
      var j=null; try{ j=await r.json(); }catch(e){}
      if(!r.ok||!j||!j.ok) throw new Error((j&&j.error)||('send '+r.status));
      // 3) owner's model: the item goes in the basket WITH its design cost (companion
      //    fee line, Same-Day pattern) and the brief attached to BOTH lines.
      if(vvdsTier){
        var briefShort=brief.replace(/\s+/g,' ').slice(0,140)+(brief.length>140?'…':'');
        var mainProps={'Design services':'Vivid designs it — '+vvdsTier.tier+' ($'+(vvdsTier.price/100).toFixed(2)+')',
                       'Design brief':briefShort};
        if(j.url)mainProps['_Design_Brief_URL']=j.url;
        if(j.ref)mainProps['_Design_Brief_Ref']=j.ref;
        if(refs.length)mainProps['_Design_Ref_Files']=refs.map(function(f){return f.url;}).join(', ');
        if(vv&&vv.sku)mainProps['_CC_Variant_SKU']=vv.sku;
        var feeProps={'For':PRODUCT_TITLE+((vv&&vv.title)?(' — '+vv.title):''),'Design brief':briefShort};
        if(j.url)feeProps['_Design_Brief_URL']=j.url;
        if(j.ref)feeProps['_Design_Brief_Ref']=j.ref;
        var res=await cartWrite('/cart/add.js',{items:[
            {id:Number(vvid),quantity:qty(),properties:mainProps},
            {id:Number(vvdsTier.variant),quantity:1,properties:feeProps}
          ]},'cart/add');
        if(!res.ok)throw new Error(await cartErrMsg(res,'cart/add'));
        try{window.__vvNoNav=1;}catch(e){}
        window.location.href=vvAfterCartHref();
        return;                                  // navigating — leave the button busy
      }
      // no tier for this product type — brief-only outcome (email + stored brief)
      document.getElementById('vvds-form').setAttribute('hidden','');
      document.getElementById('vvds-done-p').textContent='We’ll reply to '+email+' within business hours to get your design underway.';
      document.getElementById('vvds-done').removeAttribute('hidden');
    }catch(err){
      er.textContent=String(err&&err.message||err).slice(0,160); er.removeAttribute('hidden');
    }
    send.removeAttribute('disabled'); vvdsSyncBtn();
    vvdsSend._busy=false;
  }
  (function(){ // UPDATE 37 wiring — browse products only; the panels don't exist otherwise
    if(!BROWSE_MODE||!browseUp||!browseDs)return;
    var drop=document.getElementById('vvup-drop'), fi=document.getElementById('vvup-file');
    drop.addEventListener('click',function(){ fi.click(); });
    drop.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); fi.click(); } });
    fi.addEventListener('change',function(){ vvupTake(fi.files||[]); fi.value=''; });
    ['dragover','dragenter'].forEach(function(ev){ drop.addEventListener(ev,function(e){ e.preventDefault(); drop.setAttribute('data-over','1'); }); });
    ['dragleave','drop'].forEach(function(ev){ drop.addEventListener(ev,function(e){ e.preventDefault(); drop.removeAttribute('data-over'); }); });
    drop.addEventListener('drop',function(e){ if(e.dataTransfer&&e.dataTransfer.files)vvupTake(e.dataTransfer.files); });
    document.getElementById('vvup-list').addEventListener('click',function(e){
      var rm=e.target.closest?e.target.closest('.vvup-rm'):null;
      if(rm){ vvup.files.splice(parseInt(rm.getAttribute('data-rm'),10),1); vvupRender(); }
    });
    document.getElementById('vvup-add').addEventListener('click',function(){ vvupAdd(true); });
    document.getElementById('vvup-later').addEventListener('click',function(){ vvupAdd(false); });
    (function(){ try{   // dd3d-up: explicit Continue designing / Cancel
      var add=document.getElementById('vvup-add'); if(!add||document.getElementById('vvup-design'))return;
      var later=document.getElementById('vvup-later');
      var b=document.createElement('button'); b.type='button'; b.id='vvup-design'; b.className=add.className; b.style.marginTop='8px'; b.textContent='Continue designing with this file'; b.setAttribute('hidden','');
      var c=document.createElement('button'); c.type='button'; c.id='vvup-cancel'; c.className=(later&&later.className)||''; c.style.marginTop='8px'; c.textContent='Cancel';
      add.parentNode.insertBefore(b,add.nextSibling); var after=later||b; after.parentNode.insertBefore(c,after.nextSibling);
      b.addEventListener('click',function(){ vvupToEditor(); }); c.addEventListener('click',function(){ vvupCancel(); });
    }catch(e){} })();
    document.getElementById('vvup-x').addEventListener('click',vvupX);
    browseUp.addEventListener('click',function(e){ if(e.target===browseUp)vvupX(); });
    document.getElementById('vvds-x').addEventListener('click',vvdsClose);
    document.getElementById('vvds-back').addEventListener('click',vvdsClose);
    browseDs.addEventListener('click',function(e){ if(e.target===browseDs)vvdsClose(); });
    document.getElementById('vvds-form').addEventListener('submit',function(e){ e.preventDefault(); vvdsSend(); });
    // Measured on the deployed preview: a REAL click on the submit button never
    // produced a submit event (some theme/app-level click handler swallows the
    // button's default form-submission; a dispatched submit works fine). Wire
    // the button directly as well — preventDefault stops the form path, and the
    // _busy guard in vvdsSend makes click+submit double-fires harmless.
    document.getElementById('vvds-send').addEventListener('click',function(e){ e.preventDefault(); vvdsSend(); });
    // UPDATE 38: design-service tier picker
    document.getElementById('vvds-tiers').addEventListener('click',function(e){
      var t=e.target.closest?e.target.closest('.vvds-tier'):null;
      if(!t)return;
      vvdsTier=DESIGN_TIERS[parseInt(t.getAttribute('data-ti'),10)]||null;
      vvdsRenderTiers();
    });
  })();
  // UPDATE 30: gallery-entered editors hide the design rail VISUALLY only —
  // the widget stays MOUNTED (kickCompile / galSync / resolveCartVariant /
  // restore all read it), the hideProductOptions occlusion pattern. The rail
  // column collapses so the canvas reclaims the width. Direct flow untouched.
  function hideDesignRail(){
    // UPDATE 39: also for edit-from-cart sessions on browse products — the
    // owner's 522 "Change artwork" editor was showing the 2-tile rail because
    // this gate was gallery-only. Direct-flow products still return here.
    // 21-Aug BURST FIX: also hide the HOST during the browse phase itself
    // (modal[data-browse]), not just once entered. The customer never sees the
    // rail in browse mode — it sat occluded but IN LAYOUT at 278x650, which is
    // why its 500 eager images all fetched. display:none host + loading=lazy
    // imgs (railImgCalm) = no box, no intersection, no fetch. Host-only:
    // the edMounted-gated ancestor collapse below is unchanged, so the editor
    // never mounts inside a container this code hid.
    if(!BROWSE_MODE||!(browse.entered||browseCartEdit()||modal.hasAttribute('data-browse')))return;
    var sel=deepFind('au-widget-pim-design-selector'); if(!sel)return;
    var host=(sel.parentElement&&sel.parentElement.tagName&&
              sel.parentElement.tagName.toLowerCase()==='au-widget')?sel.parentElement:sel;
    // UPDATE 36: idempotent re-assert every tick — UIF re-renders can recreate
    // the host/ancestors, and the old width<420/flexGrow heuristic raced first
    // paint and missed the mobile-layout ancestor (the ~390px empty-strip bug).
    host.style.setProperty('display','none','important');
    host.setAttribute('data-vv-cc-railhidden','1');
    // Structural column collapse (mirrors the UPDATE-36 CSS :has rule): every
    // ancestor under the editor mount whose subtree holds the rail but NOT the
    // design editor is rail-only column chrome — hide the whole chain.
    // Only collapse ancestors once the design editor is MOUNTED — before that,
    // every ancestor is trivially "rail-only" and an inline display:none would
    // outlive the mount (the CSS :has rule self-heals; inline styles do not).
    // 9-Aug: this was a LIGHT-DOM query for an element that lives in the
    // widget's shadow DOM, so edMounted was permanently false and the ancestor
    // collapse below never ran at all. deepFind pierces shadow roots.
    var edMounted=false;
    try{ edMounted=!!deepFind('au-widget-design-editor'); }catch(e){}
    var p=host.parentElement, hops=0;
    while(p&&hops<6&&p.id!=='vv-cc-editor'&&p!==document.body){
      var railOnly=false;
      try{ railOnly=!p.querySelector('au-widget-design-editor'); }catch(e){}
      if(!railOnly){                       // self-heal a stale stamp (re-parenting)
        if(p.getAttribute('data-vv-cc-railhidden')==='1'){
          p.style.removeProperty('display'); p.removeAttribute('data-vv-cc-railhidden');
        }
        break;
      }
      if(edMounted){
        p.style.setProperty('display','none','important');
        p.setAttribute('data-vv-cc-railhidden','1');
      }
      p=p.parentElement; hops++;
    }
    // UPDATE 36 root cause: the hub-served (unpinned — 33b watch item) UIF build
    // renders the rail inside the wizard's SHADOW-DOM left drawer
    // (div#drawer.left-drawer > .tool-panel > iron-pages > au-widget.iron-selected
    //  ~> shadow ~> au-widget-pim-design-selector). Page CSS cannot reach it and
    // the light-DOM ancestor walk above never finds it — the drawer kept its
    // 320px and painted the empty strip. Walk UP THROUGH shadow boundaries to
    // the drawer; collapse it WHILE the selected tool panel is the rail panel
    // (passed an .iron-selected ancestor), restore the moment it is not — so a
    // future UIF panel using the same drawer still opens. Re-asserted per tick.
    var n=sel, drawer=null, passedSelected=false, sh=0;
    while(n&&sh<20){
      var el=(n.nodeType===11)?n.host:n;
      if(el&&el.classList){
        if(el.classList.contains('iron-selected'))passedSelected=true;
        if(el.classList.contains('left-drawer')||(el.classList.contains('drawer')&&el.id==='drawer')){ drawer=el; break; }
      }
      n=(n.nodeType===11)?n.host:n.parentNode; sh++;
    }
    if(drawer){
      if(passedSelected){
        // 9-Aug, owner: the rail still painted for him while it was correctly
        // hidden for me. Inline styles are re-asserted per tick, so a slow UIF
        // mount can paint the drawer in the gap before a tick runs, and a
        // re-render drops the style until the next one. A <style> element
        // inside the drawer's OWN shadow root has neither problem: it is
        // installed once and applies to the drawer even if the element is
        // recreated. The inline style stays as belt-and-braces.
        // ⚠ 9-Aug, SECOND CUT. The first version injected a blanket
        // `#drawer.drawer{display:none}` into the shadow root. The widget reuses
        // that SAME drawer for the Text / Image / Shape panels, so opening one
        // hid it until the next tick removed the rule — the owner saw panels
        // "disappear and then show again". The stylesheet is still the right
        // idea (it survives re-renders, unlike an inline style), but it must be
        // gated on an attribute WE control and set only while the rail panel is
        // the selected one, so the moment that stops being true the rule stops
        // applying — with no tick in between.
        try{
          var rt=drawer.getRootNode();
          if(rt&&rt.nodeType===11&&!rt.getElementById('vv-cc-railcss')){
            var st=document.createElement('style'); st.id='vv-cc-railcss';
            st.textContent='[data-vv-cc-railhidden="1"]{display:none!important;}';
            rt.appendChild(st);
          }
        }catch(e){}
        drawer.style.setProperty('display','none','important');
        drawer.setAttribute('data-vv-cc-railhidden','1');
      }else if(drawer.getAttribute('data-vv-cc-railhidden')==='1'){
        // Restore fully — including the injected rule — so a future UIF panel
        // that reuses this drawer still opens.
        try{ var rt2=drawer.getRootNode(), old2=rt2&&rt2.getElementById&&rt2.getElementById('vv-cc-railcss');
             if(old2)old2.remove(); }catch(e){}
        drawer.style.removeProperty('display');
        drawer.removeAttribute('data-vv-cc-railhidden');
      }
    }
  }
  function browseRender(){
    var items=browse.items||[];
    /* 26-Aug: the one place that always sees the real, current item list —
       cold-start cache, live CC feed and every re-render pass alike. Cheap and
       self-guarded: it returns immediately unless a SLICE is loaded, and once
       the full registry is in it never runs again. */
    vvRegCheckCoverage(items);
    /* 21-Aug STUCK-AFTER-FILTER FIX. The filter-change page reset used to sit
       BELOW the fingerprint block, so the fingerprint was computed with the
       STALE browse.pg. Killer sequence: deep-scrolled to pg 2, change any
       filter/search/sort → this render stores a fingerprint claiming pg 2
       while actually rendering pg 1; the sentinel's observer fires once, sets
       pg back to 2, and the fresh fingerprint matches the stale one exactly —
       the render no-ops WITHOUT re-arming the observer it just disconnected.
       Auto-load is then dead for good ("gallery stuck"). Reset pg FIRST so the
       fingerprint always describes what is actually on screen. */
    var PGSIZE=36;
    var pgSig=[browse.q,browse.cat,browse.typ,browse.col,browse.thm,browse.sort].join('');
    if(pgSig!==browse.pgSig){ browse.pgSig=pgSig; browse.pg=1; }   // any filter change restarts
    /* 21-Aug FREEZE FIX #3 (owner: freezes "opening and closing the edit app
       … and coming back"). browseReturnToGallery() calls this purely to
       "refresh selected states", and a feed re-poll calls it again — with a
       deep-scrolled gallery each of those was a full innerHTML rebuild of
       every rendered card. Fingerprint what the grid actually depends on and
       leave the DOM alone when none of it moved. */
    try{
      var _cap=36*(browse.pg||1), _favs0=browseFavs(), _vis0=browseVisible();
      /* 4-Sep-2026 (owner, corflute: "show more button is not working and
         style and gallery is also not working"). This fingerprint decides
         whether a render is a no-op, and it did not include the two pieces of
         SIDEBAR state: which facet sections are open (browse.fs) and whether
         "Show More" has been pressed (browse.more). Toggling either changed
         nothing here, so browseRender() returned early and the sidebar never
         redrew — zero DOM mutations, measured. Industry buttons still worked
         only because they change browse.cat, which IS in the fingerprint.
         Regression from the 21-Aug freeze fix that introduced this memo. */
      var _fp=[browse.q,browse.cat,browse.typ,browse.col,browse.thm,browse.sort,
               browse.pg,items.length,_vis0.length,String(vid()),
               Object.keys(BROWSE_STYLE_NAMES).length,
               JSON.stringify(browse.fs||{}),JSON.stringify(browse.more||{}),
               (function(){ try{ return 'sv'+vvSavedForHere().length+(vvSaved.sig||''); }catch(e){ return ''; } })()].join('');
      for(var _i=0;_i<_vis0.length&&_i<_cap;_i++){ var _g=_vis0[_i];
        _fp+='|'+(_g.blank?'b':browseDispIx(_g))+((_g.style&&_favs0[_g.style])?'f':''); }
      if(browse._fp===_fp&&browse._items===items&&browseGrid
         &&browseGrid.querySelector('.vvbr-card')){
        /* A no-op render must still leave auto-load ARMED: the sentinel's IO
           callback disconnects its observer BEFORE calling browseRender, so
           returning here without re-arming would strand a live sentinel
           forever (the 21-Aug "gallery stuck" failure). Re-observe if a
           sentinel is present; if it is already in view the observer fires
           again and pg advances — which is a fresh fingerprint, not a loop. */
        browseMoreIO(!!browseGrid.querySelector('[data-pagemore]'));
        return; }
      browse._fp=_fp;
    }catch(e){}
    var counts={},colCounts={},thmCounts={},typeCounts={},total=0;
    items.forEach(function(g){ if(g.blank)return; total++;
      var _t=browseTypeOf(g);
      ((g.style&&BROWSE_STYLE_INDUSTRIES[g.style])||[]).forEach(function(d){counts[d]=(counts[d]||0)+1;
        if(_t){ (typeCounts[d]||(typeCounts[d]={}))[_t]=((typeCounts[d]||{})[_t]||0)+1; } });
      var th=BROWSE_STYLE_THEMES[g.style]; if(th)thmCounts[th]=(thmCounts[th]||0)+1;
      var fams={};
      for(var i=0;i<g.cws.length;i++)fams[browseCwMeta(g,i).fam]=1;
      for(var f in fams)colCounts[f]=(colCounts[f]||0)+1; });
    if(browse.cat!=='all'&&!counts[browse.cat])browse.cat='all';
    if(browse.col&&!colCounts[browse.col])browse.col='';
    if(browse.thm&&!thmCounts[browse.thm])browse.thm='';
    // collapsible facet sections (Vistaprint chevron pattern) + Show More >5
    function fs(key,title,body){
      var open=!!browse.fs[key];
      return '<button type="button" class="vvbr-fs-h" data-fs="'+key+'"'+(open?' data-open':'')+'>'
        +title+'<span class="vvbr-chev" aria-hidden="true">&#9660;</span></button>'
        +(open?body:'');
    }
    var ind='<button type="button" class="vvbr-cat" data-cat="all"'+(browse.cat==='all'?' data-active':'')
      +'>All designs<span class="vvbr-n">('+total+')</span></button>';
    // 10-Aug, owner on corflute: "no designs showing under industry". The rail
    // was ordered by BROWSE_INDUSTRY_ORDER — a PULL-UP priority list that opens
    // corporate/charity/education. Corflute's real volume is construction,
    // manufacturing and government, which fell below the "Show More" fold, so
    // the industries that actually have designs looked absent. Order by how
    // many designs each industry HAS on this product; the fixed list only
    // breaks ties, so pull-ups keep their familiar order where counts match.
    var indRows=BROWSE_INDUSTRY_ORDER.filter(function(d){return counts[d];})
      .sort(function(a,b){
        return (counts[b]-counts[a]) ||
               (BROWSE_INDUSTRY_ORDER.indexOf(a)-BROWSE_INDUSTRY_ORDER.indexOf(b));
      });
    var indShown=browse.more.ind?indRows:indRows.slice(0,5);
    indShown.forEach(function(d){
      ind+='<button type="button" class="vvbr-cat" data-cat="'+d+'"'+(browse.cat===d?' data-active':'')
        +'>'+BROWSE_INDUSTRY_LABELS[d]+'<span class="vvbr-n">('+counts[d]+')</span></button>';
      /* Types only under the selected industry; an empty one is dimmed, not
         hidden — the gaps are the commissioning list. */
      if(browse.cat!==d)return;
      /* Do not advertise gaps in a taxonomy this product does not use:
         typesByIndustry is the CORFLUTE sign taxonomy and on selfie frames it
         listed "Beach Waterway: empty". See git log. */
      var own=Object.keys(typeCounts[d]||{});
      var declared=BROWSE_TYPES_BY_IND[d]||[];
      var usesTaxonomy=own.some(function(t){return declared.indexOf(t)>=0;});
      var ts=(usesTaxonomy?declared.slice():own.slice()).sort(function(a,b){
        var n=((typeCounts[d]||{})[b]||0)-((typeCounts[d]||{})[a]||0);
        return n||(a<b?-1:(a>b?1:0)); });
      if(!ts.length)return;
      ind+='<div class="vvbr-styps">';
      ind+='<button type="button" class="vvbr-styp'+(browse.typ===''?' data-active':'')
        +'" data-typ="">All types<span class="vvbr-n">('+counts[d]+')</span></button>';
      ts.forEach(function(t){
        var n=(typeCounts[d]||{})[t]||0;
        ind+='<button type="button" class="vvbr-styp'+(n?'':' vvbr-styp--empty')
          +(browse.typ===t?' data-active':'')+'" data-typ="'+t+'"'+(n?'':' disabled')+'>'
          +(BROWSE_TYPE_LABELS[t]||vvTypeName(t))+'<span class="vvbr-n">'+(n?'('+n+')':'empty')+'</span></button>'; });
      ind+='</div>'; });
    if(indRows.length>5&&!browse.more.ind)
      ind+='<button type="button" class="vvbr-more" data-more="ind">Show More</button>';
    var col='<button type="button" class="vvbr-col" data-col=""'+(browse.col===''?' data-active':'')
      +'><span class="vvbr-colsw" style="background:conic-gradient(#2b4f9e,#3c6b40,#c96a1e,#a8232c,#6b2d5e,#2b4f9e)"></span>Any colour</button>';
    BROWSE_FAM_ORDER.forEach(function(f){ if(!colCounts[f])return;
      col+='<button type="button" class="vvbr-col" data-col="'+f+'"'+(browse.col===f?' data-active':'')
        +'><span class="vvbr-colsw" style="background:'+BROWSE_FAMS[f][1]+'"></span>'
        +BROWSE_FAMS[f][0]+'<span class="vvbr-n">('+colCounts[f]+')</span></button>'; });
    var thm='';
    BROWSE_THEME_ORDER.forEach(function(t){ if(!thmCounts[t])return;
      thm+='<button type="button" class="vvbr-cat" data-thm="'+t+'"'+(browse.thm===t?' data-active':'')
        +'>'+BROWSE_THEME_LABELS[t]+'<span class="vvbr-n">('+thmCounts[t]+')</span></button>'; });
    /* 27-Aug: a Colour facet that can only offer one family is not a filter, it is a
       dead end that returns the whole catalogue or nothing. Corflute and pull-up have
       no colour in their design names at all (see browseCwOf), so they were showing
       "Grey (1,468)" and nothing else. Show the section only when there is a real
       choice to make. */
    var colFams=BROWSE_FAM_ORDER.filter(function(f){return colCounts[f];});
    if(colFams.length<2)browse.col='';
    if(browseFacets)browseFacets.innerHTML=
      /* 4-Sep: same rule as Colour — a section with nothing in it is not a
         filter. Corflute's 1,465 designs carry no theme tags, so "Styles &
         Themes" opened onto an empty list and read as broken. */
      fs('ind','Industry',ind)+(colFams.length>1?fs('col','Colour',col):'')+(thm?fs('thm','Styles & Themes',thm):'');
    var vis=browseVisible(), shown=0;
    vis.forEach(function(g){ if(!g.blank)shown++; });
    if(browseCount)browseCount.textContent=shown+(shown===1?' design':' designs');
    /* PAGED RENDERING (9-Aug). The grid built every card up front — 323 of them
       at 600x1400 — so first paint scaled with catalogue size. The IMAGES were
       already lazy (UPDATE 43/46b); the DOM was not, and that is what the owner
       felt as "loading is taking time". Canva and Vistaprint both render a
       screenful and extend on scroll. The count above still reports the WHOLE
       result set — only the DOM is paged, so "323 designs" stays honest. */
    /* (pg reset + PGSIZE/pgSig hoisted to the top of browseRender - see
       STUCK-AFTER-FILTER FIX above; they must run before the fingerprint.) */
    var visAll=vis, pgCap=PGSIZE*(browse.pg||1);
    if(!('IntersectionObserver' in window))pgCap=visAll.length;     // no observer, no paging
    vis=visAll.slice(0,pgCap);
    var qq=browse.q.trim(), ch='';
    if(browse.cat!=='all')
      ch+='<button type="button" class="vvbr-chip" data-clear="cat">'+BROWSE_INDUSTRY_LABELS[browse.cat]+'&nbsp;&times;</button>';
    if(browse.col)
      ch+='<button type="button" class="vvbr-chip" data-clear="col">'+BROWSE_FAMS[browse.col][0]+'&nbsp;&times;</button>';
    if(browse.thm)
      ch+='<button type="button" class="vvbr-chip" data-clear="thm">'+BROWSE_THEME_LABELS[browse.thm]+'&nbsp;&times;</button>';
    if(qq)
      ch+='<button type="button" class="vvbr-chip" data-clear="q">&ldquo;'+qq.replace(/[<>&"]/g,'')+'&rdquo;&nbsp;&times;</button>';
    if(ch)ch+='<button type="button" class="vvbr-chip vvbr-chip--clear" data-clear="all">Clear all</button>';
    if(browseChips)browseChips.innerHTML=ch;
    var price=BROWSE_PRICES[String(vid())];
    var priceLine=(typeof price==='number')
      ?'<span class="vvbr-price">$'+(price/100).toFixed(2)+'</span><span class="vvbr-unit">1 unit</span>':'';
    var gh='';
    // 1) Upload-your-own card (existing PDP own-artwork flow)
    gh+='<button type="button" class="vvbr-card vvbr-card--upload" data-upl="1">'
      +'<span class="vvbr-thumbwrap"><span class="vvbr-plus" aria-hidden="true">&#8682;</span>'
      +'<span class="vvbr-upbtn">Upload artwork</span></span>'
      +'<span class="vvbr-name">Upload your own design</span>'+priceLine
      +'<span class="vvbr-tag">Print-ready file? Skip the editor</span></button>';
    // 2) blank starter
    vis.forEach(function(g){ if(!g.blank)return; var gx=items.indexOf(g);
      gh+='<button type="button" class="vvbr-card vvbr-card--blank" data-gx="'+gx+'" data-blank="1">'
        +'<span class="vvbr-thumbwrap"><span class="vvbr-plus" aria-hidden="true">+</span>'
        +'<span class="vvbr-edit">Start designing</span></span>'
        +'<span class="vvbr-name">Start from blank</span>'+priceLine
        +'<span class="vvbr-tag">Design your own from scratch</span></button>'; });
    /* 9-Sep: the customer's own saved designs for THIS product, newest first. */
    try{ vvSavedForHere().slice(0,6).forEach(function(r){
      var when=''; try{ var d=new Date(r.at||0); when='Saved '+d.getDate()+'/'+(d.getMonth()+1)+'/'+d.getFullYear(); }catch(e){}
      var nm=String(r.name||'Saved design').replace(/[<>&"]/g,function(c){return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c];});
      var th=(r.preview&&/^https:\/\/[a-z0-9.-]+\.aurigma\.net\//.test(r.preview))?r.preview:(r.thumb||'');
      gh+='<button type="button" class="vvbr-card vvbr-card--saved" data-vvsaved="'+r.guid+'" data-gx="-1">'
        +'<span class="vvbr-thumbwrap"><span class="vvbr-rm" role="button" tabindex="0" data-rm="'+r.guid+'" aria-label="Remove this saved design" title="Remove this saved design">&times;</span>'+(th?('<img class="vvbr-thumb" src="'+th+'" alt="" loading="lazy" style="object-fit:contain;background:#f6f6f6">'):'<span class="vvbr-plus" aria-hidden="true">&#128190;</span>')
        +'<span class="vvbr-edit">Continue</span></span>'
        +'<span class="vvbr-name">'+nm+'</span>'+priceLine
        +'<span class="vvbr-tag">'+when+(r.claimed?' · your account':' · this device')+'</span></button>'; }); }catch(e){}
    var favs=browseFavs();
    /* vix = position in the VISIBLE list. gx is an index into the full catalogue
       and is what the click handler needs, but it is the wrong thing to decide
       eager-loading by: after a filter, nine visible cards can carry gx values
       in the 90s, so every one of them fell to loading="lazy" and the grid
       painted blank before filling in. That is the "click industry and designs
       dont show" the owner reported — the images were fine, they just were not
       being asked for. Judge eagerness by where a card actually IS. */
    /* 21-Aug: markup for ONE card, shared by the full render below and by the
       append-only pagination path (FREEZE FIX #2). */
    function browseCardHtml(g,vix){
      var gx=items.indexOf(g), selIx=browseDispIx(g), cur=g.cws[selIx];
      var inds=(g.style&&BROWSE_STYLE_INDUSTRIES[g.style])||[];
      var tag=inds.map(function(d){return BROWSE_INDUSTRY_LABELS[d];}).filter(Boolean).join(' · ');
      var dots='';
      if(g.cws.length>1){
        dots='<span class="vvbr-dots" role="group" aria-label="Colour options">';
        for(var i=0;i<g.cws.length;i++){ var mm=browseCwMeta(g,i);
          dots+='<span class="vvbr-dot'+(i===selIx?' vvbr-dot--on':'')+'" role="button" tabindex="0" data-gx="'+gx
            +'" data-cw="'+i+'" style="background:'+mm.css+'" aria-label="'+mm.label
            +'" aria-pressed="'+(i===selIx)+'" title="'+mm.label+'"></span>'; }
        dots+='</span>';
      }
      /* 22-Aug: a middle srcset candidate. The card model only ships 240w and 600w,
         and on any DPR>=2 phone the browser must pick 600w for a 155px slot, so every
         card on mobile pulled ~150KB. Deep in a 500-card wall gallery that is hundreds
         of 150KB requests queued behind each other: measured cards sitting
         complete=false with naturalWidth 0 eight seconds after the scroll stopped,
         with zero failed responses - nothing was broken, everything was queued.
         400w is derived from the same URL, and it is the rung browseCardRung already
         picks for this slot, so the upgrade chain has nothing left to do. */
      var thumbMd=cur&&cur.thumb?cur.thumb.replace(/([?&]w=)\d+/,'$1400'):'';
      var fav=(g.style&&g.style!=='null'&&favs[g.style])?' data-on':'';
      return '<button type="button" class="vvbr-card" data-gx="'+gx+'" data-cwix="'+selIx+'">'
        +'<span class="vvbr-thumbwrap"><span class="vvbr-fav" role="button" tabindex="0" data-fav="'+g.style+'"'+fav
        +' aria-label="Save to favourites" title="Save to favourites">&#10084;︎</span>'
        +(VV_DEL_KEY?'<span class="vvbr-del" role="button" tabindex="0" data-del="'+gx
          +'" aria-label="Delete this design" title="Delete this design (testing)">Delete</span>':'')
        +'<span class="vvbr-prod">'
        /* UPDATE 46b: the FIRST SCREENFUL loads eagerly. Canva does not lazy-load
           what is already in view (measured: loading="auto"), and lazy-loading
           above-the-fold images means the browser waits for layout before it
           even asks — which is exactly the "blank first" the owner saw. Cards
           past the first two rows stay lazy so the rest of a 113-card shelf
           still costs nothing until scrolled. */
        +(cur.thumb?'<img class="vvbr-thumb" decoding="async"'
          +(vix<(innerWidth<700?6:18)?' loading="eager" fetchpriority="high"':' loading="lazy"')
          +(cur.id?' data-vvid="'+cur.id+'"':'')   /* UPDATE 43: hi-res card upgrade target */
          +(cur.cc?' data-vvcc="'+cur.cc+'" onerror="if(this.dataset.vvcc&&this.src!==this.dataset.vvcc)this.src=this.dataset.vvcc"':'')
          /* 21-Aug: I changed this to `(max-width:600px) 42vw, 160px` on a
             suspicion the thumbs were over-fetched, then measured it and put it
             back. The painted slot is 130x155 on a phone but 307x364 on
             desktop — I had compared a mobile measurement against a desktop
             assumption. The new value made desktop pull 240w into a 307px box
             (soft) and mobile pull 600w into a 130px box (2.5x the pixels for
             nothing). The original arms are correctly tuned; leave them. */
          /* sizes is the CSS slot, measured: 155px on a phone, 307px on desktop. The
             browser multiplies by DPR itself - the previous value of 240px/600px was
             describing the asset we wanted rather than the box it lands in, which is
             what forced 600w onto every phone. */
          +(cur.thumbSm?' srcset="'+cur.thumbSm+' 240w, '+thumbMd+' 400w, '+cur.thumb+' 600w" sizes="(max-width:700px) 155px, 307px"':'')
          +' alt="'+(BROWSE_STYLE_NAMES[g.style]||'Design')+' template" src="'+(thumbMd||cur.thumb)+'">':'')
        +'</span>'
        +'<span class="vvbr-edit">See this design</span></span>'
        +dots
        +'<span class="vvbr-name">'+(BROWSE_STYLE_NAMES[g.style]||g.names)
        +(g.cws.length>1?' <span class="vvbr-n">· '+browseCwMeta(g,selIx).label+'</span>':'')+'</span>'
        +priceLine
        +(tag?'<span class="vvbr-tag">'+tag+'</span>':'')+'</button>';
    }
    /* 21-Aug FREEZE FIX #2 (owner: "freezing again and again" scrolling the
       500-design bollard gallery). Paging used to REBUILD the whole grid: at
       page 14 every scroll-to-bottom destroyed and recreated ~500 card nodes
       and every <img> inside them, so each append cost more than the last.
       When only the page counter moved — same filters, same feed — append the
       new slice instead. Any other change still takes the full-rebuild path,
       so card markup lives in exactly one place (browseCardHtml). */
    var newSlice=(browse._cap&&pgCap>browse._cap)?visAll.slice(browse._cap,pgCap):null;
    if(newSlice&&browse._sig===pgSig&&browse._items===items&&browseGrid
       &&browseGrid.querySelector('.vvbr-card')
       &&!newSlice.some(function(g){return g.blank;})){
      var addHtml='';
      newSlice.forEach(function(g,ix){ addHtml+=browseCardHtml(g,browse._cap+ix); });
      var svc=browseGrid.querySelector('.vvbr-card--svc');
      if(svc)svc.insertAdjacentHTML('beforebegin',addHtml);
      else browseGrid.insertAdjacentHTML('beforeend',addHtml);
      var oldSent=browseGrid.querySelector('.vvbr-pagemore');
      if(oldSent&&oldSent.parentNode)oldSent.parentNode.removeChild(oldSent);
      if(visAll.length>pgCap)browseGrid.insertAdjacentHTML('beforeend',browseMoreBtn(visAll.length-pgCap));
      browse._cap=pgCap;
      browseCardsHiRes();
      browseMoreIO(visAll.length>pgCap);
      return;
    }
    vis.forEach(function(g,vix){ if(g.blank)return; gh+=browseCardHtml(g,vix); });
    /* 27-Aug — THE EMPTY STATE STOPPED BEING A DEAD END.
       The daily report already lists every search that finds nothing ("each of
       these is a design to add"), but the customer who typed it got one line of
       advice and left; we learned the gap the next morning with no way to tell
       them it was filled. Now the zero-result state takes the request with an
       email, the owner adds the designs free within 24 hours, and the customer
       is emailed when they are live. Design decisions (docs/GALLERY-REQUEST-
       FEEDBACK-DESIGN.md): the heading repeats THEIR term so it reads as an
       answer, not a form; the textarea is pre-filled with that term so email is
       the only typing left; the promise sits next to the button, where the
       decision happens; and this card renders BEFORE the paid design-service
       card because free-gallery-add and done-for-you-design are different jobs. */
    var zeroActive = !shown&&(qq||browse.cat!=='all'||browse.col||browse.thm);
    /* The search term goes into markup, and it is CUSTOMER-TYPED text. There is
       no escaping helper in this file because nothing before this interpolated
       user input into HTML — every card paints registry data. So the helper
       arrives with the first feature that needs it. */
    var esc=function(t){return String(t==null?'':t)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');};
    if(zeroActive){
      var wantTxt = qq || (function(){var f=[];try{
          if(browse.cat&&browse.cat!=='all')f.push(browse.cat);
          if(browse.col)f.push(browse.col);
          if(browse.thm)f.push(browse.thm);}catch(e){}return f.join(' ');})();
      gh+='<form class="vvbr-req" id="vvbr-req">'
        +'<h3 class="vvbr-req-h">No matches for &ldquo;'+esc(wantTxt||'that')+'&rdquo; &mdash; yet.</h3>'
        +'<p class="vvbr-req-p">Tell us what you\u2019re after and we\u2019ll add matching designs to this gallery '
        +'<strong>free of charge</strong> &mdash; and email you the moment they\u2019re live.</p>'
        +'<label class="vvbr-req-l" for="vvbr-req-msg">What designs do you need?</label>'
        +'<textarea id="vvbr-req-msg" rows="2" maxlength="3000" required>'+esc(wantTxt)+'</textarea>'
        +'<label class="vvbr-req-l" for="vvbr-req-email">Your email &mdash; so we can tell you the moment they\u2019re live</label>'
        +'<input id="vvbr-req-email" type="email" maxlength="200" required placeholder="you@business.com.au">'
        +'<input type="text" name="company_website" class="vvbr-hp" tabindex="-1" autocomplete="off" aria-hidden="true">'
        +'<button type="submit" class="vvbr-req-btn">Add these designs for me</button>'
        +'<p class="vvbr-req-note">Free &middot; usually live within 24 hours</p>'
        +'<p class="vvbr-req-done" hidden aria-live="polite"></p>'
        +'</form>';
    }
    // Vivid design-service promo card (their "Work with a designer" slot)
    gh+='<button type="button" class="vvbr-card vvbr-card--svc" data-svc="1">'
      +'<span class="vvbr-thumbwrap"><span class="vvbr-svc-h">Work with our designers</span>'
      +'<span class="vvbr-svc-p">Send us your brief &mdash; our team designs it and you approve before print.</span>'
      +'<span class="vvbr-upbtn">Add design service</span></span>'
      +'<span class="vvbr-name">Vivid design service</span>'
      +'<span class="vvbr-tag">We design, you approve</span></button>';
    if(visAll.length>pgCap)gh+=browseMoreBtn(visAll.length-pgCap);
    browseGrid.innerHTML=gh;
    browse._cap=pgCap; browse._sig=pgSig; browse._items=items;  // append-path state
    browseCardsHiRes();
    browseMoreIO(visAll.length>pgCap);
  }
  // Extend the grid when the sentinel nears the viewport. rootMargin keeps a
  // page in hand so the user never actually waits at the bottom of the scroll.
  // Re-rendering (rather than appending) keeps dots, favourites and filters in
  // ONE code path; the scroller is the wrapper, so appending below does not
  // move what the user is looking at.
  var browseMoreObs=null;
  /* 21-Aug — PAGINATION, and what it is NOT.
     I replaced auto-load with a Canva-style "Show more" button, measured it
     (bollards at open: 38 cards / 1.4 MB decoded, vs 503 cards / 86.1 MB after
     an auto-scroll to the bottom) — and the owner still hit the hang, while
     pull-up banners paged on scroll perfectly. So paging was never the cause.
     Auto-load is back; see browseMoreIO. What the traces actually showed:
     opening the BOLLARD gallery fires 501 requests to
     api.au.customerscanvashub.com/api/storage/v1/resources/{id}/file, 612 of
     613 of them before a single page-2 card exists — one per design in the
     whole 500-design catalogue, not per rendered card. Pull-ups fire 245 for
     their 254 designs. Chrome allows 6 connections per host, and half these
     responses take >2s, so bollards queues roughly 500/6 x 2s of network on one
     host while pull-ups queues half that. That is the whole difference between
     "smooth" and "hangs". Our own Fly portal served 107 thumbnails, max 440ms,
     none over 2s — the portal is not the problem. */
  function browseMoreBtn(left){
    return '<div class="vvbr-pagemore" data-pagemore="1">Loading more designs&hellip;'
      +'<span class="vvbr-pagemore-n">'+left+' more</span></div>';
  }
  /* 21-Aug (second pass) — AUTO-LOAD RESTORED at the owner's call: pull-up
     banners page perfectly well on scroll, so paging was never the problem.
     The bollard hang is a request burst, not the grid (see the CC storage-call
     note above). The ONE thing kept from the Canva pass is the class: this
     sentinel is .vvbr-pagemore, NOT .vvbr-more. Sharing that class with the
     facet list's "Show More" meant a mobile rule set display:none on it, the
     sentinel had no box, the IntersectionObserver could never fire, and every
     phone was stuck at 36 designs for good. */
  function browseMoreIO(hasMore){
    try{
      if(browseMoreObs){ browseMoreObs.disconnect(); browseMoreObs=null; }
      if(!hasMore||!('IntersectionObserver' in window))return;
      var sent=browseGrid?browseGrid.querySelector('[data-pagemore]'):null; if(!sent)return;
      var root=browseEl?browseEl.querySelector('.vvbr-gridwrap'):null;
      browseMoreObs=new IntersectionObserver(function(es){
        if(!es.some(function(e){return e.isIntersecting;}))return;
        browseMoreObs.disconnect(); browseMoreObs=null;
        browse.pg=(browse.pg||1)+1;
        browseRender();
      },{root:root||null,rootMargin:'600px 0px'});
      browseMoreObs.observe(sent);
    }catch(e){}
    browseStuckWatch();
  }
  /* 21-Aug (evening) STUCK WATCHDOG — after the fingerprint fix, one more
     layer so "gallery stuck" is structurally impossible, whatever the cause
     (a stranded observer, an engine that suppresses IO in some state, a
     future regression). Every 1.5s: if a sentinel is sitting inside (or
     within 200px of) the scrollport and the page counter has not moved since
     the previous tick that saw this same sentinel, force the advance
     ourselves. When the observer is healthy it always wins the race (fires in
     ms, replaces the sentinel), so the watchdog stays silent; it only ever
     acts on a sentinel nothing else is servicing. Skipped while the tab is
     hidden and while the gallery is not on screen (editor open). */
  var browseStuckIv=null;
  window.__vvGalBuild='dd3o-prevrestore';   // reported in every beacon ("Theme asset build"): bump per release so a record says which code produced it
  /* 21-Aug gal telemetry — the owner's iPhone shows a stuck gallery that no
     emulation (chromium+webkit engines, touch gestures, deep-scroll+filter)
     reproduces. Log-only beacons to the portal (/api/gal-telemetry, fly logs,
     no email): 'open' carries the build id (tells a stale page instance from a
     real bug in one line), 'wd-force' logs every watchdog rescue, 'hard-stuck'
     dumps scroller state when even a forced render did not add cards. Remove
     after the mobile report is closed. */
  var galBeatStuckN=0;
  function galBeat(ev,extra){
    try{
      var m=document.getElementById('vv-cc-modal');
      var gw=m&&m.querySelector('.vvbr-gridwrap');
      var sent=m&&m.querySelector('[data-pagemore]');
      var p={ev:ev,build:window.__vvGalBuild,ts:new Date().toISOString(),
        handle:window.__VVCC.HANDLE,pg:browse.pg||1,
        cards:m?m.querySelectorAll('.vvbr-card').length:-1,
        st:gw?Math.round(gw.scrollTop):-1,sh:gw?gw.scrollHeight:-1,ch:gw?gw.clientHeight:-1,
        sent:sent?1:0,vis:document.visibilityState,
        bodyPos:getComputedStyle(document.body).position,
        vp:innerWidth+'x'+innerHeight,dpr:window.devicePixelRatio||1,
        ua:navigator.userAgent.slice(0,160)};
      try{ p.jid=(typeof vvInc!=='undefined'&&vvInc&&vvInc.id)||''; p.variant=String((new URLSearchParams(location.search)).get('variant')||''); }catch(e){}   // rc4.2.6: journey correlation
      if(extra)for(var k in extra)p[k]=extra[k];
      /* Same events, second destination. galBeat already fires for the gallery
         opening and (since today) the editor mounting, so hooking it here means
         Clarity and the portal counters can never disagree about what happened. */
      /* 31-Aug: 'editor-open' fires right after sf.loadEditor() resolves, and that
         call warms the editor shell BEHIND the gallery whether or not the customer
         ever picks a design — proved by driving the live page and reading
         __vvCCSteps: gallery@77380ms then editor@78858ms, with a 500-card grid on
         screen and no canvas. So the step it produces is renamed to what it means.
         The WIRE name stays 'editor-open' so the portal's editor_open counter and
         its history are untouched; only the Clarity rung is corrected. */
      try{ ccClarity(ev==='open'?'gallery':(ev==='editor-open'?'gallery-ready':ev),extra); }catch(e){}
      var s=JSON.stringify(p), blob=new Blob([s],{type:'text/plain'});
      if(!(navigator.sendBeacon&&navigator.sendBeacon(PORTAL+'/api/gal-telemetry',blob)))
        fetch(PORTAL+'/api/gal-telemetry',{method:'POST',body:s,keepalive:true,
          headers:{'Content-Type':'text/plain'}}).catch(function(){});
    }catch(e){}
  }
  function browseStuckWatch(){
    if(browseStuckIv)return;
    galBeat('open');
    browseStuckIv=setInterval(function(){
      try{
        if(document.hidden||!browseGrid||!browseEl)return;
        var sent=browseGrid.querySelector('[data-pagemore]'); if(!sent)return;
        var root=browseEl.querySelector('.vvbr-gridwrap'); if(!root)return;
        var rr=root.getBoundingClientRect(); if(!(rr.height>0))return;
        var sr=sent.getBoundingClientRect(); if(!(sr.height>0))return;
        if(sr.top<rr.bottom+200&&sr.bottom>rr.top-200){
          if(sent.__vvSeenPg===(browse.pg||1)){
            sent.__vvSeenPg=-1;                       // one shot per sentinel
            var cardsBefore=browseGrid.querySelectorAll('.vvbr-card').length;
            galBeat('wd-force');
            browse.pg=(browse.pg||1)+1;
            browseRender();
            setTimeout(function(){
              try{
                if(galBeatStuckN>=3)return;
                var now=browseGrid?browseGrid.querySelectorAll('.vvbr-card').length:-1;
                if(now===cardsBefore){ galBeatStuckN++; galBeat('hard-stuck',{cardsBefore:cardsBefore}); }
              }catch(e){}
            },1200);
          }else if(sent.__vvSeenPg!==-1){ sent.__vvSeenPg=(browse.pg||1); }
        }
      }catch(e){}
    },1500);
  }
  // ---- UPDATE 43: hi-res GALLERY CARDS. Cards painted upscaled from the 240px
  // feed asset (measured 1.72x). Request painted width x2, snapped UP to rungs
  // (bounded Tigris cache; never softer than asked).
  // The x2 is a FIXED sharpening factor, deliberately not devicePixelRatio: the
  // owner's 3440x1440 display is DPR 1 while a phone is DPR 3, and keying the
  // cache on DPR would multiply the warm set for no visible gain.
  // Cards never exceed 349.3*2=699px of painted width (the grid is
  // auto-fill/minmax(300px,1fr), so more viewport width buys more COLUMNS, not
  // bigger cards — measured 325.8px cards at 3440px), so the ladder stops at 800
  // and a card never pulls the quick-view's 1200px render.
  var BROWSE_CARD_RUNGS=[400,600,800];
  var browseCardIO=null;
  function browseCardRung(im){
    var r=im.getBoundingClientRect();
    if(!(r.width>8&&r.height>8)||!im.naturalWidth||!im.naturalHeight)return 0;
    // ⚠ 9-Aug: this asked for painted*2 REGARDLESS of the screen. The owner's
    // display is devicePixelRatio 1, so a 274px slot was pulling the 600 rung —
    // twice the pixels it can show, twice the bytes, and on a cold portal twice
    // the render. Ask for what the screen can actually resolve, with a small
    // margin so a slot that grows on resize still looks sharp.
    var painted=Math.min(r.width,r.height*(im.naturalWidth/im.naturalHeight));
    var dpr=Math.max(1,Math.min(2,window.devicePixelRatio||1));
    var need=Math.ceil(painted*dpr*1.25);
    for(var i=0;i<BROWSE_CARD_RUNGS.length;i++)if(BROWSE_CARD_RUNGS[i]>=need)return BROWSE_CARD_RUNGS[i];
    return BROWSE_CARD_RUNGS[BROWSE_CARD_RUNGS.length-1];
  }
  function browseCardUpgrade(im){
    if(!im||!im.getAttribute)return;
    var id=im.getAttribute('data-vvid'); if(!id)return;
    // the rung needs the placeholder's intrinsic aspect, so wait for it if the
    // 240px asset has not decoded yet (one-shot; lazy imgs fire load normally)
    if(!im.naturalWidth){ if(!im.getAttribute('data-vvwait')){ im.setAttribute('data-vvwait','1');
        im.addEventListener('load',function(){ browseCardUpgrade(im); },{once:true}); } return; }
    var rung=browseCardRung(im); if(!rung)return;
    // ⚠ 9-Aug, owner: "the blurry behaviour is still there". The blur is OURS —
    // .vvbr-thumb[data-vvlo] carries blur(2.5px) while an upgrade is in flight.
    // It was being applied even when the image already on screen was at or
    // above the rung we were about to fetch, so a sharp image was deliberately
    // blurred while a redundant request completed. If what is painted is already
    // good enough, there is nothing to upgrade and nothing to blur.
    if(im.naturalWidth>=rung)return;
    var hi=prevUrl(id,rung);
    if(im.getAttribute('data-vv-want')===hi)return;       // same guard as the qv
    im.setAttribute('data-vv-want',hi);
    var pre=new Image(), settled=false;
    function clear(){ if(settled)return; settled=true; im.removeAttribute('data-vvlo'); }
    im.setAttribute('data-vvlo','1');
    pre.onload=function(){ if(im.getAttribute('data-vv-want')===hi)im.src=hi; clear(); };
    pre.onerror=clear;                                     // portal down => keep the 240px
    setTimeout(clear,6000);                                // and never strand the blur
    pre.src=hi;
  }
  // Lazy: only cards at/near the viewport are upgraded, so a 20-card gallery
  // does not fire 20 portal requests on open. The scroller is .vvbr-gridwrap
  // (the grid itself does not scroll), and rootMargin pre-warms one row ahead.
  function browseCardsHiRes(){
    try{
      var imgs=browseGrid?browseGrid.querySelectorAll('img.vvbr-thumb[data-vvid]'):null;
      if(!imgs||!imgs.length)return;
      if(!('IntersectionObserver' in window)){
        for(var j=0;j<imgs.length;j++)browseCardUpgrade(imgs[j]); return; }
      if(browseCardIO)browseCardIO.disconnect();
      var root=browseEl?browseEl.querySelector('.vvbr-gridwrap'):null;
      browseCardIO=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(!e.isIntersecting)return;
          browseCardIO.unobserve(e.target); browseCardUpgrade(e.target); });
      },{root:root||null,rootMargin:'400px 0px'});
      for(var i=0;i<imgs.length;i++)browseCardIO.observe(imgs[i]);
    }catch(e){}
  }
  // ---- quick-view v2 (UPDATE 31): two-panel modal, prev/next, zoom ---------
  // Vistaprint's qv has NO prev/next (it uses a more-like-this rail); the
  // arrows through the FILTERED result set are our deliberate improvement.
  function browseQvList(){ return browseVisible().filter(function(g){return !g.blank;}); }
  function browseQvRender(){
    if(!browse.qv)return;
    var items=browse.items||[], g=items[browse.qv.gx];
    if(!g){ browseQvClose(); return; }
    var ix=browse.qv.ix; if(ix>=g.cws.length)ix=0;
    var cur=g.cws[ix], meta=browseCwMeta(g,ix);
    document.getElementById('vvqv-h').textContent=(BROWSE_STYLE_NAMES[g.style]||g.names);
    var inds=(g.style&&BROWSE_STYLE_INDUSTRIES[g.style])||[];
    document.getElementById('vvqv-tags').textContent=inds.length
      ?inds.map(function(d){return BROWSE_INDUSTRY_LABELS[d];}).filter(Boolean).join(' · '):'All-purpose design';
    var price=BROWSE_PRICES[String(vid())];
    document.getElementById('vvqv-price').innerHTML=(typeof price==='number')
      ?('$'+(price/100).toFixed(2)+'<span class="vvbr-unit">1 unit &middot; design included free</span>'):'';
    var vv=null; for(var i=0;i<SHOPIFY_VARIANTS.length;i++){ if(String(SHOPIFY_VARIANTS[i].id)===String(vid())){vv=SHOPIFY_VARIANTS[i];break;} }
    document.getElementById('vvqv-size').textContent=vv?('Sized for your selection: '+vv.title):'';
    var media=document.getElementById('vvqv-media'), im=document.getElementById('vvqv-img');
    // UPDATE 33: hi-res quick-view. Cards keep the 240px CDN thumb; the large
    // panel shows the 240px INSTANTLY as a placeholder, then blur-up swaps in
    // the portal's cached hi-res render (design-preview proxy). data-vv-want
    // guards the swap against prev/next + colourway races (a slow hi-res of a
    // superseded design never lands). Zoomed state reuses the same 1200px img.
    var hi=prevUrl(cur.id,1200);
    var want=hi||cur.thumb||'';
    if(im.getAttribute('data-vv-want')!==want){
      im.setAttribute('data-vv-want',want);
      media.setAttribute('data-loading','1');
      im.onload=function(){ media.removeAttribute('data-loading'); };
      im.src=cur.thumb||''; if(im.complete)media.removeAttribute('data-loading');
      if(hi){ var pre=new Image();
        pre.onload=function(){ if(im.getAttribute('data-vv-want')===want)im.src=hi; };
        pre.src=hi; }
    }
    im.alt=(BROWSE_STYLE_NAMES[g.style]||'Design')+' preview';
    var fv=document.getElementById('vvqv-fav');
    if(g.style&&g.style!=='null'&&browseFavs()[g.style])fv.setAttribute('data-on','1'); else fv.removeAttribute('data-on');
    fv.setAttribute('data-fav',g.style||'');
    var cl=document.getElementById('vvqv-cl'), cw=document.getElementById('vvqv-cws');
    if(g.cws.length>1){
      cl.innerHTML='Colours <span class="vvbr-n">&mdash; '+meta.label+'</span>'; var h='';
      for(var j=0;j<g.cws.length;j++){ var mm=browseCwMeta(g,j);
        h+='<button type="button" class="vvqv-cw" data-cw="'+j+'"'+(j===ix?' data-active':'')
          +' style="background:'+mm.css+'" aria-label="'+mm.label+'" title="'+mm.label+'"></button>'; }
      cw.innerHTML=h;
    } else { cl.textContent=''; cw.innerHTML=''; }
    var list=browseQvList(), pos=list.indexOf(g);
    var pv=document.getElementById('vvqv-prev'), nx=document.getElementById('vvqv-next');
    if(pos<=0)pv.setAttribute('disabled',''); else pv.removeAttribute('disabled');
    if(pos<0||pos>=list.length-1)nx.setAttribute('disabled',''); else nx.removeAttribute('disabled');
    browseQv.removeAttribute('hidden');
  }
  function browseQvStep(dir){
    var items=browse.items||[], g=items[browse.qv.gx], list=browseQvList();
    var pos=list.indexOf(g)+dir;
    if(pos<0||pos>=list.length)return;
    var ng=list[pos];
    browse.qv={gx:items.indexOf(ng),ix:browseDispIx(ng)};
    var m=document.getElementById('vvqv-media'); if(m)m.removeAttribute('data-zoom');
    browseQvRender();
  }
  function browseQvOpen(gx,ix){ browse.qv={gx:gx,ix:ix};
    try{ ccClarity('design-picked'); }catch(e){}   // rung 3: opened a card's quick-view
    var m=document.getElementById('vvqv-media'); if(m)m.removeAttribute('data-zoom');
    browseQvRender(); }
  function browseQvClose(){ browse.qv=null; if(browseQv)browseQv.setAttribute('hidden',''); }
  function browseSync(){
    if(!BROWSE_MODE||browse.done||!browseEl.hasAttribute('data-on'))return;
    var fc=feedChoices();
    if(fc&&!feed.ok){ browseSkeleton(); return; }
    var items=browseCollect();
    if(!items){ browseSkeleton(); return; }
    /* 24-Aug STALE-FEED GUARD — the "picked a design, got a blank editor" bug
       (owner's iPhone 23-Aug, reproduced on desktop 23-Aug at 610x2400 and
       850x2000). After a SIZE CHANGE between launches, feedSync's read-back can
       confirm the new choices while the rail's displayedVariants are still the
       PREVIOUS size's response — so the gallery rendered old-size cards as if
       settled, and picking one clicked a tile the refilter was about to
       destroy: editor opened on the blank starter with the design's name in
       the header. Rows carry their own option values (same shape galKeys
       reads), so verify them directly: if the PDP's chosen value for an option
       is absent from EVERY row while other values for that option are present,
       these rows belong to another selection — keep the cached grid +
       "refreshing…" and let the true feed repaint. A size with genuinely no
       designs never trips this (its rows carry the chosen value or don't
       exist), and products whose options don't bind designs have no chosen
       title among row options, so the loop never fires for them. */
    try{
      var _ch=pdpChosen();
      var _sel=deepFind('au-widget-pim-design-selector');
      var _rows=(_sel&&_sel.displayedVariants)||[];
      if(_ch&&_rows.length){
        var _by={},_ri,_oj,_ro,_t;
        for(_ri=0;_ri<_rows.length;_ri++){ var _os=_rows[_ri].options||[];
          for(_oj=0;_oj<_os.length;_oj++){ _ro=_os[_oj];
            _t=vnorm(_ro.productOptionTitle); if(!_t)continue;
            (_by[_t]=_by[_t]||{})[vnorm(_ro.productOptionValueTitle)]=1; } }
        for(_t in _by){ if(_ch[_t]!==undefined && !_by[_t][_ch[_t]]){ browseSkeleton(); return; } }
      }
    }catch(e){}
    var sig=items.map(function(g){return g.names;}).join('||');
    if(browse.sig===sig)return;
    try{ vvInc.mark('feed:rows-landed',{cards:items.length,rows:(function(){try{return (deepFind('au-widget-pim-design-selector')||{}).displayedVariants.length;}catch(e){return -1;}})(),filtered:!!(feed&&feed.ok)}); }catch(e){}
    browse.sig=sig; browse.items=items; browseRender();
    /* UPDATE 45: lean card-model cache -> next open paints instantly (SWR); tile refs excluded. */
    try{ localStorage.setItem(VVBR_CACHE_KEY, JSON.stringify({t:Date.now(),
      items:items.map(function(g){return {names:g.names,blank:g.blank,style:g.style,
        cws:g.cws.map(function(e){return {name:e.name,thumb:e.thumb,cc:e.cc,slug:e.slug,id:e.id};})};})})); }catch(e){}
    if(browse.pendingPick){
      var want=browse.pendingPick; browse.pendingPick=null;
      browseWait(false);
      /* a pending BLANK is one design per size, so the refreshed blank card (whatever size it is now named
         for) is the one to pick — browsePick resolves the right-size starter from the rail */
      if(browseIsBlank(want)){
        for(var pb=0;pb<items.length;pb++){ if(items[pb].blank){ browsePick(items[pb],0); return; } } }
      for(var pi=0;pi<items.length;pi++){
        for(var pj=0;pj<items[pi].cws.length;pj++){
          if(items[pi].cws[pj].name===want){ browsePick(items[pi],pj); return; }
        }
      }
    }
  }
  /* 27-Aug — request-a-design + feedback submission. One portal endpoint, two
     kinds. Delegated 'submit' listener because the request card is re-rendered
     with the grid: a listener on the form dies with every repaint; one on the
     container survives them all (same reason every card handler is delegated). */
  function vvbrSend(kind, msg, email, done, btn){
    var fl=[];try{
      if(browse.cat&&browse.cat!=='all')fl.push('industry:'+browse.cat);
      if(browse.col)fl.push('colour:'+browse.col);
      if(browse.thm)fl.push('theme:'+browse.thm);}catch(e){}
    var payload={kind:kind,message:msg,email:email||'',
                 product:(window.__VVCC&&window.__VVCC.HANDLE)||'',
                 term:(browse.q||''),filters:fl.join(', ')};
    btn.disabled=true;var old=btn.textContent;btn.textContent='Sending…';
    fetch(PORTAL+'/api/gallery-request',{method:'POST',
      headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok&&j.ok,err:j.error};});})
      .then(function(x){
        if(!x.ok){btn.disabled=false;btn.textContent=old;
          alert(x.err||'That didn’t send — please try again or call 1300 721 614.');return;}
        done();
      })
      .catch(function(){btn.disabled=false;btn.textContent=old;
        alert('That didn’t send — please check your connection and try again.');});
  }
  /* Clicking the submit button did NOT submit the form on the live page: the
     click reached the form un-prevented, yet no submit event fired anywhere —
     not even at document capture — while form.requestSubmit() worked. Something
     later in this page's click chain (150 scripts deep, most not ours) cancels
     the button's default action. Measured, not guessed: clickSeenOnForm=true,
     defaultPrevented-at-capture=false, submit events fired=0. So the buttons
     are driven explicitly, capture-phase so nothing runs before us, through
     requestSubmit() which still runs native validation and fires 'submit'. */
  browseEl.addEventListener('click',function(e){
    var b=e.target.closest?e.target.closest('.vvbr-req-btn, .vvbr-fb-send'):null;
    if(!b)return;
    e.preventDefault();e.stopPropagation();
    var fm=b.closest('form');
    if(!fm)return;
    if(fm.requestSubmit)fm.requestSubmit();
    else if(fm.reportValidity&&!fm.reportValidity())return;
    else fm.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
  },true);
  browseEl.addEventListener('submit',function(e){
    var f=e.target;
    if(f&&f.id==='vvbr-req'){
      e.preventDefault();
      if(f.querySelector('.vvbr-hp').value)return;              // bot
      var msg=f.querySelector('#vvbr-req-msg').value.trim();
      var em=f.querySelector('#vvbr-req-email').value.trim();
      if(!msg||!em)return;
      vvbrSend('design-request',msg,em,function(){
        var d=f.querySelector('.vvbr-req-done');
        /* The confirmation repeats THEIR email and the promise — a generic
           "thanks" is what the critique flagged. textContent, never innerHTML:
           the email is customer-typed. */
        d.textContent='Done — we’re on it. We’ll email you at '+em+
          ' the moment your designs are live (usually within 24 hours).';
        [].forEach.call(f.children,function(c){if(c!==d)c.style.display='none';});
        d.hidden=false;
      },f.querySelector('.vvbr-req-btn'));
      return;
    }
    if(f&&f.id==='vvbr-fb'){
      e.preventDefault();
      if(f.querySelector('.vvbr-hp').value)return;
      var fmsg=f.querySelector('#vvbr-fb-msg').value.trim();
      if(!fmsg)return;
      vvbrSend('feedback',fmsg,f.querySelector('#vvbr-fb-email').value.trim(),function(){
        var fd=f.querySelector('.vvbr-fb-done');
        [].forEach.call(f.children,function(c){if(c!==fd)c.style.display='none';});
        fd.hidden=false;
        setTimeout(function(){try{
          f.hidden=true;fd.hidden=true;
          [].forEach.call(f.children,function(c){c.style.display='';});
          f.reset();
          var ob=document.getElementById('vvbr-fb-open');if(ob)ob.style.display='';
        }catch(e2){}},4000);
      },f.querySelector('.vvbr-fb-send'));
      return;
    }
  });
  browseEl.addEventListener('click',function(e){
    if(e.target&&e.target.id==='vvbr-fb-open'){
      var ff=document.getElementById('vvbr-fb');
      if(ff){ff.hidden=false;e.target.style.display='none';
        try{ff.querySelector('#vvbr-fb-msg').focus();}catch(e2){}}
      return;
    }
    if(browse.qv){
      if(e.target.closest&&e.target.closest('#vvqv-prev')){ browseQvStep(-1); return; }
      if(e.target.closest&&e.target.closest('#vvqv-next')){ browseQvStep(1); return; }
      if(e.target.closest&&e.target.closest('#vvqv-zoom')){
        var zm=document.getElementById('vvqv-media');
        if(zm.hasAttribute('data-zoom'))zm.removeAttribute('data-zoom'); else zm.setAttribute('data-zoom','1');
        return; }
      if(e.target.closest&&e.target.closest('#vvqv-fav')){
        var gf=(browse.items||[])[browse.qv.gx];
        if(gf&&gf.style){ browseFavToggle(gf.style); browseQvRender(); browseRender(); }
        return; }
      var qcw=e.target.closest?e.target.closest('.vvqv-cw'):null;
      if(qcw){ browse.qv.ix=parseInt(qcw.getAttribute('data-cw'),10)||0;
        var gq=(browse.items||[])[browse.qv.gx];
        if(gq&&gq.style)browse.cwSel[gq.style]=browse.qv.ix;
        browseQvRender(); browseRender(); return; }
      if(e.target.id==='vvqv-edit'){ var ge=(browse.items||[])[browse.qv.gx]; if(ge)browsePick(ge,browse.qv.ix); return; }
      if(e.target.id==='vvqv-blank'){ var bl=(browse.items||[]).filter(function(g){return g.blank;})[0];
        if(bl)browsePick(bl,0); return; }
      if(e.target.id==='vvqv-x'||e.target===browseQv){ browseQvClose(); return; }
      if(e.target.closest&&e.target.closest('.vvqv-card'))return;
      browseQvClose(); return;
    }
    // TESTING-PHASE delete: two-step arm, then portal hard-delete + card removal.
    var dl=e.target.closest?e.target.closest('.vvbr-del'):null;
    if(dl&&browse.items&&VV_DEL_KEY){
      e.preventDefault(); e.stopPropagation();
      if(!dl.hasAttribute('data-arm')){
        dl.setAttribute('data-arm','1'); dl.textContent='Tap again to delete';
        setTimeout(function(){ if(dl.isConnected&&!dl.hasAttribute('data-busy')){ dl.removeAttribute('data-arm'); dl.textContent='Delete'; } },4000);
        return;
      }
      var dg=browse.items[parseInt(dl.getAttribute('data-del'),10)]; if(!dg)return;
      var dc=dl.closest('.vvbr-card'), dcw=dc?(parseInt(dc.getAttribute('data-cwix'),10)||0):0;
      var de=dg.cws[dcw]||dg.cws[0]; if(!de||!de.id)return;
      dl.setAttribute('data-busy','1'); dl.textContent='…';
      var dpid=0; try{ var dt=window.__vvCCDet; dpid=(dt&&(dt.productId||(dt.product&&dt.product.id)||dt.id))||0; }catch(de2){}
      fetch(PORTAL+'/api/design-admin-delete',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({key:VV_DEL_KEY,id:de.id,ccProductId:dpid})})
      .then(function(r){ return r.json().catch(function(){return null;}).then(function(j){return {s:r.status,j:j};}); })
      .then(function(x){
        if(!(x.j&&x.j.ok)){
          dl.removeAttribute('data-busy'); dl.removeAttribute('data-arm'); dl.textContent='Failed — retry';
          dl.title='Delete failed ('+x.s+'): '+((x.j&&(x.j.error||x.j.deleteError||x.j.unbindError))||'server error');
          return;
        }
        var di=dg.cws.indexOf(de); if(di>=0)dg.cws.splice(di,1);
        if(!dg.cws.length){ var gi=browse.items.indexOf(dg); if(gi>=0)browse.items.splice(gi,1); }
        browseRender();
      })
      .catch(function(){ dl.removeAttribute('data-busy'); dl.removeAttribute('data-arm'); dl.textContent='Failed — retry'; dl.title='Network error — try again'; });
      return;
    }
    var fv=e.target.closest?e.target.closest('.vvbr-fav'):null;
    if(fv){ browseFavToggle(fv.getAttribute('data-fav')); browseRender(); return; }
    var fsh=e.target.closest?e.target.closest('.vvbr-fs-h'):null;
    if(fsh){ var k=fsh.getAttribute('data-fs'); browse.fs[k]=!browse.fs[k]; browseRender(); return; }
    /* 21-Aug: the page-more button is a DIFFERENT control from the facet list's
       "Show More" below — it advances the grid by one page. It deliberately no
       longer shares the .vvbr-more class: a mobile rule hid that class (written
       for the facet button) and, when the auto-load sentinel still carried it,
       display:none left the sentinel with no box, so the IntersectionObserver
       could never fire and the gallery was frozen at 36 designs on every phone. */
    var mr=e.target.closest?e.target.closest('.vvbr-more'):null;
    if(mr){ browse.more[mr.getAttribute('data-more')]=true; browseRender(); return; }
    var up=e.target.closest?e.target.closest('[data-upl]'):null;
    if(up){ vvupOpen(); return; }                   // UPDATE 37: in-gallery upload panel (real dropzone)
    var sv=e.target.closest?e.target.closest('[data-svc]'):null;
    if(sv){ vvdsOpen(); return; }                   // UPDATE 37: designer-brief panel
    var d=e.target.closest?e.target.closest('.vvbr-dot'):null;
    if(d){ var g=(browse.items||[])[parseInt(d.getAttribute('data-gx'),10)];
      if(g&&g.style){ browse.cwSel[g.style]=parseInt(d.getAttribute('data-cw'),10)||0; browseRender(); }
      return; }
    /* Sub-category first: a .vvbr-sub sits INSIDE the industry block, so if the
       industry handler ran first it would swallow the click and reset the
       type. */
    /* One beacon for every facet, taken AFTER the render so the count is what
       the customer is now looking at. A facet that lands on zero is worth as
       much as a zero-result search: it is a category the menu offers and the
       library cannot fill. Fire-and-forget; a telemetry failure must never be
       able to stop a filter from applying. */
    var facetBeat=function(kind,val){ try{
      galBeat('facet',{kind:kind,val:String(val||'').slice(0,40),n:searchHits(),
        cat:browse.cat||'all',typ:browse.typ||'',col:browse.col||'',thm:browse.thm||''});
    }catch(e){} };
    var sb=e.target.closest?e.target.closest('.vvbr-styp'):null;
    if(sb){ if(sb.hasAttribute('disabled'))return;          // empty type: nothing to show
      var tv=sb.getAttribute('data-typ')||'';
      browse.typ=(browse.typ===tv)?'':tv; browseRender(); facetBeat('type',browse.typ); return; }
    var c=e.target.closest?e.target.closest('.vvbr-cat'):null;
    if(c){ if(c.hasAttribute('data-thm')){ browse.thm=(browse.thm===c.getAttribute('data-thm'))?'':c.getAttribute('data-thm'); }
      else { var nc=c.getAttribute('data-cat')||'all';
             if(nc!==browse.cat)browse.typ='';              // changing industry clears the type
             browse.cat=nc; }
      browseRender(); facetBeat(c.hasAttribute('data-thm')?'theme':'industry',browse.thm||browse.cat); return; }
    var col=e.target.closest?e.target.closest('.vvbr-col'):null;
    if(col){ browse.col=col.getAttribute('data-col')||''; browseRender(); facetBeat('colour',browse.col); return; }
    var ch=e.target.closest?e.target.closest('.vvbr-chip'):null;
    if(ch){ var kk=ch.getAttribute('data-clear');
      if(kk==='cat'||kk==='all')browse.cat='all';
      if(kk==='col'||kk==='all')browse.col='';
      if(kk==='thm'||kk==='all')browse.thm='';
      if(kk==='q'||kk==='all'){ browse.q=''; if(browseSearch)browseSearch.value=''; }
      browseRender(); return; }
    var rm=e.target.closest?e.target.closest('.vvbr-rm'):null;
    if(rm){ e.preventDefault(); e.stopPropagation();
      var rg=rm.getAttribute('data-rm');
      if(rm.getAttribute('data-armed')!=='1'){ rm.setAttribute('data-armed','1'); rm.textContent='Remove?'; setTimeout(function(){ try{ rm.removeAttribute('data-armed'); rm.innerHTML='&times;'; }catch(e){} },4000); return; }
      try{ localStorage.setItem(VV_SAVES_KEY,JSON.stringify(vvSavesRead().filter(function(x){return x.guid!==rg;}))); }catch(e){}
      if(vvSaved.remote){ vvSaved.remote=vvSaved.remote.filter(function(x){return x.guid!==rg;}); vvSaved.sig='r'+vvSaved.remote.length+'-'+rg.slice(0,6); }
      if(CUSTOMER_ID){ try{ fetch(PORTAL+'/api/my-designs/remove',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({customerId:String(CUSTOMER_ID),guid:rg})}).catch(function(){}); }catch(e){} }
      try{ prepMark('saved-removed'); }catch(e){}
      browseRender(); return; }
    var card=e.target.closest?e.target.closest('.vvbr-card'):null;
    if(card&&card.getAttribute('data-vvsaved')){
      var _sg=card.getAttribute('data-vvsaved'), _sr=vvSavedForHere().filter(function(r){return r.guid===_sg;})[0];
      if(_sr){ try{ prepMark('resume-saved'); }catch(e){} try{ window.__vvNoNav=1; }catch(e){} location.href=vvResumeUrl(_sr); }
      return;
    }
    if(card&&browse.items){
      var gg=browse.items[parseInt(card.getAttribute('data-gx'),10)];
      if(!gg)return;
      /* Opening a design WHILE A SEARCH IS ACTIVE is the difference between "we
         have it" and "we have it and they found it". Without this, a popular
         term whose matches are all wrong looks identical to one that works. */
      try{ var _q=(browse.q||'').trim();
        if(_q.length>=2) galBeat('search-pick',{q:_q.slice(0,60),n:searchHits()}); }catch(e){}
      if(card.getAttribute('data-blank')){ browsePick(gg,0); return; }
      browseQvOpen(parseInt(card.getAttribute('data-gx'),10),parseInt(card.getAttribute('data-cwix'),10)||0);
    }
  });
  /* 26-Aug — RECORD WHAT THE GALLERY IS ASKED FOR.
     The search box and the facet menu were both completely uninstrumented: this
     handler set browse.q, re-rendered, and that was the end of it. So the two
     questions worth asking about a 12,000-design library — what are people
     looking for, and what do they look for and NOT find — had no answer at all.
     A zero-result search is the single most actionable signal here: it names a
     design we should commission, or a word missing from the tags of one we
     already have.
     DEBOUNCED, on purpose. Beaconing per keystroke would send "c", "co", "cof",
     "coff"... and bury the real term in its own prefixes. 900ms after typing
     stops is the query the customer actually meant. The result count is taken at
     the same moment, so "found nothing" is measured against what they saw. */
  /* HOW MANY DESIGNS DID THAT ACTUALLY FIND.
     browseVisible() includes the "Start from blank" entries, which are always
     shown whatever the query — so a search that matches nothing reported n=2,
     and "found nothing" could never be recorded at all. Caught by
     qa/cc-search-telemetry-check.mjs typing a deliberate nonsense term and
     asserting the count reached zero; the counter would otherwise have looked
     healthy while never once firing the signal it exists for. */
  function searchHits(){
    try{ return browseVisible().filter(function(g){ return g && !g.blank; }).length; }
    catch(e){ return -1; }
  }
  var _qBeat=null,_qLast='';
  function searchBeat(){
    try{
      var q=(browse.q||'').trim();
      if(q.length<2||q===_qLast)return;
      _qLast=q;
      galBeat('search',{q:q.slice(0,60),n:searchHits(),
        cat:browse.cat||'all',typ:browse.typ||'',col:browse.col||''});
    }catch(e){}
  }
  if(browseSearch)browseSearch.addEventListener('input',function(){
    browse.q=browseSearch.value||''; browseRender();
    try{ clearTimeout(_qBeat); }catch(e){}
    _qBeat=setTimeout(searchBeat,900);
  });
  if(browseSort)browseSort.addEventListener('change',function(){ browse.sort=browseSort.value||'rec'; browseRender(); });
  browseEl.addEventListener('keydown',function(e){
    if(e.key!=='Enter'&&e.key!==' ')return;
    var d=e.target.closest?e.target.closest('.vvbr-dot'):null;
    if(d){ e.preventDefault(); e.stopPropagation(); d.click(); }
  });
  // Esc layering: quick-view closes first; only then does Esc reach the
  // modal-level close handler (capture phase, so we run before it).
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape'||modal.hasAttribute('hidden'))return;
    if(browseUp&&!browseUp.hasAttribute('hidden')){ e.stopPropagation(); vvupClose(); return; }  // UPDATE 37
    if(browseDs&&!browseDs.hasAttribute('hidden')){ e.stopPropagation(); vvdsClose(); return; }  // UPDATE 37
    if(browse.qv){ e.stopPropagation(); browseQvClose(); return; }
    if(BROWSE_MODE && browse.entered && !browseEl.hasAttribute('data-on')){
      /* 30-Sep: Esc matches the back control — the page the session came from (hub,
         Tier-2 gallery) or the VividCanvas gallery, never the studio's own grid */
      try{ var _gk=vvFromTarget(); if(_gk&&_gk.path&&!browseCartEdit()){ e.stopPropagation(); location.href=_gk.path; return; } }catch(err){}
      e.stopPropagation(); browseReturnToGallery(); return;
    }
    // UPDATE 39: Esc MATCHES the button in an edit session — both go to the cart.
    if(browseCartEdit() && !browseEl.hasAttribute('data-on')){
      e.stopPropagation(); vvccBackToCart();
    }
  },true);

  // ---- Silent autosave (UPDATE 11) -----------------------------------------
  // The HelloPrint-parity bar hides Save Project / My Projects, which is only safe if the work
  // is being kept for the customer automatically (Canva autosaves for them; CC does not). Now
  // that a design state actually exists (H7 fix above), saveProject completes — verified: a
  // guest save resolved and the project appeared in getAllProjects(), where before it hung 30s+
  // and never landed. So: save quietly in the background, no UI, never block the customer.
  //  · identity is whatever get-cc-token.php minted for — shopify_customer_<id> when signed in,
  //    the localStorage guest id otherwise. Projects are already scoped to that CC user.
  //  · idle-triggered, not per-keystroke: a tick only saves when something has changed since the
  //    last save AND the cadence has elapsed.
  //  · ONE rolling project per product: after each save the older same-named autosaves are
  //    deleted, so a customer never accumulates dozens of "Autosave" entries.
  //  · silent-fail: any error is a console.warn, never a UI state.
  var AUTOSAVE_ENABLED=true, AUTOSAVE_MS=45000, AUTOSAVE_POLL=5000;
  var AUTOSAVE_NAME='Autosave — '+PRODUCT_TITLE;
  var aut={timer:null,last:0,dirty:false,busy:false};
  function autosaveDirty(){ aut.dirty=true; }
  function namedIds(list){
    var arr=Array.isArray(list)?list:((list&&list.items)||[]);
    return arr.filter(function(x){return (x&&(x.name||x.title))===AUTOSAVE_NAME;}).map(function(x){return x.id;});
  }
  /* ---- Release-hardening (2026-10-06), class 10 — DRAFTS SURVIVE THE EDITOR SESSION ----------------
     What expires is the Customer's Canvas storefront-user token the editor mounted with (JWT, TTL 3600 s,
     minted by the portal /api/cc-token; docs/customers-canvas/CC-TOKEN-MINTING.md). After that every CC call
     from this editor fails — saveProject, getAllProjects, the finish — while the canvas still looks fine. The
     customer's WORK already lives server-side as the rolling autosave project; what was missing was a durable
     pointer to it and a path that reopens it instead of "make your changes again". The pointer is one record
     per product+variant on this device (localStorage), refreshed after every autosave (the rolling save gets a
     NEW guid each time), pruned at VV_DRAFT_DAYS. Nothing here lengthens any server session. */
  var VV_DRAFTS_KEY='vv_drafts', VV_DRAFT_DAYS=90, VV_PRESAVE_MS=50*60*1000;
  function vvDraftKey(){ return vvHandle()+'|'+String(vid()||''); }
  function vvEntryKey(){ try{ var q=new URLSearchParams(location.search); if(q.get('vvstyle'))return 'style:'+q.get('vvstyle'); var c=q.get('vvcc'); if(c==='blank')return 'blank'; if(c==='upload')return 'upload'; if(c==='1'&&q.get('vvproj'))return 'proj:'+q.get('vvproj'); return ''; }catch(e){ return ''; } }
  function vvDraftsRead(){ try{ var o=JSON.parse(localStorage.getItem(VV_DRAFTS_KEY)||'{}'); if(!o||typeof o!=='object')return {}; var cut=Date.now()-VV_DRAFT_DAYS*864e5, out={}; for(var k in o){ if(o[k]&&o[k].guid&&o[k].at>cut) out[k]=o[k]; } return out; }catch(e){ return {}; } }
  function vvDraftsWrite(o){ try{ localStorage.setItem(VV_DRAFTS_KEY,JSON.stringify(o)); }catch(e){} }
  function vvDraftGet(){ return vvDraftsRead()[vvDraftKey()]||null; }
  function vvDraftPut(stateId,guid){ try{ if(!stateId)return; var o=vvDraftsRead(); var cur=o[vvDraftKey()]||{}; o[vvDraftKey()]={stateId:String(stateId),guid:guid||cur.guid||'',userId:guestId(),handle:vvHandle(),variant:String(vid()||''),title:PRODUCT_TITLE,
      entry:(function(){ var ek=vvEntryKey(); return (ek||cur.entry||''); })(),designId:(browse&&browse.pickedId)||cur.designId||'',at:Date.now(),editorAt:vvEditorAt||0}; vvDraftsWrite(o); try{ console.log('[vivid-cc] draft pointer state',stateId); }catch(e){} }catch(e){} }
  /* The resume link is THE SAME ENTRY (product, variant, template/blank) plus the saved state to restore over it —
     the studio opens exactly as it did, then restoreWidgetFromData({stateId}) puts the customer's canvas back. */
  function vvDraftResumeUrl(rec,why){
    var q; try{ q=new URLSearchParams(location.search); }catch(e){ q=new URLSearchParams(''); }
    ['vvstate','vvuser','vvresume','vvfresh','vvcc','vvstyle','vvproj','vvsaved','vvline'].forEach(function(k){ q.delete(k); });
    if(rec.variant) q.set('variant',rec.variant);
    var ek=rec.entry||''; if(ek==='blank'||ek==='upload') q.set('vvcc',ek); else if(ek.indexOf('style:')===0) q.set('vvstyle',ek.slice(6));
    if(!q.get('vvfrom')) q.set('vvfrom','gallery');
    q.set('vvstate',rec.stateId); q.set('vvuser',rec.userId||guestId()); q.set('vvresume',why||'1');
    return location.pathname+'?'+q.toString();
  }
  function autosaveTick(force){
    if(!AUTOSAVE_ENABLED||aut.busy)return;
    if(!force&&!aut.dirty)return;
    if(modal.hasAttribute('hidden')||anyStateOn())return;
    if(!force&&Date.now()-aut.last<AUTOSAVE_MS)return;
    var wiz=deepFind('au-wizard'), ed=deepFind('au-widget-design-editor');
    var mgr=wiz&&wiz.savedProjectsManager, svc=mgr&&mgr._service;
    // No state id => the design has not compiled yet; saving in that condition is the exact
    // call that used to hang forever. Wait for the editor instead.
    if(!mgr||!svc||!ed||!ed.stateId)return;
    /* dd3l: never save a design that has not loaded (CC's 1x1 placeholder) — it would become the customer's draft */
    if(!vvDesignReady()){ if(force) aut.presaved=false;
      if(aut.skipSid!==String(ed.stateId)){ aut.skipSid=String(ed.stateId); try{ vvInc.mark('autosave:skip-not-ready',{sid:String(ed.stateId).slice(0,8),surf:VV_RD.surf}); }catch(e){} }
      return; }
    aut.busy=true; aut.dirty=false; aut.last=Date.now();
    var before=[];
    /* Release-hardening (2026-10-06), class 10 — MEASURED: the editor's server-side state (ed.stateId) does NOT
       change when the customer edits; it changes only when the widget's own saveProduct() pushes the canvas
       (API edit, UI edit: stateId identical 20 s later; after ed.saveProduct(): new stateId). saveProject() on its
       own therefore filed a project pointing at the state the design was LOADED with — the "autosave" could never
       restore an edit. Push the canvas first, then file the project. */
    var savedState='';
    Promise.resolve(typeof ed.saveProduct==='function'?ed.saveProduct():null)
      .then(function(r){ savedState=(r&&r.stateId)||ed.stateId||''; if(savedState) vvDraftPutSafe(savedState); })
      .catch(function(e){ try{console.warn('[vivid-cc] autosave: saveProduct failed (continuing)',e);}catch(_){ } })
      .then(function(){ return svc.getAllProjects(); })
      .then(function(l){ before=namedIds(l); return mgr.saveProject(AUTOSAVE_NAME); })
      .then(function(){ return svc.getAllProjects(); })
      .then(function(l){
        var after=namedIds(l);
        var stale=before.filter(function(id){return after.indexOf(id)>=0;}); // survived => older copy
        var fresh=after.filter(function(id){return before.indexOf(id)<0;});
        if(savedState&&fresh.length) vvDraftPutSafe(savedState,fresh[fresh.length-1]);
        return Promise.all(stale.map(function(id){
          return Promise.resolve(svc.deleteProject(id)).catch(function(){});
        }));
      })
      .then(function(){ try{console.log('[vivid-cc] autosaved');}catch(e){} })
      .catch(function(e){ try{console.warn('[vivid-cc] autosave failed (ignored)',e);}catch(_){ } })
      .then(function(){ aut.busy=false; });
  }
  function startAutosave(){ stopAutosave(); aut.last=Date.now(); aut.dirty=false; aut.presaved=false;
    if(AUTOSAVE_ENABLED) aut.timer=setInterval(function(){
      /* one forced save as the token nears its end (50 of 60 min), so the draft is never older than the
         last ten minutes when the session does expire; after that the token cannot save at all */
      if(!aut.presaved&&vvEditorAt&&Date.now()-vvEditorAt>VV_PRESAVE_MS){ aut.presaved=true; autosaveTick(true); return; }
      autosaveTick();
    },AUTOSAVE_POLL); }
  /* the tab goes to the background (phone locked, laptop lid, another tab): keep whatever changed */
  try{ document.addEventListener('visibilitychange',function(){ if(document.hidden&&aut.dirty) autosaveTick(true); }); }catch(e){}
  function stopAutosave(){ if(aut.timer){clearInterval(aut.timer);aut.timer=null;} }

  // ---- UPDATE 24: per-LINE saved project, so "Change artwork" restores THAT line -----------
  // Owner: "on my screen on the cart page click change artwork and it will not take you to this
  // same artwork to edit". UPDATE 23 proved mgr.loadProject(guid) restores the artwork and found
  // the trap: NOTHING on the line identified which project to load, and the rolling autosave is
  // one project PER PRODUCT — so two designed lines of the same product would both have restored
  // the most recent artwork. Silent wrong-artwork, the exact class of bug this integration keeps
  // paying for. So each finish now writes its OWN durable project and stamps the GUID on the line.
  //
  //  · the autosave stays exactly as it was (crash recovery, one rolling copy per product). Its
  //    pruning only deletes projects whose name === AUTOSAVE_NAME, so these are never collected.
  //  · the name carries the state id so it is unique per finish and readable in Aurigma's UI.
  //  · the GUID is read BACK out of getAllProjects() by diffing before/after — saveProject does
  //    not return it, and guessing is how §23.3 got two of three ids wrong.
  var LINE_PROJECT_PREFIX='Line — '+PRODUCT_TITLE+' — ';
  function projIds(list,name){
    var arr=Array.isArray(list)?list:((list&&list.items)||[]);
    return arr.filter(function(x){return (x&&(x.name||x.title))===name;}).map(function(x){return x.id;});
  }
  // Returns the new project's GUID, or '' — never throws, never blocks the finish.
  async function saveLineProject(stateId){
    try{
      var wiz=deepFind('au-wizard'), ed=deepFind('au-widget-design-editor');
      var mgr=wiz&&wiz.savedProjectsManager, svc=mgr&&mgr._service;
      if(!mgr||!svc||!ed||!ed.stateId) return '';
      var name=LINE_PROJECT_PREFIX+String(stateId||ed.stateId).split(',')[0].slice(0,8);
      var before=projIds(await svc.getAllProjects(),name);
      await mgr.saveProject(name);
      var after=projIds(await svc.getAllProjects(),name);
      var fresh=after.filter(function(id){return before.indexOf(id)<0;});
      var guid=fresh.length?fresh[fresh.length-1]:(after.length?after[after.length-1]:'');
      try{console.log('[vivid-cc] line project',name,guid||'(no guid)');}catch(e){}
      return guid||'';
    }catch(e){ try{console.warn('[vivid-cc] saveLineProject failed (ignored)',e);}catch(_){ } return ''; }
  }

  // ---- The edit session: which cart line we are editing, and its artwork -------------------
  // "Change artwork" (sections/vivid-cart.liquid) carries three things: vvcc=1 to auto-open,
  // vvline=<line key> so the finish UPDATES that line instead of adding another, and
  // vvproj=<saved project GUID> so the artwork is restored.
  var EDIT={line:'',proj:'',tries:0,last:0,done:false,failed:false,base:null,inflight:false,t0:0};
  /* 31-Aug — HOW LONG A RESTORE IS ALLOWED TO TAKE.
     Measured on a real cart line (project e869032a, Feather Flags, order 125616):
       t+2s   stateId unchanged
       t+32s  stateId empty  — the editor is tearing down and rebuilding
       t+36s  stateId NEW    — the artwork is on the canvas
     loadProject takes about thirty-six seconds and it works. The old code gave
     it three tries three seconds apart — a nine-second budget — so it declared
     failure at t+9s every single time, and each retry tore down the load that
     was already most of the way there. Retrying was not recovering from the
     failure, it was causing it. One attempt, ninety seconds, no interference. */
  var RESTORE_MS=90000;
  try{
    var _q=new URLSearchParams(location.search);
    EDIT.line=_q.get('vvline')||''; EDIT.proj=_q.get('vvproj')||'';
    EDIT.saved=(_q.get('vvsaved')==='1'&&!!EDIT.proj);   // 9-Sep: reopening a SAVED design, not a cart line
    /* 20-Oct: "Create it again" from a cart line whose saved design CC has purged (vivid-cart.liquid). Still bound to the
       line (finishing REPLACES its artwork: same line, quantity, options — no duplicate), but nothing to restore, so the
       gallery opens as for a new design (?vvcc=blank picks the blank starter) and the header says what this is. */
    EDIT.fresh=(_q.get('vvfresh')==='1'&&!!EDIT.line&&!EDIT.proj);
  }catch(e){}
  /* rc4.2.9 CHANGE ARTWORK = THE LINE'S OWN DESIGN STATE. A line edit arrives as ?vvcc=1&vvline=<key>&vvproj=<saved project>;
     saved-project restore has been broken at the vendor since 11-Sep. The line carries the state it was finished with
     (_CC_Design_ID) and its CC user (_CC_User_ID): re-enter the SAME product + variant with that state (?vvstate=), which the
     editor reopens natively. Nothing is written to the cart here; the line is only updated if the customer finishes again. */
  /* 20-Oct-2026 CART EDIT FIX — ASK BEFORE LOADING A STATE (Customer's Canvas support, D. Korobitsyn: "add a check
     to confirm the design exists in storage before proceeding … 200 → load, 404 → halt and inform the client").
     MEASURED 20 Oct on 990 render jobs: CC purges design-editor states ~7.5–8.5 days after they are made (every
     state < 7 d present; 87% of 7–14 d and 100% of older ones 404), but a cart line keeps pointing at its state
     for as long as the cart lives. Restoring a purged state makes design-editor 7.4.4 answer RequestInitData 404
     and dispose the editor; restoreWidgetFromData never settles, so the customer sat on "Loading your design…"
     forever (reproduced on a test cart: 180 s+, no message). The portal answers exists true / false / null
     (null = could not tell → carry on exactly as before; a check that cannot answer must never block anyone). */
  function vvStateExists(sid,uid,why){ return new Promise(function(res){ var fin=false;
    var to=setTimeout(function(){ if(!fin){ fin=true; res(null); } },7000);
    function done(v){ if(fin) return; fin=true; clearTimeout(to); res(v); }
    try{
      fetch(PORTAL+'/api/cc-design-exists?id='+encodeURIComponent(sid)+'&owner='+encodeURIComponent(uid)+'&why='+encodeURIComponent(why||'')+'&handle='+encodeURIComponent(vvHandle()),{cache:'no-store',credentials:'omit'})
        .then(function(r){ return r.ok?r.json():null; })
        .then(function(j){ done(j&&j.ok===true?(j.exists===true?true:(j.exists===false?false:null)):null); },function(){ done(null); });
    }catch(e){ done(null); }
  }); }
  /* A cart line whose saved design is gone: back to the cart, which explains it on that line and offers the way
     forward (create it again on the same line, or contact us). Never load the missing state into the editor. */
  function vvLineStateMissing(site){
    try{ window.__vvCAState='state-missing'; }catch(e){}
    try{ galBeat('cc-changeart',{ok:0,why:'state-missing',site:site||''}); }catch(e){}
    try{ prepMark('state-missing:'+(site||'')); }catch(e){}
    try{ stopMonitor(); stopAutosave(); }catch(e){}
    try{ window.__vvNoNav=1; window.__vvIntentNav='state-missing'; vvInc.mark('nav:state-missing'); }catch(e){}
    location.replace('/cart?vvmissing='+encodeURIComponent(EDIT.line));
  }
  try{
    var _caq=new URLSearchParams(location.search);
    if(EDIT.line && !EDIT.saved && !_caq.get('vvstate') && _caq.get('vvfresh')!=='1'){   // vvfresh=1: "create it again" on this line — no restore
      window.__vvCAState='resolving';
      fetch('/cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}}).then(function(r){ return r.json(); }).then(function(c){
        var it=(c&&c.items||[]).filter(function(i){ return i&&i.key===EDIT.line; })[0]; var p=(it&&it.properties)||{};
        var sid=String(p._CC_Design_ID||''), uid=String(p._CC_User_ID||'');
        if(/^[0-9a-f\-]{20,60}$/i.test(sid) && /^[A-Za-z0-9_\-]{3,80}$/.test(uid)){
          window.__vvCAState='checking';
          return vvStateExists(sid,uid,'change-artwork').then(function(ex){
          if(ex===false){ vvLineStateMissing('change-artwork'); return; }
          _caq.set('vvstate',sid); _caq.set('vvuser',uid); _caq.set('vvresume','change-artwork'); _caq.delete('vvproj');
          if(ex===true) _caq.set('vvok','1');                                    // already confirmed: the restore below need not ask again
          if(it.variant_id) _caq.set('variant',String(it.variant_id));          // the LINE's variant is the truth for this edit
          window.__vvCAState='state';
          try{ galBeat('cc-changeart',{ok:1,via:'state',chk:ex===true?'found':'unknown'}); }catch(e){}
          /* 21-Oct-2026 alert v2 (inc_mvh9bp5w_78fw4t): this reload is OUR navigation — it cancels the launch's in-flight
             token request ("Failed to fetch" at pagehide). Mark it like every other intentional navigation (dd3f) so no
             failure beacon is sent for the page we are leaving. */
          try{ window.__vvIntentNav='change-artwork'; vvInc.mark('nav:change-artwork',{chk:ex===true?'found':'unknown'}); }catch(e){}
          location.replace(location.pathname+'?'+_caq.toString());
          });
        } else {
          window.__vvCAState=it?'no-state-on-line':'line-not-in-cart';
          try{ galBeat('cc-changeart',{ok:0,why:window.__vvCAState}); }catch(e){}
        }
      }).catch(function(){ window.__vvCAState='cart-read-failed'; });
    }
  }catch(e){}
  /* Release-hardening (2026-10-06), class 10 — COMING BACK TO THE SAME ENTRY. A refresh of the entry URL
     (F5, "reload" navigation) reopens the draft transparently; arriving at the same entry again by any other
     route offers it ("Welcome back") and lets the customer start fresh instead. Only modern entries
     (?vvcc=blank / ?vvstyle=) with a draft made from that very entry; never a resume link, never upload. */
  try{
    var _ek=vvEntryKey(), _dr=(_ek==='blank'||_ek.indexOf('style:')===0)&&!EDIT.proj?vvDraftGet():null;
    if(_dr&&_dr.stateId&&_dr.entry===_ek&&!/[?&]vvfresh=1|[?&]vvstate=/.test(location.search)){
      var _nav=''; try{ var _ne=performance.getEntriesByType('navigation')[0]; _nav=(_ne&&_ne.type)||''; }catch(e){}
      if(_nav==='reload'){ try{ galBeat('cc-draft-resume',{ok:1,why:'reload'}); }catch(e){} try{ window.__vvIntentNav='draft-resume'; vvInc.mark('nav:draft-resume',{why:'reload'}); }catch(e){} location.replace(vvDraftResumeUrl(_dr,'reload')); }
      else {
        var _wb=document.createElement('div'); _wb.id='vv-welcome-back';
        _wb.setAttribute('style','position:fixed;inset:0;z-index:2147483300;background:rgba(20,20,22,.55);display:flex;align-items:center;justify-content:center;padding:16px;font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif');
        _wb.innerHTML='<div role="dialog" aria-labelledby="vv-wb-h" style="background:#fff;border-radius:14px;max-width:440px;width:100%;padding:26px 24px;box-shadow:0 20px 60px rgba(0,0,0,.35);text-align:center">'
          +'<div style="font-size:30px" aria-hidden="true">&#128075;</div>'
          +'<h2 id="vv-wb-h" style="margin:8px 0 6px;font-size:22px;line-height:1.2;color:#1c1c1e">Welcome back</h2>'
          +'<p style="margin:0 0 18px;font-size:15px;color:#48484a;line-height:1.45">Your design has been saved. Continue designing where you left off, or start this one fresh.</p>'
          +'<div style="display:flex;gap:10px;justify-content:center;flex-wrap:wrap">'
          +'<a id="vv-wb-go" href="'+vvDraftResumeUrl(_dr,'return').replace(/"/g,'&quot;')+'" style="display:inline-block;background:#D6202B;color:#fff;text-decoration:none;font-weight:700;font-size:15px;padding:12px 20px;border-radius:999px">Continue designing</a>'
          +'<button type="button" id="vv-wb-fresh" style="background:#fff;color:#1c1c1e;border:1px solid #cfcfd6;font:inherit;font-weight:600;font-size:15px;padding:12px 20px;border-radius:999px;cursor:pointer">Start fresh</button>'
          +'</div></div>';
        (document.body||document.documentElement).appendChild(_wb);
        _wb.querySelector('#vv-wb-fresh').addEventListener('click',function(){ try{ galBeat('cc-draft-resume',{ok:1,why:'fresh'}); }catch(e){} _wb.remove(); });
        _wb.querySelector('#vv-wb-go').addEventListener('click',function(){ try{ galBeat('cc-draft-resume',{ok:1,why:'return'}); }catch(e){} try{ window.__vvIntentNav='draft-resume'; vvInc.mark('nav:draft-resume',{why:'return'}); }catch(e){} });
      }
    }
  }catch(e){}
  /* Release-hardening (2026-10-06), class 10 — RESTORE THE SAVED STATE OVER THE ENTRY'S DESIGN (?vvstate=).
     MEASURED: Customer's Canvas keeps every pushed canvas as a server-side STATE (ed.saveProduct() → stateId) and
     the wizard's design-editor widget reopens one natively with restoreWidgetFromData({stateId}, true) — 0.5 s,
     same device / same CC user (states are per user: another user gets "state file cannot be found"). This is the
     vendor's own persistence; saved PROJECTS are not usable for this (payload decode broken since 11-Sep, see the
     restore path below). The studio opens exactly as the entry says (right product, variant, template / blank),
     and once that pick has landed the saved canvas is put back over it. */
  var VVSTATE=''; try{ var _sq=new URLSearchParams(location.search); VVSTATE=/^[0-9a-f\-]{20,60}$/i.test(_sq.get('vvstate')||'')?_sq.get('vvstate'):''; }catch(e){}
  if(VVSTATE){ (function(){
    var done=false, lastSid='', stable=0, t0=Date.now(), why='', edAt=0;
    try{ why=new URLSearchParams(location.search).get('vvresume')||''; }catch(e){}
    /* 20-Oct: confirm the state still exists BEFORE it is handed to the editor (see vvStateExists). Asked now, in
       parallel with the studio starting, so it costs nothing on the happy path. vvok=1: Change artwork already asked. */
    var _vx='pending';
    try{ var _vq=new URLSearchParams(location.search), _vu=_vq.get('vvuser')||'';
      if(_vq.get('vvok')==='1') _vx=true;
      else { if(!/^[A-Za-z0-9_\-]{3,80}$/.test(_vu)){ try{ _vu=guestId(); }catch(e){ _vu=''; } }
        if(_vu) vvStateExists(VVSTATE,_vu,why||'resume').then(function(v){ _vx=v; }); else _vx=null; }
    }catch(e){ _vx=null; }
    function vvMissingNoLoad(){   // the state is gone: never load it (that is what disposed the editor)
      done=true; clearInterval(iv);
      try{ galBeat('cc-state-restore',{ok:0,why:'state-missing:'+String(why).slice(0,30)}); }catch(e){}
      if(EDIT.line){ vvLineStateMissing('restore'); return; }
      vvDraftQuarantine(VVSTATE,'not-found');
      try{ var q3=new URLSearchParams(location.search); ['vvstate','vvuser','vvresume','vvok'].forEach(function(x){ q3.delete(x); }); history.replaceState(history.state,'',location.pathname+'?'+q3.toString()+location.hash); }catch(e2){}
      try{ browseWait(false); }catch(e){}
      try{ prepMark('state-restore:missing'); }catch(e){}
      editNotice('We couldn’t find this saved design, so we’ve opened the design you started from. You can carry on from here, or contact us on 1300 721 614 if you need the earlier version.');
    }
    function finish(ok,detail){
      done=true; clearInterval(iv);
      try{ browseWait(false); }catch(e){}
      try{ galBeat('cc-state-restore',{ok:ok?1:0,why:String(detail||why).slice(0,60)}); }catch(e){}
      try{ prepMark('state-restore:'+(ok?'ok':'fail')); }catch(e){}
      if(!ok && EDIT.line){   // rc4.2.9: a failed restore inside a LINE edit must never let a starter design replace the line's artwork
        EDIT.failed=true; try{ editGuard(); }catch(e){}
        editNotice('We couldn\u2019t reopen this design just now. The artwork on your cart line is unchanged \u2014 nothing here will replace it.');
      }
      else if(!ok) editNotice('We couldn\u2019t reopen your saved changes just now, so this is the design you started from. Your saved version is still kept — reload to try again.');
      else { try{ aut.dirty=false; }catch(e){} }
    }
    var iv=setInterval(function(){
      if(done)return;
      var ed=deepFind('au-widget-design-editor'); var sid=ed&&ed.stateId;
      if(sid&&!edAt) edAt=Date.now();
      if((edAt&&Date.now()-edAt>90000)||Date.now()-t0>480000){ finish(false,'timeout'); return; }   // rc4.2.9: from editor-ready, not page start
      if(!sid){ stable=0; return; }
      if(modal.hasAttribute('hidden')){ stable=0; return; }
      if(Date.now()-t0>4000 && !browseWaitOn()) { try{ browseWait(true,'Welcome back — reopening your design where you left off…'); }catch(e){} }
      /* the entry's own pick must have landed first (its design is on the canvas), then the state holds still */
      var picked=null; try{ picked=browse&&browse.pickedId; }catch(e){}
      var now=null; try{ now=edDesignId(ed); }catch(e){}
      if(browse.pendingPick||(picked&&now&&String(picked)!==String(now))){ stable=0; return; }
      if(sid!==lastSid){ lastSid=sid; stable=0; return; }
      if(++stable<2) return;
      if(_vx==='pending') return;                 // existence check still out (it answers within 7 s, null on any doubt)
      if(_vx===false){ vvMissingNoLoad(); return; }
      done=true; var _vvPrev=String(sid||'');
      /* 20-Oct: `done` is set before the call, so the 90-s watchdog above can no longer fire; a restore that never
         settles (CC 7.4.4 on a missing/foreign state) used to hang the studio for good. Give it its own deadline. */
      Promise.race([Promise.resolve(ed.restoreWidgetFromData({stateId:VVSTATE},true)),
                    new Promise(function(_,rej){ setTimeout(function(){ rej(new Error('restore-timeout')); },60000); })])
        .then(function(){ var ok=String(ed.stateId)===String(VVSTATE); if(!ok){ done=false; finish(false,'state-mismatch'); return; }
          var _force=false; try{ _force=new URLSearchParams(location.search).get('vvforce')==='1'; }catch(e){}
          if(_force){ done=false; finish(true,'force'); return; }   // the customer chose "open it anyway": no validation
          return vvSurfProbe(ed).then(function(r){
            /* dd3n: a restored draft must also be the size being bought (registry); wrong size = quarantine + the entry's design back */
            if(r.ok===true&&r.sf){ var _ge=null; try{ _ge=vvGeomExpect(); }catch(e){}
              if(_ge&&vvGeomVerdict(r.sf,_ge)==='mismatch'){ var _qr=vvDraftQuarantine(VVSTATE,'wrong-size:'+vvGeomMm(r.sf));
                try{ var q2=new URLSearchParams(location.search); ['vvstate','vvuser','vvresume'].forEach(function(x){ q2.delete(x); }); history.replaceState(history.state,'',location.pathname+'?'+q2.toString()+location.hash); }catch(e){}
                return vvRestorePrev((_vvPrev&&_vvPrev!==String(VVSTATE))?ed:null,_vvPrev,'refused').then(function(){
                  done=false; finish(false,'restored-wrong-size');
                  if(!EDIT.line) vvNoticeLink('Your earlier save was a different size from the one selected, so we\u2019ve opened the design you started from.','Open the earlier save anyway',_qr?vvDraftResumeUrl(_qr,'force')+'&vvforce=1':''); }); } }
            if(r.ok!==false){ done=false; finish(true,why); return; }
            /* dd3l: the saved state has no printable surface — discard it, put the entry's design back */
            try{ vvInc.mark('draft:restored-empty',{sid:String(VVSTATE).slice(0,8),surf:r.surf}); }catch(e){}
            var _qe=vvDraftQuarantine(VVSTATE,'empty:'+String(r.surf||''));   // dd3n: kept (recoverable) instead of deleted
            try{ var q=new URLSearchParams(location.search); ['vvstate','vvuser','vvresume'].forEach(function(x){ q.delete(x); }); history.replaceState(history.state,'',location.pathname+'?'+q.toString()+location.hash); }catch(e){}
            return vvRestorePrev((_vvPrev&&_vvPrev!==String(VVSTATE))?ed:null,_vvPrev,'refused').then(function(){
              done=false; finish(false,'restored-empty');
              if(!EDIT.line) vvNoticeLink('Your last visit ended before your design finished loading, so there were no saved changes to reopen. This is the design you started from.','Open the earlier save anyway',_qe?vvDraftResumeUrl(_qe,'force')+'&vvforce=1':'');
            });
          });
        })
        .catch(function(e){ var m=String(e&&e.message||e), _nf=/not.?found|cannot be found|does not exist|\b404\b/i.test(m);
          /* 20-Oct: on a cart line a state CC says is gone goes back to the cart (which explains it and offers "create it
             again"); a restore that timed out is asked about once more before it is called transient. */
          if(EDIT.line && _nf){ vvLineStateMissing('restore-threw'); return; }
          if(EDIT.line && m==='restore-timeout'){
            var _ou=''; try{ _ou=new URLSearchParams(location.search).get('vvuser')||guestId(); }catch(_e){}
            vvStateExists(VVSTATE,_ou,'restore-timeout').then(function(v){ if(v===false){ vvLineStateMissing('restore-timeout'); return; }
              done=false; finish(false,'restore-timeout'); });
            return; }
          /* dd3n: a state CC says does not exist can never open — quarantine it (any other error = transient, the draft is kept), and in
             both cases put the entry's own design back: a failed restore can leave the editor without a product (draft-matrix 'corrupt') */
          var _qn=_nf?vvDraftQuarantine(VVSTATE,'not-found'):null;
          if(_nf){ try{ var q3=new URLSearchParams(location.search); ['vvstate','vvuser','vvresume'].forEach(function(x){ q3.delete(x); }); history.replaceState(history.state,'',location.pathname+'?'+q3.toString()+location.hash); }catch(e2){} }
          var _ed=deepFind('au-widget-design-editor');
          vvRestorePrev((_ed&&_vvPrev&&_vvPrev!==String(VVSTATE))?_ed:null,_vvPrev,_nf?'not-found':'threw').then(function(){
            done=false; finish(false,'threw:'+m.slice(0,40));
            if(_nf&&!EDIT.line) vvNoticeLink('Your earlier save could not be found, so we\u2019ve opened the design you started from.','Try the earlier save again',_qn?vvDraftResumeUrl(_qn,'force')+'&vvforce=1':''); }); });
    },1500);
  })(); }
  /* dd3o: putting the entry's design back after a refused / failed draft restore must never hang or leave a disposed editor */
  function vvEditorAlive(){ return new Promise(function(res){ try{ var ed=deepFind('au-widget-design-editor'); if(!ed) return res(false);
      var to=setTimeout(function(){ res(false); },5000);
      Promise.resolve(ed.customersCanvasPromise).then(function(cc){ return cc.getProduct(); })
        .then(function(p){ clearTimeout(to); res(!!(p&&p.surfaces&&p.surfaces.length&&p.surfaces[0].width>0)); })
        .catch(function(){ clearTimeout(to); res(false); });
    }catch(e){ res(false); } }); }
  function vvRestorePrev(ed,prev,site){ var t0=Date.now();
    var restore=Promise.resolve(ed&&prev?ed.restoreWidgetFromData({stateId:prev},true):null).then(function(){ return 'done'; },function(){ return 'err'; });
    var timeout=new Promise(function(r){ setTimeout(function(){ r('timeout'); },12000); });
    return Promise.race([restore,timeout]).then(function(r){ if(r==='timeout') return {ok:false,why:'timeout'};
        return vvEditorAlive().then(function(a){ return {ok:a,why:a?r:'dead'}; }); })
      .then(function(rp){ try{ vvInc.mark('draft:prev-restore',{site:site,res:rp.why,ok:rp.ok,ms:Date.now()-t0}); }catch(e){}
        window.__vvPrevDead=!rp.ok; if(!rp.ok&&EDIT.line) setTimeout(function(){ vvReloadWithNotice('','','',site); },0); return rp; }); }
  function vvReloadWithNotice(msg,label,href,why){ var n=0; try{ n=+(sessionStorage.getItem('vvPrevReload')||0); }catch(e){}
    if(n>=1){ try{ vvInc.mark('draft:prev-reload-skip',{why:why}); }catch(e){} return false; }
    try{ sessionStorage.setItem('vvPrevReload',String(n+1)); sessionStorage.setItem('vvPendingNotice',JSON.stringify({m:msg||'',l:label||'',h:href||'',at:Date.now()})); }catch(e){ return false; }
    try{ vvInc.mark('draft:prev-reload',{why:why}); }catch(e){}
    try{ var u=new URL(location.href); ['vvstate','vvuser','vvresume','vvforce'].forEach(function(x){ u.searchParams.delete(x); }); u.searchParams.set('vvcc','1'); location.replace(u.toString()); }
    catch(e){ location.reload(); }
    return true; }
  (function(){ var pn=null; try{ pn=JSON.parse(sessionStorage.getItem('vvPendingNotice')||'null'); }catch(e){}
    if(!pn){ try{ sessionStorage.removeItem('vvPrevReload'); }catch(e){} return; }
    if(Date.now()-(+pn.at||0)>180000){ try{ sessionStorage.removeItem('vvPendingNotice'); sessionStorage.removeItem('vvPrevReload'); }catch(e){} return; }
    var tries=0; (function wait(){ tries++; var f=document.getElementById('vvcc-finish');
      if(f&&!(f.disabled||f.hasAttribute('disabled'))&&/finished/i.test(f.textContent||'')){
        try{ sessionStorage.removeItem('vvPendingNotice'); }catch(e){} try{ vvInc.mark('draft:prev-notice-shown',{}); }catch(e){}
        if(pn.m){ try{ vvNoticeLink(pn.m,pn.l,pn.h); }catch(e){} } return; }
      if(tries<150) setTimeout(wait,1000); })(); })();
  var VV_DRAFTQ_KEY='vv_drafts_q';
  function vvDraftQuarantine(stateId,reason){ try{ var o=vvDraftsRead(), k=vvDraftKey(), rec=o[k]; if(!rec||String(rec.stateId)!==String(stateId)) return null;
      var q={}; try{ q=JSON.parse(localStorage.getItem(VV_DRAFTQ_KEY)||'{}')||{}; }catch(e){ q={}; }
      var a=(q[k]||[]).filter(function(x){ return x&&x.qAt>Date.now()-30*864e5; }); a.push(Object.assign({},rec,{qWhy:reason,qAt:Date.now()})); q[k]=a.slice(-5);
      localStorage.setItem(VV_DRAFTQ_KEY,JSON.stringify(q)); delete o[k]; vvDraftsWrite(o);
      try{ vvInc.mark('draft:quarantined',{why:reason,sid:String(stateId).slice(0,8)}); }catch(e){} return rec; }catch(e){ return null; } }
  function vvNoticeLink(msg,label,href){ if(window.__vvPrevDead){ window.__vvPrevDead=false; if(vvReloadWithNotice(msg,label,href,'notice')) return; } editNotice(msg); try{ var n=document.getElementById('vvEditNotice'); if(!n||!href) return;
      var a=document.createElement('a'); a.href=href; a.textContent=label; a.style.cssText='margin-left:10px;color:inherit;text-decoration:underline'; n.insertBefore(a,n.lastChild); }catch(e){} }
  function vvDraftPutSafe(stateId,guid){ try{ var cur=vvDraftGet(), sid=String(stateId);
      var own=cur&&(String(cur.stateId)===String(aut.ownSid||'')||String(cur.stateId)===String(VVSTATE||'')||String(cur.stateId)===sid);
      if(cur&&cur.stateId&&!own&&!_ccEdited){ if(aut.keptTold!==String(cur.stateId)){ aut.keptTold=String(cur.stateId); try{ vvInc.mark('autosave:pointer-kept',{why:'no-edit-in-this-tab',kept:String(cur.stateId).slice(0,8)}); }catch(e){} } return; }
      if(cur&&cur.stateId&&String(cur.stateId)!==sid){ try{ var h={}; try{ h=JSON.parse(localStorage.getItem('vv_drafts_hist')||'{}')||{}; }catch(e){ h={}; } var k=vvDraftKey();
          var a=(h[k]||[]).filter(function(x){ return x&&x.at>Date.now()-30*864e5&&String(x.stateId)!==String(cur.stateId); }); a.push(cur); h[k]=a.slice(-3); localStorage.setItem('vv_drafts_hist',JSON.stringify(h)); }catch(e){} }
      vvDraftPut(stateId,guid); aut.ownSid=sid; }catch(e){ try{ vvDraftPut(stateId,guid); }catch(_){ } } }
  function vvSurfProbe(ed){ var t0=Date.now(); return new Promise(function(res){ (function go(){
      Promise.race([Promise.resolve(ed.customersCanvasPromise).then(function(cc){ return (cc&&typeof cc.getProduct==='function')?cc.getProduct():null; }),
                    new Promise(function(r){ setTimeout(function(){ r(null); },4000); })])
        .then(function(pr){ var sf=(pr&&pr.surfaces)||[];
          if(sf.length){ var surf=sf.map(function(x){ return Math.round(x.width)+'x'+Math.round(x.height); }).join(',');
            if(sf.every(function(x){ return x&&x.width>=VV_RD_MIN_PT&&x.height>=VV_RD_MIN_PT; })) return res({ok:true,surf:surf,sf:sf});
            if(Date.now()-t0>6000) return res({ok:false,surf:surf}); }
          if(Date.now()-t0>30000) return res({ok:null,surf:''}); setTimeout(go,1500); },
        function(){ if(Date.now()-t0>30000) return res({ok:null,surf:''}); setTimeout(go,1500); }); })(); }); }
  function browseWaitOn(){ try{ var w=document.getElementById('vvbr-wait'); return !!w&&!w.hasAttribute('hidden')&&w.getBoundingClientRect().height>0; }catch(e){ return false; } }
  function editNotice(msg){
    try{
      var n=document.getElementById('vvEditNotice');
      if(!n){ n=document.createElement('div'); n.id='vvEditNotice';
        n.style.cssText='position:absolute;z-index:9;left:0;right:0;top:0;padding:10px 14px;'+
          'background:#fff4e5;border-bottom:1px solid #f0c78a;color:#6b4b16;font-size:14px;text-align:center';
        n.innerHTML='<span></span> <button type="button" style="margin-left:10px;border:0;background:transparent;'+
          'font:inherit;text-decoration:underline;cursor:pointer">Dismiss</button>';
        n.lastChild.addEventListener('click',function(){ n.remove(); });
        box.parentNode.insertBefore(n,box);
      }
      n.firstChild.textContent=msg;
    }catch(e){}
  }
  /* 11-Sep — THE OVERWRITE GUARD. THE MOST IMPORTANT THING ON THIS PAGE.

     Finishing from an edit session UPDATES the cart line it came from:
         cartWrite('/cart/change.js', {id: EDIT.line, properties: keep})
     merging the new properties over the old. That is correct when the restore
     worked. When the restore FAILED the canvas holds the blank starter, not the
     customer's design — so finishing replaces _CC_HiRes_PDF and
     vivid.artwork_uploads with a blank sign, the real artwork is gone from the
     line, and if they check out we print the blank.

     Nothing stopped that. A customer who waited out the ninety seconds, saw the
     template and pressed the big button lost their design.

     So when a restore fails on a LINE edit, the finish button stops being a
     finish button. It is not disabled — a dead control explains nothing — it
     says what happened and takes them back to the cart with their artwork
     intact. A saved-design session (no vvline) is untouched by this: there is
     no line to overwrite. */
  function editGuard(){
    if(!EDIT.line || !EDIT.failed || !finishBtn || finishBtn.__vvGuarded) return;
    finishBtn.__vvGuarded=true;
    try{ finishBtn.textContent='Back to cart \u2014 artwork unchanged'; }catch(e){}
    finishBtn.addEventListener('click',function(ev){
      ev.preventDefault(); ev.stopImmediatePropagation();
      try{ editNotice('Your original artwork is still on the cart line and is what we would '+
        'print. Nothing here has replaced it. Taking you back to the cart.'); }catch(e){}
      try{ galBeat('cc-restore',{ok:0,why:'blocked-finish',proj:EDIT.proj}); }catch(e){}
      setTimeout(function(){ try{ window.__vvNoNav=1; }catch(e){} location.href='/cart'; },900);
    },true);
  }
  /* Belt as well as braces: if anything ever reaches the cart write on a failed
     line restore by another route, refuse there too. Losing the edit is
     recoverable; losing the artwork is not. */
  function editWriteBlocked(){ return !!(EDIT.line && EDIT.failed); }

  // Restore is attempted only once the wizard is up, the editor has a state id, and feedSync has
  // READ BACK its choices (feed.ok) — otherwise the design-selector is still swapping designs
  // underneath us and fights the restore. Verified by read-back: ed.stateId must CHANGE.
  /* 11-Oct (saved-designs fix): lz-string 1.5.0 decompressFromBase64 (MIT, (c) Pieroxy) — the UIF stores a saved
     project's editor snapshot in this format. Only the decoder is needed; kept dependency-free. */
  function vvLzB64(input){
    if(input==null) return '';
    if(input==='') return null;
    var ks='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=', rev={};
    for(var q=0;q<ks.length;q++) rev[ks.charAt(q)]=q;
    var length=input.length, resetValue=32;
    var dictionary=[], enlargeIn=4, dictSize=4, numBits=3, entry='', result=[], w, c, i;
    var data={val:rev[input.charAt(0)], position:resetValue, index:1};
    function read(n){
      var bits=0, maxpower=Math.pow(2,n), power=1, resb;
      while(power!==maxpower){
        resb=data.val&data.position; data.position>>=1;
        if(data.position===0){ data.position=resetValue; data.val=rev[input.charAt(data.index++)]; }
        bits|=(resb>0?1:0)*power; power<<=1;
      }
      return bits;
    }
    for(i=0;i<3;i+=1) dictionary[i]=i;
    switch(read(2)){
      case 0: c=String.fromCharCode(read(8)); break;
      case 1: c=String.fromCharCode(read(16)); break;
      case 2: return '';
    }
    dictionary[3]=c; w=c; result.push(c);
    while(true){
      if(data.index>length) return '';
      c=read(numBits);
      switch(c){
        case 0: dictionary[dictSize++]=String.fromCharCode(read(8)); c=dictSize-1; enlargeIn--; break;
        case 1: dictionary[dictSize++]=String.fromCharCode(read(16)); c=dictSize-1; enlargeIn--; break;
        case 2: return result.join('');
      }
      if(enlargeIn===0){ enlargeIn=Math.pow(2,numBits); numBits++; }
      if(dictionary[c]){ entry=dictionary[c]; }
      else { if(c===dictSize){ entry=w+w.charAt(0); } else { return null; } }
      result.push(entry);
      dictionary[dictSize++]=w+entry.charAt(0);
      enlargeIn--; w=entry;
      if(enlargeIn===0){ enlargeIn=Math.pow(2,numBits); numBits++; }
    }
  }

  function restoreSync(){
    if(!EDIT.proj||EDIT.done||EDIT.failed) return;
    var wiz=deepFind('au-wizard'), ed=deepFind('au-widget-design-editor');
    var mgr=wiz&&wiz.savedProjectsManager;
    if(!mgr||!ed||!ed.stateId) return;
    if(!feed.ok && feedChoices()) return;              // let the feed settle first
    if(EDIT.inflight) return;                          // one load at a time — see RESTORE_MS
    EDIT.tries++; EDIT.inflight=true; EDIT.base=ed.stateId; EDIT.t0=Date.now();
    /* The customer used to watch a template gallery for nine seconds and then be
       told their artwork was gone. Say what is happening instead. */
    editNotice('Reloading your saved artwork\u2026 this can take up to a minute on a large design.');

    var settled=false, stable=0, poll=null;
    function settle(ok,why){
      if(settled) return; settled=true; EDIT.inflight=false;
      if(poll){ clearInterval(poll); poll=null; }
      if(ok){
        EDIT.done=true;
        try{ var n=document.getElementById('vvEditNotice'); if(n) n.remove(); }catch(e){}
        try{console.log('[vivid-cc] artwork restored',EDIT.proj,'in',Math.round((Date.now()-EDIT.t0)/1000)+'s');}catch(e){}
      }else{
        EDIT.failed=true;
        /* 11-Sep — SAY WHICH FAILURE IT IS, AND STOP THE CANVAS BEING MISTAKEN
           FOR THEIR DESIGN. The old copy said "you're starting from the
           templates for this size", which reads like an invitation to carry on
           designing. On a cart line that is the worst possible advice: finishing
           from here UPDATES the line and overwrites the real print file with the
           blank template. See editGuard below. */
        /* 11-Oct (staging): the cart wording is only true for a CART-LINE edit. A saved design reopened from
           "Saved designs" has no cart line, so it gets its own, accurate wording. */
        var msg, _line=!!(EDIT.line&&!EDIT.saved), _w=String(why);
        if(_line){
          if(why==='not-listed'){
            msg='We can\u2019t find your saved artwork for this browser. If you designed it '+
                'while signed in, sign in and open the link again. Your cart line and its '+
                'print file are unchanged \u2014 you can still check out.';
          }else if(_w.indexOf('payload:')===0){
            msg='We can\u2019t reload your saved artwork right now \u2014 this is a fault at our '+
                'end, not yours. Your cart line and its print file are unchanged, so your order '+
                'is safe. Please go back to the cart rather than designing here.';
          }else{
            msg='We couldn\u2019t reload your saved artwork. Your cart line and its print file '+
                'are unchanged, so your order is safe. Please go back to the cart rather than '+
                'designing here.';
          }
        }else if(why==='not-listed'){
          msg='We can\u2019t find this saved design in this browser. Designs saved without signing in '+
              'stay on the device they were saved on \u2014 if you saved it while signed in, sign in '+
              'and open it again. You\u2019re looking at the design you started from.';
        }else if(_w==='payload:wrong-size'){
          msg='This saved design was made for a different size, so we\u2019ve opened the design for the '+
              'size you chose. Your saved design is still kept.';
        }else if(_w==='payload:other-product'){
          msg='This saved design belongs to a different product, so it can\u2019t be opened here. '+
              'Your saved design is still kept.';
        }else{
          msg='We couldn\u2019t reopen this saved design just now \u2014 this is a fault at our end, not yours. '+
              'Your saved design is still kept; please reload to try again. You\u2019re looking at the '+
              'design you started from.';
        }
        editNotice(msg);
        try{ editGuard(); }catch(e){}
        try{console.warn('[vivid-cc] restore failed',why,EDIT.proj,Math.round((Date.now()-EDIT.t0)/1000)+'s');}catch(e){}
        try{ galBeat('cc-restore',{ok:0,why:String(why).slice(0,60),proj:EDIT.proj}); }catch(e){}
      }
    }
    /* READ-BACK is still the truth — the promise stays pending well past the point
       where the artwork is visibly on the canvas, so it cannot be the signal. But a
       remount also changes the state id, and a false 'restored' shows the customer
       somebody else's starter template while telling them it is theirs. So the new
       id has to hold still for two consecutive samples before we believe it. */
    poll=setInterval(function(){
      try{
        var e2=deepFind('au-widget-design-editor');
        var sid=e2&&e2.stateId;
        if(EDIT.verifying){ stable=0; }                       // 11-Oct: not while the restored state is being size-checked
        else if(sid && sid!==EDIT.base){ if(++stable>=2) settle(true,'read-back'); }
        else stable=0;
        if(!settled && Date.now()-EDIT.t0>RESTORE_MS) settle(false,'timeout');
      }catch(e){}
    },1000);

    /* 11-Sep — PROBE BEFORE COMMITTING TO NINETY SECONDS.

       This used to hand the GUID straight to mgr.loadProject and wait. Two
       reasons that is wrong, both measured today:

         1. mgr.loadProject(<guid string>) NEVER SETTLES. The promise stays
            pending for ever, so the only thing that ever ended the wait was our
            own 90s timeout. It wants the project OBJECT from getAllProjects().
         2. Since Aurigma changed their storage response the payload cannot be
            decoded at all — every project dies on
              Unexpected token 'o', "[object ArrayBuffer]" is not valid JSON
            (see INCIDENT-2026-09-11). Waiting ninety seconds to discover a
            failure that is knowable in one is a minute and a half of a customer
            staring at a design that is not theirs.

       So: list (36ms measured), confirm the project is there, then test that
       the payload actually decodes. Only if both hold do we hand off to the
       vendor's full restore — with the object, not the id — and keep the 90s
       read-back watch for the genuinely slow 36-second case.

       When Aurigma fix their end this needs no change: the probe starts
       succeeding and the normal path runs again. */
    (async function(){
      var svc = mgr && mgr._service;
      if(!svc || typeof svc.getAllProjects!=='function'){
        /* older SDK without the service: take the old blind path rather than
           refuse a restore that might work */
        try{ Promise.resolve(mgr.loadProject(EDIT.proj)).catch(function(){ settle(false,'threw'); }); }
        catch(e){ settle(false,'threw-sync'); }
        return;
      }
      /* 11-Oct FIX (staging) — SAVED DESIGNS RESTORE, root cause measured on the hidden QA product:
           • Customer's Canvas storage returns the saved project correctly (raw GET 200, valid JSON), and the vendor
             SDK's own svc.loadProject(<id STRING>) decodes it.
           • The 11-Sep workaround passed the project OBJECT, which builds .../private-resources/[object Object]/file
             -> 404; the vendor's 404 handler then JSON.parses the binary body, which is the misleading
             "[object ArrayBuffer] is not valid JSON" every customer has seen since.
           • The vendor's own restoreEditor(snapshot) does not complete in this studio ("editor is not ready yet").
         So: load by id string, decode the snapshot, and reopen its editor STATE with restoreWidgetFromData — the
         same supported call ?vvstate= and Change artwork (rc4.2.9) already use. The read-back poll above decides. */
      /* existence first (one listing call, ~40 ms): the vendor's getFile turns a 404 into a JSON-parse error, so
         "not found" can only be told apart from a real fault by checking the list */
      try{
        var _all=await vvWithTimeout(svc.getAllProjects(),12000), _arr=Array.isArray(_all)?_all:((_all&&_all.items)||[]);
        if(!_arr.some(function(x){ return String(x.id||x.guid||x.projectId||'')===String(EDIT.proj); })){ settle(false,'not-listed'); return; }
      }catch(e){ /* listing failed: try the load anyway */ }
      var proj=null;
      try{ proj=await vvWithTimeout(svc.loadProject(String(EDIT.proj)),20000); }
      catch(e){
        var _nf=(e&&e.status===404)||/Not Found/i.test(String(e&&e.message||''));
        settle(false,_nf?'not-listed':'payload:'+String((e&&e.message)||e).slice(0,90)); return;
      }
      var snap=null; try{ snap=JSON.parse(vvLzB64(String(proj&&proj.snapshot||''))||'null'); }catch(e){ snap=null; }
      var sid=snap&&snap.editor&&snap.editor.stateId;
      if(!sid||!/^[0-9a-f\-]{20,60}$/i.test(String(sid))){ settle(false,'payload:no-state'); return; }
      /* never put another product's artwork on this product */
      try{ var _here=String((window.__VVCC&&window.__VVCC.PRODUCT_ID)||''); if(proj.productId&&_here&&String(proj.productId)!==_here){ settle(false,'payload:other-product'); return; } }catch(e){}
      var ed2=deepFind('au-widget-design-editor');
      EDIT.verifying=true;
      try{ await Promise.resolve(ed2.restoreWidgetFromData({stateId:String(sid)},true)); }
      catch(e){ EDIT.verifying=false; settle(false,'payload:state '+String((e&&e.message)||e).slice(0,70)); return; }
      /* same size rule as ?vvstate= (dd3n): a saved design of another size is put back to the entry's design */
      try{
        var _r=await vvSurfProbe(ed2), _ge=vvGeomExpect();
        if(_r&&_r.ok===true&&_r.sf&&_ge&&vvGeomVerdict(_r.sf,_ge)==='mismatch'){
          try{ await Promise.resolve(ed2.restoreWidgetFromData({stateId:String(EDIT.base)},true)); }catch(_){ }
          EDIT.verifying=false; settle(false,'payload:wrong-size'); return;
        }
      }catch(e){}
      EDIT.verifying=false;
      try{ galBeat('cc-restore-state',{ok:1,proj:EDIT.proj}); }catch(e){}
    })();
  }

  // "Something changed" signals. The canvas is a cross-origin iframe so its events never reach
  // us — but focus moving INTO that iframe fires window blur with it as activeElement, which is
  // a reliable proxy for the customer starting to edit. Option/rail clicks bubble normally.
  var _vvTelEdited=0;   // rc4.2.6 telemetry-only edit signal
  window.addEventListener('blur',function(){ try{ if(_vvTelEdited)return; var ae=document.activeElement, d=0; while(ae&&ae.shadowRoot&&ae.shadowRoot.activeElement&&d++<20) ae=ae.shadowRoot.activeElement;
    if(ae&&ae.tagName==='IFRAME'&&box&&box.contains(document.activeElement)){ _vvTelEdited=1; galBeat('cc-edit',{ms:Date.now()-(_ccT0||Date.now())}); } }catch(e){} });
  window.addEventListener('blur',function(){
    try{ var ae=document.activeElement; if(ae&&ae.tagName==='IFRAME'&&box.contains(ae)){ autosaveDirty();
      /* rung 5, once. The first preview run fired this 22ms after canvas-open
         because it was hooked to autosaveDirty, which is also bound to
         pointerdown anywhere in the modal — including the click that opens the
         canvas. Focus entering the canvas iframe is the honest signal, and the
         rung gate stops it counting before there is a canvas to type into. */
      if(!_ccEdited&&(_ccStepRank[_ccStepBest]||0)>=_ccStepRank['canvas-open']){
        _ccEdited=1; try{ ccClarity('edited'); }catch(e){} }
    } }catch(e){}
  });
  modal.addEventListener('pointerdown',autosaveDirty,true);
  modal.addEventListener('keydown',autosaveDirty,true);

  // ---- Pre-flight wizard + progress modal (UPDATE 12) ----------------------
  // HelloPrint's "Finished designing?" opens a 4-step print-education checklist, then a progress
  // modal, then lands on the basket — it never shows an approval screen
  // (docs/customers-canvas/helloprint-finish-flow/SPEC.md). We mirror that sequence. Aurigma's
  // Approval step still does the real work (saveProduct → preview → the order widget's add), but
  // the customer never sees it: our checklist is the sign-off, and the progress modal covers the
  // machinery. Their geometry, our copy and colour — we do not reproduce a competitor's wording.
  var PF_FIG={
    edges:'<svg viewBox="0 0 325 225"><rect width="325" height="225" fill="#eef1f4"/><rect x="46" y="26" width="233" height="173" fill="#fff" stroke="#c8ccd4"/><rect x="62" y="42" width="201" height="141" fill="#d6202b" opacity=".85"/><rect x="46" y="26" width="233" height="173" fill="none" stroke="#1c1c1f" stroke-dasharray="5 4"/><text x="162" y="215" text-anchor="middle" font-family="system-ui,sans-serif" font-size="13" fill="#5a5a63">White edge = background stopped too soon</text></svg>',
    safe:'<svg viewBox="0 0 325 225"><rect width="325" height="225" fill="#eef1f4"/><rect x="46" y="20" width="233" height="165" fill="#fff" stroke="#c8ccd4"/><rect x="46" y="20" width="233" height="165" fill="#d6202b" opacity=".12"/><rect x="72" y="44" width="181" height="117" fill="#fff" stroke="#d6202b" stroke-dasharray="6 4"/><text x="162" y="108" text-anchor="middle" font-family="system-ui,sans-serif" font-size="14" font-weight="600" fill="#1c1c1f">keep text inside</text><text x="162" y="211" text-anchor="middle" font-family="system-ui,sans-serif" font-size="13" fill="#5a5a63">Tinted band = may be trimmed or wrapped</text></svg>',
    quality:'<svg viewBox="0 0 325 225"><rect width="325" height="225" fill="#eef1f4"/><rect x="26" y="30" width="126" height="140" fill="#fff" stroke="#c8ccd4"/><g>'+
      '<rect x="42" y="46" width="94" height="72" fill="#9fb4c7"/><rect x="42" y="46" width="24" height="18" fill="#7d96ab"/><rect x="90" y="64" width="30" height="26" fill="#7d96ab"/></g>'+
      '<text x="89" y="140" text-anchor="middle" font-family="system-ui,sans-serif" font-size="12" fill="#8a8a92">blurry</text>'+
      '<rect x="173" y="30" width="126" height="140" fill="#fff" stroke="#d6202b"/><rect x="189" y="46" width="94" height="72" fill="#5b7ea0"/><circle cx="212" cy="70" r="9" fill="#f2c14e"/><path d="M189 118l26-26 18 14 20-18 30 30z" fill="#3d5c78"/>'+
      '<text x="236" y="140" text-anchor="middle" font-family="system-ui,sans-serif" font-size="12" font-weight="600" fill="#1c1c1f">sharp</text>'+
      '<text x="162" y="200" text-anchor="middle" font-family="system-ui,sans-serif" font-size="13" fill="#5a5a63">Small images stretch badly at banner size</text></svg>',
    proof:'<svg viewBox="0 0 325 225"><rect width="325" height="225" fill="#eef1f4"/><rect x="40" y="30" width="245" height="150" rx="6" fill="#fff" stroke="#c8ccd4"/><text x="62" y="70" font-family="system-ui,sans-serif" font-size="17" font-weight="700" fill="#1c1c1f">Grand Openning</text><path d="M150 76 l38 0" stroke="#d6202b" stroke-width="2.5"/><text x="62" y="103" font-family="system-ui,sans-serif" font-size="14" fill="#4a4a52">Saturday 31 Feburary</text><path d="M139 109 l86 0" stroke="#d6202b" stroke-width="2.5"/><text x="62" y="134" font-family="system-ui,sans-serif" font-size="14" fill="#4a4a52">Call 1300 000 00</text><path d="M148 140 l52 0" stroke="#d6202b" stroke-width="2.5"/><text x="162" y="205" text-anchor="middle" font-family="system-ui,sans-serif" font-size="12" fill="#5a5a63">Three mistakes above. We print what you approve.</text></svg>'
  };
  // Part 2 (F1, 2026-10): the mandatory 4-screen "Let's get your print right" tutorial
  // (edges / safe / quality / proof) is removed. The trim / safe-area / finished-area guides
  // are already drawn on the live canvas throughout designing (VV_GUIDES_ON_MOUNT — see
  // safetyLines(true) on the compile tick), and production prepress still checks every file
  // before print, so dropping the three educational screens weakens no print safety. What
  // remains is ONE concise proofreading acknowledgement next to add-to-cart — a final sign-off,
  // not a wizard — still recorded to the cart line (_CC_Preflight).
  var PF_STEPS=[
    {k:'proof', h:'Give it one last read before we print',
     t:'Check spelling, phone numbers, dates and web addresses — we print exactly what you approve here. Your design is shown with its trim and safe-area guides.',
     ex:'', fig:'proof'}
  ];
  var pfEl=document.getElementById('vvcc-preflight'), pfChips=document.getElementById('vvpf-chips'),
      pfSh=document.getElementById('vvpf-sh'), pfTxt=document.getElementById('vvpf-txt'),
      pfFig=document.getElementById('vvpf-fig'), pfHelp=document.getElementById('vvpf-help'),
      pfEx=document.getElementById('vvpf-ex'), pfGo=document.getElementById('vvpf-go');
  var pf={i:0, seen:[], t0:0};

  // Step 2 asks about the trim zone. If CC can draw real safety lines on the live canvas, do that
  // (much better than an illustration). Probe once, fall back silently to the diagram.
  function safetyLines(on){
    try{
      var ed=deepFind('au-widget-design-editor');
      if(ed && typeof ed.applyViewerSettings==='function'){
        ed.applyViewerSettings({safetyLinesEnabled:!!on});
        return true;
      }
    }catch(e){ try{console.warn('[vivid-cc] safety lines unavailable',e);}catch(_){ } }
    return false;
  }
  function pfRender(){
    var s=PF_STEPS[pf.i];
    [].forEach.call(pfChips.children,function(c,n){
      if(n===pf.i)c.setAttribute('data-active','1'); else c.removeAttribute('data-active');
      if(n<pf.i)c.setAttribute('data-done','1'); else c.removeAttribute('data-done');
    });
    pfSh.textContent=s.h;
    // Part 2 (F4): on a configuration-required product (more than one Shopify variant), the
    // pre-cart sign-off NAMES the exact size + options being printed, so the variant is
    // explicitly shown and confirmed here — never silently carried from the PDP default.
    var _pfTxt=s.t;
    try{
      if(s.k==='proof' && Array.isArray(SHOPIFY_VARIANTS) && SHOPIFY_VARIANTS.length>1){
        var _vv=vvVariant();
        if(_vv && _vv.title){ _pfTxt='You’re ordering '+PRODUCT_TITLE+' — '+_vv.title.replace(/\s*-\s*SALE!?/ig,'')+'. Check the size and options are right; we print exactly this. '+_pfTxt; }
      }
    }catch(e){}
    pfTxt.textContent=_pfTxt;
    pfFig.innerHTML=PF_FIG[s.fig]||'';
    if(s.ex){ pfHelp.removeAttribute('hidden'); } else { pfHelp.setAttribute('hidden',''); }
    pfEx.textContent=s.ex||''; pfEx.removeAttribute('data-on');
    pfGo.textContent = pf.i===PF_STEPS.length-1 ? 'Looks good — add to cart' : 'Continue';
    if(pf.seen.indexOf(s.k)<0) pf.seen.push(s.k);
    // rungs 7-9. Step 1 is covered by preflight-open, so only advances count.
    if(pf.i>0){ try{ ccClarity('preflight-'+(pf.i+1)); }catch(e){} }
    safetyLines(true); // Part 2 (F1): keep the trim/safe guides ON through the sign-off (was only the 'safe' step)
  }
  function pfOpen(){
    pf.i=0; pf.seen=[]; pf.t0=Date.now();
    try{ ccClarity('preflight-open'); }catch(e){}   // rung 6: committed to finishing
    // Part 2 (F1): a single-step sign-off hides the multi-step chip rail so it reads as a final
    // acknowledgement, not a wizard. (The rail returns automatically if PF_STEPS ever grows back.)
    try{ if(pfChips) pfChips.style.display=(PF_STEPS.length>1?'':'none'); }catch(e){}
    pfRender(); pfEl.setAttribute('data-on','1');
  }
  function pfCloseOnly(){ pfEl.removeAttribute('data-on'); safetyLines(true); /* VV_GUIDES_ON_MOUNT: stay on while designing */ }
  pfEl.addEventListener('click',function(e){
    var a=e.target.closest?e.target.closest('[data-vvpf]'):null; if(!a)return;
    var k=a.getAttribute('data-vvpf');
    if(k==='close'){ pfCloseOnly(); }
    if(k==='examples'){ if(pfEx.hasAttribute('data-on'))pfEx.removeAttribute('data-on'); else pfEx.setAttribute('data-on','1'); }
  });
  pfGo.addEventListener('click',function(){
    if(pf.i < PF_STEPS.length-1){ pf.i++; pfRender(); return; }
    pfCloseOnly();
    driveFinish();
  });

  // ---- progress modal ------------------------------------------------------
  var prepEl=document.getElementById('vvcc-prep'), prepFill=document.getElementById('vvpr-fill'),
      prepQ=document.getElementById('vvpr-q'), prepLong=document.getElementById('vvpr-long');
  // How long a finish run may take before we stop pretending and hand the customer an exit.
  //  · PREP_LONG_MS  — show reassurance, keep going. A big design legitimately takes a while.
  //  · PREP_HARD_MS  — total backstop. prep.on suppresses the monitor's cover + stall rescues, so
  //    without this the modal can creep to 92% and sit there forever if a step neither resolves
  //    nor rejects. Fails LOUD into the timeout panel (which offers the upload fallback).
  //  · PREVIEW_MS    — createPreviewResource() is a nice-to-have (the cart thumbnail); it must
  //    never be able to hold the whole add-to-cart hostage.
  /* 25-Aug: PREP_HARD_MS raised 180000 -> 300000 at the owner's direction. The
     24-Aug teardrop customer lost a finished design at exactly 180s while the
     Customer's Canvas tenant was congested — six gallery preview renders in the
     four minutes before the click, render times degrading 13s -> 58s. Five
     minutes is a long stare, but it is shorter than losing the design, and the
     marks added in the onFinish handler below mean a run that still blows the
     cap now names the step that actually hung instead of guessing. */
  var PREP_LONG_MS=30000, PREP_HARD_MS=300000, PREVIEW_MS=90000;
  /* 4-Sep-2026: how long Aurigma's own "Add to cart" button gets to enable
     after we tick their approval box. Was a hard-coded 20s. Every occurrence of
     "timed out waiting for add to cart" in 21 days of alerts (4 alerts, 2
     customers, 28-Aug and 3-Sep) was an ANDROID PHONE, and every one of those
     customers tried twice and left. A phone compiling a proof of a 3m table
     cloth can legitimately need more than 20s. */
  var ADD_WAIT_MS=45000;
  var PREP_LONG_TEXT='Large designs can take a few minutes — hang tight, your work is safe.';
  // Short, attributed design aphorisms — rotated while the customer waits.
  var PREP_QUOTES=[
    '“Simplicity is the ultimate sophistication.” — Leonardo da Vinci',
    '“Good design is obvious. Great design is transparent.” — Joe Sparano',
    '“Typography is what language looks like.” — Ellen Lupton',
    '“Design creates culture. Culture shapes values.” — Robert L. Peters',
    '“White space is to be regarded as an active element.” — Jan Tschichold'
  ];
  var prep={on:false,pct:0,qi:0,qt:null,qfade:null,creep:null,cancelled:false,longT:null,hardT:null,timedOut:false};
  /* 22-Aug: per-step timings for the finish run, so a hard timeout can tell us
     WHICH step ran long instead of just "180s elapsed". The bounded steps are
     approval (45s), proof image (90s) and add-to-cart (20s) — but everything
     AFTER add.click() is Customer's Canvas generating the hi-res file, and that
     part has no deadline of ours at all. If the beacons keep showing the last
     mark as 'add-clicked', the CC-side finish is the slow step and that is what
     goes to Aurigma. */
  var prepStages=[], prepT0=0;
  /* 10-Sep: THE FINISH RESCUE (see the teardrop stall in the module docstring).
     vvFinishRun   increments once per driveFinish run.
     vvFinishTaken the run number whose finish has already been claimed — the guard that
                   makes a late CC callback a no-op instead of a second cart line.
     vvFinishHandler the onFinish body, hoisted so the rescue can invoke the very same code
                   path rather than reimplementing the finish. */
  var vvFinishRun=0, vvFinishTaken=0, vvFinishHandler=null, vvRescueT=null;
  var VV_RESCUE_MS=75000;      // how long CC gets to call onFinish before we step in
  var VV_RESCUE_GRACE_MS=150000;  // fresh hard cap once the rescue is driving the finish
  /* ==========================================================================
     CLARITY: make the design funnel visible in session recordings.

     26-Aug (owner). The portal counters tell you WHERE people drop. They cannot
     tell you WHY, and no amount of extra counters will - you have to watch what
     the person actually did. Clarity is already on every page (Shopify app
     block) but knew nothing about VividCanvas, so a recording could not be
     filtered to "opened the editor and never bought".

     Every telemetry point we already emit is now also a Clarity event and a
     Clarity tag. Tags are filterable in the Clarity dashboard, so:
       vv_cc_step = furthest step this session reached (gallery / editor /
                    finish-start / finish-ok / a failure)
       vv_cc_product = the handle, so a bad product stands out
     Filter recordings on vv_cc_step=editor and no purchase, and you are watching
     exactly the people who dropped, with their mouse movements and rage clicks.

     Deliberately fire-and-forget and fully wrapped: Clarity must never be able to
     throw into the design flow. If the tag is blocked or slow, nothing here cares.
     ========================================================================== */
  /* 31-Aug — THE DARK MIDDLE. This ladder had four rungs and the customer walks
     nine. Two were lit: opening the gallery, and clicking add-to-cart. Everything
     between — picking a design, opening the canvas, editing it, opening the
     print checklist and walking its four steps — was recorded nowhere, so the
     8.4% finish rate could say a problem existed and never where it was.
     'gallery-ready' is the old 'editor' rung under an honest name. */
  var _ccStepRank={gallery:1,'gallery-ready':2,'design-picked':3,'canvas-open':4,
                   'edited':5,'preflight-open':6,'preflight-2':7,'preflight-3':8,
                   'preflight-4':9,'finish-start':10,'finish-ok':11};
  var _ccStepBest='';
  /* State for the abandon beacon. _ccT0 starts at the first rung so 'ms' is time
     spent, not time on page. _ccFinished suppresses the beacon for anyone who
     reached add-to-cart — they did not abandon. */
  var _ccT0=0,_ccEdited=0,_ccFinished=0,_ccAbandonSent=0;
  function ccClarity(step,extra){
    /* An in-page trail of the steps this session reached, independent of Clarity.
       Two reasons. First, support: "what did this customer actually do" is
       answerable from the console on their machine without waiting for a
       recording to process. Second, it is the only honest way to TEST this -
       Clarity's real library replaces window.clarity when it loads, so a test
       that spies on that function silently stops seeing calls and reports the
       tracking broken when it is fine. Ask our own code what it did instead. */
    try{
      if(!_ccT0)_ccT0=Date.now();
      if((_ccStepRank[step]||0)>=_ccStepRank['finish-start'])_ccFinished=1;
      window.__vvCCSteps=window.__vvCCSteps||[];
      if(window.__vvCCSteps.length<60) window.__vvCCSteps.push(step+'@'+Math.round(performance.now())+'ms');
    }catch(e){}
    try{
      if(typeof window.clarity!=='function')return;
      window.clarity('event','vv_'+String(step).replace(/[^a-z0-9]+/gi,'_'));
      // keep the FURTHEST step, so the tag answers "how far did this person get"
      var r=_ccStepRank[step]||0, b=_ccStepRank[_ccStepBest]||0;
      if(r>b||/fail|error|stuck/i.test(step)){ _ccStepBest=step; window.clarity('set','vv_cc_step',String(step)); }
      try{ window.clarity('set','vv_cc_product',String((window.__VVCC&&window.__VVCC.HANDLE)||'')); }catch(e){}
      if(extra&&extra.ms!=null) window.clarity('set','vv_cc_ms',String(Math.round(extra.ms/1000))+'s');
    }catch(e){}
  }

  /* 31-Aug — WHERE THEY STOPPED. The counters could say how many people opened the
     gallery and how many finished; nothing said where the rest went. This fires
     once per session, on modal close or pagehide, carrying the furthest rung, the
     time spent, and the Clarity session id — the same join the checkout pixel uses,
     so a number can be turned into a recording of the person it counted.
     Never fires for someone who reached add-to-cart, and never for someone who only
     opened the gallery and shut it — that is browsing, not abandonment.
     'cc-abandon' is not on the portal's bump allowlist, so today it lands in the
     logs only. That is deliberate: the theme can ship without waiting on the portal. */
  function ccAbandon(why){
    try{
      if(_ccAbandonSent||_ccFinished||!_ccT0)return;
      var r=_ccStepRank[_ccStepBest]||0;
      if(r<_ccStepRank['design-picked'])return;
      _ccAbandonSent=1;
      var ck='';
      try{ ck=((document.cookie.match(/(?:^|;\s*)_clck=([^;]*)/)||[])[1]||''); }catch(e){}
      /* _clck is  <userId>^<ver>^<sessionId>^...  — the first field is the User ID
         Clarity shows on a recording, so storing just that makes the join one step:
         paste it into the Clarity user filter and watch the person this row counted.
         Split on both separators; a probe run returned '8zs8ko^2^g92^0^2434'. */
      try{ ck=decodeURIComponent(ck).split(/[|^]/)[0]; }catch(e){}
      galBeat('cc-abandon',{step:_ccStepBest,rung:r,ms:Date.now()-_ccT0,
                            why:why||'',edited:_ccEdited?1:0,clarity:ck,h:vvHealth()});
    }catch(e){}
  }
  try{ addEventListener('pagehide',function(){ ccAbandon('pagehide'); }); }catch(e){}
  /* dd3n: the customer leaves while the design is still loading — one beacon with what the page knew (the 7 silent 8-Oct pages) */
  var _vvLeftSent=false;
  try{ addEventListener('pagehide',function(){ try{ if(_vvLeftSent||_ccFinished||modal.hasAttribute('hidden')||!VV_RD.key||VV_RD.ok) return; _vvLeftSent=true;
      var ed=deepFind('au-widget-design-editor'); galBeat('cc-left-loading',{ms:Date.now()-(VV_RD.since||Date.now()),sid:String((ed&&ed.stateId)||'').slice(0,8),surf:VV_RD.surf,geom:VV_RD.geom||'',retried:VV_RD.retried?1:0,failed:VV_RD.failed?1:0,diag:vvRdDiag(ed),h:vvHealth()}); }catch(e){} },{capture:true}); }catch(e){}

  function prepMark(s){
    try{ prepStages.push(s+'@'+((Date.now()-(prepT0||Date.now()))/1000).toFixed(1)+'s'); }catch(e){}
    try{ var _fm=/^(start|onfinish-fired|onfinish-rescued|cart-write|cart-ok)/.exec(String(s)); if(_fm) galBeat('cc-finish',{stage:_fm[1],detail:String(s).slice(0,40),ms:Date.now()-(prepT0||Date.now())}); }catch(e){}   // rc4.2.6
    /* The finish run's own stage marks double as Clarity events, so the last
       thing a stalled session did is visible in the recording timeline. */
    try{ if(/^(start|onfinish-fired|artwork-post|cart-write|cart-ok|finish-error|hard-timeout)/.test(s)) ccClarity(s==='start'?'finish-start':s); }catch(e){}
  }
  function prepQuote(){
    if(!prep.on)return;                       // never write into a stopped modal
    if(prep.qfade){clearTimeout(prep.qfade);prep.qfade=null;}
    prepQ.style.opacity='0';
    prep.qfade=setTimeout(function(){
      prep.qfade=null;
      if(!prep.on)return;
      prepQ.textContent=PREP_QUOTES[prep.qi%PREP_QUOTES.length]; prep.qi++; prepQ.style.opacity='1';
    },350);
  }
  // The bar is driven off REAL milestones (prepTo). Between them it creeps slowly toward the next
  // one so it never looks frozen — it is eased, not fabricated, and it never reaches 100 early.
  function prepTo(p){ prep.pct=Math.max(prep.pct,Math.min(p,100)); prepFill.style.width=prep.pct+'%'; }
  // IDEMPOTENT. The first cut overwrote prep.qt / prep.creep without clearing them, so any second
  // call (double-tap on the checklist's Go, a re-entrant driveFinish, or a repeated __vvQA.prep())
  // left the previous intervals running. Observed live on the owner's screen: the quote changed
  // 3x in 10s instead of once per 6s, out of catalogue order — and because the whole card used to
  // be one aria-live region, every one of those mutations re-announced heading AND quote, which is
  // the stacking transcript he reported. Now: already running -> no-op; otherwise always clear first.
  function prepClearTimers(){
    if(prep.qt){clearInterval(prep.qt);prep.qt=null;}
    if(prep.creep){clearInterval(prep.creep);prep.creep=null;}
    if(prep.qfade){clearTimeout(prep.qfade);prep.qfade=null;}
    if(prep.longT){clearTimeout(prep.longT);prep.longT=null;}
    if(prep.hardT){clearTimeout(prep.hardT);prep.hardT=null;}
    if(vvRescueT){clearTimeout(vvRescueT);vvRescueT=null;}   // 10-Sep: never leave a rescue armed
  }
  /* 10-Sep: this was an anonymous setTimeout body inside prepStart. It is a named function
     now for one reason: the finish rescue RE-ARMS it. A rescue that starts at 165s would
     otherwise be cut off by this timer at 180s — mid print-file render, mid cart write —
     and the customer would get the timeout panel for work that then completed behind it.
     The mark reports elapsed rather than PREP_HARD_MS, because once re-armed the constant
     is no longer what actually elapsed. */
  function prepHardTimeout(){
      prep.hardT=null;
      if(!prep.on)return;
      prep.timedOut=true; prep.cancelled=true;   // unblocks waitFor and short-circuits driveFinish
      prepStop();
      showState('timeout');                      // honest panel: upload my own artwork / try again
      /* 10-Sep: ...but "we are very busy, try again in a few minutes" is a lie when
         the session died hours ago, and following that advice cannot work. Ask CC,
         and if it does not answer, replace the panel with the truth. */
      (async function(){ try{ if(!(await vvSessionAlive())) vvShowExpired(); }catch(e){} })();
      try{console.warn('[vivid-cc] finish run exceeded '+Math.round(Date.now()-(prepT0||Date.now()))+'ms — bailed to timeout panel');}catch(e){}
      /* 22-Aug: BEACON THIS. Until now the mount path reported its failures and
         this one did not, even though BOTH show the customer the same "design
         studio is very busy" panel. The consequence was measured, not guessed:
         zero "VividCanvas failed to load" emails had ever arrived (the Postmark
         transport was verified working with a self-test the same day) while this
         panel was being hit repeatedly in testing. The failure customers actually
         reach at the last step before cart was completely invisible to us.
         prepStages carries the per-step timings, so the email says WHICH step ran
         long — approval, proof image, add-to-cart, or the unbounded CC-side
         finish after the click — instead of just "it timed out". */
      try{ beaconPhase='finish'; }catch(e){}
      try{ mountStage('finish-hard-timeout@'+Math.round(Date.now()-(prepT0||Date.now()))+'ms'); }catch(e){}
      try{ galBeat('cc-finish',{stage:'hard-timeout',ms:Date.now()-(prepT0||Date.now())}); }catch(e){}   // rc4.2.6
      try{ (prepStages||[]).forEach(function(s){ mountStage('finish:'+s); }); }catch(e){}
      try{ mountBeacon(true); }catch(e){}
      try{ beaconPhase='mount'; }catch(e){}
  }
  function prepStart(){
    if(prep.on)return;                        // single instance — never stack timers
    prepClearTimers();
    prep.on=true; prep.pct=0; prep.qi=0; prep.cancelled=false; prep.timedOut=false;
    prepStages=[]; prepT0=Date.now();          // fresh timing log for this finish run
    prepFill.style.width='0%'; prepQuote();
    prepLong.textContent=''; prepLong.removeAttribute('data-on');
    prepEl.setAttribute('data-on','1');
    prep.qt=setInterval(prepQuote,6000);
    prep.creep=setInterval(function(){ if(prep.pct<92) prepTo(prep.pct+0.7); },600);
    // 30s: still working, say so.
    prep.longT=setTimeout(function(){
      prep.longT=null;
      if(!prep.on)return;
      prepLong.textContent=PREP_LONG_TEXT; prepLong.setAttribute('data-on','1');
    },PREP_LONG_MS);
    // 3 min: stop creeping at 92% forever. prep.on suppresses the monitor's rescues, so this is
    // the ONLY backstop for a step that neither resolves nor rejects. Flag it before stopping so
    // driveFinish's own catch/finally can't overwrite the panel with a second, softer message.
    prep.hardT=setTimeout(prepHardTimeout,PREP_HARD_MS);
  }
  function prepStop(){
    prep.on=false;
    prepClearTimers();
    prepEl.removeAttribute('data-on');
  }
  prepEl.addEventListener('click',function(e){
    var a=e.target.closest?e.target.closest('[data-vvpr]'):null; if(!a)return;
    prep.cancelled=true; prepStop();   // escape hatch — back to the live editor, nothing added
  });

  // ---- driving Aurigma's Approval step behind the progress modal -----------
  function ccAddButton(){ // the order widget's "Add to cart" — NOT the PDP's own buttons
    var hit=null, seen=new Set();
    (function scan(root,d){ if(!root||d>13||hit)return; var els=root.querySelectorAll?root.querySelectorAll('*'):[];
      for(var i=0;i<els.length;i++){var e=els[i]; if(seen.has(e))continue; seen.add(e);
        var tn=e.tagName;
        if((tn==='PAPER-BUTTON'||tn==='BUTTON')&&/add to cart/i.test(e.textContent||'')){hit=e;return;}
        if(e.shadowRoot)scan(e.shadowRoot,d+1); if(hit)return;}
    })(box,0);   // scoped to OUR editor container, so PDP buttons can never match
    return hit;
  }
  function ccApproveBox(){
    var hit=null, seen=new Set();
    (function scan(root,d){ if(!root||d>13||hit)return; var els=root.querySelectorAll?root.querySelectorAll('*'):[];
      for(var i=0;i<els.length;i++){var e=els[i]; if(seen.has(e))continue; seen.add(e);
        if(e.tagName==='PAPER-CHECKBOX'){hit=e;return;}
        if(e.shadowRoot)scan(e.shadowRoot,d+1); if(hit)return;}
    })(box,0);
    return hit;
  }
  function waitFor(fn,ms,label){
    var t0=Date.now();
    return new Promise(function(res,rej){
      (function tick(){
        if(prep.cancelled)return rej(new Error('cancelled'));
        var v; try{ v=fn(); }catch(e){ v=null; }
        if(v)return res(v);
        if(Date.now()-t0>ms)return rej(new Error('timed out waiting for '+(label||'element')));
        setTimeout(tick,300);
      })();
    });
  }
  window.__vvPreflight=''; window.__vvPreviewUrl='';
  /* 10-Sep — COMPLETE A FINISH THAT CUSTOMER'S CANVAS ABANDONED.
     Armed at add-clicked. Everything past that click is CC's: save the project, render the
     hi-res, call onFinish. When onFinish never comes (twice on 10 Sep, teardrop; once on
     24 Aug) the customer loses the lot at the last step with their artwork sitting intact on
     Aurigma's servers. We do not need CC to hand us anything: `uid` is ours and `ed.stateId`
     is the state the approved proof was compiled from, which is all POST /api/cc-artwork
     takes. So run the same finish body on a synthesised r. */
  function vvArmFinishRescue(run){
    try{ if(vvRescueT){clearTimeout(vvRescueT);vvRescueT=null;} }catch(e){}
    vvRescueT=setTimeout(function(){
      vvRescueT=null;
      (async function(){
        try{
          if(!prep.on||prep.cancelled||prep.timedOut)return;   // customer left, or the cap already fired
          if(run!==vvFinishRun)return;                         // a newer finish run owns the modal
          if(vvFinishTaken===run)return;                       // CC's callback got there first
          if(typeof vvFinishHandler!=='function')return;
          var ed=null; try{ ed=deepFind('au-widget-design-editor'); }catch(e){}
          var sid=''; try{ sid=String((ed&&ed.stateId)||''); }catch(e){}
          if(!sid){ prepMark('finish-rescue-nostate'); return; }  // rather the honest timeout than a guess
          prepMark('finish-rescue-armed');
          try{console.warn('[vivid-cc] onFinish never fired after '+VV_RESCUE_MS+'ms — finishing from editor state '+sid);}catch(e){}
          /* Re-arm the hard cap: a print render has its own 28s sync budget and being cut off
             half way through is the failure we are here to remove. */
          try{ if(prep.hardT)clearTimeout(prep.hardT); prep.hardT=setTimeout(prepHardTimeout,VV_RESCUE_GRACE_MS); }catch(e){}
          await vvFinishHandler(null,{line_items:[{stateId:sid}]},true);
        }catch(e){ try{console.warn('[vivid-cc] finish rescue failed',e);}catch(_){ } }
      })();
    },VV_RESCUE_MS);
  }

  var driving=false;
  async function driveFinish(){
    if(driving)return;          // re-entrancy guard: one finish run at a time
    driving=true;
    vvFinishRun++;              // 10-Sep: this run's claim token (see vvArmFinishRescue)
    prepStart();
    // Record the sign-off BEFORE anything can fail, so the audit trail reflects what the customer
    // actually did. This replaces the Aurigma approval checkbox as our sign-off artifact.
    window.__vvPreflight='completed '+pf.seen.length+'/'+PF_STEPS.length+' '+new Date().toISOString()
      +' ('+Math.round((Date.now()-pf.t0)/1000)+'s)';
    try{
      prepTo(12); prepMark('start');
      /* 10-Sep: on a tab that has been open long enough for CC to have closed the
         session, ASK before spending five minutes finding out. A second here, or
         five minutes and the customer's work. */
      if(vvEditorAt && (Date.now()-vvEditorAt)>VV_STALE_MS){
        prepMark('session-check');
        if(!(await vvSessionAlive())){ vvShowExpired(); return; }
      }
      if(!finishBtn.__vvGuarded){   // rc4.2.8: readiness re-check (closes the click -> drive race)
        prepMark('ready-check'); var _rd0=Date.now(), _rdOk=false;
        try{ await waitFor(function(){ return vvDesignReady(); },15000,'design ready'); _rdOk=true; }catch(e){ if(prep.cancelled)return; }
        if(!_rdOk&&VV_RD.geom==='mismatch'){ prepMark('ready-fail:geom'); var _gv0=await vvGeomFinal(vid()); vvGeomBlock(_gv0.v==='match'?{v:'unstable',mm:_gv0.mm,exp:_gv0.exp,vid:_gv0.vid}:_gv0,'finish-ready'); return; }
        if(!_rdOk){ prepMark('ready-fail'); vvRdTell('drive-ready-fail',{surf:VV_RD.surf}); prep.cancelled=true; prepStop();
          showState('error','Your design hasn\u2019t finished loading, so we haven\u2019t let it be finished \u2014 nothing has been added to your cart. Tap Try again; your product and design are kept.','Your design is still loading');
          return; }
        prepMark('ready-ok@'+(Date.now()-_rd0)+'ms');
      }
      /* dd3n: runs on EVERY finish (also when the click handler already checked readiness) */
      var _gv=await vvGeomFinal(vid()); if(prep.cancelled)return;
      if(_gv.v==='mismatch'||_gv.v==='unstable'){ prepMark('geom-fail:'+_gv.v); vvGeomBlock(_gv,'finish'); return; }
      prepMark('geom-'+_gv.v);
      var nx=nativeNext();
      if(nx && !nx.disabled && !nx.hasAttribute('disabled')) nx.click();  // -> Aurigma Approval step
      var cb=await waitFor(ccApproveBox,45000,'approval step');
      if(prep.cancelled)return;
      prepTo(30); prepMark('approval-up');
      // ---- UPDATE 14: the mockup dependency is GONE; the proof image is the thumbnail --------
      // THE 92% STALL, finally resolved at the root. UPDATE 13 fixed the missing Approval
      // onActivate by compiling the preview-mockup-slider ourselves — but that only exposed the
      // real problem: **products 394 and 522 have no mockup** (the design variant's
      // resourcePreview.mockupId is null), so createPreviewResource() throws
      // "Cannot read properties of undefined (reading 'data')" every single time. No cart
      // thumbnail, and Add to cart could settle back to disabled.
      // Checked the tenant for a mockup we could attach: there are exactly SIX, all Aurigma's
      // stock BUSINESS-CARD samples (3.5x2in, 2.5x2.5in, 2x3.5in). Putting a business-card mockup
      // behind a 2100mm teardrop flag would be worse than no thumbnail, and authoring a real
      // banner mockup is photography + a PSD smart object, i.e. design work, not config.
      // So the mockup path is abandoned on both sides:
      //   · BackOffice: workflow 74 no longer calls the slider at all —
      //     `$['preview-slider'].createPreviewResource()` removed from the finish widget's
      //     onClick chain (it was throwing there too, killing onFinish) and
      //     `$['preview-slider'].compile()` removed from the Approval step's onActivate.
      //     Byte-exact rollback: workflow **76** "…BACKUP pre-mockup-fix 2 Aug 2026".
      //   · here: no compile, no createPreviewResource.
      // **getProofImages() is the better source and it works now.** It "never resolved" in
      // UPDATE 13 for the same reason everything else hung — there was no compiled state. With
      // H7 fixed it returns in seconds, and the URL is anonymously fetchable exactly like the
      // mockup one was: verified live on teardrop — HTTP 200, image/jpeg, 35 KB, 374x800, loads
      // as a plain <img> with no Authorization header. It is also strictly better for a cart
      // tile: it is the customer's artwork at its own aspect ratio, with no mockup furniture.
      // Still a NICE-TO-HAVE: raced against PREVIEW_MS so a slow render can never hold the
      // finish hostage — on timeout we ship the line without a thumbnail.
      if(prep.cancelled)return;
      prepTo(45);
      try{
        var edp=deepFind('au-widget-design-editor');
        if(edp && typeof edp.getProofImages==='function'){
          var pu=await Promise.race([
            Promise.resolve(edp.getProofImages()),
            new Promise(function(res){ setTimeout(function(){ res(null); },PREVIEW_MS); })
          ]);
          if(pu===null) try{console.warn('[vivid-cc] proof image timed out after '+PREVIEW_MS+'ms — continuing without a cart thumbnail');}catch(_){ }
          else {
            var first=Array.isArray(pu)?pu[0]:pu;
            if(typeof first==='string' && /^https?:/.test(first)) window.__vvPreviewUrl=first;
          }
        }
      }catch(e){ try{console.warn('[vivid-cc] proof image failed (non-fatal)',e);}catch(_){ } }
      if(prep.cancelled)return;
      prepTo(72); prepMark('proof-done');
      if(!cb.checked) cb.click();                       // approval is implied by the checklist
      /* 4-Sep-2026 — THE ANDROID APPROVAL STALL.
         Alert, 3 Sep 15:22 and again 15:38 UTC, Samsung/Android Chrome:
           0:editor-loaded@23.0s
           0:finish-error:finish:timed out waiting for add to cart@335.1s
         The editor was fine; the customer designed for five minutes; then
         Aurigma's Add-to-cart button never enabled inside our 20s and they lost
         the lot, twice. No render project was ever created, so this stalls
         BEFORE our portal is involved. Same shape on 28-Aug (big-head-cutout,
         also Android). Two possible causes, and the old beacon could not tell
         them apart: (a) the paper-checkbox click did not register in Aurigma's
         shadow DOM on Android Chrome, or (b) their proof compile simply takes
         longer than 20s on a phone. So: re-assert the checkbox once at 5s,
         wait ADD_WAIT_MS, and if it still fails put the checkbox state, button
         state and proof state INTO the error text so the next alert names the
         cause instead of saying "timed out". */
      var add=null, _addT0=Date.now(), _rekick=false;
      try{
        add=await waitFor(function(){
          var b=ccAddButton();
          if(b && !b.disabled && !b.hasAttribute('disabled')) return b;
          if(!_rekick && Date.now()-_addT0>5000){
            _rekick=true;
            try{ var c2=ccApproveBox();
                 if(c2 && !c2.checked){ c2.click(); prepMark('approval-reclick'); }
                 else prepMark(c2?'approval-was-checked':'approval-box-missing'); }catch(e){}
          }
          return null;
        },ADD_WAIT_MS,'add to cart');
      }catch(e){
        var _d='';
        try{ var cbx=ccApproveBox(), bt=ccAddButton();
             _d=' [cb='+(cbx?(cbx.checked?'chk':'UNCHK'):'none')
               +' btn='+(bt?((bt.disabled||bt.hasAttribute('disabled'))?'dis':'en'):'none')
               +' pf='+(window.__vvPreviewUrl?'ok':'none')+' rk='+(_rekick?'y':'n')+']'; }catch(e2){}
        prepMark('add-stall'+_d);
        throw new Error('timed out waiting for add to cart'+_d);
      }
      if(prep.cancelled)return;
      prepTo(88); prepMark('add-enabled');
      add.click();     // -> workflow onClick -> sf.onFinish -> our /cart/add.js -> /cart
      /* EVERYTHING PAST THIS POINT IS UNBOUNDED BY US. add.click() hands over to
         Customer's Canvas: save the project, generate the hi-res file, call our
         /cart/add.js, navigate to /cart. None of that carries a deadline of
         ours — the only backstop is prep.hardT at 180s total. So if a beacon's
         last mark is 'add-clicked', the slow step is CC's, not ours, and that
         is the evidence to send Aurigma. */
      prepMark('add-clicked');
      vvArmFinishRescue(vvFinishRun);   // 10-Sep: ...and if CC never calls back, finish it ourselves
    }catch(err){
      if(prep.cancelled)return;
      prepStop();
      finishFail('finish', err); showState('error','We couldn’t finish your design ('+(err&&err.message||err)+'). Nothing has been added to your cart.','We couldn’t finish your design');
    }finally{
      driving=false;   // every exit path clears the guard, including cancel and error
    }
  }

  // Monitor the load. Phases: waiting-for-wizard -> wizard-up (check empty) -> watch preloader stall.
  // Tick rate is VARIABLE (UPDATE 12): 140ms until the design is ready, then 400ms. The old flat
  // 400ms meant kickCompile could fire up to 400ms after the gallery selection resolved, on a path
  // where every 100ms is visible to the customer; once the canvas is up the tick is only doing
  // header occlusion + stall watching, which does not need to be fast.
  function startMonitor(){
    stopMonitor();
    var t0=Date.now(), wizardUp=false, preloadSince=0, settleChecks=0, coverSince=0;
    /* 21-Aug (owner's iPhone, real Safari, beacon 08:05Z): editor-loaded at
       14.8s on a slow link, then the Aurigma cover sat 30s and the old flat
       stall net declared death — on a connection where the DESIGN may simply
       still be downloading. Watch the network instead of the clock alone: a
       PerformanceObserver counts completed resource fetches; the cover is only
       "stalled" when it has been up 30s AND nothing has finished arriving for
       15s (hard cap 75s regardless). And a stall now routes through
       mountFail's bounded AUTO-RELAUNCH instead of dumping the customer
       straight onto a dead timeout panel. */
    var resAt=Date.now(), resObs=null;
    try{ resObs=new PerformanceObserver(function(l){ if(l.getEntries().length)resAt=Date.now(); });
         resObs.observe({entryTypes:['resource']}); }catch(e){}
    var stopRes=function(){ try{ if(resObs)resObs.disconnect(); }catch(e){} };
    var tick=function(){
      headerSync(); // HelloPrint-parity bar: occlude the wizard header row + mirror Next's state
      // While OUR progress modal is driving the finish (UPDATE 12) the Aurigma preloader
      // underneath is expected and already covered by the modal: suppress both the Vivid cover
      // and the stall timeouts, or they fight each other over the same wait. The prep modal has
      // its own Cancel and its own per-step waitFor timeouts.
      // NB: must RESCHEDULE, not return — this tick self-schedules at the tail.
      if(prep.on){ coverOff(); monTimer=setTimeout(tick,400); return; }
      var covering=coverSync(); // keep any Aurigma-branded preloader occluded while it is visible
      // Generic stall net: ANY visible preloader stuck 30s continuously -> honest timeout panel
      // instead of an occluded infinite spinner. (Observed live: a guest "Saving project..." hung
      // forever — that interstitial says nothing matching the 16s "Preparing Your Design" rule.)
      // Cannot false-fire on the editor's idle "Loading, please wait…": that preloader is 0x0.
      if(covering){ if(!coverSince)coverSince=Date.now();
        else { var cdur=Date.now()-coverSince, netIdle=Date.now()-resAt;
          /* 3-Sep-2026: raised in step with NO_WIZARD_MS. On a 3G link a single
             large asset can be in flight for well over 15s with no resource
             entry COMPLETING, so the old 30s/15s pair read a healthy slow
             download as a stall and relaunched into the crash above. These
             thresholds must stay above NO_WIZARD_MS or this fires first and
             the deadline change does nothing. */
          if((cdur>60000&&netIdle>30000)||cdur>120000){
            mountStage('cover-stall-'+Math.round(cdur/1000)+'s-netidle-'+Math.round(netIdle/1000)+'s');
            stopRes(); stopMonitor(); coverOff();
            mountFail('cover-stall'); return; } } }   // bounded auto-relaunch, then honest panel
      else coverSince=0;
      var elapsed=Date.now()-t0;
      var wiz=deepFind('au-wizard');
      if(wiz && !wizardUp){ wizardUp=true; guardAllOff(); mountTry.n=0; mountTry.stages.length=0; try{ if(VV_REC.capture){ VV_REC.capture.stop(); VV_REC.capture=null; } if(VV_REC.launchAt) vvRecTell('editor','wizard-up',{ms:Date.now()-VV_REC.launchAt}); }catch(e){}
        try{ mountProgress('wizard-up'); }catch(e){}   // NOW it is genuinely ready
        try{ vvInc.mark('mount:wizard-up'); }catch(e){}
        try{ var _lh=STATES.loading.querySelector('.vvcc-h'); if(_lh)_lh.textContent='Opening your design studio'; }catch(e){}
        if(STATES.loading.hasAttribute('data-on'))showState(null); } // wizard mounted: retries reset (UPDATE 32b)
      /* 3-Sep-2026 — THE 18-SECOND DEADLINE WAS KILLING MOUNTS THAT WERE WORKING.
         40 throttled runs (probe: ccprobe TIER A2, 3 Sep): unthrottled desktop
         mounted 100/100 and every profile slower than that failed — Pixel 7 on
         3G went 0/10. The wizard needs 29-78s to paint on those links, so an
         18s deadline fired mountFail on a mount that was still building, and
         mountRetry then emptied `box` underneath Aurigma's UI Framework. Their
         Web Animations shim threw "Cannot read properties of null (reading
         'cancel')" in au.editor.js on every one of those teardowns: present in
         19 of 19 failures and 0 of 21 successes. Four relaunches deep the
         customer had watched a full progress bar reading "Ready" for two
         minutes over a studio that never opened.
         Retrying was not recovering from the failure, it was CAUSING it — the
         same lesson already written at RESTORE_MS for the project-restore path
         ("One attempt, ninety seconds, no interference") and never applied
         here. 75s covers the measured 78s worst case with the slow-connection
         copy running throughout, so the wait is explained rather than silent.
         Do not lower this without re-running the throttled probe. */
      if(!wizardUp && _loadInFlight && VV_REC.launchAt && document.readyState==='complete'){
        var _poor=vvPoorNet(), _since=Date.now()-VV_REC.launchAt, _idle=Date.now()-resAt;
        if(_since>(_poor?60000:25000) && _idle>(_poor?45000:20000)){
          vvRecTell('editor','stall-relaunch',{since:_since,idle:_idle,poor:_poor,wc:!!(window.WebComponents&&window.WebComponents.ready)});
          stopMonitor(); coverOff(); _loadInFlight=false; mountRetry._stall=true; mountFail('editor-stall'); return; }
      }
      if(!wizardUp && elapsed>NO_WIZARD_MS){ stopMonitor(); coverOff(); mountFail('no-wizard-'+Math.round(NO_WIZARD_MS/1000)+'s'); return; }
      if(wizardUp){
        feedSync();    // UPDATE 21: the design FEED must follow the PDP (run before galSync)
        galSync();     // UPDATE 16: rail limited to the PDP's chosen options; opens on that canvas
        browseSync();  // UPDATE 26: browse-mode gallery mirrors the settled rail (no-op unless BROWSE_MODE)
        restoreSync(); // UPDATE 24: on an edit session, reload THIS line's artwork (after feedSync)
        hideProductOptions(); // UPDATE 20: option groups belong on the PDP, not in the rail
        hideDesignRail();     // UPDATE 30/39: gallery-entered AND edit-from-cart editors have no design rail (visual only)
        kickCompile(); // H7: run the initial step's compile chain UIF skips (and on design switch)
        safetyLines(true); // VV_GUIDES_ON_MOUNT (9.5b note 1, 4 Aug 2026): trim/safe/finished-area guides visible WHILE designing; tick re-asserts after design switches
        sizeGallery(); // HelloPrint-parity tile size (re-applied: the rail re-renders)
        try{ vvDDSettle(); }catch(e){}   // dd3
        var gc=galleryCount();
        // empty gallery (workflow-71 products with no templates). Require the zero reads to persist
        // for a real DURATION, not a tick count — the tick rate is variable now. Observed: teardrop
        // mounts the selector with variants:[] and can take several seconds to populate (it read 3
        // designs moments after a 2s-equivalent threshold wrongly fired the empty panel).
        if(gc===0&&!vvDDHolds()&&(feed.ok||!feed.want||feed.tries>=40)){ /* dd3: an empty rail is not "no designs" when the editor holds the direct row */ if(!settleChecks)settleChecks=Date.now();
          else if(Date.now()-settleChecks>10000){ showState('empty'); stopMonitor(); coverOff(); return; } }
        else if(gc>0){ settleChecks=0; }
        var pl=preloaderText(); // "Preparing Your Design" stuck > 25s -> timeout with fallback
        // 2 Aug: raised 16s -> 25s. With H7 fixed the Approval step genuinely does work
        // (saveProduct + preview render); 16s was tuned against a step that never completed.
        if(pl){ if(!preloadSince)preloadSince=Date.now(); else if(Date.now()-preloadSince>25000){ mountStage('preloader-stall-25s'); mountBeacon(true); showState('timeout'); stopMonitor(); coverOff(); return; } }
        else { preloadSince=0; }
      }
      /* 9-Sep-2026: while the customer is still BROWSING the gallery, this loop's
         deepFind() walks of the editor's shadow DOM are pure overhead on a phone
         (measured ~1s of main thread per 17s of browsing at 4x CPU slowdown). Slow it
         to 1/s until a design is picked; the mount is still watched. */
      monTimer=setTimeout(tick, modal.hasAttribute('data-browse')?1000:(ccKick.loaded?400:140));
    };
    monTimer=setTimeout(tick,0);
  }

  // ---- PERFORMANCE: warm the cold path before the customer clicks (UPDATE 12) -------------
  // Measured cold/warm launch on pull-up (owner's Chrome, resource timing) BEFORE this block:
  //   click -> StorefrontJS fetch 225ms warm / 930-1515ms cold (147KB, fetched+eval'd ON CLICK)
  //        -> get-cc-token.php 161-460ms (Cloudways)
  //        -> getIntegrationDetails 80ms
  //        -> UIF bundle: 25 files, 470ms..5058ms  <- Aurigma's, the long pole, not ours
  //        -> DESIGN READY at ~4.0s warm.
  // The first three are strictly serial and entirely avoidable: none of them need the click.
  //  1. preconnect to every origin the flow touches (DNS+TLS off the critical path);
  //  2. fetch+eval StorefrontJS on idle — no CC user is provisioned by this, it is a static file;
  //  3. mint the token + resolve integration details on the FIRST INTENT SIGNAL (hover/focus/
  //     touch on the button), not on page load — so a visitor who never intends to design never
  //     provisions a CC guest user (the cost-control rule from UPDATE 4 still holds), but anyone
  //     who is about to click has it in hand before the click lands.
  /* 26-Aug: the blob store came OUT (SDK fallback only now — see lib()) and the
     portal went IN. The portal was the one host on the critical chain we never
     preconnected, even though the token mint is the first thing prewarm does;
     vivid-buy-cards.liquid preconnects it but only on pages that render buy
     cards, so this covers everywhere else. */
  var CC_ORIGINS=['https://staticjs-aurigma.azureedge.net',
                  'https://cc-au-apps.aurigma.net','https://api.au.customerscanvashub.com',
                  'https://au.customerscanvashub.com','https://portal.vividads.com.au',
                  'https://phpstack-321644-985620.cloudwaysapps.com'];
  var _preconnected=false;
  function preconnect(){
    if(_preconnected)return; _preconnected=true;
    CC_ORIGINS.forEach(function(h){
      try{var l=document.createElement('link');l.rel='preconnect';l.href=h;l.crossOrigin='';document.head.appendChild(l);}catch(e){}
    });
  }
  // Prewarmed StorefrontJS instance + integration details, reused by runLaunch.
  // Tokens live 60 min (backend-php README) — rebuild anything older than 40 min.
  // 21-Aug: was 45, and the token() cache underneath had NO TTL, so this rebuild
  // re-embedded the same expired JWT — the mobile "invalid token". token() now
  // expires at 10 min, so a rebuilt instance holds a token aged <=10+40=50 <60.
  /* ---- DIRECT-DESIGN (staging candidate, 7-Oct-2026) — see scripts/qa/apply-directdesign.mjs header ---- */
  var VV_DD_ON=(function(){ try{ if(/[?&]vvdd=1\b/.test(location.search)){ try{ sessionStorage.setItem('vvdd','1'); }catch(e){} return true; }
    if(/[?&]vvdd=0\b/.test(location.search)){ try{ sessionStorage.removeItem('vvdd'); }catch(e){} return false; }
    return (window.__VVCC&&window.__VVCC.DIRECT_DESIGN===true)||sessionStorage.getItem('vvdd')==='1'; }catch(e){ return false; } })();
  function ddTell(r,x){ try{ vvInc.mark('dd:'+r,x||{}); }catch(e){} try{ galBeat('direct-design',Object.assign({r:r},x||{})); }catch(e){} }
  function ddFetch(url,tok,ms){ var c=('AbortController' in window)?new AbortController():null; var t=c?setTimeout(function(){ try{c.abort();}catch(e){} },ms):0;
    return fetch(url,{headers:{Authorization:'Bearer '+tok},signal:c?c.signal:undefined}).then(function(r){ clearTimeout(t); if(!r.ok) throw new Error('http '+r.status); return r.json(); })
      .catch(function(e){ try{ window.__vvDDLast={u:url,t:tok,at:Date.now(),e:String(e&&e.message||e).slice(0,60)}; }catch(_){} throw e; }); }   // dd3e: remember what failed
  async function vvDirectDesign(W){
    if(!VV_DD_ON||!W||!W.det||!W.user||!W.user.userToken) return null;
    var st=(typeof DEEP!=='undefined'&&DEEP&&DEEP.style)||'', way=st?'template':((typeof VV_ENTRY!=='undefined'&&VV_ENTRY)||'');
    if(!way){ ddTell('off-no-entry'); return null; }
    var t0=Date.now();
    try{
      var cfgObj=JSON.parse(W.det.config), c=cfgObj.config||cfgObj, pa=null;
      for(var i=0;i<(c.widgets||[]).length;i++){ if(c.widgets[i].name==='pim-ajax'){ pa=c.widgets[i]; break; } }
      if(!pa||!pa.params||!pa.params.productId){ ddTell('off-no-pim'); return null; }
      var base=HUB.replace(/\/$/,'')+'/api/storefront/v1/products/ext/'+encodeURIComponent(pa.params.productId);
      var q='?productVersionId='+encodeURIComponent(pa.params.productVersionId)+'&takeAvailableOnly=true&tenantId='+TENANT;
      var vv=vvVariant(); if(!vv){ ddTell('off-no-pdp-variant'); return null; }
      var names=PRODUCT_OPTION_NAMES.map(vnorm);
      var cvs=((await ddFetch(base+'/variants'+q,W.user.userToken,5000))||{}).items||[];
      var hits=cvs.filter(function(cv){ var o=cv.productVariantOptions||[]; return o.length&&o.every(function(x){ var k=names.indexOf(vnorm(x.productOptionTitle)); return k>=0&&vnorm(vv.options[k])===vnorm(x.productOptionValueTitle); }); });
      if(hits.length!==1&&cvs.length===1) hits=cvs;            // a CC product with ONE variant: every PDP choice maps to it
      if(hits.length!==1){ ddTell('off-cc-variant',{n:hits.length}); return null; }
      var cv=hits[0];
      var rows=((await ddFetch(base+'/variant-designs'+q+'&productVariantId='+cv.id+(st?'&search='+encodeURIComponent(st):''),W.user.userToken,6000))||{}).items||[];
      var row=null;
      if(st){
        var cand=rows.filter(function(r){ var n=r.designName||''; if(String(r.designId)===String(st)) return true; if(vvStyleSame(n,st)) return true;
          var so=null; try{ so=browseStyleOf(n); }catch(e){} if(so&&vvStyleSame(so,st)) return true; var j=n.indexOf('-'); return vvStyleTail(j<0?n:n.slice(j+1),st); });
        if(cand.length>1&&vvRailSizeKeys().length){ var sz=cand.filter(function(r){ return vvRailSizeMatch(r.designName); }); if(sz.length) cand=sz; }
        if(cand.length===1) row=cand[0]; else { ddTell('off-style-rows',{n:cand.length}); return null; }
      } else {
        var bl=rows.filter(function(r){ return browseIsBlank(r.designName||'')&&vvSideOk(r.designName||''); });
        if(bl.length>1&&vvRailSizeKeys().length){ var bz=bl.filter(function(r){ return vvRailSizeMatch(r.designName)||!vvHasSize(r.designName); }); if(bz.length) bl=bz; }
        if(bl.length===1) row=bl[0]; else { ddTell('off-blank-rows',{n:bl.length}); return null; }
      }
      if(String(row.productVariantId)!==String(cv.id)){ ddTell('off-row-variant'); return null; }
      var pr=(row.productVariantResources||[]).filter(function(x){ return x.type==='Preview'; })[0]||{};
      var dv={ id:row.productVariantId+':'+row.designId, productVariantId:row.productVariantId, productVersionId:row.productVersionId, productId:row.productId,
        sku:row.sku, designId:row.designId, designName:row.designName, designGroup:row.designGroup, options:row.productVariantOptions,
        resources:row.productVariantResources||[], previewUrl:pr.url||'', designResourceId:'', previewResourceId:pr.resourceId||'', price:null };
      c.vars=Object.assign({},c.vars||{},{vvDesign:dv});
      for(var k=0;k<(c.widgets||[]).length;k++){ if(c.widgets[k].name==='editor'&&c.widgets[k].params) c.widgets[k].params.changeDesignVariant={designVariant:'{{ vars.vvDesign }}'}; }
      var txt=JSON.stringify(cfgObj).split("$['design-selector']._").join('vars.vvDesign');
      var det2=Object.assign({},W.det,{config:txt});
      ddTell('on',{way:way,name:row.designName,cc:cv.id,ms:Date.now()-t0});
      return {det:det2,dv:dv,cv:cv,way:way};
    }catch(e){ try{ window.__vvDDErr={at:Date.now(),e:String(e&&e.message||e).slice(0,60)}; }catch(_){} ddTell('off-error',{e:String(e&&e.message||e).slice(0,60),ms:Date.now()-t0}); return null; }
  }
  /* dd3: the editor holds the direct row -> the selector feed is not needed for anything the customer does. */
  function vvDDHolds(){ try{ var d=window.__vvDD; if(!d||!d.dv) return false; var ed=deepFind('au-widget-design-editor'); return !!ed&&String(edDesignId(ed))===String(d.dv.designId); }catch(e){ return false; } }
  function vvDDSettle(){
    var d=window.__vvDD; if(!d||d.settled||!vvDDHolds()) return;
    d.settled=Date.now();
    /* dd3b (8-Oct): an Upload entry (?vvcc=upload) lives IN the browse modal (upload panel). Settling must not close it —
       closing hid #vvup-add and the customer could not add their file (lab U1, feed blocked AND normal). */
    var _upEntry=/[?&]vvcc=upload\b/.test(location.search||'');
    if(!_upEntry){ try{ browse.pickedId=d.dv.designId; browse.entered=true; browse.done=true; browseEl.removeAttribute('data-on'); modal.removeAttribute('data-browse'); if(browseQv)browseQv.setAttribute('hidden',''); }catch(e){} }
    try{ browseWait(false); }catch(e){}
    if(!_upEntry){   // dd3c: an Upload entry's splash is lifted by its opener once the panel holds — never early
    try{ var cv=document.getElementById('vv-dl-cover'); if(cv) cv.remove(); }catch(e){}
    try{ if(typeof window.__vvdeepDone==='function') window.__vvdeepDone(); }catch(e){}
    }
    ddTell('settled',{name:d.dv.designName,way:d.way});
  }
  var _pre=null, _preAt=0;
  try{window.__vvCCPreReset=function(){_pre=null;_preAt=0;};}catch(e){}
  function prewarm(){
    if(_pre && (Date.now()-_preAt)<40*60*1000) return _pre;
    _preAt=Date.now();
    _pre=(async function(){
      /* 26-Aug: prewarm has four steps that can fail and the beacon used to show
         one stage for all four — "prewarm-start" followed by an error message
         from a library, with no way to tell whether the SDK bundle, our token
         mint, or Customer's Canvas was the thing that broke. A customer on
         table-runner produced four identical "HTTP 200 OK. <!DOCTYPE html>"
         failures and answering "which request returned that?" took an hour of
         probing every host in the chain by hand. Now the stage list answers it. */
      await lib();                    mountStage('pw-sdk');
      var user=await token(guestId());mountStage('pw-token');
      var sf=new Aurigma.StorefrontJS({tenantId:TENANT,storefrontId:STOREFRONT,cchubUrl:HUB,user:user});
      mountStage('pw-sf');
      var det=await sf.getIntegrationDetails(PRODUCT_ID);
      try{ if(VV_UIF_PIN&&det&&det.uiFrameworkUrl&&det.uiFrameworkUrl!==VV_UIF_PIN){ det.vvUifFloating=det.uiFrameworkUrl; det.uiFrameworkUrl=VV_UIF_PIN; } window.__vvUIF=det&&det.uiFrameworkUrl; }catch(e){}   // 7-Oct: pin the UIF (see VV_UIF_PIN)
      mountStage('pw-integration');
      try{window.__vvCCDet=det;}catch(e){}   // testing-phase delete uses det's CC product id
      return {sf:sf,det:det,user:user};
    })();
    _pre.catch(function(){_pre=null;}); // a failed prewarm must not poison the click
    return _pre;
  }
  function armWarmers(){
    preconnect();
    var idle=function(){ lib().catch(function(){}); };           // static bundle only, no CC user
    if(window.requestIdleCallback) requestIdleCallback(idle,{timeout:3000}); else setTimeout(idle,1500);
    var armed=false;
    var intent=function(){ if(armed)return; armed=true; prewarm(); };
    ['pointerenter','focus','touchstart'].forEach(function(ev){
      document.addEventListener(ev,function(e){
        var t=e.target; if(t&&t.closest&&t.closest('.vvbc-cta--canvas')) intent();
      },{capture:true,passive:true});
    });
    /* 26-Aug SPEED — ARM EARLIER, BUT ONLY WHERE IT IS FREE.
       Hover is the last thing that happens before a click: on desktop it buys
       maybe 200ms, and on a phone there IS no hover, so touchstart fires with
       the finger already down and prewarm's ~0.3-1.1s lands squarely inside the
       wait the customer is watching. Scrolling the Design button into view
       happens seconds earlier and predicts a click far better than opening the
       page does.
       The reason this was hover-gated in the first place (UPDATE 4) is COST,
       not speed: prewarm mints a token, and minting for an unknown id makes the
       portal provision a storefront-user record at Customer's Canvas that their
       API gives us no way to delete (405 on DELETE — raised with Aurigma). So
       arm on visibility ONLY for an identity that already exists: a signed-in
       customer, or a guest device that has been here before and already has a
       cc_guest_id. For those, prewarm creates NOTHING new — it is a cache hit
       on a record we already paid for. A brand-new device still waits for a
       real intent signal, so the record count grows exactly as slowly as it
       does today. */
    try{
      var known=!!CUSTOMER_ID;
      if(!known){ try{ known=!!(localStorage.getItem('cc_guest_id')||sessionStorage.getItem('cc_guest_id')); }catch(e){} }
      if('IntersectionObserver' in window){
        /* THE BUTTON DOES NOT EXIST YET. armWarmers() runs as soon as
           resolves() confirms the product has a CC integration, and the buy
           cards — which is what renders .vvbc-cta--canvas — are built by
           vivid-buy-cards.liquid's own JS, which may not have run. The first
           version of this observed the result of a querySelector that returned
           null, so it silently did nothing: verified on the preview theme,
           where scrolling the button into view bound no registry and minted no
           token. Wait for the button instead of assuming it. MutationObserver
           catches it the moment it is inserted; the interval is the belt to
           that braces, and both give up after 20s so a page without a button
           does not leave observers running. */
        var _ctaWait=null,_ctaMo=null,_ctaTries=0;
        var withCta=function(cb){
          var found=document.querySelector('.vvbc-cta--canvas');
          if(found){ cb(found); return; }
          var stop=function(){ try{ clearInterval(_ctaWait); }catch(e){}
                               try{ _ctaMo&&_ctaMo.disconnect(); }catch(e){} };
          var check=function(){
            var el=document.querySelector('.vvbc-cta--canvas');
            if(el){ stop(); cb(el); return true; }
            if(++_ctaTries>40){ stop(); }        // 40 x 500ms = 20s
            return false;
          };
          _ctaWait=setInterval(check,500);
          try{ _ctaMo=new MutationObserver(check);
               _ctaMo.observe(document.body,{childList:true,subtree:true}); }catch(e){}
        };
        withCta(function(cta){
          var io=new IntersectionObserver(function(en){
            for(var i=0;i<en.length;i++){ if(!en[i].isIntersecting) continue;
              io.disconnect();
              /* THE REGISTRY IS ON THE CLICK PATH. __vvCCLaunch blocks on
                 vvRegLoad() before it will open anything — 367KB brotli that
                 parses to 2.84MB — so a visitor whose prefetch never ran pays
                 all of it AFTER tapping Design, staring at "Opening your design
                 studio". vivid-buy-cards warms the HTTP cache at page load, but
                 it deliberately skips anyone on Save-Data or 2G, which means the
                 slowest connections we have are precisely the ones that pay it
                 at tap time. Loading it when the button comes into view is the
                 same bytes moved off the click and onto the dwell, and it costs
                 nothing at Customer's Canvas — it is a static theme asset, not
                 a token mint. Save-Data is still honoured: that one is the
                 visitor telling us not to speculate with their data. */
              var sd=false; try{ sd=(navigator.connection||{}).saveData===true; }catch(e){}
              if(!sd) try{ vvRegLoad().catch(function(){}); }catch(e){}
              /* prewarm() DOES cost something at CC — it mints a token, and for
                 an id we have never seen the portal has to provision a
                 storefront-user record their API will not let us delete (405).
                 So it is armed on visibility only for an identity that already
                 exists; a brand-new device still waits for hover/touch. */
              if(known) intent();
              return; }
          },{rootMargin:'200px'});
          io.observe(cta);
        });
      }
    }catch(e){}
  }

  // ---- launch --------------------------------------------------------------
  // Generation counter: a "Try again" (or any second launch) while a previous loadEditor is still
  // pending must not let the OLD mount finish into the container the NEW one is using. Two
  // concurrent mounts produced duplicate au-wizard / au-widget-design-editor elements, and
  // deepFind() then returned the dead one — which is how a run could report a real stateId while
  // the visible canvas stayed blank, and how the preview widget came back undefined
  // ("Cannot read properties of undefined (reading 'createPreviewResource')").
  var launchGen=0;
  /* 21-Aug "INVALID SECURITY TOKEN" WATCHDOG. Seen on the owner's real phone
     (Shopify-app preview browser, 2-bar 5G) and reproducible in NO emulation:
     WebKit, third-party-cookie hard-block, cookie-stripped requests, 3G-class
     throttle, stale-token aging — every lab run mounts clean. Whatever the
     device-side trigger (CGNAT split-IP, clock skew, WebView quirk, a broken
     server-side CC user), the customer outcome must not be a dead screen. So:
     for ~60s after a mount, scan the editor subtree for the error text.
     Strike 1: re-mint everything (token+prewarm) and relaunch.
     Strike 2 (guests only): also ROTATE cc_guest_id — a guest whose CC user is
       broken server-side can never recover under the same identity, and a
       failing session has nothing to lose (durable saves require sign-in).
     Strike 3: the error panel, whose "Upload my own artwork" path always works.
     Every strike beacons /api/cc-mount-failure (fly logs + email) so real
     devices finally give us telemetry instead of screenshots. */
  var tokTry=0;
  function tokScan(){
    try{
      var seen=0, hit=false;
      var walk=function(root){
        if(hit||seen>4000||!root)return;
        var els; try{ els=root.querySelectorAll('*'); }catch(e){ return; }
        for(var i=0;i<els.length;i++){
          if(hit||++seen>4000)return;
          var el=els[i];
          if(!el.children.length&&/invalid security token/i.test(el.textContent||'')){ hit=true; return; }
          if(el.shadowRoot)walk(el.shadowRoot);
        }
      };
      walk(box);
      return hit;
    }catch(e){ return false; }
  }
  function tokWatch(gen){
    var checks=0;
    var iv=setInterval(function(){
      if(gen!==launchGen||modal.hasAttribute('hidden')){ clearInterval(iv); return; }
      if(++checks>24){ clearInterval(iv); return; }
      if(!tokScan())return;
      clearInterval(iv);
      tokTry++;
      try{ if(navigator.sendBeacon)navigator.sendBeacon(PORTAL+'/api/cc-mount-failure',
        JSON.stringify({reason:'invalid-security-token',attempt:tokTry,uid:guestId(),ua:(navigator.userAgent||'').slice(0,140)})); }catch(e){}
      if(tokTry>2){ showState('error'); return; }
      if(tokTry===2&&!CUSTOMER_ID){
        try{ localStorage.setItem('cc_guest_id','guest_'+Math.random().toString(36).slice(2,12)); }catch(e){}
      }
      try{ if(window.__vvCCPreReset)window.__vvCCPreReset(); if(window.__vvCCTokReset)window.__vvCCTokReset(); }catch(e){}
      booted=false;
      runLaunch();
    },2500);
  }
  /* 21-Aug GALLERY HIDDEN BEHIND THE EDITOR SPINNER (owner: "gallery still
     freezing ... the 2 metre wall just shows 4 designs then hangs").
     Filmstrip of Stretch Fabric Media Walls, phone, seconds after the tap:
        1s..12s  full-screen panel "Opening your design studio"
        20s      panel escalates to "Still loading — retrying (1/3)…"
        30s      finally settles
     The gallery had 38 designs rendered from the shipped card model the whole
     time — the customer just could not see them, because runLaunch() throws
     the loading panel over everything while Customer's Canvas mounts. On
     bollards the mount is quick so nobody noticed; on the walls it takes 20-30s
     and looks like a hang.
     The editor is only needed once a design is PICKED, so when the gallery is
     already usable we mount it behind the gallery instead of in front of it. */
  function browseUsable(){
    try{ return BROWSE_MODE && browseEl && browseEl.hasAttribute('data-on')
      && browseGrid && browseGrid.querySelector('.vvbr-card[data-gx]'); }catch(e){ return false; }
  }
  async function runLaunch(){
    var gen=++launchGen;
    armScriptGuard();   // re-assert: the optimiser can re-patch appendChild after we first armed
    guardAllOn();       // bypass the lazyJs optimiser for the whole mount, closed on wizard-up
    /* 23-Aug: was `if(!browseUsable())` — but usable demands a REAL card
       (data-gx), and 700ms after first open only the skeleton may be up, so
       this re-threw the splash over a visible gallery. If the browse UI is
       on-screen at all, the customer has their first screen: mount behind it.
       Non-browse products keep the splash exactly as before. */
    if(!browseUsable() && !(BROWSE_MODE&&browseEl&&browseEl.hasAttribute('data-on')))showState('loading');
    coverOff();
    hdrcover.removeAttribute('data-on');
    finishBtn.setAttribute('disabled','');
    box.innerHTML='';
    // Emptying the box makes `div:empty{display:none}` (theme base.css) apply, which hands Aurigma
    // a 0x0 display:none container and deadlocks loadEditor forever. The stylesheet above fixes
    // this properly; this line is the belt-and-braces guarantee at the exact moment it matters,
    // so a future theme-CSS change can never silently reintroduce the hang.
    box.style.setProperty('display','block','important');
    ccKick.loaded=false; ccKick.busy=false; ccKick.last=null; ccKick.want=null; ccKick.tries=0; ccKick.at=0; // fresh compile kick per launch
    galReset();  // the PDP selection can change between launches — re-derive the rail filter
    galUser=false; // UPDATE 22: a new launch is a new session; the latch starts clear
    feedReset(); // UPDATE 21: and re-push the PDP's choices into the design feed
    browseReset(); // UPDATE 26: browse-mode gallery re-opens per launch (no-op unless BROWSE_MODE)
    // UPDATE 32: a relaunch (Try again / retry) must RE-ATTEMPT the artwork
    // restore. EDIT.tries/failed/done persisted across launches, so a restore
    // that failed (or a session that timed out mid-restore) never tried again
    // after [Try again] - the customer silently lost their artwork. Fresh
    // counters per launch; the line key and project GUID are URL state and stay.
    EDIT.tries=0; EDIT.done=false; EDIT.failed=false; EDIT.base=null; EDIT.last=0;
    startMonitor();
    startAutosave();
    try{
      // Use the prewarmed StorefrontJS instance + integration details when the warmers already
      // built them (hover/focus/touch on the button). If the customer clicked without any intent
      // event, or the prewarm failed, prewarm() runs now and this is the old serial path.
      var uid=guestId();
      mountStage('prewarm-start');
      vvPauseGalleryImgs();   // 10-Sep: the editor load must not queue behind the card images
      /* 21-Aug: a LAUNCH is the moment the customer commits to a possibly-long
         editing session, so it never starts on an aged token. If the prewarmed
         instance is >5 min old, drop it and re-mint — one portal call +
         getIntegrationDetails (~300ms) buys ~55 min of editing headroom on a
         60-min token. The idle prewarm still gives the fast path for the
         common tap-within-minutes case. */
      if(_preAt&&(Date.now()-_preAt)>5*60*1000){ _pre=null; _preAt=0; try{window.__vvCCTokReset();}catch(e){} }
      var W=await prewarm();
      mountStage('prewarmed');
      if(gen!==launchGen)return;          // superseded while the prewarm was in flight
      var sf=W.sf, det=W.det;
      /* 7-Oct-2026 (REAL CUSTOMER inc_muxl1yje_mniw5m, Loose Table Cloth): never hand Aurigma's UI framework to the page
         before window load. Its webcomponents-loader.js, run while readyState is 'interactive', waits for load and then
         never sees it: the theme's script-deferral optimiser rewrites 'load' listeners to its own one-shot 'vividads-load',
         already fired — WebComponentsReady never fires, the editor never boots (proved over CDP: hangs = UIF executed in
         'interactive' after the optimiser's synthetic load; boots = UIF executed after the real load). Bounded so a page
         whose load never completes (a hung third-party resource) still launches. See docs/incident/INCIDENT-2026-10-07-uif-boot-before-load.md */
      if(document.readyState!=='complete'){
        var _wl0=Date.now(); try{ vvInc.mark('launch:wait-window-load',{rs:document.readyState}); }catch(e){}
        /* POLL readyState — never listen for 'load': the theme's script-deferral optimiser rewrites window/document
           'load' + 'DOMContentLoaded' listeners to its own 'vividads-load' event, which it fires ONCE, early. A listener
           added after that never fires — which is exactly how webcomponents-loader.js deadlocks. */
        await new Promise(function(res){ var t0=Date.now(); (function poll(){ if(document.readyState==='complete'||Date.now()-t0>=VV_WINLOAD_MAX_MS) return res(); setTimeout(poll,100); })(); });
        try{ vvInc.mark('launch:window-load',{ms:Date.now()-_wl0,rs:document.readyState}); }catch(e){}
        if(gen!==launchGen)return;        // superseded while waiting
      }
      try{ var _dd=await vvDirectDesign(W); if(gen!==launchGen)return; if(_dd){ det=_dd.det; window.__vvDD=_dd; mountStage('dd-direct'); } else { window.__vvDD=null; } }catch(e){ window.__vvDD=null; }
      try{ if(document.readyState!=='complete'){ VV_REC.capture=vvCaptureLateLoad(); vvRecTell('boot','capture-armed',{rs:document.readyState}); } }catch(e){}
      VV_REC.loadCalled=true; VV_REC.launchAt=Date.now();
      _loadInFlight=true;
      try{ await sf.loadEditor(box,det); }
      finally{ _loadInFlight=false; }
      mountStage('editor-loaded');
      vvEditorAt=Date.now(); vvExpiredShown=false;   // 10-Sep: the age the expiry checks read
      if(gen!==launchGen)return;          // a newer launch owns the container now — do not touch it
      booted=true;
      /* 26-Aug: TELL THE PORTAL THE EDITOR ACTUALLY OPENED.
         Nothing did, until now. The only usage signal reaching the portal was the
         CC token mint, and that fires inside prewarm(), which is armed on
         pointerenter / focus / touchstart over the Design button - so it counted
         people HOVERING the button, not people designing. On 26 Aug that read 201
         "launches" against 50 gallery opens, and any conversion rate computed from
         it was meaningless.
         Placed AFTER the generation check and booted=true, so a mount that was
         superseded by a newer launch is not counted, and each editor that really
         opened counts exactly once. sendBeacon, fire-and-forget, wrapped - it can
         never delay or break the editor the customer is waiting for. */
      try{ galBeat('editor-open',{ms:Math.round(performance.now())}); }catch(e){}
      tokWatch(gen);                      // 21-Aug: self-heal "Invalid security token" (see above)

      // The prewarmed sf instance is reused across retries, so bind onFinish exactly once —
      // otherwise a "Try again" would add the line twice.
      if(!sf.__vvFinishBound){
      sf.__vvFinishBound=1;
      vvFinishHandler=async function(s,r,viaRescue){
        try{
          /* 25-Aug — THE BLIND SPOT, closed. Between prepMark('add-clicked') and the
             cart write there were NO marks at all, so every finish timeout blamed
             "Customer's Canvas generating the hi-res file" whether or not CC had
             ever called us back. The 24-Aug teardrop failure proved that blame can
             be wrong: the portal logged NOTHING for that customer — no render, no
             28s background hand-off, no error — which means this callback never
             fired and the hang was entirely CC-side, before our pipeline was asked
             for anything. 'onfinish-fired' is the mark that separates the two
             worlds. If a future alert shows it, the stall is ours; if it does not,
             it is Aurigma's and that is what goes to them. */
          /* 10-Sep: ONE finish per run. Whoever arrives first — CC's callback or our
             rescue — owns it; the other returns. Keyed on the run, not globally, so a
             genuine failure followed by "Try again" still finishes normally. */
          if(vvFinishTaken===vvFinishRun&&vvFinishRun){
            try{console.warn('[vivid-cc] onFinish arrived after the rescue already finished this run — ignored');}catch(e){}
            return;
          }
          vvFinishTaken=vvFinishRun;
          try{ if(vvRescueT){clearTimeout(vvRescueT);vvRescueT=null;} }catch(e){}
          prepMark(viaRescue?'onfinish-rescued':'onfinish-fired');
          var it=(r&&(r.line_items||r.lineItems||r.items))||[r];
          var f=it[0]||{};
          var did=f.stateId||f.designId||'';
          if(Array.isArray(did))did=did.filter(Boolean).join(',');
          if(!did){ // FAIL LOUD — never add a line with no design
            prepStop();
            finishFail('capture', 'no preview/hi-res captured'); showState('error','We couldn’t capture your finished design, so nothing was added to your cart.','We couldn’t save your design');
            return;
          }
          var props={'_CC_Design_ID':did,'_CC_User_ID':uid,'Design services':'Design tool'};
          try{ var _ur=vvupRec(); if(_ur&&window.__vvUpPlaced){ props['_Artwork_Source_File']=_ur.url; props['_Artwork_Source_Name']=String(_ur.name||'').slice(0,120); } }catch(e){}   // dd3d-up
          (function(){ var pk=vvPackCtx(); if(!pk)return;
            props['_vv_pack']=pk.pack; if(pk.slot)props['_vv_slot']=pk.slot;
            props['_vv_artwork']='D'; })();
          /* 3-Oct-2026 fix, ported 6-Oct (it was committed to the theme repo but never reached the live
             theme) — CARRY THE USER-SELECTED CALCULATOR SIZE ONTO A DESIGNED CALCULATOR LINE.
             Corflute / ACP / foam / fabric are carrier-variant products priced ENTIRELY from line
             properties (Size / Width / Height / …) by the Cart Transform + checkout-validation
             Functions. The finish built the line with only _CC_* design properties, so the guard
             saw no size, flagged it "configuration not recognised (size_missing)" and the
             validation Function rejected the add with 422. Merge the size + options the product page
             holds, UNDER the finish's own props so the _CC_* / Design-services / print-file keys win:
               (a) window.vvCalcLine — the native JS calculators publish their current line-item
                   props on every recalc (and restore them from ?cfg= on a gallery-origin entry); then
               (b) the live product form's own properties[...] inputs — ITORIS/DPO products.
             Self-gating: a non-calculator product publishes nothing and has no such form fields. */
          try{
            var vvBase={};
            var vvVC=window.vvCalcLine;
            if(vvVC&&vvVC.valid&&vvVC.props){ for(var vk in vvVC.props){ if(Object.prototype.hasOwnProperty.call(vvVC.props,vk)) vvBase[vk]=vvVC.props[vk]; } }
            var VV_SIZE_KEYS={'Size':1,'Width':1,'Height':1,'_Standardized_Width':1,'_Standardized_Height':1,'Thickness':1,'Printing':1,'Printed Sides':1,'Cutting':1,'Eyelets':1,'Clear Eyelets':1,'Material':1,'Finishing':1,'Eyelet Configuration':1,'Finish':1,'Holes':1,'Total (sqm)':1,'_Standardized_Sided':1,'_TOTAL_SQM':1,'_PRODUCT_TITLE':1};
            var vvFormSel='form[action*="/cart/add"] input[name^="properties["],form[action*="/cart/add"] select[name^="properties["],form[action*="/cart/add"] textarea[name^="properties["]';
            Array.prototype.forEach.call(document.querySelectorAll(vvFormSel),function(inp){
              var nm=inp.name||''; if(nm.slice(0,11)!=='properties['||nm.slice(-1)!==']') return;
              var key=nm.slice(11,-1);
              if(VV_SIZE_KEYS[key]&&vvBase[key]===undefined&&String(inp.value||'').trim()!=='') vvBase[key]=inp.value;
            });
            for(var bk in vvBase){ if(Object.prototype.hasOwnProperty.call(vvBase,bk)&&props[bk]===undefined&&String(vvBase[bk]||'').trim()!=='') props[bk]=vvBase[bk]; }
            try{console.log('[vivid-cc] calc-size merged onto designed line',JSON.stringify(vvBase));}catch(e){}
          }catch(e){ try{console.warn('[vivid-cc] calc-size merge failed (ignored)',e);}catch(_){ } }
          // SIZE BINDING (UPDATE 13): buy what was designed, or refuse.
          var cartVar=resolveCartVariant();
          try{console.log('[vivid-cc] cart variant',cartVar);}catch(e){}
          if(cartVar.mode==='mismatch'){
            prepStop();
            finishFail('size-mismatch', cartVar.ccSize+' vs '+cartVar.pdpSize); showState('error','The template you designed is '+cartVar.ccSize+', but the size selected on this page is '+cartVar.pdpSize+'. We haven’t added anything to your cart — please call 1300 721 614 and we’ll sort the right size for you.','That size doesn’t match your design');
            try{console.warn('[vivid-cc] BLOCKED add-to-cart: CC design variant does not map to any Shopify variant on this product',cartVar);}catch(e){}
            return;
          }
          try{ var _g2=window.__vvGeomFinal; if(_g2&&_g2.sf&&cartVar.id&&String(cartVar.id)!==String(_g2.vid)){ var _e2=vvGeomExpect(cartVar.id);
              if(_e2&&vvGeomVerdict(_g2.sf,_e2)==='mismatch'){ finishFail('geom-mismatch',_g2.mm+' vs '+_e2.s.map(function(x){ return x[0]+'x'+x[1]; }).join(','));
                vvGeomBlock({v:'mismatch',mm:_g2.mm,exp:_e2.s.map(function(x){ return x[0]+'x'+x[1]; }).join(','),vid:String(cartVar.id)},'cart-variant'); return; } } }catch(e){}
          if(cartVar.sku) props['_CC_Variant_SKU']=cartVar.sku;
          props['_CC_Variant_Match']=cartVar.mode; // cc-options | cc-sku | pdp — production audit trail
          // Sign-off artifact. The Aurigma approval checkbox is no longer customer-facing
          // (UPDATE 12) — the pre-flight checklist is the sign-off, so production needs the
          // record of it on the line. Format: "completed 4/4 <ISO timestamp> (<seconds>s)".
          if(window.__vvPreflight) props['_CC_Preflight']=window.__vvPreflight;
          // Size check for prepress (11 Oct): the design's measured page vs this variant's production master.
          // Flags only — never blocks, never resizes. Catches designs saved before a template correction
          // (e.g. 3980 media walls saved at 3980x2300 before the 4040.7x2374.5 master fix).
          try{ var _gs=window.__vvGeomFinal, _gr=vvGeomRaw(cartVar.id||(_gs&&_gs.vid));
            if(_gs&&_gs.sf&&_gr&&_gr.s){ var _gv=vvGeomVerdict(_gs.sf,{s:_gr.s}), _gm=_gr.s.map(function(x){ return x[0]+'x'+x[1]; }).join(',');
              props['_CC_Size_Check']=(_gv==='mismatch')?('MISMATCH: design '+_gs.mm+' mm, product master '+_gm+' mm. Prepress check required; do not resize without customer approval.'):('OK '+_gs.mm+' mm');
              if(_gv==='mismatch'){ try{ vvRdTell('size-check-mismatch',{mm:_gs.mm,exp:_gm,vid:String(cartVar.id||'')}); }catch(_){ } } } }catch(e){}
          // The customer's rendered design, as a public image URL from createPreviewResource().
          // Drives the cart-line thumbnail, and gives admin/portal the same artwork to show.
          if(window.__vvPreviewUrl){
            props['_CC_Preview_URL']=window.__vvPreviewUrl;
            // NOTE: the proof URL is the cart TILE and nothing more. It used to be written into
            // vivid.artwork_uploads as well — that is the bug the 2 Aug print-readiness audit
            // found: an 800x800 session-scoped proof (~25 DPI at 800x2000mm) that 404s once the
            // editor session dies, handed to production as if it were the artwork. The artwork
            // property is now written below, and only from a real print file.
          }

          // ---- THE PRINT FILE (UPDATE 15) ----------------------------------------------
          // Everything above this point produced a design; nothing produced something we can
          // print. This step does, and it is the reason the finish flow exists:
          //   portal POST /api/cc-artwork  ->  creates the CC PROJECT from the editor state
          //                                    (owned by the durable identity in `uid`, not the
          //                                    session), renders the hi-res CMYK PDF, copies the
          //                                    bytes into our own bucket and returns a signed
          //                                    URL that outlives Customer's Canvas retention.
          // Measured 12-17s for an 800x2000 pull-up, so it runs INSIDE the progress modal.
          // The portal backgrounds anything slower than its sync budget and returns a durable
          // status URL instead, so a slow render can never hold the add-to-cart hostage.
          // FAIL LOUD: if this step fails the customer is told and NOTHING is added to the cart.
          // A silent add-to-cart with no print file is the exact failure this replaces.
          prepTo(92);
          prepMark('artwork-post');       // 25-Aug: our portal call starts HERE, not at add-clicked
          var art=null;
          try{
            var ctok='';
            // /cart.js returns the token with a "?key=…" suffix appended; the bare token is the
            // storage prefix, so strip it or every object key carries the query string inline.
            try{ var cj=await (await fetch('/cart.js',{headers:{Accept:'application/json'}})).json(); ctok=String((cj&&cj.token)||'').split('?')[0]; }catch(e){}
            /* 10-Sep: retry a NETWORK failure, twice, before giving up. The body is built
               once on purpose — the portal keys the job on (cart/order, stateId), so the same
               bytes find the same job and can never buy a second render. A response, whatever
               its status, is not retried: that is the portal talking, and the code below
               already handles it. */
            var vvBody=JSON.stringify({userId:uid,stateId:String(did).split(',')[0],cartToken:ctok,
                sku:cartVar.sku||'',productId:PRODUCT_ID,variantId:cartVar.id,item:PRODUCT_TITLE,
                geom:(function(){ try{ var g=window.__vvGeomFinal||{}; return {v:g.v||'',mm:g.mm||'',exp:g.exp||'',vid:g.vid||''}; }catch(e){ return null; } })()});
            var rr=null,vvNetErr=null;
            for(var vvA=0;vvA<3;vvA++){
              if(vvA){ prepMark('artwork-post-retry'+vvA); await new Promise(function(r){setTimeout(r,vvA*1500);}); }
              try{
                rr=await fetch(PORTAL+'/api/cc-artwork',{
                  method:'POST',headers:{'Content-Type':'application/json'},body:vvBody
                });
                vvNetErr=null;
                if((rr.status>=500||rr.status===429)&&vvA<2){ prepMark('artwork-post-'+rr.status); try{ galBeat('cc-finish',{stage:'artwork-retry',detail:String(rr.status)}); }catch(e){} continue; }   // bounded retry, same body
                break;
              }catch(ne){
                vvNetErr=ne;
                try{console.warn('[vivid-cc] print-file POST network failure, attempt '+(vvA+1)+'/3',ne);}catch(e){}
              }
            }
            if(vvNetErr) throw new Error(((vvNetErr&&vvNetErr.message)||String(vvNetErr))+' (3 attempts)');
            var rj=null; try{ rj=await rr.json(); }catch(e){}
            /* 26-Aug: THE DEFERRED CASE, and why this line is the whole fix.
               This guard used to read `|| !rj.projectId`, so it threw whenever the portal could
               not hand back a project id — which is exactly what the portal returns when
               Customer's Canvas refuses (down, throttled, or out of rendering credits). The
               portal was rewritten that morning to STOP 502-ing and to queue the render instead,
               precisely so a customer never again loses ten minutes of design work at the last
               step. But this line then threw on the queued response anyway, and the customer
               still saw “Nothing has been added to your cart”. The entire queue was inert
               until this changed. A response is a FAILURE only if the portal did not accept the
               work — not merely because there is no print file yet. */
            var accepted = rr.ok && rj && rj.ok && (rj.projectId || rj.status === 'deferred' || rj.status === 'on-order');
            if(!accepted) throw new Error((rj&&(rj.detail||rj.error))||('render '+rr.status));
            art=rj;
            // 'completed' = the portal rendered it inline; 'pending' = it exceeded CC_SYNC_MS
            // (28s) and the portal backgrounded the render; 'deferred' = CC refused outright and
            // the job is queued in the portal with the design still safe in CC under
            // userId+stateId. All three are successes for the cart; the distinction is exactly
            // what tells us how the render farm is behaving.
            prepMark('artwork-'+(art.status||'done'));
            try{console.log('[vivid-cc] print file',art.status,art.projectId,art.renderMs+'ms',art.bytes+'B');}catch(e){}
          }catch(err){
            prepStop();
            try{console.error('[vivid-cc] PRINT RENDER FAILED — add-to-cart blocked',err);}catch(e){}
            finishFail('hires', err); showState('error','We couldn’t create the print file for your design ('+(err&&err.message||err)+'). Nothing has been added to your cart — try again, or upload your own artwork and we’ll take it from there.','We couldn’t create your print file');
            return;
          }
          if(prep.cancelled)return;
          /* Only write a project id we actually have. String(null) is the string "null", which
             would sit on the order line looking like a real id and send the print floor hunting
             for a project that never existed. A deferred line carries the render JOB id instead
             — that is what the Print files console keys on to retry it. */
          if(art.projectId) props['_CC_Project_ID']=String(art.projectId);
          if(art.jobId) props['_CC_Render_Job']=String(art.jobId);
          if(art.url){
            props['_CC_HiRes_PDF']=art.url;
            // Artwork contract: production and the portal read the artwork from this property,
            // so the designed print file lands in the same place an uploaded file would.
            props['vivid.artwork_uploads']=art.url;
          }
          if(art.status!=='completed') props['_CC_HiRes_Status']=String(art.status||'pending');

          // UPDATE 24 step 1: a durable per-line project, so Change artwork can restore THIS
          // artwork later. Best-effort — a failed save must never cost the customer their add.
          var sp=await saveLineProject(did);
          if(sp) props['_CC_Saved_Project']=sp;

          // UPDATE 24 step 4: finishing from an EDIT session UPDATES that line — it never adds a
          // second one. Duplicate detection keys on the LINE KEY, never on the design/state id:
          // a restored session legitimately mints a NEW state id (§23.4), so keying on the design
          // id would treat every edit as a different product and add a line each time.
          //  · same variant  -> /cart/change.js on the key, properties MERGED over the line's own
          //    (so non-CC properties the theme or an app put there survive an edit);
          //  · variant drifted (the artwork is the truth, §23.4 step 3) -> change.js quantity:0 on
          //    the old key then add the correct variant. Two calls, but it still ends as ONE line.
          prepMark('cart-write');
          if(editWriteBlocked()){
            /* see editGuard: the canvas is not the customer's artwork */
            prepMark('blocked-failed-restore');
            try{ galBeat('cc-restore',{ok:0,why:'blocked-cartwrite',proj:EDIT.proj}); }catch(e){}
            throw new Error('Refusing to overwrite this cart line: its saved artwork could not be reloaded, so the canvas is not the customer\u2019s design.');
          }
          var res=null, mode='add';
          if(EDIT.line){
            var line=null, keep={};
            try{
              var cj2=await (await fetch('/cart.js',{headers:{Accept:'application/json'}})).json();
              line=(cj2.items||[]).filter(function(i){return i.key===EDIT.line;})[0]||null;
            }catch(e){}
            if(line){
              keep=Object.assign({},line.properties||{});
              for(var pk in props) keep[pk]=props[pk];
              if(String(line.variant_id)===String(cartVar.id)){
                mode='change';
                res=await cartWrite('/cart/change.js',{id:EDIT.line,quantity:line.quantity||qty(),properties:keep},'cart/change');
              }else{
                mode='replace';
                await cartWrite('/cart/change.js',{id:EDIT.line,quantity:0},'cart/change');
                res=await cartWrite('/cart/add.js',{id:cartVar.id,quantity:line.quantity||qty(),properties:keep},'cart/add');
              }
            }
          }
          if(!res){ // not an edit session, or the line has since gone — normal add
            res=await cartWrite('/cart/add.js',{id:cartVar.id,quantity:qty(),properties:props},'cart/add');
          }
          try{console.log('[vivid-cc] cart write',mode,res.status);}catch(e){}
          if(!res.ok)throw new Error(await cartErrMsg(res,'cart/'+mode));
          prepMark('cart-ok-'+mode);      // the last mark before we navigate
          prepTo(100);
          stopMonitor(); stopAutosave();
          try{window.__vvNoNav=1;}catch(e){}
          window.location.href=vvAfterCartHref();
        }catch(err){
          prepStop();
          finishFail('cart-add', err); showState('error','Your design was created but we couldn’t add it to the cart ('+(err&&err.message||err)+').','We couldn’t add this to your cart');
        }
      };
      sf.onFinish.subscribe(vvFinishHandler);
      }
    }catch(err){
      if(!booted){ stopMonitor(); mountFail('loadEditor-error: '+describeMountErr(err)); }
      else showState('error','The design studio couldn’t load ('+(err&&err.message||err)+').');
    }
  }

  // QA hooks. The pre-flight panel and the progress modal are pure page-side UI, but they only
  // appear at the end of a successful CC session — which makes them untestable whenever the CC
  // editor is failing to mount (it hangs inside sf.loadEditor(), platform-side). These let the
  // two surfaces be inspected on their own. They render UI only; neither touches the cart.
  // GATED (UPDATE 14): a real customer must never be able to summon these, and they must not sit
  // on window as a public API we then have to keep. They are installed only when the page is
  // explicitly in QA mode — `?vvqa=1` on the URL, or a Shopify theme PREVIEW (design mode /
  // ?preview_theme_id=…). On the published live theme, with no flag, `window.__vvQA` is
  // undefined. Nothing else in the snippet reads it.
  /* ?vvcc=diag — ON-DEVICE TRUTH PANEL (23 Aug 2026).
     Why this exists: the owner's iPhone and my emulations have now disagreed
     three times running — desktop WebKit threw a network error he never sees,
     Chromium at 393px rendered the design correctly, and his phone quietly gets
     the blank starter. Guessing across that gap has cost more rounds than it is
     worth. This puts the actual state of the apply chain on his screen so one
     screenshot settles which link is broken.

     Deliberately not behind QA_MODE: that turns itself on for every theme
     preview, and this must be summonable on the LIVE site by someone holding a
     phone. It is inert without the flag, prints no customer data, and the flag
     sticks to the tab (sessionStorage) so it survives the pick. */
  var DIAG=(function(){
    try{
      if(/[?&]vvcc=diag\b/.test(location.search)) sessionStorage.setItem('vvccDiag','1');
      return sessionStorage.getItem('vvccDiag')==='1';
    }catch(e){ return /[?&]vvcc=diag\b/.test(location.search); }
  })();
  if(DIAG){
    var _dT0=Date.now();
    var _dEl=document.createElement('div');
    _dEl.id='vvcc-diag';
    _dEl.setAttribute('style','position:fixed;left:6px;bottom:6px;z-index:2147483647;'
      +'background:rgba(0,0,0,.86);color:#0f0;font:11px/1.45 ui-monospace,Menlo,monospace;'
      +'padding:8px 10px;border-radius:8px;max-width:min(94vw,420px);white-space:pre-wrap;'
      +'pointer-events:none;');
    var _dAdd=function(){ if(document.body&&!document.getElementById('vvcc-diag')) document.body.appendChild(_dEl); };
    _dAdd();
    setInterval(function(){
      _dAdd();
      var sel=null,ed=null;
      try{ sel=deepFind('au-widget-pim-design-selector'); }catch(e){}
      try{ ed=deepFind('au-widget-design-editor'); }catch(e){}
      var selId=null; try{ selId=sel&&sel._&&sel._.designId; }catch(e){}
      var edId=null;  try{ edId=edDesignId(ed); }catch(e){}
      var pvt=null;   try{ pvt=ed&&ed._privateDesignId; }catch(e){}
      var d=browse.diag||{};
      var short=function(v){ v=String(v==null?'-':v); return v.length>14?v.slice(0,14)+'…':v; };
      var kage=ccKick.t0?Math.round((Date.now()-ccKick.t0)/1000):0;
      _dEl.textContent=
        'vvcc diag  t+'+Math.round((Date.now()-_dT0)/1000)+'s  '+innerWidth+'x'+innerHeight+'\n'
        +'picked   '+short(d.name)+'  id '+short(d.id)+'\n'
        +'tile     found='+(d.fresh?'Y':'N')+' node='+(d.tile?'Y':'N')
          +' inDoc='+(d.inDoc?'Y':'N')+' click='+(d.clicked?'Y':'N')+(d.err?(' err '+d.err):'')+'\n'
        +'selector '+(sel?'up':'MISSING')+'  designId '+short(selId)+'\n'
        +'editor   '+(ed?'up':'MISSING')+'  param    '+short(edId)+'\n'
        +'         private '+short(pvt)+'\n'
        +'WANTED   '+short(browse.pickedId||'-')+'\n'
        +'MATCH    '+(!browse.pickedId?'(nothing picked yet)'
            :(edId===browse.pickedId?'YES — your design is in the editor'
            :(selId===browse.pickedId?'editor lagging — selector has it, editor does not'
            :'NO — the tap never reached the selector')))+'\n'
        +'kick     tries '+ccKick.tries+'  age '+kage+'s  loaded='+(ccKick.loaded?'Y':'N')
          +' dead='+(ccKick.dead?'Y':'N')+'\n'
        +'cover    '+(browse.pickWaitAt?'up':'down')
        +'  boot '+(booted?'done':'running')
        +(window.__vvFinishErr?('\nFINISH   '+String(window.__vvFinishErr).slice(0,120)):'')
        +(document.getElementById('vvbr-boot')?'  notice up':'');
    },1000);
  }

  var QA_MODE=(function(){
    try{
      if(/[?&]vvqa=1\b/.test(location.search))return true;
      if(/[?&]preview_theme_id=/.test(location.search))return true;
      if(window.Shopify && Shopify.designMode)return true;
      // Shopify sets this cookie while a preview theme is being browsed without the param.
      if(/(^|;\s*)_shopify_essential=/.test(document.cookie) && document.querySelector('#preview-bar-iframe'))return true;
    }catch(e){}
    return false;
  })();
  if(QA_MODE) window.__vvQA={
    preflight:function(){ modal.removeAttribute('hidden'); vvLockScroll(); showState(null); pfOpen(); },
    prep:function(){ modal.removeAttribute('hidden'); vvLockScroll(); showState(null); prepStop(); prepStart(); },
    prepTo:function(p){ prepTo(p); },
    // QA only: shorten the 30s reassurance / 3min backstop so both can be observed without
    // waiting them out in real time. Call BEFORE prep(). Reload the page to restore defaults.
    prepDurations:function(longMs,hardMs){
      if(typeof longMs==='number')PREP_LONG_MS=longMs;
      if(typeof hardMs==='number')PREP_HARD_MS=hardMs;
      return {PREP_LONG_MS:PREP_LONG_MS,PREP_HARD_MS:PREP_HARD_MS,PREVIEW_MS:PREVIEW_MS};
    },
    prepState:function(){ return {on:prep.on,pct:prep.pct,cancelled:prep.cancelled,timedOut:prep.timedOut,
      longShown:prepLong.hasAttribute('data-on'),longText:prepLong.textContent,
      timeoutPanel:STATES.timeout.hasAttribute('data-on')}; },
    stop:function(){ prep.cancelled=true; prepStop(); pfCloseOnly(); },
    /* 25-Aug: the finish marks were only ever readable by TIMING OUT and reading the
       alert email — which meant the one code path we most needed to verify could not
       be verified without breaking it first. This returns the same two arrays the
       beacon sends, live, so a QA run can assert the finish actually walked
       onfinish-fired -> artwork-post -> artwork-completed -> cart-write -> cart-ok. */
    stages:function(){ return {mount:mountTry.stages.slice(), finish:prepStages.slice(),
      hardMs:PREP_HARD_MS}; },
    /* 30-Sep PERF: read the pick/read-back state live (QA only). */
    pick:function(){ try{ var ed=deepFind('au-widget-design-editor'), sel=deepFind('au-widget-pim-design-selector');
      return {entered:browse.entered, pickedId:browse.pickedId, pickedName:browse.pickedName, pickWaitAt:browse.pickWaitAt, pendingPick:browse.pendingPick,
        edDesign:ed?edDesignId(ed):null, selCur:(function(){ try{ return sel._&&sel._.designId; }catch(e){ return 'ERR'; } })(),
        kick:{busy:ccKick.busy,want:ccKick.want,last:ccKick.last,loaded:ccKick.loaded,tries:ccKick.tries,dead:ccKick.dead}, sig:browse.sig, items:(browse.items||[]).length}; }catch(e){ return {err:String(e)}; } }
  };

  window.__vvCCLaunch=function(){
    /* 22-Aug desktop gate. Body lives in vivid-cc-desktop-gate.liquid — this
       file sits ~450 bytes under Shopify's 256 KB template ceiling, so it
       cannot host it. Runs before the 356 KB registry fetch. */
    if(window.__vvCCDeskBlock&&window.__vvCCDeskBlock())return;
    /* Pull the registry now, not on page load. First open pays ~356 KB once;
       every visitor who never opens the gallery pays nothing. */
    /* Retry ONCE. The first version re-entered __vvCCLaunch after the registry
       loaded, and if the registry did not define __VVREG — asset 404, CDN
       hiccup, blocked script — the same branch was taken again against an
       already-resolved promise, so it recursed forever and the customer sat on
       "Opening your design studio". A gallery with no labels is a bad gallery;
       a studio that never opens is a lost order. Proceed either way. */
    if(!_vvRegTried&&!(window.__VVREG&&window.__VVREG.names)){
      _vvRegTried=true;
      modal.removeAttribute('hidden');
      vvLockScroll();
      vvRegLoad().then(function(){ window.__vvCCLaunch(); });
      return;
    }
    modal.removeAttribute('hidden');
    vvLockScroll();
    if(booted){ // already loaded once this pageview — just reopen (editor state retained)
      if(STATES.loading.hasAttribute('data-on')) showState(null);
      return;
    }
    /* 21-Aug FIRST-PAINT FIX (owner: "stuck for a good 10 seconds … the user
       will think page is hanged"). Measured on his 3440px window: a 7.5s
       zero-frame stall from the CTA click — the CC editor bootstrap (main-
       document custom elements + UMD eval + wizard mount) floods the frame
       pipeline in the same breath as the gallery's first paint. In browse
       mode the customer is looking at the GALLERY first, so paint it first:
       browseReset() shows the cached grid now; the editor bootstrap starts
       only after that paint has landed (double-rAF + a beat). The mount costs
       what it costs — it just no longer runs in front of the first paint. */
    if(BROWSE_MODE && !EDIT.proj && (!EDIT.line || EDIT.fresh)){
      try{ browseReset(); }catch(e){}
      /* 23-Aug — ON A PHONE THE PRE-WARM *IS* THE FREEZE. Owner: "it showed 5-6
         images then no scroll nothing, screen looked like frozen for like 10-15
         second and then it loaded all designs."
         Five or six images is exactly the eager-loading first row
         (vix < innerWidth<700 ? 6 : 18). What follows is this timer: 700ms after
         first paint the CC bootstrap starts — main-document custom elements, UMD
         eval, wizard mount — and it is one long main-thread task. It was measured
         at 7.5s on the owner's DESKTOP; a phone is several times that. Nothing can
         scroll while it runs, and the lazy images below the fold cannot even start.
         Deferring it by another second only moves the freeze to where the customer
         is mid-scroll, which is worse.
         So on a narrow screen the bootstrap no longer runs behind the gallery at
         all: it starts when the customer PICKS a design, where the "Opening your
         design…" cover is already up to explain the wait. The cost has not gone
         away — it has moved to the one moment the customer expects to wait, and
         out of the one where they expect to browse.
         Desktop keeps the pre-warm: it was measured and fixed there in August and
         the machine can absorb it. */
      /* 23-Aug — I TRIED DEFERRING THIS ON PHONES AND IT WAS WRONG. The idea was
         sound (the bootstrap IS the freeze) but the architecture does not allow
         it: browse.items carries a `tile` per design, and those tiles ARE the
         Aurigma rail's own .gallery__item nodes, read out of the selector's
         shadow root. With no bootstrap there is no rail, so every pick fell into
         the "live feed not in yet" branch and returned — 35 cards on screen and
         not one of them openable. Verified at 393px before it shipped: picked -,
         selector MISSING, boot deferred, forever.
         The gallery is not independent of the editor; it is a view onto the
         editor's rail. Any real fix for the freeze has to make the mount cheaper
         or the wait honest, not move the mount. */
      /* 23-Aug, owner's call: "after the first images load u can show user a
         loader until rest are loaded so it will be all good."
         Exactly right, and it is the only honest option left. The bootstrap that
         follows is one unbreakable main-thread task, so the choice is not between
         fast and slow — it is between a gallery that LOOKS frozen and one that
         says what it is doing. The first row stays on screen (that is what makes
         it feel alive); a strip explains the rest is coming.
         It has to be raised HERE, before the double-rAF, so the browser paints it
         in the same frame as the cards. Raise it after the bootstrap begins and
         nothing repaints until the bootstrap is over, which is the whole problem. */
      bootNotice(true);
      /* 7-Oct-2026 P0 (Corflute inc_mux85m71_743ign, Media Wall inc_mux9fopc_roqr0r — both tabs were in the background):
         requestAnimationFrame does NOT run in a hidden tab, so a customer who opened the product in a new tab, or switched
         away during the first second, never reached runLaunch — no prewarm, no wizard, selector rows 0 for as long as the
         tab stayed hidden — and the feed watchdog reported a dead feed. Reproduced line for line: scripts/qa/hidden-tab-probe.mjs
         (MODE=noraf-return). The paint-first intent stays for a visible tab; a hidden tab launches on a plain timer (timers
         keep running in the background), and a 2.5 s backstop guarantees the launch if the tab is hidden while we wait. */
      var _lgo=false; var _launchGo=function(){ if(_lgo)return; _lgo=true; setTimeout(function(){ if(!modal.hasAttribute('hidden') && !booted) runLaunch(); },700); };
      if(document.visibilityState==='hidden'){ try{ vvInc.mark('launch:hidden-tab'); }catch(e){} _launchGo(); }
      else{ requestAnimationFrame(function(){ requestAnimationFrame(_launchGo); }); setTimeout(function(){ if(!_lgo){ try{ vvInc.mark('launch:raf-backstop',{vis:document.visibilityState}); }catch(e){} _launchGo(); } },2500); }
      return;
    }
    runLaunch();
  };

  // "Change artwork" on a designed cart line links back here with ?vvcc=1 — open the studio
  // straight away so the customer lands in the editor, not on the PDP wondering what to click.
  // The gate still applies: __vvCCLinked must be true (the product resolves a CC integration),
  // otherwise this is a no-op and they just see the normal PDP.
  // NOTE: this re-opens a NEW design session. It does not reload the design from the cart line —
  // resuming a specific line's artwork needs the saved-project id on the line and a load path,
  // which is the natural follow-up once the autosave/resume story is settled.
  try{
    if(/[?&]vvcc=1\b/.test(location.search)){
      var openWhenReady=setInterval(function(){
        if(window.__vvCCLinked===false){ clearInterval(openWhenReady); return; }
        if(window.__vvCCLinked===true){ clearInterval(openWhenReady); window.__vvCCLaunch(); }
      },200);
      setTimeout(function(){ clearInterval(openWhenReady); },15000);
    }
  }catch(e){}

  // ---- GALLERY DEEP LINK (31-Aug-2026) -------------------------------------
  // The design gallery pages (/pages/<product>-<facet>) link here carrying the
  // design the customer actually clicked:
  //     ?vvstyle=<registry style key>[&vvsize=small|medium|large][&vvsides=single|double]
  //
  // Without this the gallery is a promise the product page breaks: the customer
  // picks "Now Open", lands on a blank PDP and sees nothing they chose. It is
  // also, in Google's own words, "generating pages to funnel visitors into the
  // actual usable portion of a site" — a doorway page — because the landing
  // page adds no function the product page did not already have. This is what
  // VistaPrint does with selectedOptions in their studio URL, and it is the
  // whole reason their template pages are merchandising rather than doorways.
  //
  // vvsize / vvsides drive the ordinary Shopify variant selectors by matching a
  // WORD, not an exact string — the option reads "Medium (3500mm H) Poles +
  // Carry Bag" while the URL carries "medium".
  // vvstyle opens the studio and picks the design once the browse feed lands,
  // which takes 15-25s on a cold cache, so the watcher is patient.
  try{
    var DEEP=(function(){
      function q(n){ try{ var m=location.search.match(new RegExp('[?&]'+n+'=([^&#]+)'));
        return m?decodeURIComponent(m[1]):''; }catch(e){ return ''; } }
      return { style:q('vvstyle'), size:q('vvsize'), sides:q('vvsides'), qty:q('vvqty') };
    })();

    /* 31-Aug: the gallery quick view lets the buyer pick quantity BEFORE they
       reach the editor, which matters here more than anywhere else — corflute
       has a $136 minimum order, so one sign and ten signs cost the same and
       nobody works that out unaided. Carry the choice into the PDP quantity. */
    /* 11-Sep — vvqty WAS SETTING THE WRONG BOX.

       This only ever wrote Shopify's own input[name=quantity]. On a calculator
       product that input does not drive the price at all: corflute prices from
       its OWN controls — a row of .vcorf-chip presets (1 / 10 / 25 / 50 / 100 /
       250 / 500) and an #custom-qty field for anything else.

       Measured with ?vvqty=12: Shopify's box read 12 while the page quoted
       "$18.64 ea · Order total $186.41", which is ten signs. The gallery would
       have promised a twelve-sign price and handed the customer a ten-sign one.
       Found by reading the total back off the page rather than trusting that
       setting a field named "quantity" had done something.

       So: press the preset when the number is one, type it into the
       calculator's own field when it is not, and set Shopify's box as well
       because that is what the cart reads. */
    if(DEEP.qty && /^\d{1,4}$/.test(DEEP.qty)){
      var _wantQty=String(parseInt(DEEP.qty,10));
      var qTries=0, applyQty=setInterval(function(){
        if(++qTries>60){ clearInterval(applyQty); vvlog('vvqty: no quantity control found'); return; }
        var did=false;

        /* THE CALCULATOR'S OWN BOX. vv-corflute-calc.js binds exactly one
           listener for quantity:
               qtyInput = root.querySelector('[data-qty]');
               qtyInput.addEventListener('input', ... syncChips(); recalc(); )
           so writing that input and firing 'input' is the whole contract — it
           reprices AND lights the right chip. Read out of the calculator source
           rather than guessed: the first attempt wrote #custom-qty, which
           belongs to a different and hidden quantity UI, and dispatching input,
           change, keyup, Enter and blur at it moved the total not one cent. */
        var qcalc=document.querySelector('input[data-qty]');
        if(qcalc){
          if(String(qcalc.value)!==_wantQty){
            qcalc.value=_wantQty;
            qcalc.dispatchEvent(new Event('input',{bubbles:true}));
          }
          did=true; vvlog('vvqty',_wantQty,'(calculator)');
        }

        /* a preset chip, for calculators that only expose those */
        if(!did){
          var chips=document.querySelectorAll('.vcorf-chip,[data-q]');
          for(var c=0;c<chips.length;c++){
            var ch=chips[c];
            var lab=String(ch.getAttribute('data-q')||((ch.firstElementChild||ch).textContent)||'').trim();
            if(lab!==_wantQty) continue;
            if(!ch.classList.contains('on')){ try{ ch.click(); }catch(e){} }
            did=true; vvlog('vvqty',_wantQty,'(preset)'); break;
          }
        }

        /* last resort: the older tiered UI's free-entry field */
        if(!did){
          var cq=document.getElementById('custom-qty');
          if(cq){
            cq.value=_wantQty;
            cq.dispatchEvent(new Event('input',{bubbles:true}));
            cq.dispatchEvent(new Event('change',{bubbles:true}));
            did=true; vvlog('vvqty',_wantQty,'(custom field)');
          }
        }

        /* and Shopify's box, which is what the cart line reads */
        var qi=document.querySelector('input[name="quantity"], input#Quantity, input.qty, input[data-quantity-input]');
        if(qi && qi.value!==_wantQty){
          qi.value=_wantQty;
          qi.dispatchEvent(new Event('input',{bubbles:true}));
          qi.dispatchEvent(new Event('change',{bubbles:true}));
        }
        if(did||qi) clearInterval(applyQty);
      },250);
    }

    /* 11-Sep — SIZE MUST ARRIVE WITH THE LINK.

       WITHDRAWN, 11-Sep, same day: an earlier version of this note claimed the
       live feed holds only 24 designs "because CC returns variant-designs for
       the size currently selected". That was inferred from one console line and
       is FALSE. Re-measured with the rail mounted: displayedVariants = 1468,
       tiles = 1468, one page, and the target design present throughout. The 24
       was a stale browse.items snapshot, and the picker's real fault was giving
       up after reading it once — see the long note at the picker below, which
       is where that is now fixed. Nothing here rescued a deep link on its own.

       What IS true, and is why this block stays: the size has to arrive with
       the link. One design exists once per size on the rail, so a link without
       ?vvsize lands on whichever size sorts first, and the customer sees a
       price and "1 unit" with no dimensions anywhere.
       Corflute takes size as two free-text mm boxes, not a select, and the
       loop below only ever searched <select> option text and radio labels —
       so ?vvsize could never apply to the product with the most designs.
       Handle a WxH size by writing the boxes directly. */
    var VVDBG=false; try{ VVDBG=/[?&]vvdebug=1/.test(location.search); }catch(e){}
    function vvlog(){ if(!VVDBG) return; try{ console.log.apply(console,['[vvdeep]'].concat([].slice.call(arguments))); }catch(e){} }
    if(DEEP.size && /^\d{2,5}x\d{2,5}$/i.test(DEEP.size)){
      var _wh = DEEP.size.toLowerCase().split('x');
      var whTries=0, applyWH=setInterval(function(){
        if(++whTries>60){ clearInterval(applyWH); return; }
        var boxes=[].filter.call(document.querySelectorAll('input[type=text],input[type=number]'),function(el){
          var ph=String(el.placeholder||'');
          return /^e\.g\.\s*\d+$/.test(ph);
        });
        if(boxes.length<2) return;
        if(boxes[0].value===_wh[0] && boxes[1].value===_wh[1]){ clearInterval(applyWH); return; }
        [0,1].forEach(function(n){
          var el=boxes[n];
          var setter=Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype,'value').set;
          setter.call(el,_wh[n]);
          el.dispatchEvent(new Event('input',{bubbles:true}));
          el.dispatchEvent(new Event('change',{bubbles:true}));
        });
        vvlog('applied size',DEEP.size);
        clearInterval(applyWH);
      },250);
    }
    if(DEEP.size||DEEP.sides){
      var want=[];
      if(DEEP.size)  want.push(DEEP.size.toLowerCase());
      if(DEEP.sides) want.push(DEEP.sides.toLowerCase()==='double'?'double-sided':'single-sided');
      var optTries=0, applyOpts=setInterval(function(){
        if(++optTries>40){ clearInterval(applyOpts); return; }
        var hit=0;
        want.forEach(function(w){
          [].forEach.call(document.querySelectorAll('select'),function(sel){
            for(var i=0;i<sel.options.length;i++){
              if(String(sel.options[i].text||'').toLowerCase().indexOf(w)>-1){
                if(sel.selectedIndex!==i){ sel.selectedIndex=i;
                  sel.dispatchEvent(new Event('change',{bubbles:true})); hit++; }
                break;
              }
            }
          });
          [].forEach.call(document.querySelectorAll('input[type=radio]'),function(r){
            var lab=r.closest&&r.closest('label');
            var txt=String((lab&&lab.textContent)||r.value||'').toLowerCase();
            if(txt.indexOf(w)>-1 && !r.checked){ r.click(); hit++; }
          });
        });
        if(hit){ clearInterval(applyOpts); }
      },250);
    }

    /* 11-Sep — CARRY THE REST OF THE OPTIONS, NOT JUST SIZE.

       Owner: "all product options are must to appear other then locking the
       size". The gallery quick view now offers eyelets, cutting, thickness and
       printing and prices them, so the choices have to survive the hop to the
       PDP — otherwise the panel is decoration and the customer picks twice.

       The gallery emits one param per option (vvopt_eyelets=...), which is why
       this reads them generically rather than naming any: a product that gains
       an option needs no change here.

       Corflute puts eyelets in a <select> and cutting/thickness/printing in
       button cards, so both are handled. Matching is on the FULL value text,
       not a substring — "2 x eyelets (top corners)" and "2 x eyelets (centre
       top & bottom)" share a prefix and a loose match would pick whichever
       came first. Disabled controls are left alone: a value the product cannot
       supply must not be forced on by a URL. */
    var DEEPOPTS=(function(){
      var out=[];
      try{
        var q=(location.search||'').replace(/^\?/,'').split('&');
        for(var i=0;i<q.length;i++){
          var kv=q[i].split('='); if(kv.length<2) continue;
          var k=decodeURIComponent(kv[0]);
          if(k.indexOf('vvopt_')!==0) continue;
          var v=decodeURIComponent(kv[1].replace(/\+/g,' ')).trim();
          if(v) out.push({k:k.slice(6), v:v});
        }
      }catch(e){}
      return out;
    })();
    if(DEEPOPTS.length){
      var _norm=function(t){ return String(t||'').toLowerCase().replace(/\s+/g,' ').trim(); };
      var oTries=0, oDone={}, applyDeepOpts=setInterval(function(){
        if(++oTries>60){ clearInterval(applyDeepOpts); vvlog('vvopt: gave up, applied', Object.keys(oDone).join(',')||'nothing'); return; }
        DEEPOPTS.forEach(function(o){
          if(oDone[o.k]) return;
          var want=_norm(o.v);
          /* selects first — an exact option-text match */
          var sels=document.querySelectorAll('select');
          for(var s2=0;s2<sels.length;s2++){
            var sel=sels[s2];
            for(var i=0;i<sel.options.length;i++){
              if(_norm(sel.options[i].text)!==want) continue;
              if(sel.selectedIndex!==i){
                sel.selectedIndex=i; sel.dispatchEvent(new Event('change',{bubbles:true}));
              }
              oDone[o.k]=1; vvlog('vvopt',o.k,'->',o.v,'(select)');
              return;
            }
          }
          /* then button cards. The label is the FIRST CHILD, not the first line:
             corflute renders <button><span class=vcorf-nm>Custom Contour</span>
             <span class=vcorf-sub>cut to shape</span></button>, and textContent
             glues those into "Custom Contourcut to shape" with no newline to
             split on. Splitting on '\n' was the first attempt and it silently
             matched nothing — innerText has the break, textContent does not. */
          var btns=document.querySelectorAll('button,[role=radio],label');
          for(var b=0;b<btns.length;b++){
            var el=btns[b];
            if(el.disabled||el.getAttribute('aria-disabled')==='true') continue;
            var kid=el.firstElementChild;
            var first=_norm(kid&&kid.textContent ? kid.textContent
                        : ((el.innerText||el.textContent||'').split('\n')[0]));
            if(first!==want) continue;
            if(el.getAttribute('aria-pressed')==='true'||el.classList.contains('on')){ oDone[o.k]=1; return; }
            try{ el.click(); oDone[o.k]=1; vvlog('vvopt',o.k,'->',o.v,'(button)'); }catch(e){}
            return;
          }
        });
        var all=true; DEEPOPTS.forEach(function(o){ if(!oDone[o.k]) all=false; });
        if(all){ clearInterval(applyDeepOpts); vvlog('vvopt: all applied'); }
      },300);
    }

    /* rc4.2.7 ENTRY STARTER — ?vvcc=upload / ?vvcc=blank must start on THIS variant's blank starter, or fail closed.
       v2: re-ordering the selector's rows does NOT change what the editor auto-loads (measured: rows front-loaded, editor still
       on LTC-arcframeCrimson). The only proven selection path is the rail tile tap + editor read-back (Blank / templates, RC4.2.5).
       Upload: once the feed is settled for the PDP's choices, resolve the blank row (vvBlankRowFor: blank/DYO name, sides word,
       size key — null = not identifiable, never guessed), tap ITS tile quietly behind the upload panel, read the editor back,
       retry (bounded). Blank: the existing card-click path is untouched; only the no-blank case changes (fail closed). */
    var VV_ENTRY=(function(){ try{ var m=(location.search||'').match(/[?&]vvcc=(blank|upload)\b/); return m?m[1]:''; }catch(e){ return ''; } })();
    if(VV_ENTRY&&!DEEP.style){
      (function(){
        var said={}, t0=Date.now(), taps=0, lastTap=0, noBlankSince=0, done=false;
        function tell(k,d){ if(said[k])return; said[k]=1; try{ vvInc.mark('entry:'+k,d||{}); }catch(e){} try{ galBeat('entry-starter',Object.assign({way:VV_ENTRY,r:k,ms:Date.now()-t0},d||{})); }catch(e){} }
        function edNow(){ try{ var ed=deepFind('au-widget-design-editor'); var dv=ed&&ed.params&&ed.params.changeDesignVariant&&ed.params.changeDesignVariant.designVariant; return dv||null; }catch(e){ return null; } }
        function failClosed(){
          tell('fail-closed',{});
          if(VV_ENTRY==='blank'){
            try{ showState('empty'); }catch(e){}
            try{ if(typeof window.__vvdeepDone==='function') window.__vvdeepDone(); }catch(e){}
            try{ var cv=document.getElementById('vv-dl-cover'); if(cv) cv.remove(); }catch(e){}
          }
        }
        var iv=setInterval(function(){
          if(done)return;
          if(Date.now()-t0>90000){ done=true; clearInterval(iv); var dv=edNow(); tell('starter-timeout',{name:dv?dv.designName:''}); return; }
          try{
            if(vvDDHolds()){ done=true; clearInterval(iv); var _ddv=edNow(); tell('starter-ok',{name:_ddv?_ddv.designName:'',taps:0,dd:1}); try{ vvDDSettle(); }catch(e){} return; }   // dd3
            if(!vvFeedSettled())return;
            var sel=deepFind('au-widget-pim-design-selector'); var rows=(sel&&sel.displayedVariants)||[];
            if(!rows.length)return;
            var row=vvBlankRowFor(rows);
            if(!row){
              if(rows.some(function(r){ return browseIsBlank(r&&r.designName); }))return;      // blanks exist, not this size yet: wait
              if(!noBlankSince) noBlankSince=Date.now();
              if(Date.now()-noBlankSince>3000){ done=true; clearInterval(iv); tell('no-blank',{rows:rows.length}); failClosed(); }
              return;
            }
            noBlankSince=0;
            var dv=edNow();
            if(dv&&String(dv.designId)===String(row.designId)){ done=true; clearInterval(iv); tell('starter-ok',{name:row.designName,taps:taps}); return; }
            if(VV_ENTRY!=='upload')return;                      // Blank: the card path owns the pick (unchanged)
            if(taps>=4){ done=true; clearInterval(iv); tell('starter-not-blank',{name:dv?dv.designName:'',want:row.designName}); return; }
            if(Date.now()-lastTap<4000)return;                   // give UIF its binding time before re-tapping
            var tile=browseTileFor(row.designName); if(!tile)return;
            taps++; lastTap=Date.now(); tell('tap-'+taps,{want:row.designName,had:dv?dv.designName:''});
            browseTap(tile);
          }catch(e){}
        },500);
      })();
    }

    if(DEEP.style){
      /* 30-Sep PERF — LOAD THE ASKED-FOR DESIGN FIRST, NOT SECOND. Measured on
         media-wall?vvstyle=gpt15-bday4-60th-lakemist: the design selector auto-loads
         designs[0] (MediaWall-DYO-…, the blank starter) the moment its rows land —
         from-design + editor init — and our tile click then loads the real design
         on top: a second from-design, a second init, +1.1 s, and an orphan private
         design every time. The widget takes its rows through updateParams; put the
         deep-linked row first before they reach it, so the design it auto-loads IS
         the one the customer clicked. The later tile click finds it already selected. */
      (function(){
        var _tailD=function(n){ n=String(n||''); var j=n.indexOf('-'); return j<0?n:n.slice(j+1); };
        function _rowIsD(r){
          if(!r)return false;
          if(String(r.designId||'')===String(DEEP.style))return true;
          var n=r.designName||''; if(!n)return false;
          if(vvStyleSame(n,DEEP.style))return true;                       // 30-Sep: gpt15- optional
          var st=null; try{ st=browseStyleOf(n); }catch(e){}
          if(st&&vvStyleSame(st,DEEP.style))return true;
          var t=_tailD(n);
          return vvStyleTail(t,DEEP.style);
        }
        function _front(p){
          if(!p||!Array.isArray(p.designs)||p.designs.length<2)return p;
          var rows=p.designs, hit=-1, any=-1, want=vvRailSizeKey();
          for(var i=0;i<rows.length;i++){ if(!_rowIsD(rows[i]))continue; if(any<0)any=i; if(!want){hit=i;break;}
            if(vvRailSizeMatch(rows[i].designName)){hit=i;break;} }
          if(hit<0)hit=any;
          if(hit<=0)return p;
          rows=rows.slice(); rows.unshift(rows.splice(hit,1)[0]);
          vvlog('front-loaded row',hit,'for',DEEP.style);
          return Object.assign({},p,{designs:rows});
        }
        var hooked=false, ht0=Date.now();
        var hv=setInterval(function(){
          if(hooked||Date.now()-ht0>60000){ clearInterval(hv); return; }
          var sel=null; try{ sel=deepFind('au-widget-pim-design-selector'); }catch(e){}
          if(!sel||typeof sel.updateParams!=='function')return;
          hooked=true; clearInterval(hv);
          try{
            var oU=sel.updateParams, oA=sel.updateParamsAsync;
            sel.updateParams=function(p){ try{ p=_front(p); }catch(e){} return oU.apply(this,[p].concat([].slice.call(arguments,1))); };
            if(typeof oA==='function') sel.updateParamsAsync=function(p){ try{ p=_front(p); }catch(e){} return oA.apply(this,[p].concat([].slice.call(arguments,1))); };
          }catch(e){}
        },100);
      })();
      var deepOpen=setInterval(function(){
        if(window.__vvCCLinked===false){ clearInterval(deepOpen); return; }
        if(window.__vvCCLinked===true){ clearInterval(deepOpen);
          try{ window.__vvCCLaunch(); }catch(e){} }
      },200);
      setTimeout(function(){ clearInterval(deepOpen); },15000);

      var deepT0=Date.now(), deepDone=false;
      var deepPick=setInterval(function(){
        if(deepDone){ clearInterval(deepPick); return; }
        if(vvDDHolds()){ deepDone=true; clearInterval(deepPick); try{ vvDDSettle(); }catch(e){} try{ galBeat('cc-deeplink',{style:DEEP.style,ok:1,why:'dd'}); }catch(e){} return; }   // dd3
        if(Date.now()-deepT0>90000){ clearInterval(deepPick);
          vvlog('TIMEOUT after 90s for',DEEP.style);
          /* the deep-link cover is opaque and is hiding a gallery that works.
             Give up honestly and show it rather than hold a dead screen. */
          try{ if(!browse.pickWaitAt) browseWait(false); }catch(e){}
          try{ galBeat('cc-deeplink',{style:DEEP.style,ok:0,why:'timeout'}); }catch(e){} return; }
        if(typeof browse==='undefined'||!browse) return;
        /* 11-Sep — THE DEEP LINK, MEASURED. READ THIS BEFORE CHANGING IT.

           Two earlier "root causes" of mine were both wrong, and both were
           asserted without measuring. Recorded so nobody re-walks them:
             (1) the style matcher. browseStyleOf() returns the FULL design key
                 ("dog-pet-p00"), not a style family, so the original
                 `items[i].style === DEEP.style` was already correct.
             (2) "the live feed only ever holds page one, 24 of 1,467". There is
                 no paging. Measured on corrugated-plastic-signs, 11-Sep, with
                 the rail mounted: displayedVariants = 1468, .gallery__item
                 tiles = 1468, currentPage = 1, pages = 1, _itemsPerPage = 1468,
                 from 3s after load onwards. CorrugatedSign-dog-pet-p00-600x900
                 was in that list the entire time, and __vvOk was undefined on
                 all 1468 rows, so the PDP rail filter was not hiding it either.

           The actual fault: browse.items is a SNAPSHOT maintained by
           browseSync, and browseSync returns early unless the gallery panel
           carries data-on and browse.done is false. The picker read exactly one
           snapshot — an early 24-group one — and on a miss called
           clearInterval and never looked again. The rail was already complete
           at that moment. Nothing re-checked it, so every design sorting after
           the first two dozen was permanently unreachable by deep link.

           The fix is therefore two things, not one:
             - resolve against the RAIL (displayedVariants + its tiles), which
               is the source of truth and is what browseTileFor/browsePick
               click anyway, instead of a snapshot of a derived model;
             - on a miss, KEEP LOOKING until the 90s budget expires. Never
               clearInterval on a single miss.
           browse.items is still preferred when it happens to hold the design,
           because its grouped card carries the colourway siblings the gallery
           header reads. */
        var _sel=null,_rows=[],_tiles=null;
        try{ _sel=deepFind('au-widget-pim-design-selector');
             _rows=(_sel&&_sel.displayedVariants)||[];
             _tiles=(_sel&&_sel.shadowRoot)?_sel.shadowRoot.querySelectorAll('.gallery__item'):null; }catch(e){}
        /* tiles must match rows 1:1 — browseCollect makes the same demand, because
           the tile is addressed BY INDEX and a mid-render rail lies about both. */
        if(!_rows.length||!_tiles||_tiles.length!==_rows.length){
          if(!window.__vvdbg1){ window.__vvdbg1=1;
            vvlog('waiting on the rail, rows=',_rows.length,'tiles=',_tiles?_tiles.length:-1); }
          return; }
        if(!window.__vvdbg2){ window.__vvdbg2=1;
          vvlog('rail ready, rows=',_rows.length,'looking for',DEEP.style); }

        var g=null, ix=0, i, k, cs;
        var _tail=function(n){ n=String(n||''); var j=n.indexOf('-'); return j<0?n:n.slice(j+1); };
        /* Is this rail row the design we were sent for? designId first (exact,
           and what a gallery card links with), then the registry key via
           browseStyleOf, then the raw name with its product prefix taken off. */
        function _rowIs(r){
          if(!r)return false;
          if(String(r.designId||'')===String(DEEP.style))return true;
          var n=r.designName||''; if(!n)return false;
          if(vvStyleSame(n,DEEP.style))return true;                       // 30-Sep: gpt15- optional
          var st=null; try{ st=browseStyleOf(n); }catch(e){}
          if(st&&vvStyleSame(st,DEEP.style))return true;
          var t=_tail(n);
          return vvStyleTail(t,DEEP.style);
        }
        /* One design exists once PER SIZE on this rail and the size is fused into
           the row name (…-dog-pet-p00-600x900 vs …-900x600), so when ?vvsize was
           asked for, take the row that IS that size. Falling through to "first
           row that matches the style" is how a portrait deep link used to open
           the landscape artwork. */
        /* 30-Sep: without ?vvsize the first matching row won — and the rail's FIRST
           page (24 rows, before the PDP-size filter lands) can hold another size of
           the same style, so a warm pull-up opened 600x1400 for an 800x2000 page and
           the read-back then waited 30 s for a design that was never going to match.
           The PDP's own chosen size is the default the link did not spell out. */
        var _want=vvRailSizeKey(), _hit=-1, _any=-1, _n=0;
        for(i=0;i<_rows.length;i++){
          if(!_rowIs(_rows[i]))continue;
          _n++; if(_any<0)_any=i;
          if(_hit<0&&vvSideOk(_rows[i].designName)){ if(!_want){ _hit=i; } else if(vvRailSizeMatch(_rows[i].designName)){ _hit=i; } }   // rc4.2.5: size AND sides
        }
        /* 7-Oct-2026 P0 (loose table cloth ?vvstyle=flame-loose, REAL_CUSTOMER give-up after 9.5 min): a style exists once PER
           SIZE and the size is not always in the name (…-4-closed / …-6-closed). On the UNFILTERED first feed the first match
           was the 4 ft design; the PDP filter landed a second later, Customer's Canvas loaded the 6 ft one (this variant's — the
           right design) and the read-back waited for an id that was never on this rail. Several rows match and the feed is
           not yet filtered to the PDP's choices → wait for the filter (bounded); once filtered the rail IS this variant's rows. */
        if(_n>1&&!(_want&&_hit>=0&&vvRailSizeMatch(_rows[_hit].designName))&&!vvFeedSettled()&&Date.now()-deepT0<20000){
          if(!window.__vvdbg8){ window.__vvdbg8=1; vvlog('style matches',_n,'rail rows (sizes) and the feed is not filtered yet; waiting'); }
          return; }
        /* 30-Sep: a wanted size that is not on the rail YET (the unfiltered first page
           shows other sizes first) must wait for it, not fall back to another size —
           that fallback is the 30 s pull-up. Only when the style's names carry a size
           at all, and for 6 s at most (the full rail lands 1–2 s after the first page). */
        if(_hit<0&&_any>=0&&_want&&vvHasSize(_rows[_any].designName)&&Date.now()-deepT0<6000){
          if(!window.__vvdbg7){ window.__vvdbg7=1; vvlog('style on the rail but not size',_want,'yet; waiting'); }
          return; }
        /* rc4.2.5: the style is on the rail only at another size/sides = the unfiltered default-variant feed. Wait for the PDP
           filter (bounded 20 s from the deep link); never take another size or sides early. */
        if(_hit<0&&_any>=0&&!vvFeedSettled()&&Date.now()-deepT0<20000){
          if(!window.__vvdbg9){ window.__vvdbg9=1; vvlog('style on the rail only at another size/sides; waiting for the PDP filter'); try{ vvInc.mark('pick:wait-filter',{style:DEEP.style}); }catch(e){} }
          return; }
        if(_hit<0)_hit=_any;
        if(_hit<0){
          /* NOT a failure — the rail refilters on every size/option change and
             repopulates. Keep looking; the interval's own 90s budget is the only
             thing allowed to end this. */
          if(!window.__vvdbg5){ window.__vvdbg5=1;
            vvlog('not on the rail yet for',DEEP.style,'— rows=',_rows.length,'; still looking');
            vvlog('first names=',[].slice.call(_rows,0,6).map(function(r){return r&&r.designName;}).join(' | ')); }
          return; }

        var _name=_rows[_hit].designName||'';
        var items=(browse&&browse.items)||[];
        for(i=0;i<items.length&&!g;i++){
          cs=items[i].cws||[];
          for(k=0;k<cs.length;k++){
            if(cs[k].name===_name||(cs[k].id&&String(cs[k].id)===String(_rows[_hit].designId||''))){
              g=items[i]; ix=k; break; } } }
        if(!g){
          /* browseSync has not published a card for it yet. Build the minimal
             group browsePick needs — it reads g.blank, g.style and
             g.cws[ix].{name,id,tile} — pointed at the real tile we just
             resolved, so the pick clicks the same node a customer would. */
          g={names:_name,blank:false,
             style:(function(){ try{ return browseStyleOf(_name); }catch(e){ return null; } })(),
             cws:[{name:_name,thumb:'',thumbSm:'',cc:(_rows[_hit].previewUrl||''),
                   tile:_tiles[_hit],slug:null,id:_rows[_hit].designId}]};
          ix=0;
          if(!window.__vvdbg6){ window.__vvdbg6=1; vvlog('built group from rail row',_hit,_name); }
        }
        if(!window.__vvdbg3){ window.__vvdbg3=1; vvlog('MATCHED group style=',g.style,'ix=',ix,'cws=',(g.cws||[]).length); }
        /* 31-Aug, second miss: g.cws is the SIZE variant list and each entry's
           name is size-specific ("FeatherFlags-…-600x2213.8"). browseTileFor
           matches that name against CC's own displayedVariants, so cws[0] only
           resolves when the customer is on the size the cold model was built
           at. With ?vvsize=large the pick matched the right design, found no
           tile, and sat forever on "Loading this design… Ready". Take whichever
           variant CC is actually showing right now. */
        var cws=g.cws||[], want=-1;
        /* 30-Sep: the size-matched entry (ix) first — "first cw with a tile" picked the
           wrong size whenever the unfiltered first page still showed it. */
        try{ if(ix>=0&&cws[ix]&&browseTileFor(cws[ix].name)) want=ix; }catch(e){}
        if(want<0) for(k=0;k<cws.length;k++){ try{ if(browseTileFor(cws[k].name)){ want=k; break; } }catch(e){} }
        if(want<0 && ix>0) want=ix;
        if(want<0){
          try{ want=(browse.cwSel&&browse.cwSel[g.style])||0; }catch(e){ want=0; }
          /* no tile for any variant yet — CC's rail has not caught up with the
             size change. Keep waiting rather than firing a pick that cannot land. */
          if(!window.__vvdbg4){ window.__vvdbg4=1; vvlog('no tile yet for any variant; waiting. names=',(g.cws||[]).map(function(c){return c.name}).join(', ')); }
          if(Date.now()-deepT0<75000) return;
          vvlog('tile wait expired, picking anyway want=',want);
        }
        deepDone=true; clearInterval(deepPick);
        try{ galBeat('cc-deeplink',{style:DEEP.style,ok:1,ix:want,ms:Date.now()-deepT0}); }catch(e){}
        vvlog('PICKING',g.style,'variant',want);
        try{ browsePick(g,want); }catch(e){ vvlog('browsePick threw', e && e.message); }
      },400);
    }
  }catch(e){}

  // ---- save gate (HelloPrint parity, UPDATE 9) -----------------------------
  // HelloPrint never shows its own login to save a design: saving/resuming is delegated to the
  // design platform's durable identity (their Canva embed autosaves to the customer's Canva
  // account; their shop account menu has no designs section at all). Our CC Hub has no consumer
  // login — the durable identity is OUR userId at the token endpoint: shopify_customer_<id> when
  // signed in, an ephemeral guest_<random> otherwise. Observed live: a guest Save Project shows
  // Aurigma's name dialog, then "Saving project..." — tied to a throwaway guest CC user (and it
  // currently hangs). So for GUESTS we intercept the UIF header's "Save Project" / "My Projects"
  // paper-buttons — composed click, CAPTURE phase on our container, so we run before Aurigma's
  // shadow-DOM handlers — and show the branded sign-in panel pointing at the store's passwordless
  // account (email code — same UX as the portal's Door A; both resolve to the same Shopify
  // customer, so projects saved on www persist per customer). Signed-in customers are untouched:
  // native save is already durable under shopify_customer_<id>. Label-matching note: if the hub
  // config ever renames these buttons this gate degrades gracefully (no intercept, native dialog).
  box.addEventListener('click',function(e){
    if(CUSTOMER_ID)return; // signed-in: native Save/My Projects is durable, leave it alone
    var p=e.composedPath?e.composedPath():[];
    for(var i=0;i<p.length;i++){var n=p[i];
      if(n&&n.tagName&&n.tagName.toLowerCase()==='paper-button'){
        var t=(n.textContent||'').trim().toLowerCase();
        if(t==='save project'||t==='my projects'){
          e.stopPropagation(); e.preventDefault();
          showState('signin');
        }
        return; // any other paper-button (Next, dialog buttons…) passes through untouched
      }
    }
  },true);

  // shell + state-panel button wiring
  // UPDATE 30 back matrix: gallery-entered editor -> GALLERY (state intact);
  // gallery itself, direct flow, and edit-from-cart -> close (today's behaviour).
  document.getElementById('vv-cc-close').addEventListener('click',function(){
    /* 30-Sep: a session that came from the VividCanvas gallery goes back to it —
       from the editor AND from the studio's grid — never to the studio's grid. */
    /* 30-Sep (later): with no vvfrom at all the target is implicit (vvGalleryDefault) and
       replaces ONLY the old "back to the studio's grid" case below — editor entered from
       the grid, grid not showing. A plain × on the grid itself still just closes. */
    /* 5-Oct (Q3 legacy-reachability): × now matches Esc for a hub / event-pack origin
       too — from the editor it returns to that page, never to the studio's own grid.
       (Esc already did; the × used to drop such sessions into the grid.) */
    try{ var _gf=vvFromTarget();
      if(_gf&&_gf.path&&!browseCartEdit()){
        var _inEd=BROWSE_MODE&&browse.entered&&!browseEl.hasAttribute('data-on');
        if(_gf.gallery ? (!_gf.implicit||_inEd) : _inEd){
          try{ galBeat('cc-backto',{ok:1,why:_gf.gallery?(_gf.implicit?'vv-gallery-default':'vv-gallery'):'vvfrom'}); }catch(e){} location.href=_gf.path; return; } } }catch(e){}
    if(BROWSE_MODE && browse.entered && !browseEl.hasAttribute('data-on')){ browseReturnToGallery(); return; }
    if(browseCartEdit()){ if(EDIT.saved){ closeModal(); } else vvccBackToCart(); return; }   // UPDATE 39: "‹ Back to cart" / 9-Sep: saved design -> close
    closeModal();
  });
  // UPDATE 35: the labelled "View all designs" button IS the chevron's replacement
  // (shown only under [data-vvbrhdr]) — it delegates to the close control's own
  // handler, so the UPDATE-30 back matrix is reused verbatim, never re-implemented.
  document.getElementById('vvcc-backall').addEventListener('click',function(){
    /* Came from a gallery: go back to it, rather than closing the editor onto
       the full catalogue the customer never asked for. */
    var from = vvFromTarget();
    if(from && !browseCartEdit()){
      try{ galBeat('cc-backto',{ok:1,why:'gallery',proj:from.path}); }catch(e){}
      location.href = from.path;
      return;
    }
    document.getElementById('vv-cc-close').click();
  });
  /* 9-Sep-2026 — SAVE A DESIGN (owner: "give save button and account signup
     only appears when user wants to save"). The artwork is saved FIRST, under
     whatever CC user this session runs as, through the same savedProjectsManager
     the 45s autosave uses — so nothing is ever lost to the sign-in redirect.
     Then, and only for guests, the account offer. The portal keeps the index
     (customer -> saves); localStorage keeps this device's list. */
  var VV_SAVES_KEY='vv_saves';
  function vvHandle(){ try{ var m=location.pathname.match(/\/products\/([a-z0-9\-]+)/i); return m?m[1].toLowerCase():''; }catch(e){ return ''; } }
  function vvSavesRead(){ try{ var a=JSON.parse(localStorage.getItem(VV_SAVES_KEY)||'[]'); return Array.isArray(a)?a:[]; }catch(e){ return []; } }
  function vvSavesWrite(a){ try{ localStorage.setItem(VV_SAVES_KEY,JSON.stringify(a.slice(0,60))); }catch(e){} }
  function vvSavesPut(rec){ var a=vvSavesRead().filter(function(x){return x.guid!==rec.guid;}); a.unshift(rec); vvSavesWrite(a); }
  function vvResumeUrl(rec){
    return '/products/'+rec.handle+'?'+(rec.variant?('variant='+rec.variant+'&'):'')+'vvcc=1&vvsaved=1&vvproj='+rec.guid+'&vvuser='+encodeURIComponent(rec.userId);
  }
  var vvSaved={remote:null,sig:''};          // portal list for the signed-in customer (all products)
  function vvSavedForHere(){
    var h=vvHandle(), local=vvSavesRead(), out=[], seen={};
    (vvSaved.remote||[]).concat(local).forEach(function(r){
      if(!r||!r.guid||seen[r.guid]||r.handle!==h)return; seen[r.guid]=1; out.push(r); });
    out.sort(function(a,b){return (b.at||0)-(a.at||0);});
    return out;
  }
  function vvSavedFetch(){
    if(!CUSTOMER_ID||vvSaved.remote)return;
    fetch(PORTAL+'/api/my-designs?customerId='+encodeURIComponent(CUSTOMER_ID),{signal:_abortIn(8000)})
      .then(function(r){return r.json();})
      .then(function(j){ vvSaved.remote=(j&&j.designs)||[]; vvSaved.sig='r'+vvSaved.remote.length; try{ browseRender(); }catch(e){} })
      .catch(function(){ vvSaved.remote=[]; });
  }
  function vvSavedPost(rec,notify){
    if(!CUSTOMER_ID)return Promise.resolve(null);
    return fetch(PORTAL+'/api/my-designs',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({customerId:String(CUSTOMER_ID),record:rec,notify:!!notify}),signal:_abortIn(12000)})
      .then(function(r){return r.json();})
      .then(function(j){ if(j&&j.ok){ rec.claimed=true; vvSavesPut(rec); if(vvSaved.remote){ vvSaved.remote=vvSaved.remote.filter(function(x){return x.guid!==rec.guid;}); vvSaved.remote.unshift(rec); vvSaved.sig='r'+vvSaved.remote.length+'-'+rec.guid.slice(0,6); } } return j; })
      .catch(function(){ return null; });
  }
  // ---- panels (built here so vivid-cc.liquid needs no change) ----
  (function(){
    try{
      var host=STATES.signin&&STATES.signin.parentNode; if(!host)return;
      var p=document.createElement('div'); p.className='vvcc-state'; p.id='vvcc-save';
      p.innerHTML='<div class="vvcc-emoji" aria-hidden="true">&#128190;</div>'
        +'<p class="vvcc-h" id="vvsv-h">Save this design</p>'
        +'<p class="vvcc-p" id="vvsv-p">Give it a name so you can find it again.</p>'
        +'<div id="vvsv-form" style="width:min(420px,90%);margin-top:8px"><input id="vvsv-name" type="text" maxlength="80" autocomplete="off" '
        +'style="width:100%;box-sizing:border-box;font:inherit;font-size:16px;padding:12px 14px;border:1px solid #cfcfd6;border-radius:8px"></div>'
        +'<div class="vvcc-actions" id="vvsv-actions"></div>'
        +'<p class="vvcc-sub" id="vvsv-sub"></p>';
      host.appendChild(p); STATES.save=p;
    }catch(e){}
  })();
  function vvsvUi(h,ptxt,actions,sub,form){
    try{
      document.getElementById('vvsv-h').textContent=h;
      document.getElementById('vvsv-p').textContent=ptxt||'';
      document.getElementById('vvsv-sub').textContent=sub||'';
      document.getElementById('vvsv-form').style.display=form?'block':'none';
      var a=document.getElementById('vvsv-actions'); a.innerHTML='';
      actions.forEach(function(x){
        var el=document.createElement(x.href?'a':'button');
        if(x.href)el.href=x.href; else el.type='button';
        el.className='vvcc-btn '+(x.primary?'vvcc-btn--primary':'vvcc-btn--ghost'); el.textContent=x.label;
        if(x.onclick)el.addEventListener('click',x.onclick);
        a.appendChild(el);
      });
      showState('save');
    }catch(e){}
  }
  function vvDefaultName(){
    var n=''; try{ n=(document.getElementById('vvcc-ctx1').textContent||'').replace(/\s*·\s*Original\s*$/,'').trim(); }catch(e){}
    if(!n||/^blank canvas$/i.test(n)||/^your saved design$/i.test(n)) n=PRODUCT_TITLE;
    var d=new Date(); return (n+' — '+d.getDate()+'/'+(d.getMonth()+1)+'/'+d.getFullYear()).slice(0,80);
  }
  function vvSaveOpen(){
    try{ prepMark('save-open'); }catch(e){}
    var input=document.getElementById('vvsv-name'); if(input)input.value=vvDefaultName();
    vvsvUi('Save this design','Give it a name so you can find it again.',
      [{label:'Save',primary:true,onclick:vvSaveGo},{label:'Cancel',onclick:function(){ showState(null); }}],'',true);
    try{ setTimeout(function(){ input&&input.focus()&&input.select(); },50); }catch(e){}
  }
  async function vvSaveGo(){
    var name=''; try{ name=(document.getElementById('vvsv-name').value||'').trim(); }catch(e){}
    if(!name)name=vvDefaultName();
    vvsvUi('Saving…','Keeping a copy of everything on your canvas.',[],'',false);
    var guid='', preview='';
    try{
      var wiz=deepFind('au-wizard'), ed=deepFind('au-widget-design-editor');
      var mgr=wiz&&wiz.savedProjectsManager, svc=mgr&&mgr._service;
      if(!mgr||!svc||!ed||!ed.stateId) throw new Error('editor not ready');
      var pname=name;
      try{ if(typeof ed.saveProduct==='function') await ed.saveProduct(); }catch(e){}   // class 10: push the canvas before filing the project (see autosaveTick)
      var before=projIds(await svc.getAllProjects(),pname);
      await mgr.saveProject(pname);
      var afterList=await svc.getAllProjects();
      var after=projIds(afterList,pname);
      var fresh=after.filter(function(id){return before.indexOf(id)<0;});
      guid=fresh.length?fresh[fresh.length-1]:'';
      /* Customer's Canvas makes a proof JPEG for every saved project (previews[0]) —
         a proof image, not the billed print render. That is the card thumbnail. */
      try{ var _pl=Array.isArray(afterList)?afterList:((afterList&&afterList.items)||[]);
           var _pj=_pl.filter(function(x){return x&&x.id===guid;})[0];
           preview=(_pj&&_pj.previews&&_pj.previews[0])||''; }catch(e){}
    }catch(e){ try{ prepMark('save-fail:'+String(e&&e.message||e).slice(0,40)); }catch(e2){} }
    if(!guid){
      vvsvUi('We couldn’t save just now','Your design is still on the canvas. Give it a few seconds and try again.',
        [{label:'Try again',primary:true,onclick:vvSaveGo},{label:'Keep designing',onclick:function(){ showState(null); }}],'',false);
      return;
    }
    var rec={guid:guid,userId:guestId(),handle:vvHandle(),variant:String(vid()||''),name:name,title:PRODUCT_TITLE,
             designId:(browse&&browse.pickedId)||'',preview:preview,at:Date.now(),claimed:false};
    vvSavesPut(rec);
    try{ prepMark('saved'); ccClarity('design-saved'); }catch(e){}
    if(CUSTOMER_ID){
      var j=await vvSavedPost(rec,true);
      vvsvUi('Saved to your account',(j&&j.emailed)?'We’ve also emailed you a link to reopen it. It’s in My designs and at the top of this gallery.':
        'It’s in My designs and at the top of this gallery.',
        [{label:'Keep designing',primary:true,onclick:function(){ showState(null); }},{label:'Open My designs',href:PORTAL+'/#/account/designs'}],'',false);
    }else{
      /* 9-Sep: the store's customer login is the PORTAL (portal.vividads.com.au), not
         Shopify's hosted account page. /login?next= brings them straight back here. */
      var back=vvResumeUrl(rec)+'&vvclaim=1';
      var href=PORTAL+'/login?next='+encodeURIComponent(location.origin+back);
      /* Shopify's hosted sign-in does not reliably honour return_url (measured 9-Sep: it
         lands on the account page or the home page). theme.liquid's
         shopify-vividads-resume snippet reads this on the first signed-in page and
         sends the customer straight back to the design. */
      var _armResume=function(){ try{ localStorage.setItem('vv_resume_pending',JSON.stringify({url:back,at:Date.now(),guid:rec.guid})); }catch(e){} };
      vvsvUi('Saved on this device','To keep it and open it on any device, sign in or create a free Vivid Ads account — no password, we email you a code. You’ll come straight back to this design.',
        [{label:'Sign in or create account',primary:true,href:href,onclick:_armResume},{label:'Not now',onclick:function(){ showState(null); }}],
        'Without an account it stays in this browser only.',false);
    }
    try{ browseRender(); }catch(e){}
  }
  // ---- header button ----
  (function(){
    try{
      var back=document.getElementById('vvcc-backall'); if(!back||document.getElementById('vvcc-save-btn'))return;
      var sb=document.createElement('button'); sb.type='button'; sb.id='vvcc-save-btn';
      sb.className='vvcc-back vvcc-savebtn'; sb.setAttribute('aria-label','Save this design');
      sb.innerHTML='<span class="bk" aria-hidden="true">&#128190;</span><span class="lbl">Save</span><span class="lbls">Save</span>';
      var so=document.getElementById('vvcc-startover');
      back.parentNode.insertBefore(sb,(so||back).nextSibling);
      var st=document.createElement('style');
      st.textContent='#vv-cc-modal .vvcc-savebtn{display:none;margin-left:6px}'
        +'#vv-cc-modal[data-vvbrhdr] .vvcc-savebtn{display:inline-flex}'
        +'#vv-cc-modal[data-vvedit] .vvcc-startover{display:none!important}'
        +'#vvcc-browse .vvbr-rm{position:absolute;top:10px;right:10px;width:34px;height:34px;border-radius:50%;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,.18);display:flex;align-items:center;justify-content:center;font-size:20px;line-height:1;color:#555;cursor:pointer;z-index:2}'
        +'#vvcc-browse .vvbr-rm[data-armed]{width:auto;padding:0 12px;font-size:12px;font-weight:700;border-radius:999px;background:#E02832;color:#fff}'   /* cart-edit + saved-design sessions: no re-pick */
        +'@media (max-width:760px){#vv-cc-modal .vvcc-savebtn .lbl{display:none}#vv-cc-modal .vvcc-savebtn .lbls{display:inline}}';
      document.head.appendChild(st);
      sb.addEventListener('click',function(){ try{ vvSaveOpen(); }catch(e){} });
    }catch(e){}
  })();
  // ---- claim: back from sign-in (?vvclaim=1), and any unclaimed device saves ----
  function vvClaimRun(){
    if(!CUSTOMER_ID)return;
    try{
      var q=new URLSearchParams(location.search);
      var claimGuid=(q.get('vvclaim')==='1')?(q.get('vvproj')||''):'';
      var list=vvSavesRead(), todo=[];
      if(claimGuid){
        var have=list.filter(function(r){return r.guid===claimGuid;})[0];
        if(!have){ have={guid:claimGuid,userId:q.get('vvuser')||guestId(),handle:vvHandle(),variant:String(q.get('variant')||vid()||''),name:'Saved design',title:PRODUCT_TITLE,designId:'',at:Date.now(),claimed:false}; }
        todo.push(have);
        try{ q.delete('vvclaim'); history.replaceState(null,'',location.pathname+'?'+q.toString()); }catch(e){}
      }
      list.forEach(function(r){ if(r&&!r.claimed&&r.guid!==claimGuid)todo.push(r); });
      var chain=Promise.resolve();
      todo.forEach(function(r,i){ chain=chain.then(function(){ return vvSavedPost(r,i===0&&!!claimGuid); }); });
      chain.then(function(){ vvSavedFetch(); });
    }catch(e){}
  }
  /* Identity (9-Sep): Liquid gives CUSTOMER_ID only for Shopify's hosted account login.
     The store's real login is the portal, whose session cookie is same-SITE with www —
     so one credentialed GET tells us who this is. Adopt the id before the editor boots
     (the click that mounts the editor is seconds away); if it is late, the session
     simply runs as a guest and the device save is claimed on the next visit. */
  function vvPortalIdentity(){
    return fetch(PORTAL+'/api/cc-identity',{credentials:'include',signal:_abortIn(6000)})
      .then(function(r){return r.json();})
      .then(function(j){ return (j&&j.signedIn&&/^[0-9]{5,20}$/.test(String(j.customerId||'')))?String(j.customerId):''; })
      .catch(function(){ return ''; });
  }
  try{ var _sg=STATES.signin&&STATES.signin.querySelector('a.vvcc-btn--primary');
       if(_sg) _sg.href=PORTAL+'/login?next='+encodeURIComponent(location.origin+location.pathname+location.search); }catch(e){}
  if(CUSTOMER_ID){ vvClaimRun(); vvSavedFetch(); }
  else{ vvPortalIdentity().then(function(id){ if(id){ CUSTOMER_ID=id; try{ modal.setAttribute('data-vvportal','1'); }catch(e){} vvClaimRun(); vvSavedFetch(); } }); }
  /* 9-Sep-2026 — START OVER (blank canvas). Owner: customers could not delete the
     locked background of a picked design and "build from scratch". Two-tap
     confirm (no native dialog: it is ugly on phones and blocks automation), then
     the same re-pick the quick-view's #vvqv-blank does. Only while a gallery
     design is open ([data-vvbrhdr]); never in an edit-from-cart session (a
     re-pick under a restored project is the cart-safety no-go, UPDATE 39). */
  (function(){
    try{
      var back=document.getElementById('vvcc-backall'); if(!back||document.getElementById('vvcc-startover'))return;
      var so=document.createElement('button'); so.type='button'; so.id='vvcc-startover';
      so.className='vvcc-back vvcc-startover'; so.setAttribute('aria-label','Start over on a blank canvas');
      so.innerHTML='<span class="bk" aria-hidden="true">&#8635;</span><span class="lbl">Start over</span><span class="lbls">Blank</span>';
      back.parentNode.insertBefore(so,back.nextSibling);
      var st=document.createElement('style');
      st.textContent='#vv-cc-modal .vvcc-startover{display:none;margin-left:6px}'
        +'#vv-cc-modal[data-vvbrhdr]:not([data-vvedit]) .vvcc-startover{display:inline-flex}'
        +'#vv-cc-modal .vvcc-startover[data-arm]{background:#fff;color:#C8102E}'
        +'@media (max-width:760px){#vv-cc-modal .vvcc-startover .lbl{display:none}#vv-cc-modal .vvcc-startover .lbls{display:inline}}';
      document.head.appendChild(st);
      var armT=0;
      function disarm(){ so.removeAttribute('data-arm'); so.querySelector('.lbl').textContent='Start over'; so.querySelector('.lbls').textContent='Blank'; }
      so.addEventListener('click',function(){
        try{
          if(browseCartEdit()){ disarm(); return; }
          if(!so.hasAttribute('data-arm')){
            so.setAttribute('data-arm','1');
            so.querySelector('.lbl').textContent='Clear everything? Tap again';
            so.querySelector('.lbls').textContent='Tap again';
            clearTimeout(armT); armT=setTimeout(disarm,5000); return;
          }
          clearTimeout(armT); disarm();
          var bl=(browse.items||[]).filter(function(g){return g.blank;})[0];
          if(!bl){ prepMark('startover-no-blank'); return; }
          prepMark('startover'); browsePick(bl,0);
        }catch(e){ try{ prepMark('startover-err:'+String(e&&e.message||e).slice(0,40)); }catch(e2){} }
      });
    }catch(e){}
  })();
  /* 10-Sep: the seventeen-hour tab. Coming back to it is the moment to find out,
     not after designing. Only when the editor is actually open, only after a long
     absence, and only ever after vvSessionAlive() has said so twice. */
  document.addEventListener('visibilitychange',function(){
    try{
      if(document.hidden){ vvHiddenAt=Date.now(); return; }
      var away=vvHiddenAt?(Date.now()-vvHiddenAt):0; vvHiddenAt=0;
      if(!booted||modal.hasAttribute('hidden')||anyStateOn())return;
      if(away<VV_AWAY_MS)return;
      (async function(){ try{ if(!(await vvSessionAlive())) vvShowExpired(); }catch(e){} })();
    }catch(e){}
  });
  modal.addEventListener('click',function(e){
    var b=e.target.closest('[data-vvcc]'); if(!b)return;
    var a=b.getAttribute('data-vvcc');
    if(a==='vvreload'){ try{ location.reload(); }catch(e){} }
    else if(a==='upload'){ openOwnDesign(); }
    else if(a==='design-service'){ openDesignService(); }
    else if(a==='back'){ showState(null); } // sign-in panel -> back to the editor
    else if(a==='retry'){ mountTry.n=0; mountTry.stages.length=0; booted=false;
      // 21-Aug: an explicit retry always re-mints — a customer only presses this
      // when something looked broken, and a stale token is one of the somethings.
      try{ if(window.__vvCCPreReset)window.__vvCCPreReset(); if(window.__vvCCTokReset)window.__vvCCTokReset(); }catch(e){}
      /* Release-hardening (2026-10-06) — Invariant 3. A session that entered from the VividCanvas gallery
         (?vvcc=blank|upload or ?vvstyle=, vvfrom=gallery) must re-enter THE SAME WAY: an in-page relaunch
         re-runs browseReset(), which turns the legacy grid on, and the one-shot entry pickers never re-arm
         (owner: "Try again loaded the old gallery"). Reload the entry URL instead — fresh editor, same entry. */
      if(vvModernEntry()){ try{ location.reload(); }catch(e){} return; }
      if(_vvEverMounted&&vvRelaunchReload(false)) return;   // dd3n: never stack a second UI-framework instance
      runLaunch(); }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && !modal.hasAttribute('hidden')) closeModal(); });

  // ---- gate: hide the VividCanvas button on products not linked on SF54 ----
  var linked;
  function hideNow(){
    if(linked!==false)return;
    [].forEach.call(document.querySelectorAll('.vvbc-cta--canvas:not([data-vv-cc-hidden])'),function(b){
      b.style.setProperty('display','none','important'); // buy-card CSS uses !important (ITORIS lesson)
      b.setAttribute('data-vv-cc-hidden','1');
    });
  }
  function boot(){
    resolves(PRODUCT_ID).then(function(ok){linked=ok;window.__vvCCLinked=ok;hideNow();
      if(ok) armWarmers(); // UPDATE 12: only warm the CC path on products that actually have it
      /* 6-Oct-2026 — SILENT LAUNCH, FOUND BY THE CONTROLLED-FAILURE SERIES (FAIL=token). When the token mint or the
         hub integration check cannot answer (5xx / network), __vvCCLinked stays null: the deep-link / gallery auto-open
         polls for 15 s and gives up without a word, and nothing was ever reported. Behaviour is unchanged; the launch
         that never happened is now an incident record (phase 'resolve', final) so it is diagnosed, not guessed. */
      if(ok===null&&(vvModernEntry()||/[?&]vvcc=/.test(location.search))){ (function rr(k){ if(k>=3) return; setTimeout(function(){ try{ if(window.__vvCCTokReset) window.__vvCCTokReset(); }catch(e){} resolves(PRODUCT_ID).then(function(ok2){ if(ok2===true&&linked!==true){ linked=true; window.__vvCCLinked=true; armWarmers(); vvRecTell('resolve','retry-ok',{k:k+1}); } else if(ok2===null){ vvRecTell('resolve','retry-unknown',{k:k+1}); rr(k+1); } },function(){ rr(k+1); }); },[1500,3000,6000][k]); })(0); }
      if(ok===null){ try{ vvInc.mark('resolve:unknown'); if(vvModernEntry()||/[?&]vvcc=/.test(location.search)){
        beaconPhase='resolve'; mountStage('resolve-unknown'); mountBeacon(true); beaconPhase='mount'; } }catch(e){} }
    });
    var n=0,iv=setInterval(function(){n++;hideNow();if(n>=20)clearInterval(iv);},700);
  }
  boot(); // direct, not via DOMContentLoaded (the optimiser rewrites DCL listeners)
})();

/* Big Head Builder loader (28-Aug): product 8135356612677 only — injects the
   sibling asset vivid-bighead.js (upload-a-photo flow with CutContour print
   files). URL computed from this script's own CDN src so it follows theme
   versioning. */
(function __vvbhLoader(){
  try{
    if(String((window.__VVCC||{}).PRODUCT_ID)!=='8135356612677') return;
    var me=null,sc=document.getElementsByTagName('script');
    for(var i=0;i<sc.length;i++){ if(sc[i].src&&sc[i].src.indexOf('vivid-cc-app.js')>-1){ me=sc[i].src; break; } }
    if(!me) return;
    var BH_VER='20260829b'; /* bump on every vivid-bighead.js change — the CDN
      caches by full URL and the cc-app v= param does not change with it */
    var s=document.createElement('script');
    s.src=me.slice(0,me.indexOf('vivid-cc-app.js'))+'vivid-bighead.js?v='+BH_VER;
    s.async=true; document.head.appendChild(s);
  }catch(e){}
})();
